export default {
  "12313": "",
  "123123": "",
  "77777777": "",
  "language.name": "Français",
  "system.dataScreen": "Tableau de bord",
  "login.email": "Boîte aux lettres",
  "login.password": "Mot de passe",
  "login.remember": "Mémoriser votre boîte mail et votre mot de passe",
  "login.rememberAccount": "Se souvenir du compte et du mot de passe",
  "login.enteremail": "Veuillez entrer une boîte aux lettres",
  "login.enterpassword": "Veuillez entrer votre mot de passe",
  "login.enterAccount": "Veuillez saisir votre courriel ou numéro de téléphone",
  "login.correctAccount": "Veuillez saisir un courriel ou numéro de téléphone valide",
  "login.accountPlaceholder": "Veuillez saisir votre courriel ou numéro de téléphone",
  "login.accountNumber": "Numéro de compte",
  "login.system": "Système intelligent de gestion de l'énergie Haier",
  "login.read": "Lire et accepter",
  "login.userAgreement": "Accord utilisateur",
  "login.privacyPolicy": "Politique de confidentialité",
  "login.temporarilyDisagree": "Refuser temporairement",
  "login.agreeAndAccept": "Accepter et consentir",
  "login.retrievePassword": "Récupérer le mot de passe",
  "login.verCode": "Code de vérification",
  "login.newPassword": "Nouveau mot de passe",
  "login.sendverCode": "Envoyer le Code de vérification",
  "login.greenLife": "Énergie propre innovante pour une vie verte",
  "login.welcome": "Bienvenue chez haier energy cloud",
  "login.downloadApp": "Télécharger l'application",
  "login.sure": "Confirmer",
  "weather.clearSky": "Ciel dégagé",
  "weather.fewClouds": "Quelques nuages",
  "weather.scatteredClouds": "Nuages épars",
  "weather.brokenClouds": "Ciel nuageux",
  "weather.overcastClouds": "Ciel couvert",
  "weather.lightRain": "Légère pluie",
  "weather.moderateRain": "Pluie modérée",
  "weather.heavyRain": "Fortes pluies",
  "weather.thunderstormWithLightRain": "Orage avec légère pluie",
  "weather.thunderstormWithRain": "Orage avec pluie",
  "weather.thunderstormWithHeavyRain": "Orage avec fortes pluies",
  "weather.lightSnow": "Légère neige",
  "weather.snow": "Neige",
  "weather.heavySnow": "Forte neige",
  "weather.sleet": "Verglas",
  "weather.showerRain": "Averse",
  "weather.lightShowerRain": "Légère averse",
  "weather.heavyShowerRain": "Forte averse",
  "weather.mist": "Brume",
  "weather.smoke": "Fumée",
  "weather.haze": "Brouillard sec",
  "weather.dust": "Poussière",
  "weather.fog": "Brouillard",
  "weather.sand": "Sable",
  "weather.ash": "Cendres",
  "weather.squall": "Rafale de vent",
  "weather.tornado": "Tornade",
  "zh-CN": "Chinois",
  "en-US": "Anglais",
  "de-DE": "Allemand",
  "fr-FR": "Français",
  "it-IT": "Italien",
  "uk-UA": "Ukrainien",
  "th-TH": "Thaï",
  "nl-NL": "Néerlandais",
  "language.management": "Multilingue",
  "sidebar.roleManagement": "Rôle",
  "user.userEmail": "E-mail de l'utilisateur",
  "user.agentCode": "Code agent",
  "user.phoneModel": "Modèle de téléphone",
  "user.phoneOs": "Système d'exploitation du téléphone",
  "user.appVersion": "Version de l'application",
  "user.country": "Pays",
  "user.createTime": "Heure de création",
  "user.loginTime": "Heure de connexion",
  "shipment.MdmCode": "Code MDM",
  "product.createProduct": "Créer un produit",
  "product.shippingMarket": "Marché d'expédition",
  "shipment.MaterialCode": "Code MDM",
  "product.deviceSubclass": "Sous-classe de l'appareil",
  "shipment.supplier": "Fournisseur",
  "product.networkingMode": "Mode de connexion",
  "product.productImage": "Image du produit",
  "product.bluetoothIcon": "Icône Bluetooth",
  "product.uploadOneBluetoothIcon": "Une seule icône Bluetooth peut être téléchargée",
  "product.UploadUpTo9Photos": "Téléverser jusqu'à 9 photos",
  "product.PleaseUploadNoBackground": "Veuillez téléverser des images d'appareils sans arrière-plan",
  "product.havePublished": "Publié",
  "product.inDevelopment": "En développement",
  "shipment.haierSn": "Haier SN",
  "shipment.category": "Catégorie",
  "shipment.devType": "Type de développement",
  "log.operationEmail": "Email d'opération",
  "log.deviceSn": "Numéro de série de l'appareil",
  "log.opType": "Type d'opération",
  "log.opTime": "Heure de l'opération",
  "log.operator": "Opérateur",
  "log.operationDescription": "Description de l'opération",
  "log.content": "Contenu de l'opération",
  "log.params": "Paramètres",
  "bTerminal.correlationDeleteTheDevice": "Si cet appareil est supprimé, les appareils associés seront également supprimés simultanément. Êtes-vous sûr de vouloir supprimer ?",
  "role.action": "Opération",
  "role.add.select.menu": "Veuillez sélectionner menu Ressources",
  "role.addRole": "Ajouter un rôle",
  "role.addTip": "Prend en charge la configuration des autorisations pour les utilisateurs Web et APP côté B, mais pas pour les utilisateurs APP côté C.",
  "role.applySuccess": "Soumission réussie",
  "role.appPermissions": "Autorisations du menu APP",
  "role.base": "Informations de base",
  "role.edit": "Modifier",
  "role.exist": "Les rôles existent déjà",
  "role.info": "Détails",
  "role.name": "Nom du rôle",
  "role.no": "Numéro de rôle",
  "role.not.empty": "Les informations de rôle ne peuvent pas être vides",
  "role.per.user": "Un seul rôle peut être attribué à chaque utilisateur",
  "role.permissions": "Autorisations des données",
  "role.status": "Statut du rôle",
  "role.submit": "Soumettre",
  "role.type": "Type de rôle",
  "role.typeTip": "Administrateur installateur : Rôle par défaut pour le responsable de l'organisation installatrice, il n'y en a qu'un sur toute la plateforme. Rôle installateur : Rôles que le responsable de l'organisation installatrice peut attribuer aux employés, il peut y en avoir plusieurs. Rôle plateforme : Rôles utilisables par tous sauf les installateurs.",
  "role.updateTime": "Heure de mise à jour",
  "role.webPermissions": "Autorisations du menu Web",
  "shipment.PleaseEnterMaterialCode": "Veuillez saisir le code matière MDM",
  "product.PleaseEnterSupplier": "Veuillez saisir le fournisseur",
  "common.reset": "Réinitialisation",
  "common.confirm": "Confirmer",
  "common.cancel": "Annuler",
  "common.save": "Sauvegarder",
  "common.delete": "Supprimer",
  "common.add": "Nouvellement ajouté",
  "common.edit": "Modifier",
  "common.update": "Mise à jour",
  "common.submit": "Soumettre",
  "common.tip": "Rappel",
  "common.success": "Succès",
  "common.fail": "L'échec",
  "common.password": "Mot de passe",
  "common.handleFail": "L'opération a échoué",
  "common.required": "Champs obligatoires",
  "common.environmentChange": "Changement d'environnement de compte, confirmation de l'actualisation du compte ou de la reconnexion",
  "common.noPermissions": "Aucun contenu pour l'instant, veuillez contacter l'administrateur pour configuration~",
  "plant.plantName": "Nom de la centrale",
  "plant.country": "Pays/Région",
  "plant.installer": "Installateur",
  "plant.installPerson": "Installateur",
  "plant.plantOverview": "Vue d'ensemble de la centrale",
  "plant.deviceList": "Liste des équipements",
  "device.operationMonitoring": "Surveillance du fonctionnement",
  "device.parameterControl": "Contrôle des paramètres",
  "device.Fault&Alarm": "Panne et alerte",
  "device.dynamicPriceTip": "Le mode IA pour cet appareil est activé par le propriétaire, vous ne pouvez pas enregistrer ce paramètre.",
  "sidebar.default": "Page de navigation",
  "sidebar.plant_plant": "Centrale électrique",
  "sidebar.device": "Équipement",
  "sidebar.firmware": "Liste des firmwares",
  "sidebar.endbenutzer": "Utilisateur",
  "sidebar.organizationalManagement": "Organisation",
  "sidebar.system": "Journal",
  "sidebar.auth_manage": "Authorisation",
  "sidebar.system_app": "Version de l'app",
  "sidebar.workorder": "Ordre de travail",
  "shipment.shippingManagement": "Livraison",
  "shipment.shippingManagementTemplage": "Modèle d'importation de gestion d'expédition",
  "product.management": "Produit",
  "device.paramRangeErrorDefault": "Erreur de plage de paramètres, la plage d'entrée doit être ",
  "device.paramRangeError": "Erreur de plage de paramètres",
  "plant.dataUpdate": "Mise à jour des données",
  "plant.pleaseSelectDate": "Veuillez sélectionner la date",
  "validate.requiredFormat": "Veuillez saisir selon le format d'exemple",
  "subtitle.alarmName": "Nom d'alarme",
  "subtitle.noSolution": "Veuillez vous référer au Manuel d'utilisation ou contacter directement le service après - vente.",
  "plant.addStation": "Ajouter une plante",
  "product.ProtocolCode": "ID produit IoT",
  "product.IoIDandPlatformSource": "ID de produit IoT et source de la plateforme",
  "product.productIdCannotRepeat": "L'ID du produit ne peut pas être dupliqué",
  "product.deviceTypeAccess.maxAddRows": "Vous pouvez ajouter jusqu'a 2 entrees maximum",
  "product.accessPlatformCannotRepeat": "La source de plateforme ne peut pas etre dupliquee",
  "product.productId": "ID du produit",
  "product.powerType": "Type d'alimentation",
  "product.power": "Puissance nominale kW",
  "system.taskCenter": "Centre de Tâches",
  "task.name": "Nom de la Tâche",
  "task.type": "Type de Tâche",
  "task.status": "Statut",
  "task.createDate": "Date de Création",
  "task.progress": "Progression",
  "task.view": "Voir",
  "task.stop": "Arrêter",
  "task.stopConfirm": "Êtes-vous sûr de vouloir arrêter la tâche ?",
  "task.stopSuccess": "Tâche arrêtée avec succès",
  "task.stopFail": "Échec de l'arrêt de la tâche",
  "task.confirm": "Confirmer",
  "task.cancel": "Annuler",
  "task.mutipleSearch": "Recherche Multiple",
  "task.mutipleSend": "Envoi Multiple",
  "task.taskDetail": "Détails de la Tâche",
  "task.equipmentList": "Liste d'Équipements",
  "task.fileLimit": "Seuls les fichiers xls/xlsx peuvent être téléchargés",
  "task.reChoose": "Vider la liste et sélectionner à nouveau",
  "task.tip": "Glissez le fichier ici, ou",
  "task.upload": "Cliquez pour Télécharger",
  "task.templateDownload": "Télécharger le Modèle",
  "task.mutipleHandleParams": "Paramètres de Traitement Multiple",
  "common.previousStep": "Étape Précédente",
  "task.requiredProductModel": "Veuillez sélectionner un modèle de produit",
  "task.requiredEquipmentList": "Veuillez télécharger la liste d'équipements",
  "task.equipmentListTip": "Les données du tableau sont vides ou le téléchargement a échoué, veuillez vérifier",
  "task.requiredParameter": "Veuillez sélectionner un paramètre",
  "task.writeValue": "Valeur d'Écriture",
  "task.progressRate": "Taux d'Achèvement",
  "task.readTime": "Temps de Lecture",
  "task.sendTime": "Temps d'Envoi",
  "task.mutipleSearchTemplate": "Modèle de Recherche Multiple",
  "task.mutipleSendTemplate": "Modèle d'Envoi Multiple",
  "task.uploadSuccess": "Téléchargement Réussi",
  "task.sendSuccess": "Tâche Créée avec Succès",
  "task.inProgress": "En Cours",
  "task.completed": "Terminé",
  "task.failed": "Échec",
  "task.success": "Succès",
  "device.workMode": "Mode de travail",
  "device.alarmInfo": "Informations d'alarme",
  "device.countryStandard": "Normes nationales",
  "device.runningStatus": "État de fonctionnement",
  "device.inverterTemp": "Température de l'onduleur(℃)",
  "device.dcdcTemp": "Température de la batterie (℃)",
  "device.mpptTemp": "Température MPPT(℃)",
  "device.drmStatus": "État DRM",
  "device.version": "Version",
  "device.communicationEquipment": "Équipement de communication",
  "device.basicInfo": "Informations de base",
  "device.productName": "Nom du produit",
  "device.productType": "Type de produit",
  "device.productModel": "Modèle de produit",
  "device.softVersion": "Version du logiciel",
  "device.softUpdateTime": "Heure de mise à jour du logiciel",
  "device.plant": "Centrale",
  "device.installer": "Installateur",
  "device.installPerson": "Installateur",
  "device.deviceRegisterDate": "Date d'enregistrement de l'équipement",
  "device.ownerEmail": "Email du propriétaire",
  "device.ownerReceiveTime": "Heure de réception du propriétaire",
  "device.ownerFamily": "Famille du propriétaire",
  "device.versionInfo": "Informations de version",
  "device.searchSn": "Veuillez entrer le SN pour la recherche",
  "device.user": "Utilisateur",
  "device.userReceiveDate": "Date de réception par l'utilisateur",
  "device.yuan": "Source : Photovoltaïque",
  "device.totalPower": "Puissance totale",
  "device.todayPowerGeneration": "Production électrique aujourd'hui",
  "device.dataGateway": "Passerelle de données",
  "device.optimizer": "Optimiseur",
  "device.chu": "Stockage : Batterie de stockage",
  "device.power": "Puissance",
  "device.todayChargingCapacity": "Charge aujourd'hui",
  "device.todayDischargingCapacity": "Décharge aujourd'hui",
  "device.he": "Charge : Consommation électrique",
  "device.todayElectricityConsumption": "Consommation électrique du jour",
  "device.totalElectricityConsumption": "Consommation électrique cumulée",
  "device.wang": "Réseau : Côté réseau",
  "device.totalFrequency": "Fréquence totale",
  "device.buyPowers": "Achat d'électricité",
  "device.sellPowers": "Vente d'électricité",
  "device.more": "Plus",
  "device.readWrite": "Outil de lecture/écriture directe",
  "device.chargeAndDisChargeSetting": "Paramètres de charge/décharge",
  "device.mutipleSave": "Envoi en lot",
  "device.mutipleRead": "Lecture par lot",
  "device.deviceSnisExist": "Veuillez confirmer l'existence du numéro de série de l'équipement",
  "device.saveSuccess": "La commande de paramètres a été envoyée. Veuillez actualiser la page ou cliquer sur le bouton [Lire] pour confirmer si les paramètres sont effectifs.",
  "device.saveFail": "Échec de l'envoi des paramètres",
  "device.getParamsSuccess": "Obtention des paramètres réussie",
  "device.getParamsFail": "Échec de l'obtention des paramètres",
  "device.operationalDataAnalysis": "Analyse des données de fonctionnement",
  "device.pleaseSelect": "Veuillez sélectionner un élément de données à gauche",
  "device.maxFour": "Les unités ne doivent pas dépasser 4",
  "device.maxFourOrTwenty": "Pas plus de 4 types ou 20 options autorisées",
  "device.protocolDirectives": "Instruction de protocole",
  "device.dateRangeError": "La plage de dates doit être dans les 3 jours",
  "device.noDeviceDetail": "Aucun détail sur l'équipement pour le moment",
  "device.address": "Adresse du registre",
  "device.faultClearing": "Réinitialisation des défauts",
  "device.chargeSetting": "Paramètre de charge",
  "device.dischargeSetting": "Paramètre de décharge",
  "system.configureImport": "Import de configuration",
  "product.DeviceHlepInstructions": "Instructions d'aide pour le dispositif",
  "product.addDeviceHlepInstructions": "Ajouter des instructions d'aide pour le dispositif",
  "product.deviceInstallationGuideFirst": "Veuillez télécharger des images de guide d'installation d'appareil pour guider les installateurs étape par étape à travers l'installation et les opérations d'application.",
  "product.deviceInstallationGuideSecond": "Il est recommandé d'inclure des instructions pour entrer en mode de configuration réseau de l'appareil, l'emplacement du code QR SN, la création de site, l'ajout d'appareil, les opérations Bluetooth, la configuration rapide, etc.",
  "product.mdnTip": "9 premiers chiffres du SN Haier",
  "plant.powerGeneration": "Production d'électricité",
  "plant.powerConsumption": "Consommation d'électricité",
  "plant.spontaneousSelfUse": "Auto-consommation",
  "plant.selfSufficient": "Autosuffisance",
  "plant.photovoltaicPowerGeneration": "Puissance photovoltaïque",
  "plant.electricPowerConsumption": "Puissance consommée",
  "plant.spontaneousSelfUsePower": "Puissance d'auto-consommation",
  "plant.buyPowers": "Puissance d'achat d'électricité",
  "plant.sellPowers": "Puissance de vente d'électricité",
  "plant.selfSufficientPower": "Puissance d'autosuffisance",
  "plant.batterySOC": "SOC de la batterie de stockage",
  "plant.storageChargingPower": "Puissance de charge de la batterie",
  "plant.storageDischargePower": "Puissance de décharge de la batterie",
  "plant.co2emissionReduction": "Réduction des émissions de CO2",
  "plant.plantPowerGeneration": "Production d’électricité cumulée de la centrale",
  "plant.equivalentTreePlanting": "Nombre d'arbres équivalents plantés",
  "plant.saveStandardCoal": "Économie de charbon standard",
  "plant.today": "Aujourd'hui",
  "plant.month": "Mois en cours",
  "plant.year": "Année en cours",
  "plant.total": "Cumulée",
  "Firmware.secretType": "Méthode de chiffrement",
  "common.copySuccess": "Copie réussie",
  "bTerminal.ModifyTheNameOfTheDevice": "Modifier le nom de l'appareil",
  "bTerminal.changeFailed": "Échec de la modification",
  "bTerminal.OnlyWithin100Characters": "Limité à 100 caractères ou moins en chinois, anglais et chiffres",
  "bTerminal.OnlyWithin30Characters": "Limité à 30 caractères ou moins en chinois, anglais et chiffres",
  "bTerminal.rename": "Renommer",
  "sidebar.prefill": "Évaluations & Retours",
  "paramters.basicInformation": "Informations de Base",
  "paramters.DCSide": "Сторона DC",
  "paramters.ACSide": "Сторона AC",
  "paramters.stringCurrent": "Струм Ланцюга",
  "paramters.moreParamters": "Більше Інформації",
  "paramters.debugInformation": "Налагоджувальна Інформація",
  "paramters.current": "Струм",
  "paramters.voltage": "Напруга",
  "paramters.power": "Потужність",
  "paramters.init": "Ініціалізація",
  "paramters.wait": "Очікування",
  "paramters.normal": "Нормально",
  "paramters.abnormal": "Несправність",
  "paramters.burn": "Прожигання",
  "system.reportCenter": "Centre de Rapports",
  "system.reportMonth": "Rapport Mensuel",
  "system.reportYear": "Rapport Annuel",
  "system.selfServiceReport": "Libre-service",
  "system.selfServiceReport.hour": "Heure",
  "system.selfServiceReport.selectPlant": "Veuillez sélectionner une centrale",
  "system.selfServiceReport.selectYear": "Sélectionner l'année",
  "system.selfServiceReport.metricSelection": "Sélection des indicateurs",
  "system.selfServiceReport.required": "Obligatoire",
  "system.selfServiceReport.startTimeCannotBeLater": "L'heure de début ne peut pas être postérieure à l'heure de fin",
  "system.selfServiceReport.fieldIsRequired": "{field} est obligatoire",
  "system.selfServiceReport.hourTimeTooltipLine1": "L'heure représente la période d'1 heure commençant à cette heure pleine",
  "system.selfServiceReport.hourTimeTooltipLine2": "(par ex. 15:00 = 15:00–15:59)",
  "report.exportAll": "Tout exporter",
  "report.installedCapacity": "Puissance installée",
  "report.capacityErrorTip": "La plage de filtrage de la puissance installée est incorrecte",
  "report.exportFailed": "Échec de l'exportation, veuillez réessayer plus tard",
  "report.firstChoiceTime": "Veuillez d'abord sélectionner une date, puis exporter",
  "report.allSelect": "Tout sélectionner",
  "report.compare": "Comparer",
  "report.energy": "Puissance active",
  "report.ipv": "Courant continu",
  "report.vpv": "Tension continue",
  "report.fac": "Fréquence côté CA",
  "report.vac": "Tension alternative",
  "report.iac": "Courant alternatif",
  "report.temperature": "Température interne",
  "report.str_cur": "Courant de chaîne",
  "report.inverterCompare": "Comparaison d'onduleur",
  "report.inverterCompareTip": "Вже додано до списку, не додавайте повторно",
  "report.pleaseChooseInverter": "Будь ласка, виберіть інвертор",
  "report.pleaseChooseCompare": "Будь ласка, виберіть елементи для порівняння",
  "report.compareItem": "Paramètres de comparaison",
  "system.inverterCompare": "Inverter Parameter Comparison",
  "product.basicProperties": "Propriétés de base",
  "product.specialProperties": "Propriétés spéciales",
  "product.platformRelated": "Lié à la plateforme",
  "product.maxPvChannels": "Nombre maximal de chaînes PV prises en charge",
  "product.componentManufacturer": "Fabricant du module",
  "product.componentType": "Type de module",
  "product.ratedPower": "Puissance nominale",
  "product.mppVoltage": "Tension MPP",
  "product.mppCurrent": "Courant MPP",
  "product.openCircuitVoltage": "Tension à vide",
  "product.shortCircuitCurrent": "Courant de court-circuit",
  "product.maxPowerTempCoeff": "Coefficient de température de la puissance max",
  "product.openVoltageTempCoeff": "Coefficient de température de la tension à vide",
  "product.shortCurrentTempCoeff": "Coefficient de température du courant de court-circuit",
  "product.componentEfficiency": "Rendement de conversion nominal du module",
  "product.firstYearDegradation": "Dégradation la première année",
  "product.annualDegradation": "Dégradation annuelle",
  "product.fillFactor": "Facteur de remplissage",
  "product.placeholder.range_0_9999_2dp": "0-9999, jusqu'à 2 décimales",
  "product.placeholder.range_0_99_2dp": "0-99, jusqu'à 2 décimales",
  "product.placeholder.range_0_999_2dp": "0-999, jusqu'à 2 décimales",
  "product.placeholder.range_neg1_1_2dp": "-1 à 1, jusqu'à 2 décimales",
  "product.rule.range_0_9999_2dp": "Entrez un nombre entre 0 et 9999, jusqu'à 2 décimales",
  "product.rule.range_0_99_2dp": "Entrez un nombre entre 0 et 99, jusqu'à 2 décimales",
  "product.rule.range_0_999_2dp": "Entrez un nombre entre 0 et 999, jusqu'à 2 décimales",
  "product.rule.range_neg1_1_2dp": "Entrez un nombre entre -1 et 1, jusqu'à 2 décimales",
  "product.ivScanSupport": "Prise en charge du balayage de courbe IV",
  "system.intelligentDiagnosis": "Diagnostic intelligent",
  "system.ivline": "Courbe IV",
  "subtitle.ivlineCreate": "Tâche de numérisation",
  "diagnosis.diagnosisTime": "Heure du diagnostic",
  "diagnosis.faultQuantity": "Nombre de défauts",
  "diagnosis.scanCompleteTime": "Heure de fin d'analyse",
  "diagnosis.scanProgress": "Progression de l'analyse",
  "diagnosis.newTask": "Nouvelle tâche",
  "diagnosis.deleteTask": "Supprimer la tâche",
  "diagnosis.deleteTaskSuccess": "Tâche supprimée avec succès",
  "diagnosis.closeAll": "Tout effacer",
  "diagnosis.startScan": "Démarrer l'analyse",
  "diagnosis.pleaseChooseInverter": "Veuillez sélectionner l'onduleur",
  "diagnosis.stringSetting": "Paramètre chaîne",
  "diagnosis.taskSetting": "Paramètre tâche",
  "diagnosis.batchComponentSetting": "Paramétrage par lot des composants",
  "diagnosis.componentType": "Type de composant",
  "diagnosis.maxPower": "Puissance maximale (Pmax)",
  "diagnosis.bestWorkingVoltage": "Tension de fonctionnement optimale (Vmpp)",
  "diagnosis.bestWorkingCurrent": "Courant de fonctionnement optimal (Impp)",
  "diagnosis.openCircuitVoltage": "Tension en circuit ouvert (Voc)",
  "diagnosis.shortCircuitCurrent": "Courant de court-circuit (Isc)",
  "diagnosis.maxPowerTemperatureCoefficient": "Coefficient de température de la puissance maximale",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "Coefficient de température de la tension en circuit ouvert",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "Coefficient de température du courant de court-circuit",
  "diagnosis.nominalComponentConversionEfficiency": "Efficacité nominale de conversion du composant",
  "diagnosis.firstYearDecayRate": "Taux de dégradation de la première année",
  "diagnosis.yearlyDecayRate": "Taux de dégradation annuel",
  "diagnosis.fillFactor": "Facteur de remplissage",
  "diagnosis.componentManufacturer": "Fabricant du composant",
  "diagnosis.componentAmount": "Quantité de composants",
  "diagnosis.capacity": "Capacité de chaîne",
  "diagnosis.stringAmount": "Nombre de chaînes (unités)",
  "diagnosis.inverterSerialNumber": "Numéro de série de l'onduleur",
  "diagnosis.totalCapacity": "Capacité totale des chaînes",
  "diagnosis.pleaseFillInAllItems": "Des champs sont vides, veuillez vérifier",
  "diagnosis.moreParamters": "Plus de paramètres",
  "diagnosis.envParam": "Paramètres environnementaux",
  "diagnosis.startTask": "Démarrer la tâche",
  "diagnosis.startTaskSuccess": "Tâche démarrée avec succès",
  "diagnosis.start": "Démarrer",
  "diagnosis.noDevice": "Aucun appareil trouvé",
  "placeholder.selectScope": "Veuillez sélectionner {scope}",
  "placeholder.enter": "Veuillez entrer {scope}",
  "register.accountVerification": "Vérification du compte",
  "register.companyRegistration": "Enregistrement de l'entreprise",
  "register.staffRegistration": "Enregistrement du personnel",
  "register.companyInfo": "Fournir les informations de l'entreprise ci-dessous",
  "register.companyFullName": "Nom complet de l'entreprise",
  "register.installationCountryNotice": "Veuillez sélectionner attentivement le pays où l'installateur est enregistré. Vous ne pouvez pas installer le système en dehors de la zone d'enregistrement.",
  "register.detailAddress": "Adresse détaillée",
  "register.postalCode": "Code postal",
  "register.contactName": "Nom du contact",
  "register.contactInfo": "Téléphone ou e-mail du contact",
  "register.applyJoinCompany": "Demander à rejoindre l'entreprise",
  "register.companyCodeInfo": "Veuillez remplir le code de l'entreprise et les informations personnelles pour rejoindre une entreprise enregistrée",
  "register.registrationCode": "Code d'enregistrement de l'entreprise",
  "register.codeHint": "Le code peut être obtenu en contactant l'administrateur de l'entreprise",
  "register.realName": "Nom",
  "register.accountVerificationInfo": "Choisissez l'une des méthodes suivantes pour compléter l'enregistrement du compte",
  "register.emailRegistration": "Enregistrement par e-mail",
  "register.sixDigitCode": "Code de vérification à 6 chiffres",
  "register.getVerificationCode": "Obtenir le code de vérification",
  "register.resendAfterSeconds": "Renvoyer après {seconds}s",
  "register.resendAfterMinutes": "Renvoyer après {minutes}min",
  "register.resendAfterMinutesSeconds": "Renvoyer après {minutes}min{seconds}s",
  "register.password6to20": "Mot de passe de 6 à 20 caractères",
  "register.password8to20": "Mot de passe de 8 à 20 caractères",
  "register.phoneNumber": "Numéro de téléphone",
  "register.phoneRegistration": "Enregistrement par téléphone",
  "register.optionalEmail": "Facultatif : Adresse e-mail",
  "register.previousPage": "Page précédente",
  "register.goToLogin": "Aller à la connexion",
  "register.completeRegistration": "Terminer l'inscription",
  "register.accountAlreadyRegistered": "Cet e-mail ou ce numéro de téléphone est déjà enregistré. Connectez-vous ou utilisez un autre compte.",
  "register.emailAlreadyRegistered": "Cet e-mail est déjà enregistré. Veuillez vous connecter directement ou utiliser un autre compte.",
  "register.phoneAlreadyRegistered": "Ce numéro de téléphone est déjà enregistré. Veuillez vous connecter directement ou utiliser un autre compte.",
  "register.companyAlreadyRegistered": "L'entreprise '{companyName}' est déjà enregistrée",
  "register.companyExistOptions": "Vous pouvez revenir pour modifier le nom de l'entreprise, ou demander à rejoindre cette entreprise",
  "register.returnToModify": "Retourner pour modifier",
  "register.companyRegisteredApplyJoin": "Demander à rejoindre",
  "register.companyRegisteredApplyJoinFull": "Entreprise déjà enregistrée ? Demander à rejoindre",
  "register.validation.selectCountry": "Veuillez sélectionner le pays/la région",
  "register.validation.selectCity": "Veuillez sélectionner la ville",
  "register.validation.enterDetailAddress": "Veuillez saisir l'adresse détaillée",
  "register.validation.enterCorrectPostalCode": "Veuillez saisir le format de code postal correct",
  "register.validation.enterContactName": "Veuillez saisir le nom du contact",
  "register.validation.enterRegistrationCode": "Veuillez saisir le code d'enregistrement de l'entreprise",
  "register.validation.enterYourName": "Veuillez saisir votre nom",
  "register.validation.enterPassword": "Veuillez saisir le mot de passe",
  "register.validation.passwordLength": "La longueur du mot de passe doit être de 6 à 20 caractères",
  "register.validation.passwordLength8to20": "La longueur du mot de passe doit être de 8 à 20 caractères",
  "register.validation.passwordComplexity": "Le mot de passe doit contenir au moins trois types de caractères différents (chiffres, lettres majuscules, lettres minuscules, caractères spéciaux)",
  "register.validation.enterPasswordAgain": "Veuillez saisir à nouveau le mot de passe",
  "register.validation.passwordMismatch": "Les deux mots de passe ne correspondent pas",
  "register.validation.correctPhoneFormat": "Veuillez saisir le format de numéro de téléphone correct",
  "register.validation.correctPhoneOrEmailFormat": "Veuillez saisir le format de numéro de téléphone ou d'e-mail correct",
  "register.validation.correctEmailFormat": "Veuillez saisir le format d'e-mail correct",
  "register.validation.enterVerificationCode": "Veuillez saisir le code de vérification",
  "register.validation.sixDigitNumber": "Le code de vérification doit être composé de 6 chiffres",
  "register.validation.enterCompanyName": "Veuillez saisir le nom de l'entreprise",
  "register.validation.companyRegisteredChooseAction": "Entreprise déjà enregistrée, veuillez choisir une action",
  "register.message.searchCompanyFailed": "Échec de la recherche de l'entreprise",
  "register.message.checkCompanyStatusFailed": "Échec de la vérification du statut de l'entreprise",
  "register.message.getCityListFailed": "Échec de l'obtention de la liste des villes",
  "register.message.companyRegisteredChooseAction": "Entreprise déjà enregistrée, veuillez choisir une action",
  "register.message.completeCompanyInfo": "Veuillez compléter les informations de l'entreprise",
  "register.message.completeStaffInfo": "Veuillez compléter les informations du personnel",
  "register.message.enterEmailFirst": "Veuillez d'abord saisir l'adresse e-mail",
  "register.message.correctEmailFormat": "Veuillez saisir le format d'e-mail correct",
  "register.message.verificationCodeSent": "Code de vérification envoyé à : {contact}",
  "register.message.sendVerificationCodeFailed": "Échec de l'envoi du code de vérification",
  "register.message.enterPhoneFirst": "Veuillez d'abord saisir le numéro de téléphone",
  "register.message.correctPhoneFormat": "Veuillez saisir le format de numéro de téléphone correct",
  "register.message.completeAccountInfoAndFixErrors": "Veuillez compléter les informations du compte et corriger les erreurs",
  "register.message.companyRegistrationSuccess": "Enregistrement de l'entreprise réussi !",
  "register.message.companyRegistrationFailed": "Échec de l'enregistrement de l'entreprise",
  "register.message.staffRegistrationSuccess": "Enregistrement du personnel réussi !",
  "register.message.staffRegistrationFailed": "Échec de l'enregistrement du personnel",
  "register.message.phoneRegistrationNotAvailable": "L'inscription par numéro de téléphone n'est actuellement pas disponible. Restez à l'écoute.",
  "register.tooltip.title": "Comment trouver le code d'enregistrement de l'entreprise ?",
  "register.tooltip.appPathTitle": "1. Dans l'application",
  "register.tooltip.appPathDesc": "Allez dans Utilisateur -> touchez l'avatar -> Informations du compte pour voir le code d'enregistrement de l'entreprise.",
  "register.tooltip.webPathTitle": "2. Dans la console Web",
  "register.tooltip.webPathDesc": "Allez dans Gestion de l'organisation -> Informations de l'organisation pour voir le code d'enregistrement de l'entreprise.",
  "registerAccomplish.applicationComplete": "Demande terminée",
  "registerAccomplish.congratulations": "Félicitations, vous avez terminé l'enregistrement.",
  "registerAccomplish.companyRegisterCodeIs": "Votre code d'enregistrement d'entreprise est",
  "registerAccomplish.certificationRequired": "Vous devez vous rendre au centre de certification pour l'authentification, sinon vous ne pourrez pas activer les appareils.",
  "registerAccomplish.greenChannelInfo": "Pour les situations d'urgence spéciales dans les départements, afin de ne pas retarder l'installation sur site, vous pouvez choisir le canal vert pour obtenir une autorisation temporaire d'activation des appareils pendant 2 mois.",
  "registerAccomplish.certificationCenter": "Centre de certification",
  "registerAccomplish.greenChannel": "Canal vert",
  "registerAccomplish.returnToLogin": "Retour à la page de connexion",
  "registerAccomplish.useHaierEnergyApp": "Vous pouvez utiliser l'application Haier Energy pour ajouter des appareils.",
  "registerAccomplish.applyingGreenChannel": "Vous demandez le canal vert",
  "registerAccomplish.greenChannelDescription1": "Ce canal est uniquement destiné à certaines situations d'urgence spéciales, afin d'éviter de retarder l'installation sur site, pour l'activation des appareils.",
  "registerAccomplish.greenChannelDescription2": "Les autorisations de compte obtenues via ce canal sont des autorisations temporaires, et la période de validité pour l'activation des appareils est de 2 mois.",
  "registerAccomplish.greenChannelDescription3": "Vous devez vous rendre au centre de certification dans les 2 mois pour terminer l'authentification et obtenir une autorisation permanente d'activation des appareils.",
  "registerAccomplish.confirmSubmit": "Confirmer la soumission",
  "registerAccomplish.returnToPrevious": "Retour à la page précédente",
  "registerAccomplish.applicationSubmittedSuccessfully": "Votre demande a été soumise avec succès !",
  "registerAccomplish.missingAgentIdParameter": "Paramètre agentId manquant, impossible de demander le canal vert",
  "registerAccomplish.greenChannelApplicationSuccess": "Demande de canal vert réussie !",
  "registerAccomplish.greenChannelApplicationFailed": "Échec de la demande de canal vert",
  "registerAccomplish.enterSystem": "Entrer dans le système",
  "registerAccomplish.pleaseLoginFirst": "Veuillez d'abord vous connecter",
  "org.phoneNumber": "Numéro de téléphone",
  "org.certificationStatus": "Statut de certification",
  "org.permission": "Permission",
  "org.accountSource": "Source du compte",
  "org.certificationStatusTip": "Actuellement limité aux permissions d'ajout d'appareils dans l'application Haier Energy",
  "org.unauthenticated": "Non authentifié",
  "org.authenticated": "Authentifié",
  "org.noNeedToAuthenticate": "Aucune authentification requise",
  "org.unauthorized": "Non autorisé",
  "org.authorized": "Autorisé",
  "org.temporaryAuthorization": "Autorisation temporaire",
  "org.remainingDays": "Jours restants : {scope} jours",
  "org.allocated": "Alloué",
  "org.registered": "Enregistré",
  "org.authorization": "Autorisation",
  "org.addressDetail": "Adresse détaillée",
  "org.postalCode": "Code postal",
  "org.accountSwitch": "Changement de compte",
  "org.viewAccountInfo": "Voir les informations du compte",
  "org.baseInfo": "Informations de base",
  "org.certificationInfo": "Informations de certification",
  "org.restDays": "Jours restants",
  "org.applyTime": "Date de demande",
  "org.certificationTime": "Date de certification",
  "org.registerCode": "Code d'inscription",
  "org.registrationTip": "Lors de l'inscription, vous pouvez saisir le code d'inscription de l'entreprise pour demander à en devenir membre.",
  "org.authenticationTip": "Ce compte a été désactivé et ne peut pas être autorisé.",
  "org.authenticationTip2": "Ce compte a déjà été autorisé ou bénéficie d'une autorisation temporaire encore valide ; une nouvelle autorisation n'est pas possible.",
  "org.temporaryAuthorizationTip": "L'autorisation est temporaire par défaut, d'une durée de 3 mois.",
  "org.temporaryAuthorizationSuccess": "Autorisation réussie",
  "shipment.deviceSource": "Source d'expédition",
  "shipment.shippingCustomer": "Client d'expédition",
  "shipment.customerContact": "Contact client",
  "shipment.tag": "Étiquette",
  "shipment.addTag": "Ajouter une étiquette",
  "shipment.editTag": "Modifier l'étiquette",
  "shipment.tagContent": "Contenu de l'étiquette",
  "shipment.tagColor": "Couleur de l'étiquette",
  "placeholder.selectShippingCustomer": "Veuillez sélectionner le client d'expédition",
  "placeholder.enterCustomerContact": "Veuillez saisir le contact client",
  "placeholder.selectTag": "Veuillez sélectionner une étiquette",
  "placeholder.enterTagContent": "Veuillez saisir le contenu de l'étiquette",
  "placeholder.noResult": "Aucune étiquette correspondante",
  "validation.enterTagContent": "Veuillez saisir le contenu de l'étiquette",
  "validation.selectTagColor": "Veuillez sélectionner la couleur de l'étiquette",
  "shipment.operationRecordTitle": "Vorgangshistorie",
  "shipment.boundUserWarning": "Dieses Gerät ist bereits einem Benutzer zugeordnet, der Versandkunde kann nicht mehr geändert werden.",
  "shipment.batchBoundUserWarning": "Entschuldigung, die ausgewählten Geräte enthalten Geräte, die bereits Benutzern zugeordnet sind. Der Versandkunde kann nicht in größeren Mengen aktualisiert werden.",
  "shipment.uploadEquipmentListRequired": "Bitte laden Sie die Gerätelisten-Datei hoch",
  "shipment.errorDataTipTitle": "Hinweis zu fehlerhaften Daten",
  "shipment.downloadImportResult": "Importergebnis herunterladen",
  "shipment.downloading": "Wird heruntergeladen...",
  "shipment.noFailedDataToDownload": "Keine fehlgeschlagenen Daten zum Herunterladen vorhanden",
  "shipment.deleteTagConfirm": "Möchten Sie das Tag \"{tagName}\" wirklich löschen?",
  "common.addSuccess": "Erfolgreich hinzugefügt",
  "common.editSuccess": "Erfolgreich bearbeitet",
  "tip.device.deliveryWarning": "Désolé, cet appareil a été livré aux utilisateurs finaux et ne peut pas être supprimé. Vous pouvez d'abord aller à la gestion des centrales, retirer la livraison, puis supprimer l'appareil.",
  "common.ok": "OK",
  "register.contactAdminForCode": "Veuillez contacter votre administrateur d'entreprise pour obtenir le code d'enregistrement de l'entreprise",
  "register.provideCompanyInfoBelow": "Veuillez fournir les informations de l'entreprise ci-dessous",
  "login.success": "Connexion réussie",
  "flowData.existingInvTip": "Remarque :\nINV existant > 0 signifie que l'énergie solaire produit de l'électricité ;\nINV existant < 0 signifie que l'onduleur consomme de l'électricité.",
  "flowData.alert": "La valeur actuelle INV existant < 0 indique que l'onduleur externe consomme de l'énergie.",
  "dialog.confirm": "J'ai compris",
  "paramters.deviceTotalInformation": "Informations totales sur le dispositif",
  "paramters.innerInverter": "Onduleur interne",
  "paramters.outerInverter": "Onduleur externe",
  "paramters.outerInverterFromPvSide": "Depuis le compteur côté PV",
  "paramters.activePower": "Puissance active",
  "paramters.apparentPower": "Puissance apparente",
  "paramters.reactivePower": "Puissance réactive",
  "paramters.powerFactor": "Facteur de puissance",
  "paramters.phaseA": "Phase A",
  "paramters.phaseB": "Phase B",
  "paramters.phaseC": "Phase C",
  "paramters.charge": "Charger",
  "paramters.discharge": "Décharger",
  "paramters.sell": "Vendre de l'électricité",
  "paramters.buy": "Acheter de l'électricité",
  "bw_param_ctrl_group_WorkMode": "Mode défectueux",
  "bw_param_ctrl_name_GRID_Meter_negate": "GRID_Meter_négation",
  "bw_param_ctrl_name_GridBreake": "brise grille",
  "bw_param_ctrl_name_BBSOC_lx1": "SOC pour coupure de puissance L1",
  "bw_param_ctrl_name_BBSOC_lx2": "SOC pour coupure de puissance L2",
  "bw_param_ctrl_name_BBSOC_lx3": "SOC pour coupure de puissance L3",
  "bw_param_ctrl_option_ON": "ON",
  "bw_param_ctrl_name_Systemmode": "Mode système",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS Réserve Soc",
  "bw_param_ctrl_option_OFF": "OFF",
  "bw_param_ctrl_option_B5": "Modèle monophasé 5Kw",
  "bw_param_ctrl_name_InvSub": "Inv sous",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "MAX Pourcentage de grille d'alimentation",
  "bw_param_ctrl_option_T4": "Modèle triphasé 4 Kw",
  "bw_param_ctrl_option_T5": "Modèle 5Kw triphasé",
  "bw_param_ctrl_option_T6": "Modèle 6Kw triphasé",
  "bw_param_ctrl_option_T8": "Modèle 8 Kw triphasé",
  "bw_param_ctrl_option_S3": "Modèle de stockage d'énergie monophasé de 3 kW",
  "bw_param_ctrl_option_S5": "Modèle de stockage d'énergie monophasé 5Kw",
  "bw_param_ctrl_option_S6": "Modèle de stockage d'énergie monophasé 6Kw",
  "bw_param_ctrl_option_S8": "Modèle de stockage d'énergie monophasé 8Kw",
  "bw_param_ctrl_option_Grid&PV useCT": "Grille&PV utilisation CT",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "Rapport entre la puissance d'alimentation maximale et la capacité installée (y compris toute la capacité photovoltaïque connectée à l'inverseur photovoltaïque et à l'inverseur de stockage d'énergie)",
  "bw_param_ctrl_option_Grid&PVUseMeter": "Grid&PVuse compteur",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "Capacité PV totale installée connectée à l'onduleur de stockage d'énergie",
  "bw_param_ctrl_option_T10": "Modèle 10 Kw en trois phases",
  "bw_param_ctrl_name_DispatchReactivepower": "Dispatch Puissance réactive",
  "bw_param_ctrl_name_Grid_Regulation": "Grille_Régulation",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "Activer le contrôle de la période de charge et de décharge",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "Drapeau de contrôle de période",
  "bw_param_ctrl_note_BatteryReady": "La connexion à la batterie par défaut est \"avec batterie\". Si aucune batterie n'est connectée (c'est-à-dire que l'onduleur est connecté au PV mais pas à aucun module de batterie), sélectionnez \"sans batterie\" ou l'unité cherchera une batterie qui n'est pas présente et entrera en mode défaut.",
  "bw_param_ctrl_option_withBattery": "avec batterie",
  "bw_param_ctrl_name_PV_Meter_negate": "PV_Meter_négation",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "Activer uniquement le contrôle de décharge par période",
  "bw_param_ctrl_name_EMSReset": "En Réinitialiser",
  "bw_param_ctrl_name_FactoryReset": "Remise à zéro de l'usine",
  "bw_param_ctrl_name_DSPReset": "En Dsp Reset",
  "bw_param_ctrl_group_RemoteReset": "Réinitialisation à distance",
  "bw_param_ctrl_option_FactoryReset": "Réinitialiser",
  "bw_param_ctrl_option_DSPReset": "Réinitialiser",
  "bw_param_ctrl_option_EMSReset": "Réinitialiser",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "Priorité stratégique L1",
  "bw_param_ctrl_name_BBPrio_lx2": "Priorité de la stratégie L2",
  "bw_param_ctrl_name_BBPrio_lx3": "Priorité de la stratégie L3",
  "bw_param_ctrl_note_BBSOC_lx3": "Le SOC de priorité 3 doit être supérieur au SOC de priorité 1 et au SOC de priorité 2.",
  "bw_param_ctrl_note_BBSOC_lx1": "Le SOC de priorité 1 doit être le minimum SOC de L1, L2 et L3.",
  "bw_param_ctrl_note_BBSOC_lx2": "Le SOC de priorité 2 doit être plus élevé que le SOC de priorité 1.",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "Boîte de sauvegarde activée",
  "bw_param_ctrl_name_MeterCTSelect": "Métre CT Sélectionner",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "Utilisation de la grille CT、Utilisation PV Meter",
  "bw_param_ctrl_name_ChargeCutSoc": "Charge Coupe Soc",
  "bw_param_ctrl_option_HybridMode": "Mode hybride",
  "bw_param_ctrl_name_PVCapacityStorage": "Stockage de capacité PV",
  "bw_param_ctrl_name_DispatchTime": "Temps d'expédition",
  "bw_param_ctrl_name_DispatchStart": "Démarrage de l'expédition",
  "bw_param_ctrl_name_UPSreserveenable": "UPS réserve active",
  "bw_param_ctrl_option_selfuse": "Utilisation personnelle",
  "bw_param_ctrl_option_DCMode": "Mode DC",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "Capacité PV de l'inverseur de réseau",
  "bw_param_ctrl_name_RTC": "RTC",
  "bw_param_ctrl_option_Normal": "Normale",
  "bw_param_ctrl_group_SystemInfo": "Informations système",
  "bw_param_ctrl_note_Systemmode": "DC: 1.Système photovoltaïque nouvellement installé avec onduleur de stockage d'énergie hybride se connectant directement aux panneaux photovoltaïques. 2.Système de batterie sans onduleur photovoltaïque se connectant directement au réseau et uniquement être chargé à partir du réseau.\n\nAC: Rénovation du système photovoltaïque qui comprend un onduleur photovoltaïque se connectant aux panneaux photovoltaïques et au réseau. Les panneaux ne peuvent pas se connecter directement à l'onduleur de stockage d'énergie hybride.\n\nHybride : L'ensemble du système comprend un onduleur photovoltaïque se connectant au réseau et un onduleur de stockage d'énergie hybride se connectant directement aux panneaux photovoltaïques.",
  "bw_param_ctrl_group_GridMeterSettings": "Paramètres Grid Meter",
  "bw_param_ctrl_option_Forced charging and discharging": "Chargement et décharge forcés",
  "bw_param_ctrl_note_ChargeCutSoc": "La limite supérieure de la charge SOC de la batterie.",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "Activer uniquement le contrôle de la période de charge",
  "bw_param_ctrl_option_Disable": "Désactiver",
  "bw_param_ctrl_group_BatterySettings": "Paramètres de batterie",
  "bw_param_ctrl_name_BatteryReady": "Batterie prête",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "Utilisation de la grille Meter、PV utilisation CT",
  "bw_param_ctrl_name_DispatchSOC": "SOC d'expédition",
  "bw_param_ctrl_option_Disable TimePeriodControl": "Désactiver le contrôle de la période de temps",
  "bw_param_ctrl_option_Enable": "Activer",
  "bw_param_ctrl_option_TOU": "TOU",
  "bw_param_ctrl_name_ChargeTimeSlot1": "Fente de temps de charge 1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "Fente de temps de charge 2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "Les paramètres de charge et de décharge ne prennent effet que lorsque le mode \"TOU\" est sélectionné.",
  "bw_param_ctrl_group_GridSafetyConfig": "Configuration de la sécurité de la grille",
  "bw_param_ctrl_group_SystemConfig": "Configuration du système",
  "bw_param_ctrl_option_ACMode": "Mode AC",
  "bw_param_ctrl_option_Reverse": "Inverse",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "La fonction de charge/décharge n’est pas activée",
  "bw_param_ctrl_group_Charge&DischargeSettings": "Paramètres de charge et de décharge",
  "bw_param_ctrl_name_DispatchMode": "Mode d'expédition",
  "bw_param_ctrl_note_GridBreake": "Veuillez sélectionner en fonction des spécifications réelles du disjoncteur du côté grille de l'onduleur. Si les spécifications sont remplies incorrectement, cela peut provoquer le déclenchement du disjoncteur.",
  "bw_param_ctrl_note_PVCapacityStorage": "Capacité PV totale installée connectée à l'onduleur PV",
  "bw_param_ctrl_name_DischargeTimeSlot2": "Fente de temps de décharge 2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "Fente de temps de décharge 1",
  "bw_param_ctrl_group_GridDispatch": "Dispatch grille",
  "bw_param_ctrl_name_DispatchActivepower": "Envoi puissance active",
  "jl_param_ctrl_group_OnOff": "Marche/Arrêt onduleur",
  "jl_param_ctrl_name_OnOff": "Marche/Arrêt onduleur",
  "jl_param_ctrl_option_PowerOFF": "Arrêt",
  "jl_param_ctrl_option_PowerON": "Marche",
  "product.multipleLanguage": "Paramètres multilingues du modèle d'objet",
  "product.multipleLanguageNote": "Bibliothèque de termes multilingue du modèle d'objet",
  "product.entryCode": "Code du terme",
  "product.entryValue": "Valeur du terme",
  "product.endpoint": "Point de terminaison",
  "product.module": "Module",
  "product.tag": "Étiquette",
  "product.editLanguage": "Modifier le multilingue",
  "product.addLanguage": "Ajouter une langue",
  "product.maintainInfo": "Informations de maintenance",
  "product.statusChangeSuccess": "Statut mis à jour avec succès",
  "product.statusChangeFail": "Échec de la mise à jour du statut",
  "product.syncIotI18n": "Synchroniser les entrées du modèle IoT Qingluo",
  "product.confirmSyncIotI18n": "Êtes-vous sûr de vouloir synchroniser les entrées du modèle IoT Qingluo?",
  "button.sync": "Synchroniser le pack multilingue",
  "plant.withdrawDelivery": "Lieferung zurückziehen",
  "plant.deliverUser": "Benutzer übergeben",
  "plant.withdrawDeliveryTip": "Nach dem Zurückziehen der Lieferung kann der Endnutzer dieses Kraftwerk nicht mehr verwalten. Bitte vorsichtig vorgehen.",
  "plant.undelivered": "Nicht übergeben",
  "plant.deliverManage": "Übergabe-Verwaltung",
  "plant.email_format_error": "E-Mail-Formatfehler",
  "plant.deliverUserTip": "Hinweis: Nutzer können sich bei Haier Energy mit ihrer E-Mail anmelden und die installierten Geräte über die App überwachen und steuern.",
  "plant.enterUserAccount": "Veuillez saisir le compte utilisateur",
  "plant.deliverUserTipUnified": "Remarque : lorsque les utilisateurs se connectent a Haier Energy avec leur numero de telephone ou leur e-mail, ils peuvent surveiller et controler vos appareils installes via l'application.",
  "plant.placeholderPhoneOrEmail": "Saisissez le numero de telephone ou l'e-mail",
  "plant.phoneOrEmailFormatError": "Veuillez saisir un numero de telephone ou un e-mail valide",
  "plant.deliverSuccess": "Übergabe erfolgreich",
  "plant.known": "Verstanden",
  "plant.notRegistered": "Nicht registriert",
  "plant.noPermission": "Sie haben keine Berechtigung, die Übergabe zurückzuziehen. Nur Plattform-Superadmins und Installateur-Admins dürfen dies tun.",
  "plant.scanQRCode": "Bitte lassen Sie den Eigentümer den untenstehenden QR-Code scannen",
  "plant.qrCodeExpireTip": "Dieser Autorisierungscode wird nach erfolgreichem Empfang ungültig.",
  "plant.transferMethod": "Mode de transfert",
  "plant.transferRecord": "Historique des transferts",
  "plant.operationTime": "Heure de l'opération",
  "plant.operator": "Opérateur",
  "plant.transferType": "Type de transfert",
  "plant.userIdentifier": "Identifiant utilisateur",
  "plant.transferResult": "Résultat du transfert",
  "plant.totalRecordCount": "Total de {count} enregistrements",
  "device.Yield": "Yield",
  "device.ExistingINV": "Existing INV",
  "sidebar.dictManage": "Gestion du dictionnaire",
  "subtitle.dictData": "Données du dictionnaire",
  "dict.dictname": "Libellé du dictionnaire",
  "dict.dictnameen": "Clé du dictionnaire",
  "dict.dictdataname": "Libellé des données",
  "dict.dictdatavalue": "Valeur des données",
  "dict.i18nCode": "Code de langue",
  "dict.dictsort": "Ordre de tri",
  "dict.addDict": "Ajouter un dictionnaire",
  "dict.addDictData": "Ajouter une entrée de dictionnaire",
  "dict.editDict": "Modifier le dictionnaire",
  "dict.editDictData": "Modifier l’entrée du dictionnaire",
  "device.otaTabTip": "Remarque : une fois la mise à niveau terminée, l’appareil sera temporairement hors ligne. Veuillez redémarrer l’appareil.",
  "product.accessPlatform": "Plattformquelle",
  "product.valueFilter": "Valeur de terme vide",
  "setting.type22.restrictCounterCurrent.val1": "Limiter la puissance totale triphasée",
  "setting.type22.restrictCounterCurrent.val2": "Limiter la puissance monophasée",
  "setting.type22.disable": "Désactiver",
  "setting.type22.enable": "Activer",
  "setting.type22.meterSelect.str": "Compteur Stonray",
  "setting.type22.meterSelect.df": "Compteur Dongfan",
  "setting.type22.meterSelect.dh": "Compteur Donghong",
  "setting.type22.meterSelect.zt": "Compteur Chint",
  "setting.type22.meterSelect.yb": "Yeebon",
  "setting.type22.meterSelect.yz": "Ingeteam",
  "setting.type22.meterSelect.nky": "Compteur intelligent Nengkongyun",
  "workorder.searchCreateTime": "Date de création",
  "workorder.statusAll": "Tous",
  "workorder.statusPending": "En attente",
  "workorder.statusCompleted": "Terminé",
  "workorder.statusClosed": "Fermé",
  "workorder.no": "N° d'ordre de travail",
  "workorder.tableDescription": "Description",
  "workorder.plant": "Usine",
  "workorder.device": "Appareil",
  "workorder.tableStatus": "Statut",
  "workorder.owner": "Personne responsable",
  "workorder.handler": "Traité par",
  "workorder.handledTime": "Date de traitement",
  "workorder.creator": "Créateur",
  "workorder.createTime": "Date de création",
  "workorder.timeTooltip": "Heure dans le fuseau horaire de l'usine",
  "workorder.tableAction": "Opération",
  "workorder.actionDetails": "Détails",
  "workorder.actionHandle": "Traiter",
  "workorder.actionCancel": "Annuler",
  "workorder.createTitle": "Créer un ordre de travail",
  "workorder.description": "Description de la panne",
  "workorder.images": "Images de la panne",
  "workorder.handleTitle": "Traiter l'ordre de travail",
  "workorder.group": "Informations de traitement",
  "workorder.feedback": "Retour de traitement",
  "workorder.handleimages": "Images du traitement",
  "workorder.detailsTitle": "Détails de l'ordre de travail",
  "workorder.detailsGroup": "Informations sur l'ordre de travail",
  "workorder.uploadSuccess": "Téléchargement réussi",
  "workorder.uploadNums": "Maximum 3 images autorisées",
  "workorder.uploadFormatTip": "Format de fichier invalide. Veuillez télécharger des fichiers aux formats JPG, JPEG ou PNG",
  "workorder.uploadFormat": "Veuillez télécharger des fichiers ne dépassant pas 5 MB aux formats PNG/JPG/JPEG",
  "workorder.uploadImage": "Télécharger",
  "workorder.cancelTip": "L'annulation de cet ordre de travail le fermera automatiquement. Continuer ?",
  "workorder.basicInformation": "Informations de base",
  "common.networkUnstable": "La connexion réseau a été perdue, veuillez vérifier vos paramètres réseau",
  "common.networkFull": "Internet est à nouveau aussi plein que le soleil",
  "common.networkSlow": "Le réseau actuel est lent, veuillez patienter ou vérifier les paramètres réseau",
  "common.requestTimeout": "La demande a expiré, veuillez vérifier le réseau ou réessayer plus tard",
  "screen.platform": "Plateforme de Gestion de l'Énergie",
  "plantScreen.title": "Gestion de centrale",
  "plantScreen.DailyElectricityGenerated": "Électricité générée quotidienne",
  "plantScreen.DailyElectricityUsed": "Électricité consommée quotidienne",
  "plantScreen.DailyElectricityPurchased": "Électricité achetée quotidienne",
  "plantScreen.DailyElectricitySold": "Électricité vendue quotidienne",
  "plantScreen.ChargingStatus": "Statut de charge",
  "plantScreen.BatteryLevel": "Niveau de batterie",
  "plantScreen.PhotovoltaicStatus": "Statut photovoltaïque",
  "plantScreen.GridStatus": "Statut du réseau",
  "plantScreen.Charging": "En charge",
  "plantScreen.Discharging": "En décharge",
  "plantScreen.Generating": "En génération",
  "plantScreen.Idle": "Inactif",
  "plantScreen.pvIDLE": "Non génération",
  "plantScreen.BuyingElectricity": "Achat d'électricité",
  "plantScreen.SellingElectricity": "Vente d'électricité",
  "plantScreen.netdead": "Hors réseau",
  "plantScreen.day": "Jour",
  "plantScreen.month": "Mois",
  "plantScreen.year": "Année",
  "plantScreen.life": "Cumulé",
  "plantScreen.BatterySOC": "SOC batterie",
  "plantScreen.PowerAnalysis": "Analyse de puissance",
  "plantScreen.EquivalentRevenue": "Revenu équivalent",
  "plantScreen.EnergyAnalysis": "Analyse d'énergie",
  "plantScreen.SocialContribution": "Contribution sociale",
  "plantScreen.Photovoltaic": "Photovoltaïque",
  "plantScreen.Grid": "Réseau",
  "plantScreen.Battery": "Batterie",
  "plantScreen.Load": "Charge",
  "plantScreen.Daily": "Quotidien",
  "plantScreen.Monthly": "Mensuel",
  "plantScreen.Yearly": "Annuel",
  "plantScreen.Cumulative": "Cumulé",
  "plantScreen.Unit": "Unité",
  "plantScreen.ElectricityGeneration": "Production d'électricité",
  "plantScreen.ElectricityConsumption": "Consommation d'électricité",
  "plantScreen.ChartSet.explain": "Note : Puissance > 0 = Décharge; Puissance < 0 = Charge.",
  "plantScreen.ChartSet.Self-consumption": "Auto-consommation",
  "plantScreen.ChartSet.GridElectricity": "Injection réseau",
  "plantScreen.ChartSet.Self-Sufficiency": "Autosuffisance",
  "plantScreen.ChartSet.PurchasedElectricity": "Électricité achetée",
  "plantScreen.ChartSet.PVPower": "Puissance PV",
  "plantScreen.ChartSet.ConsumptionPower": "Puissance consommée",
  "plantScreen.ChartSet.BatterySOC": "SOC batterie",
  "plantScreen.ChartSet.BatteryChargingPower": "Puissance de charge batterie",
  "plantScreen.ChartSet.BatteryDischargingPower": "Puissance de décharge batterie",
  "plantScreen.ProtectedForest": "Forêt protégée",
  "plantScreen.CO2Emission": "Émission CO2",
  "plantScreen.Media": "Charbon",
  "plant.EquivalentBenefit.GridView": "Revenu équivalent = Autoconsommation * Tarif d'achat + Injection réseau * Tarif de vente",
  "plant.MonitoringScreen": "Écran de surveillance",
  "plantScreen.ChartSet.explainPower": "Note : Puissance du réseau > 0 = Vente d'électricité; Puissance du réseau < 0 = Achat d'électricité.",
  "priceConfig.currentEffectivePrice": "Tarif actuellement en vigueur",
  "priceConfig.currencyUnitLabel": "Unité monétaire :",
  "priceConfig.addPrice": "Ajouter un tarif",
  "priceConfig.effectiveTimeLabel": "Période de validité",
  "priceConfig.powerPrice": "Tarif de l'énergie",
  "priceConfig.additionalFees": "Frais supplémentaires",
  "priceConfig.lastUpdateTime": "Dernière mise à jour",
  "priceConfig.lastUpdateTimeLabel": "Dernière mise à jour",
  "priceConfig.emptyCurrent": "Aucun tarif en vigueur. Cliquez sur le bouton pour configurer.",
  "priceConfig.emptyUpcoming": "Aucun tarif à venir",
  "priceConfig.upcomingTitle": "Tarifs à venir",
  "priceConfig.copyPriceTitle": "Copier le tarif",
  "priceConfig.deletePriceTitle": "Supprimer le tarif",
  "priceConfig.deleteConfirmText": "Veuillez confirmer la suppression du tarif suivant",
  "priceConfig.otherPrice": "Autres frais",
  "priceConfig.deleteWarning": "Si ce tarif est actuellement en vigueur, cela affectera le calcul des revenus et l'exécution de la stratégie IA.",
  "priceConfig.priceTypeLabel": "Type de tarif",
  "priceConfig.timeOfUse": "Heures pleines / creuses",
  "priceConfig.dynamic": "Dynamique",
  "priceConfig.timeOfUsePrice": "Tarif heures pleines / creuses",
  "priceConfig.dynamicPrice": "Tarif dynamique",
  "priceConfig.effectiveDatePlaceholder": "Veuillez sélectionner une date d'effet",
  "priceConfig.copyEffectiveDatePlaceholder": "Veuillez sélectionner une date d'effet",
  "priceConfig.nextStep": "Suivant",
  "priceConfig.buyPriceTitle": "Tarif d'achat",
  "priceConfig.feedInPriceTitle": "Tarif d'injection",
  "priceConfig.addTimePeriod": "Ajouter une plage horaire",
  "priceConfig.electricitySurchargeTitle": "Surcharge énergie",
  "priceConfig.electricitySurchargeTooltip": "Frais supplémentaires par kWh acheté.",
  "priceConfig.fixedFeeTitle": "Abonnement fixe",
  "priceConfig.fixedFeeTooltip": "Montant fixe par période de facturation, indépendant de la consommation ou de la puissance.",
  "priceConfig.hasFeeYes": "Oui",
  "priceConfig.countryLabel": "Pays",
  "priceConfig.secondaryRegionLabel": "Région secondaire",
  "priceConfig.secondaryRegionPlaceholder": "Veuillez sélectionner une région secondaire",
  "priceConfig.currencyUnitPlaceholder": "Veuillez sélectionner une unité monétaire",
  "priceConfig.powerMarketLabel": "Marché de l'électricité",
  "priceConfig.powerMarketPlaceholder": "Veuillez sélectionner un marché de l'électricité",
  "priceConfig.electricitySurchargePlaceholder": "Max 7 chiffres entiers, 8 décimales, ≥ 0",
  "priceConfig.fixedFeePlaceholder": "Max 7 chiffres entiers, 8 décimales, ≥ 0",
  "priceConfig.priceInputPlaceholder": "Saisir le prix électricité (max 7 chiffres entiers, 8 décimales, ≥ 0)",
  "priceConfig.timePlaceholder": "Sélectionner l'heure",
  "priceConfig.selectEffectiveTimeTip": "Veuillez sélectionner une période de validité",
  "priceConfig.selectPriceTypeTip": "Veuillez sélectionner un type de tarif",
  "priceConfig.selectCountryTip": "Veuillez sélectionner un pays",
  "priceConfig.selectSecondaryRegionTip": "Veuillez sélectionner une région secondaire",
  "priceConfig.selectCurrencyUnitTip": "Veuillez sélectionner une unité monétaire",
  "priceConfig.selectPowerMarketTip": "Veuillez sélectionner un marché de l'électricité",
  "priceConfig.electricitySurchargeInputTip": "Veuillez saisir la surcharge énergie (max 7 chiffres entiers, 8 décimales, ≥ 0)",
  "priceConfig.electricitySurchargeRangeTip": "La surcharge énergie : au plus 7 chiffres entiers, 8 décimales, ≥ 0",
  "priceConfig.fixedFeeInputTip": "Veuillez saisir l'abonnement fixe (max 7 chiffres entiers, 8 décimales, ≥ 0)",
  "priceConfig.fixedFeeRangeTip": "L'abonnement fixe : au plus 7 chiffres entiers, 8 décimales, ≥ 0",
  "priceConfig.buyTimeFullDayTip": "Les plages horaires du tarif d'achat doivent couvrir 24 heures",
  "priceConfig.feedInTimeFullDayTip": "Les plages horaires du tarif d'injection doivent couvrir 24 heures",
  "priceConfig.buyTimeNoOverlapTip": "Les plages horaires du tarif d'achat ne peuvent pas se chevaucher",
  "priceConfig.feedInTimeNoOverlapTip": "Les plages horaires du tarif d'injection ne peuvent pas se chevaucher",
  "priceConfig.loadFail": "Échec du chargement des données tarifaires",
  "priceConfig.copySelectPriceTip": "Aucun tarif sélectionné, copie impossible",
  "priceConfig.copyMissingPlantTip": "Informations de centrale manquantes, copie du tarif impossible",
  "priceConfig.copySuccess": "Copie réussie",
  "priceConfig.copyFail": "Échec de la copie",
  "priceConfig.networkTimeout": "Délai d'expiration du réseau. Veuillez réessayer une fois la connexion rétablie.",
  "priceConfig.copyUnsupportedTip": "La copie n'est pas prise en charge pour ce type de tarif",
  "priceConfig.deleteSelectPriceTip": "Aucun tarif sélectionné",
  "priceConfig.deleteIdMissingTip": "Impossible d'obtenir l'ID du tarif, suppression échouée",
  "priceConfig.deleteSuccess": "Suppression réussie",
  "priceConfig.deleteFail": "Échec de la suppression",
  "priceConfig.missingPlantInfoTip": "Informations de centrale manquantes",
  "priceConfig.confirmGiveUpCreateTip": "Êtes-vous sûr de vouloir abandonner cette création de tarif ?",
  "priceConfig.confirmGiveUpEditTip": "Êtes-vous sûr de vouloir abandonner la modification de ce tarif ?",
  "priceConfig.pageTitleAdd": "Ajouter un tarif",
  "priceConfig.pageTitleEdit": "Modifier le tarif",
  "priceConfig.pageTitleView": "Voir le tarif",
  "priceConfig.createSuccess": "Création réussie",
  "priceConfig.editSuccess": "Modification réussie",
  "priceConfig.saveFail": "Échec de l'enregistrement",
  "priceConfig.dateRangePermanent": "{start} jusqu'à permanent",
  "priceConfig.dateRange": "{start} à {end}",
  "priceConfig.routeTitle": "Prix électricité",
  "priceConfig.priceLabel": "Prix",
  "priceConfig.surchargeLabel": "Surcharge",
  "priceConfig.fixedFeeLabel": "Abonnement fixe",
  "button.copy": "Copier",
  "common.view": "Voir",
  "cookie.necessary": "Cookies strictement nécessaires",
  "cookie.performance": "Cookies de performance",
  "cookie.functional": "Cookies fonctionnels",
  "cookie.targeting": "Cookies de ciblage",
  "cookie.necessaryExplain": "Ces cookies sont strictement nécessaires au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes. Ils ne sont généralement activés qu'en réponse à des actions de votre part équivalant à une demande de services, comme la définition de vos préférences de confidentialité, la connexion ou le remplissage de formulaires. Vous pouvez configurer votre navigateur pour bloquer ou vous alerter de la présence de ces cookies, mais certaines parties du site risquent alors de ne pas fonctionner. Ces cookies ne stockent aucune information d'identification personnelle.",
  "cookie.performanceExplain": "Ces cookies nous permettent de comptabiliser les visites et les sources de trafic afin de mesurer et d'améliorer les performances de notre site. Ils nous aident à connaître les pages les plus et les moins populaires et à voir comment les visiteurs naviguent sur le site. Toutes les informations collectées par ces cookies sont agrégées et donc anonymes. Si vous n'autorisez pas ces cookies, nous ne saurons pas quand vous avez visité notre site et nous ne pourrons pas surveiller ses performances.",
  "cookie.functionalExplain": "Ces cookies permettent au site web de fournir des fonctionnalités améliorées et une personnalisation. Ils peuvent être définis par nous ou par des fournisseurs tiers dont nous avons ajouté les services à nos pages. Si vous n'autorisez pas ces cookies, certains ou tous ces services peuvent ne pas fonctionner correctement.",
  "cookie.targetingExplain": "Ces cookies peuvent être installés sur notre site par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous montrer des publicités pertinentes sur d'autres sites. Ils ne stockent pas directement d'informations personnelles mais sont basés sur l'identification unique de votre navigateur et de votre appareil internet. Si vous n'autorisez pas ces cookies, vous bénéficierez d'une publicité moins ciblée.",
  "cookie.necessaryAccount": "Vérification d'identité",
  "cookie.necessaryAccountExplain": "Utilisé pour maintenir l'état de connexion de l'utilisateur, c'est une fonction essentielle de l'authentification du site web et de la gestion de session. Sans ce cookie, les comptes utilisateurs risquent de ne pas s'afficher correctement sur les pages visitées.",
  "cookie.sessionManagement": "Gestion de session",
  "cookie.sessionManagementExplain": "Utilisé pour identifier de manière unique les sessions utilisateur, en maintenant des fonctions clés telles que l'état de connexion de l'utilisateur, le contenu du panier d'achat et les données de formulaire.",
  "cookie.userInfo": "Informations utilisateur",
  "cookie.userInfoExplain": "Utilisé pour suivre des indicateurs commerciaux tels que les pages vues (PV) et les visiteurs uniques (UV), analyser le trafic système et l'engagement des utilisateurs, afin d'optimiser la priorisation des fonctionnalités et l'adéquation aux besoins fondamentaux.",
  "cookie.deviceInfo": "Informations sur l'appareil",
  "cookie.deviceInfoExplain": "Basé sur différents systèmes d'exploitation, modèles d'appareils et types de navigateurs, il résout les problèmes de mise en page et de compatibilité entre les terminaux, optimisant les fonctions d'adaptation pour différents appareils.",
  "cookie.pageInfo": "Informations sur la page",
  "cookie.pageInfoExplain": "Enregistre les chemins d'accès aux pages, les requêtes API et les temps de chargement des ressources pour identifier les goulots d'étranglement des performances, les échecs de requête et les erreurs de code, aidant ainsi l'équipe de développement à résoudre rapidement les problèmes.",
  "cookie.networkInfo": "Informations réseau",
  "cookie.networkInfoExplain": "Analyse la localisation géographique et les réseaux des fournisseurs d'accès à Internet (FAI) pour identifier les accès malveillants et le trafic anormal, optimisant ainsi l'efficacité de la diffusion de contenu pour les fournisseurs de services cloud.",
  "cookie.userPreference": "Préférences d'interface",
  "cookie.userPreferenceExplain": "Utilisé uniquement pour enregistrer les préférences de l'interface utilisateur afin d'améliorer l'expérience utilisateur, ce n'est pas une fonction essentielle requise pour le fonctionnement du site web.",
  "cookie.longTerm": "Long terme",
  "cookie.duration180": "180 jours",
  "cookie.durationSession": "Session",
  "cookie.bannerExplain": "Pour optimiser votre expérience de navigation, nous utilisons des cookies principalement pour enregistrer l'état de connexion, mémoriser vos préférences et nous adapter à vos habitudes de navigation. Cliquer sur 'Tout accepter' signifie que vous acceptez notre politique en matière de cookies.",
  "cookie.acceptNecessary": "Nécessaires uniquement",
  "cookie.openPreferences": "Paramètres des préférences",
  "cookie.acceptAll": "Tout accepter",
  "cookie.cookieSet": "Paramètres des cookies",
  "cookie.cookieSetExplain": "Pour plus d'informations, voir",
  "cookie.cookiePolicy": "Politique relative aux cookies",
  "cookie.cookieCategory": "Catégorie de cookie",
  "cookie.cookieName": "Nom du cookie",
  "cookie.cookieDescription": "Finalité",
  "cookie.cookieDuration": "Durée de validité",
  "cookie.cookieSwitch": "Interrupteur",
  "cookie.savePreferences": "Enregistrer les préférences",
  "cookie.preferencesTitle": "Préférences en matière de cookies",
  "cookie.cookiePolicyText": "Politique en matière de cookies",
  "common.currentVersion": "Version actuelle",
  "common.versionUpdateNotice": "Notification de mise à jour de version",
  "common.later": "Plus tard",
  "common.immediateUpdate": "Mise à jour immédiate",
  "sidebar.policyConfig": "Configuration de la politique",
  "common.addScope": "Ajouter {scope}",
  "editor.header.title": "En-tête",
  "editor.header.text": "Paragraphe",
  "editor.fontSize.title": "Taille de police",
  "editor.fontSize.default": "Taille de police par défaut",
  "editor.fontFamily.title": "Police",
  "editor.fontFamily.default": "Police par défaut",
  "editor.bold": "Gras",
  "editor.italic": "Italique",
  "editor.underline": "Souligné",
  "editor.through": "Barré",
  "editor.code": "Code en ligne",
  "editor.sub": "Indice",
  "editor.sup": "Exposant",
  "editor.clearStyle": "Effacer le formatage",
  "editor.color.color": "Couleur du texte",
  "editor.color.bgColor": "Couleur d'arrière-plan",
  "editor.color.default": "Couleur par défaut",
  "editor.color.clear": "Effacer la couleur",
  "editor.bulletedList": "Liste à puces",
  "editor.numberedList": "Liste numérotée",
  "editor.todo": "Liste de tâches",
  "editor.todo.title": "À faire",
  "editor.emotion.title": "Émojis",
  "editor.justifyLeft": "Aligner à gauche",
  "editor.justifyRight": "Aligner à droite",
  "editor.justifyCenter": "Centrer",
  "editor.justifyJustify": "Justifier",
  "editor.indent": "Augmenter l'indentation",
  "editor.delIndent": "Réduire l'indentation",
  "editor.lineHeight.title": "Hauteur de ligne",
  "editor.lineHeight.default": "Hauteur de ligne par défaut",
  "editor.blockquote": "Citation",
  "editor.link.insert": "Insérer un lien",
  "editor.link.text": "Texte du lien",
  "editor.link.url": "URL du lien",
  "editor.link.unLink": "Supprimer le lien",
  "editor.link.edit": "Modifier le lien",
  "editor.link.view": "Voir le lien",
  "editor.image.netImage": "Image web",
  "editor.image.delete": "Supprimer l'image",
  "editor.image.edit": "Modifier l'image",
  "editor.image.viewLink": "Voir le lien",
  "editor.image.src": "URL de l'image",
  "editor.image.desc": "Description de l'image",
  "editor.image.link": "Lien de l'image",
  "editor.video.insert": "Insérer une vidéo",
  "editor.video.delete": "Supprimer la vidéo",
  "editor.video.uploadVideo": "Télécharger une vidéo",
  "editor.video.insertVideo": "Insérer une vidéo",
  "editor.video.videoSrc": "URL de la vidéo",
  "editor.video.videoSrcPlaceHolder": "Veuillez entrer l'URL de la vidéo",
  "editor.video.videoPoster": "Affiche de la vidéo",
  "editor.video.videoPosterPlaceHolder": "Veuillez entrer l'URL de l'affiche",
  "editor.video.ok": "OK",
  "editor.video.editSize": "Modifier la taille",
  "editor.video.width": "Largeur",
  "editor.video.height": "Hauteur",
  "editor.table.header": "Tableau",
  "editor.table.insertTable": "Insérer un tableau",
  "editor.table.deleteTable": "Supprimer le tableau",
  "editor.table.insertRow": "Insérer une ligne",
  "editor.table.deleteRow": "Supprimer une ligne",
  "editor.table.insertCol": "Insérer une colonne",
  "editor.table.deleteCol": "Supprimer une colonne",
  "editor.table.widthAuto": "Largeur automatique",
  "editor.table.widthFixed": "Largeur fixe",
  "editor.codeBlock.title": "Bloc de code",
  "editor.divider": "Ligne de séparation",
  "editor.emotion": "Émojis",
  "editor.insertFormula": "Insérer une formule",
  "editor.fullScreen": "Plein écran",
  "editor.undo": "Annuler",
  "editor.redo": "Rétablir",
  "editor.delete": "Supprimer",
  "editor.enter": "Entrée",
  "editor.ok": "OK",
  "editor.cancel": "Annuler",
  "editor.uploadImgMaxSize": "Taille max image",
  "editor.uploadImgMaxSizeErr": "La taille de l'image dépasse la limite",
  "editor.uploadImgMaxLength": "Nombre max d'images",
  "editor.uploadImgMaxLengthErr": "Le nombre d'images dépasse la limite",
  "editor.uploadVideoMaxSize": "Taille max vidéo",
  "editor.uploadVideoMaxSizeErr": "La taille de la vidéo dépasse la limite",
  "editor.placeholder": "Veuillez entrer du contenu...",
  "UserHome.plantFlow.load": "Charge",
  "UserHome.plantFlow.grid": "Réseau",
  "UserHome.plantFlow.battery": "Batterie",
  "UserHome.plantFlow.pv": "PV",
  "plant.running.status.alarm": "Alarme",
  "end.web": "web",
  "test.label_G_P_C_L2": "Gen L2 Leistung",
  "device.offline": "Appareil hors ligne",
  "solid.snake.msf.test": "",
  "bigboss.shaed.test": "",
  "ywt.60419.AllowCounterCurrentPower": "Puissance de reflux autorisée",
  "ywt.60419.internalharderror0": "Aucune anomalie",
  "ywt.60419.loadDropMode": "Mode de réduction de charge",
  "ywt.60419.loadDropMode11": "Réduction de puissance en cas de flux inverse sur une seule machine",
  "ywt.60419.meterCommQuality": "Qualité de communication du compteur électrique",
  "ywt.60419.meterRPower": "Puissance de phase R du compteur électrique",
  "ywt.60419.meterSelect": "Sélection du compteur électrique",
  "ywt.60419.meterSPower": "Puissance de phase S du compteur électrique",
  "ywt.60419.meterTPower": "Puissance de phase T du compteur électrique",
  "ywt.60419.multiReverseFlowEnable": "Activation de la protection contre le reflux multi-appareils",
  "ywt.60419.restrictCounterCurrent": "Mode de limitation du reflux",
  "ywt.60419.singleReverseFlowEnable": "Activation de la protection contre le reflux pour un seul appareil",
  "bw_param_ctrl_group_ParallelSetting": "Paramètres parallèles",
  "bw_param_ctrl_group_SpecialSetting": "Paramètres spéciaux",
  "bw_param_ctrl_name_PhaseOrderResume": "Reprise de l'ordre des phases",
  "bw_param_ctrl_note_ParallelModeSetting": "Pour définir si l'onduleur est une unité maître ou esclave en fonctionnement parallèle.",
  "bw_param_ctrl_option_host": "Maître en mode parallèle",
  "bw_param_ctrl_option_PhaseOrderResume": "Réinitialiser",
  "bw_param_ctrl_option_single": "Mode non parallèle (Mode simple)",
  "bw_param_ctrl_option_Slave": "Esclave en mode parallèle",
  "0X3809-F-0607": "Défaut protection surchauffe bornes PV",
  "0X3809-F-1103": "Anomalie autotest relais",
  "0X3809-F-3112": "Défaut verrouillage phase tension réseau",
  "0X3809-F-3113": "Anomalie séquence de phases réseau",
  "0X3809-S-0101": "1. Vérifiez si les connexions des modules PV sont normales et si les modules présentent des dommages, de la poussière en surface ou des ombrages.\n2. Vérifiez si les modules PV sont correctement connectés et si leurs spécifications de tension sont supérieures à la plage de tension de fonctionnement de l'onduleur.\n3. Vérifiez s'il y a un court-circuit dans les modules PV.",
  "0X3809-S-0102": "1. Vérifiez si les connexions des modules PV sont normales et si les modules présentent des dommages, de la poussière en surface ou des ombrages.\n2. Vérifiez si les modules PV sont correctement connectés et si leurs spécifications de tension sont supérieures à la plage de tension de fonctionnement de l'onduleur.\n3. Vérifiez s'il y a un court-circuit dans les modules PV.",
  "0X3809-S-0103": "1. Vérifiez si les connexions des modules PV sont normales et si les modules présentent des dommages, de la poussière en surface ou des ombrages.\n2. Vérifiez si les modules PV sont correctement connectés et si leurs spécifications de tension sont supérieures à la plage de tension de fonctionnement de l'onduleur.\n3. Vérifiez s'il y a un court-circuit dans les modules PV.",
  "0X3809-S-0301": "1. Se produit souvent tôt le matin ; veuillez vérifier la propreté de la surface du panneau PV.\n2. Vérifiez si les panneaux PV sont correctement connectés et si leurs spécifications de tension dépassent la plage de tension de fonctionnement de l'onduleur.\n3. Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0302": "1. Se produit souvent tôt le matin ; veuillez vérifier la propreté de la surface du panneau PV.\n2. Vérifiez si les panneaux PV sont correctement connectés et si leurs spécifications de tension dépassent la plage de tension de fonctionnement de l'onduleur.\n3. Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0303": "1. Se produit souvent tôt le matin ; veuillez vérifier la propreté de la surface du panneau PV.\n2. Vérifiez si les panneaux PV sont correctement connectés et si leurs spécifications de tension dépassent la plage de tension de fonctionnement de l'onduleur.\n3. Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0304": "1. Se produit souvent tôt le matin ; veuillez vérifier la propreté de la surface du panneau PV.\n2. Vérifiez si les panneaux PV sont correctement connectés et si leurs spécifications de tension dépassent la plage de tension de fonctionnement de l'onduleur.\n3. Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0501": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0502": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0503": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0504": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0505": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0506": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0507": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0508": "Veuillez redémarrer l'onduleur. Si le défaut persiste, veuillez contacter votre revendeur.",
  "0X3809-S-0601": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0602": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0603": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0604": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0605": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0606": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0607": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le conduit d'air du radiateur est obstrué\n3. Redémarrez l'onduleur après refroidissement. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0701": "1. Vérifiez si le module présente un défaut à la terre.\n2. Vérifiez la présence de connexions desserrées dans le circuit CC.\n3. Si aucun problème n'est détecté dans le circuit CC, coupez l'alimentation pendant 5 minutes, puis rétablissez-la. Si le problème persiste, contactez votre revendeur.",
  "0X3809-S-0801": "1. Défaut du circuit de commande.\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, contactez votre revendeur.",
  "0X3809-S-0901": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0902": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0903": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0904": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0905": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0906": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-0907": "1. Défaut de la carte de commande\n2. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-1001": "1. Si cela se produit occasionnellement, cela peut être dû à des anomalies occasionnelles des lignes externes. Redémarrer l'onduleur rétablira un fonctionnement normal.\n2. Si cela se produit fréquemment ou ne peut être rétabli pendant une longue période, veuillez vérifier si la mise à la terre des chaînes photovoltaïques est fiable.",
  "0X3809-S-1002": "1. Si cela se produit occasionnellement, cela peut être dû à des anomalies occasionnelles des lignes externes. Redémarrer l'onduleur rétablira un fonctionnement normal.\n2. Si cela se produit fréquemment ou ne peut être rétabli pendant une longue période, veuillez vérifier si la mise à la terre des chaînes photovoltaïques est fiable.",
  "0X3809-S-1003": "1. Si cela se produit occasionnellement, cela peut être dû à des anomalies occasionnelles des lignes externes. Redémarrer l'onduleur rétablira un fonctionnement normal.\n2. Si cela se produit fréquemment ou ne peut être rétabli pendant une longue période, veuillez vérifier si la mise à la terre des chaînes photovoltaïques est fiable.",
  "0X3809-S-1004": "1. Si cela se produit occasionnellement, cela peut être dû à des anomalies occasionnelles des lignes externes. Redémarrer l'onduleur rétablira un fonctionnement normal.\n2. Si cela se produit fréquemment ou ne peut être rétabli pendant une longue période, veuillez vérifier si la mise à la terre des chaînes photovoltaïques est fiable.",
  "0X3809-S-1101": "1. Vérifiez si le fil de terre du côté AC est sous tension.\n2. Défaut interne du relais.\n3. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1102": "1. Vérifiez si le fil de terre du côté AC est sous tension.\n2. Défaut interne du relais.\n3. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1103": "1. Vérifiez si le fil de terre du côté AC est sous tension.\n2. Défaut interne du relais.\n3. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1201": "1. Ventilateur interne endommagé\n2. Défaut du circuit de détection du ventilateur\n3. Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur",
  "0X3809-S-1901": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1902": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1903": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1904": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1905": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1906": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-1907": "Coupez l'alimentation et redémarrez l'onduleur. S'il ne peut pas récupérer, veuillez contacter le revendeur.",
  "0X3809-S-3101": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3102": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3103": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3104": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3105": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3106": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3107": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3108": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3109": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3110": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3111": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3112": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3113": "1. Vérifiez si un disjoncteur du tableau électrique a déclenché.\n2. Mesurez si la tension réelle dépasse la plage de l'onduleur.\n3. Si la tension est hors plage, vous pouvez ajuster les valeurs de protection contre les surtensions et les sous-tensions de l'onduleur.",
  "0X3809-S-3301": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3302": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3303": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3304": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3305": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3306": "1. Vérifiez la présence de connexions desserrées dans le réseau électrique.\n2. Ajustez la plage de fréquence de manière appropriée.",
  "0X3809-S-3701": "Vérifiez si l'onduleur a été manuellement arrêté.",
  "0X3809-S-3801": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3802": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3803": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3804": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3805": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3806": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3807": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3808": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3809": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3810": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3811": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3812": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3813": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3814": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3815": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3816": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3817": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3818": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3819": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3820": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3901": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3902": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3903": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3904": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3905": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3906": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3907": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3908": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3909": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3910": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3911": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3912": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3913": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3914": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3915": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3916": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3917": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3918": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3919": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-3920": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-4101": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-4201": "Vérifiez si la tension N-PE est anormale",
  "0X3809-S-4301": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3809-S-4401": "Veuillez éteindre l'onduleur et déconnecter les commutateurs d'entrée/sortie. Redémarrez l'onduleur après 5 minutes. Si le défaut n'est pas éliminé, veuillez contacter le revendeur.",
  "0X3807-F-02": "Alerte de court-circuit PV2",
  "0X3807-F-03": "Alerte de basse tension PV",
  "0X3807-S-0101": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0102": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0103": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0104": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0105": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0106": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0107": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0108": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0109": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0110": "1. Vérifiez si le ventilateur est bloqué par des corps étrangers\n2. Vérifiez si le ventilateur tourne normalement\n3. Redémarrez l'onduleur; s'il ne peut pas récupérer, veuillez remplacer le ventilateur",
  "0X3807-S-0401": "Vérifiez si le câblage du compteur est incorrect.",
  "0X3807-S-0402": "Vérifiez si le câblage du compteur est incorrect.",
  "0X3807-S-0404": "Vérifiez si le câblage du compteur est incorrect.",
  "0X3807-S-0408": "Vérifiez si le câblage du compteur est incorrect.",
  "0X3807-S-0416": "Vérifiez si le câblage du compteur est incorrect.",
  "0X3807-S-0500": "Si cela se produit occasionnellement, cela peut être dû à une anomalie temporaire du réseau. L'onduleur reprendra un fonctionnement normal après le retour à la normale du réseau.\nSi ce défaut est signalé fréquemment, veuillez vérifier si le réseau est anormal.",
  "0X3807-S-0601": "Après l'arrêt, vérifiez si la tension du module est normale. Si le redémarrage ne résout pas le problème, cela indique une défaillance interne de l'onduleur.",
  "0X3807-S-02": "Après l'arrêt, vérifiez si la tension du module est normale. Si le redémarrage ne résout pas le problème, cela indique une défaillance interne de l'onduleur.",
  "0X3807-S-03": "Après l'arrêt, vérifiez si la tension du module est normale. Si le redémarrage ne résout pas le problème, cela indique une défaillance interne de l'onduleur.",
  "In Alarm": "En Alarme",
  "device.category.energyStorageCabinet": "Armoire de stockage d'énergie",
  "device.category.commercialRobot": "Robot industriel commercial",
  "device.category.pvinverter": "Onduleur photovoltaïque",
  "collector.upgrade.progress": "Progression de la mise à niveau du collectionneur",
  "device.upgrade.progress": "Progression de la mise à niveau de l'appareil",
  "failed.to.obtain.firmware": "Échec de l'obtention du micrologiciel",
  "file.CRC.check.failed": "Échec de la vérification CRC du fichier",
  "burning.timed.out": "Temps de gravure dépassé",
  "burning.failed": "Échec de la gravure",
  "shujvabng": "Bâton de données (Bumai)",
  "paramSet.select.dataError.tip": "L'option n'est pas l'option optimale, veuillez la réinitialiser.",
  "bw_param_qqq": "Paramétrage du Mode Parallèle",
  "paramSet.dateTime.title.month": "M",
  "ywt.60419.rGridPower": "Puissance raccordée au réseau de phase R",
  "paramSet.dateTime.title.year": "A",
  "50500_0x7572-C-15": "Échec du dissipateur thermique à haute température",
  "50500_0x7572-C-14": "Faille ARC",
  "50500_0x756F-S-6": "Défaut de démarrage progressif DC / DC\n 1. Vérifiez le fusible de la batterie ;\n 2. Redémarrez et vérifiez s'il est normal ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à l'état normal",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror1": "Anomalie du FLASH externe",
  "ywt.60419.internalharderror3": "Anomalie d'écriture de l'EEPROM",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror2": "Anomalie de lecture de l'EEPROM（",
  "50500_0x756F-S-9": "Panne d'alimentation auxiliaire\n 1. Attendez quelques minutes puis vérifiez ;\n 2. Retirez la prise wifi ou tout autre communicateur ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à l'état normal",
  "ywt.60419.internalharderror4": "Échec du test automatique du GFCI",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-C-6": "DC / DC _ Softsart _ Fault",
  "50500_0x756F-C-9": "AuxPowerBoard _ Échec",
  "50500_0x7570-F-14": "Soft _ Start _ a échoué",
  "50500_0x7570-F-12": "Défaut _ CANBus _ parallèle",
  "50500_0x756F-C-13": "Changement de mode de travail",
  "test.label_G_P_C_L1": "Gen L1 Leistung",
  "ywt.60419.internalHardwareError": "Anomalie matérielle interne à la machine",
  "test.label_G_P_C_L5": "Gen L2 Spannung",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "Gen L2 Spannung",
  "test.label_G_P_C_L4": "Gen L1 Spannung",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "Gen L3 Spannung",
  "test.label_G_P_C_L3": "Gen L3 Leistung",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "Gen L1 Spannung",
  "test.label_G_P_C_L6": "Gen L3 Spannung",
  "bw_param_ctrl_name_ParallelSetting": "Statut parallèle",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-15": "Fréquence de grille hors de portée\n 1. Vérifiez que la fréquence est dans la plage des spécifications ou non ;\n 2. Vérifiez si les câbles CA sont fermement et correctement connectés ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7571-S-13": "Défaut de la batterie de secours. \n 1. Vérifiez la capacité de la batterie ;\n 2. Vérifier la connexion entre les batteries et les onduleurs ;\n 3. Si l'onduleur ne peut pas revenir à la normale après la réduction de charge, demandez de l'aide auprès de nous",
  "50500_0x7571-S-14": "Fréquence de grille hors de portée\n 1. Vérifiez que la fréquence est dans la plage des spécifications ou non ;\n 2. Vérifiez si les câbles CA sont fermement et correctement connectés ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-C-14": "Soft _ Start _ a échoué",
  "50500_0x7570-C-12": "Défaut _ CANBus _ parallèle",
  "ywt.60419.workStatus0": "Initialisation",
  "ywt.60419.workStatus1": "Attente",
  "ywt.60419.workStatus2": "Raccordement au réseau",
  "ywt.60419.workStatus3": "Panne",
  "ywt.60419.workStatus4": "Gravure",
  "ywt.60419.workStatus5": "Hors réseau",
  "50500_0x756F-F-13": "Changement de mode de travail",
  "50500_0x756F-F-12": "Batt Mode Changed",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "Gen L2 Leistung",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "Gen L1 Leistung",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "Gen L3 Leistung",
  "paramSet.dateTime.title.hour": "H",
  "ywt.60419.tGridPower": "Puissance raccordée au réseau de phase T",
  "paramSet.dateTime.title.minute": "Min",
  "ywt.60419.loadPower": "Puissance de charge",
  "50500_0x7572-S-15": "La température du dissipateur thermique est trop élevée\n 1. Vérifiez si la température de l'environnement de travail est trop élevée ;\n 2. Éteignez l'onduleur pendant 10 minutes et redémarrez ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7572-S-14": "1. La détection des défauts ARC est uniquement destinée au marché américain ;\n 2. Vérifiez la connexion du câble du module PV et éliminez le défaut ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-F-8": "AC _ Active _ Batt _ Fault",
  "50500_0x7570-F-9": "La barre omnibus CC est déséquilibrée",
  "50500_0x7570-F-0": "Active _ Battery _ Hold",
  "50500_0x7570-F-1": "Défaut de courant alternatif du matériel",
  "50500_0x7570-F-3": "DC sur courant défectueux du matériel",
  "50500_0x7570-F-5": "Tz _ EmergSStop _ Fault",
  "50500_0x7570-F-6": "Le courant de fuite AC est transitoire par rapport au courant",
  "50500_0x7570-F-7": "Défaillance de l'impédance d'isolation CC",
  "50500_0x7571-F-13": "Bcakup _ Battery _ Fault",
  "50500_0x7571-F-14": "AC sur fréquence",
  "50500_0x7571-F-15": "AC basse fréquence",
  "50500_0x7570-S-3": "Défaut courant continu\n 1. Vérifiez la connexion du module PV et la connexion de la batterie ;\n 2. Éteignez l'interrupteur CC et l'interrupteur CA, puis attendez une minute, puis rallumez l'interrupteur CC / CA ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-S-5": "Demandez de l'aide de notre part, cet échec arrive à peine.",
  "50500_0x7570-S-6": "Défaut de courant de fuite\n 1. Vérifiez le câble du module PV et de l'onduleur ;\n 2. Redémarrer l'onduleur ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-S-7": "La résistance d'isolation PV est trop faible\n 1. Vérifiez que la connexion des panneaux photovoltaïques et de l'onduleur est fermement et correctement ;\n 2. Vérifiez si le câble PE de l'onduleur est connecté à la terre ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. Veuillez attendre un moment et vérifier si c'est normal ;\n 2. Si toujours le même, éteignez l'interrupteur CC et l'interrupteur CA et attendez une minute, puis allumez l'interrupteur CC / CA ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "Défaut de courant sur le côté AC\n 1. Veuillez vérifier si la puissance de charge de secours et la puissance de charge commune sont dans la plage ;\n 2. Redémarrez et vérifiez s'il est normal ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7570-C-3": "DC sur courant défectueux du matériel",
  "50500_0x7570-C-5": "Tz _ EmergSStop _ Fault",
  "50500_0x7570-C-6": "Le courant de fuite AC est transitoire par rapport au courant",
  "50500_0x7570-C-7": "Défaillance de l'impédance d'isolation CC",
  "50500_0x7570-C-8": "AC _ Active _ Batt _ Fault",
  "50500_0x7570-C-9": "La barre omnibus CC est déséquilibrée",
  "50500_0x7571-C-8": "Parallel _ system _ Stop",
  "50500_0x7571-C-9": "Ligne AC basse tension",
  "50500_0x7571-C-6": "DCLLC _ Over _ Current",
  "50500_0x7571-C-7": "Batt _ Over _ Current",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC _ Soft _ Over _ Cur",
  "50500_0x7570-C-0": "Active _ Battery _ Hold",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "Défaut de courant alternatif du matériel",
  "50500_0x7571-C-2": "Pas de grille AC",
  "50500_0x756F-S-13": "Le mode de travail de l'onduleur a changé\n 1. attendez une minute et vérifiez ;\n 2. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "paramSet.dateTime.title.second": "S",
  "50500_0x7571-S-8": "En parallèle, en raison d'autres défauts de l'onduleur.\n 1. Attendez quelques minutes puis vérifiez tous les onduleurs de ce système parallèle ;\n 2. Si l'onduleur ne peut pas revenir à l'état normal, enregistrez les codes d'erreur de tous les onduleurs, puis demandez de l'aide auprès de nous.",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "Aucune utilité\n 1. Veuillez confirmer que la grille est perdue ou non ;\n 2. Vérifiez que la connexion au réseau est bonne ou non ;\n 3. Vérifiez que le commutateur entre l'onduleur et le réseau est allumé ou non ;\n 4. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "ywt.60419.sGridPower": "Puissance raccordée au réseau de phase S",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC _ Over _ Current",
  "50500_0x7571-F-4": "DCLLC _ Soft _ Over _ Cur",
  "50500_0x7571-F-2": "Pas de grille AC",
  "50500_0x7571-F-9": "Ligne AC basse tension",
  "50500_0x7571-F-7": "Batt _ Over _ Current",
  "50500_0x7571-F-8": "Parallel _ system _ Stop",
  "ywt.60419.loadDropMode10": "Dérating d'ajustement ATE",
  "ywt.60419.loadDropMode12": "Dérating anti-retour de puissance pour machines multiples",
  "ywt.60419.loadDropMode13": "Dérating à surfréquence",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "Tension de la batterie faible\n 1. Vérifiez si la tension de la batterie est trop faible ;\n 2. Si la tension de la batterie est trop faible, utilisez PV ou un réseau pour charger la batterie ;\n 3. Demandez de l'aide de notre part, si vous ne pouvez pas revenir à un état normal.",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-C-7": "La tension de la barre omnibus CC est trop faible",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "Défaut de communication BMS",
  "ywt.60419.loadDropMode3": "Dérating de l'onduleur",
  "ywt.60419.loadDropMode2": "Dérating BST à haute température",
  "ywt.60419.loadDropMode1": "Dérating sous haute tension",
  "ywt.60419.loadDropMode0": "Pas de dérating",
  "50500_0x756F-F-9": "AuxPowerBoard _ Échec",
  "ywt.60419.loadDropMode9": "Dérating AC sous haute tension",
  "ywt.60419.loadDropMode8": "Dérating de pente de charge",
  "ywt.60419.loadDropMode7": "Dérating de puissance réactive",
  "ywt.60419.loadDropMode6": "Dérating de réinitialisation MPPT",
  "ywt.60419.loadDropMode5": "Dérating PF",
  "ywt.60419.loadDropMode4": "Dérating à température ambiante",
  "50500_0x756F-F-2": "GFCI Device Fault",
  "50500_0x7570-S-12": "Cet ault uniquement pour les onduleurs fonctionnant en mode parallèle\n 1. Vérifiez le réglage parallèle conformément aux instructions ;\n 2. Vérifier la connexion du CANBus ;\n 3. Demander de l'aide de notre part",
  "50500_0x756F-F-4": "EEPROM Read Fault",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-6": "DC / DC _ Softsart _ Fault",
  "50500_0x756F-F-5": "EEPROM Write Fault",
  "50500_0x7571-C-15": "AC basse fréquence",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-14": "AC sur fréquence",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": "INV Relay Fault",
  "50500_0x7571-C-13": "Bcakup _ Battery _ Fault",
  "paramSet.dateTime.title.day": "J",
  "50500_0x7572-F-14": "Faille ARC",
  "50500_0x7572-F-15": "Échec du dissipateur thermique à haute température",
  "50500_0x7572-F-7": "La tension de la barre omnibus CC est trop faible",
  "50500_0x7572-F-9": "Défaut de communication BMS",
  "ywt.60419.meterPower": "Puissance totale du compteur électrique",
  "paramSet.input.dataError.tip": "La valeur n'est pas dans une fourchette raisonnable, veuillez la réinitialiser.",
  "current.collector.upgrade.progress": "Le progrès actuel de la mise à jour du collecteur est",
  "CSP Plant": "Centrale solaire thermique concentrée",
  "platformType.android": "Android",
  "platformType.ios": "IOS",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Activation de l’inversion Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "Activation de l’inversion PV CT",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Réglage du rapport de transformation du compteur Grid CT",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "Réglage du rapport de transformation du compteur PV CT",
  "50901.ctrl_Config-Grid Profile.country": "Pays / Pays de norme de raccordement au réseau",
  "50901.ctrl_Device.meterConfiguration": "Configuration du compteur",
  "50901.ctrl_WorkMode.workMode": "Mode de fonctionnement EMS",
  "50901.ctrl_ESS_Advanced_Config-System": "Configuration avancée - Système",
  "50901.ctrl_Config-Grid Profile": "Configuration - Paramètres réseau",
  "50901.ctrl_Device": "Contrôle_Appareil",
  "50901.ctrl_WorkMode": "Mode De Fonctionnement",
  "connect.type.wifi": "Réseau sans Fil",
  "connect.type.lan": "LAN",
  "50901.ctrl_WorkModeSetting": "Paramètres du mode de travail",
  "50901.ctrl_WorkMode-Backup": "Mode de fonctionnement - Backup",
  "50901.ctrl_WorkMode-economic": "Mode de fonctionnement - Économique",
  "50901.ctrl_WorkMode-forceCharge": "Mode de fonctionnement - Charge forcée",
  "50901.ctrl_WorkMode-forceDischarge": "Mode de fonctionnement - Décharge forcée",
  "50901.ctrl_WorkMode-peakMeter": "Mode de fonctionnement - Compteur de pointe",
  "50901.ctrl_WorkMode-Selfuse": "Mode de fonctionnement - Auto-consommation",
  "50901.ctrl_WorkMode-TOU": "Mode de fonctionnement - TOU",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "Mode TOU - SOC réservé",
  "50901.ctrl_Device.meterConfiguration.desc": "Description de la configuration du compteur",
  "50901.ctrl_Config-Grid Profile.country.desc": "Description du pays / pays de norme de raccordement au réseau",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "Désactiver",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "Activer Aktivieren",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "Activer Aktivieren",
  "50901.ctrl_Device.meterConfiguration.0": "Aucun type de compteur",
  "50901.ctrl_Device.meterConfiguration.1": "Configurer le compteur du côté du réseau",
  "50901.ctrl_Device.meterConfiguration.2": "Configurer le compteur PV",
  "50901.ctrl_Device.meterConfiguration.3": "Configurer le compteur du côté du réseau + PV",
  "Do_not_connect": "Ne pas connecter",
  "connect.type.Do.not.connect": "Ne pas connecter",
  "platformType.web": "Web",
  "50901.Selfuse": "Autoconsommation",
  "50901.TOU": "Tarif Heures Creuses",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "Description de la configuration du compteur.",
  "50901.ctrl_Config.Grid Profile.country.desc": "Description du pays / du pays de la norme de raccordement au réseau",
  "50901.ctrl_Config.Device.meterConfiguration.0": "Aucun Type De Compteur",
  "50901.ctrl_Config.Device.meterConfiguration.1": "Compteur Réseau Configuré",
  "50901.ctrl_Config.Device.meterConfiguration.2": "Compteur Photovoltaïque Configuré",
  "50901.ctrl_Config.Device.meterConfiguration.3": "Compteurs Réseau + Photovoltaïque Configurés",
  "50901.ctrl_WorkMode.Switch.workMode.0": "Autoconsommation",
  "50901.ctrl_WorkMode.Switch.workMode.1": "Mode Économique",
  "50901.ctrl_WorkMode.Switch.workMode.2": "Mode Secours",
  "50901.ctrl_WorkMode.Switch.workMode.3": "Mode Hors Réseau",
  "50901.ctrl_WorkMode.Switch.workMode.4": "Mode Charge Forcée",
  "50901.ctrl_WorkMode.Switch.workMode.5": "Mode Décharge Forcée",
  "50901.ctrl_WorkMode.Switch.workMode.6": "Mode Lissage De La Demande",
  "50901.ctrl_WorkMode.Switch.workMode.7": "Mode TOU",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "Désactiver",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "Activer",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "Désactiver",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "Activer",
  "50901.ctrl_Config.Device.meterConfiguration": "Configuration Du Compteur",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Inversion Ct Réseau Activer",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Réglage Rapport De Spires Du Compteur Ct Réseau",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "Inversion Ct Pv Activer",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "Réglage Rapport De Spires Du Compteur Ct Pv",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "Heure De Début De Charge Période D’utilisation 1 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "Heure De Début De Décharge Période D’utilisation 1 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "Heure De Début De Charge Période D’utilisation 2 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "Heure De Début De Décharge Période D’utilisation 2 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "Heure De Début De Charge Période D’utilisation 3 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "Heure De Début De Décharge Période D’utilisation 3 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "Heure De Début De Charge Période D’utilisation 4 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "Heure De Début De Décharge Période D’utilisation 4 - Heure",
  "alarm.trigger.condition": "déclenché \npar l'appareil",
  "alarm.iot": "IoT Alarme",
  "module.alarmInfo": "Informations d'alarme",
  "edit.failed": "Échec de l'édition",
  "tag_test_3": "tag_test_3",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "Transit_Warehouse": "Magazzino di transito",
  "bw_Param_strl_option_GridUseMeter": "Le réseau électrique utilise des compteurs électriques",
  "bw_Param_strl_option_GridUseCT": "Le réseau électrique utilise des CT",
  "50901.fault.dSPSAFcomparatorFault": "Défaut De Comparateur",
  "50901.fault.dSPPWRfanFault": "Défaut De Ventilateur",
  "50901.fault.dSPPWRgridRelayProtection": "Déclenchement de la protection du relais réseau",
  "50901.fault.dSPPWRmachineTypeMismatch": "Non-Conformité Du Type De Machine",
  "50901.fault.dSPSAFbatteryFault": "Défaut De Batterie",
  "50901.fault.dSPSAFfanFault": "Défaut De Ventilateur",
  "50901.fault.dSPSAFgridRelayProtection": "Déclenchement De La Protection Relai Réseau",
  "50901.fault.dSPPWRbatteryFault": "Défaut Côté Batterie",
  "50901.fault.dSPPWRcomparatorFault": "Défaut du comparateur",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "Anomalie De L’alimentation Auxiliaire",
  "50901.fault.dSPSAFmachineTypeMismatch": "Non-Conformité Du Type De Machine",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "Anomalie De Biais D’échantillonnage",
  "50901.fault.canCommunicationTimeout": "Délai D’expiration De La Communication Can",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "Alimentation auxiliaire anormale",
  "50901.fault.dSPSAFarmCommunicationFault": "Défaut De Communication Arm",
  "50901.fault.dSPSAFspiCommunicationFault": "Défaut De Communication Spi",
  "50901.fault.dSPSAFversionMismatch": "Non-Conformité De Version",
  "50901.fault.dSPPWRarmCommunicationFault": "Défaut De Communication Arm",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "Anomalie De Biais D’échantillonnage",
  "50901.fault.dSPPWRspiCommunicationFault": "Défaut De Communication Spi",
  "50901.fault.dSPPWRversionMismatch": "Non-Conformité De Version (Incohérence Version Logicielle/Matérielle)",
  "50901.fault.hardwareProtection": "Déclenchement De La Protection Matérielle",
  "50901.fault.lowBatteryEnergy": "Énergie De Batterie Faible",
  "50901.fault.dSPPWRgridRelayProtection.0": "Désactiver",
  "50901.fault.dSPPWRgridRelayProtection.1": "Activer",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "Désactiver",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "Activer",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "Désactiver",
  "50901.fault.dSPPWRbatteryFault.1": "Activer",
  "50901.fault.dSPPWRcomparatorFault.0": "Désactiver",
  "50901.fault.dSPPWRcomparatorFault.1": "Activer",
  "50901.fault.dSPPWRfanFault.0": "Désactiver",
  "50901.fault.dSPPWRfanFault.1": "Activer",
  "50901.fault.canCommunicationTimeout.1": "Activer",
  "50901.fault.dSPPWRarmCommunicationFault.0": "Désactiver",
  "50901.fault.dSPPWRarmCommunicationFault.1": "Activer",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "Désactiver",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "Activer",
  "50901.fault.dSPPWRbatteryFault.0": "Désactiver",
  "50901.fault.canCommunicationTimeout.0": "Désactiver",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "Activer",
  "50901.fault.hardwareProtection.1": "Activer",
  "50901.fault.lowBatteryEnergy.0": "Désactiver",
  "50901.fault.lowBatteryEnergy.1": "Activer",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "Activer",
  "50901.fault.dSPSAFspiCommunicationFault.0": "Désactiver",
  "50901.fault.dSPSAFspiCommunicationFault.1": "Activer",
  "50901.fault.dSPSAFversionMismatch.0": "Désactiver",
  "50901.fault.dSPSAFversionMismatch.1": "Activer",
  "50901.fault.hardwareProtection.0": "Désactiver",
  "50901.fault.dSPSAFarmCommunicationFault.0": "Désactiver",
  "50901.fault.dSPSAFgridRelayProtection.1": "Activer",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "Désactiver",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "Activer",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "Désactiver",
  "50901.fault.dSPSAFbatteryFault.0": "Désactiver",
  "50901.fault.dSPSAFbatteryFault.1": "Activer",
  "50901.fault.dSPSAFcomparatorFault.0": "Désactiver",
  "50901.fault.dSPSAFcomparatorFault.1": "Activer",
  "50901.fault.dSPSAFfanFault.0": "Désactiver",
  "50901.fault.dSPSAFfanFault.1": "Activer",
  "50901.fault.dSPPWRversionMismatch.0": "Désactiver",
  "50901.fault.dSPPWRversionMismatch.1": "Activer",
  "50901.fault.dSPSAFarmCommunicationFault.1": "Activer",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "Désactiver",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "Activer",
  "50901.fault.dSPPWRspiCommunicationFault.0": "Désactiver",
  "50901.fault.dSPPWRspiCommunicationFault.1": "Activer",
  "50901.fault.dSPSAFgridRelayProtection.0": "Désactiver",
  "50901..数据分析_电网功率.tag": "Puissance du réseau électrique",
  "50901.real_time.数据分析_AC光伏功率.tag": "Puissance Photovoltaïque Ca",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "Puissance Active Photovoltaïque Ca",
  "50901.real_time.数据分析_EPS电压.tag": "Tension Eps",
  "50901.real_time.数据分析_混逆光伏电流.tag": "Courant Photovoltaïque Onduleur Hybride",
  "50901..数据分析_单体SOC.tag": "Soc D’une Cellule",
  "50901..数据分析_发电机功率.tag": "Puissance du générateur",
  "50901..数据分析_混逆光伏功率.tag": "Puissance Pv De L’onduleur Hybride",
  "50901..数据分析_电池包.tag": "Pack batterie",
  "50901..数据分析_电网电压.tag": "Tension Réseau",
  "50901..数据分析_电网电流.tag": "Courant du réseau électrique",
  "50901.Backup": "Secours",
  "50901.Battery": "Batterie",
  "50901.ClockSetting": "Réglage De L’horloge",
  "50901.Connection": "Connexion De Communication",
  "50901.ctrl_Config": "Contrôle De La Connexion De Communication",
  "50901.ctrl_Config.Device.networkingType.1": "Wifi",
  "50901.ctrl_Config.Device.networkingType.2": "Ethernet",
  "50901.ctrl_Dry_Contact": "Réglage Contact Sec",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "Description De L’heure De Début De Charge De La Commande Du Générateur - H",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "Description De La Minute De Début De Charge De La Commande Du Générateur - Minute",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "Description De La Capacité De La Batterie D’arrêt Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "Description De La Capacité De La Batterie De Démarrage Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "Description De La Fréquence Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "Description De La Durée D’exécution Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "Description De L’heure De Démarrage Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "Description De L’activation Du Temps De Veille",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "Mode D’activation De La Soc Pour Batteries De Pompe À Chaleur 0: Désactiver 1: Activer",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Puissance D’injection Réseau Maximale De La Pompe À Chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "Lorsque La Durée De Fonctionnement Unique Atteint Cette Valeur, Le Mode De Contrôle De La Pompe À Chaleur Est Désactivé",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "Lorsque Le Soc De La Batterie Atteint Cette Valeur, Le Mode De Contrôle De La Pompe À Chaleur Est Activé",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "Lire, écrire, monter",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "Jusqu’à 4 Périodes De Fonctionnement Peuvent Être Définies",
  "50901.ctrl_ESS_Advanced_Config": "Configuration Avancée",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "Description De La Puissance De Décharge Maximale De La Batterie En Période De Pointe",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "Description De La Puissance D’injection Réseau En Période De Pointe",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "Description De La Puissance De Charge Maximale De La Batterie",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "Description De La Puissance De Décharge Maximale De La Batterie",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "Description Du Temps De Maintenance De La Batterie Au Plomb",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "Description Du Soc Maximal",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "Description Du Soc Minimal",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "Description De La Compensation De Puissance",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "Description De La Puissance De Réserve Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "Description De La Désactivation Du Contournement",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "Description Du Mode Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "Description De L’activation Du Mode Photovoltaïque",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "Description Du Mode Du Port Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "Description De L’emplacement Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "Description Du Délai D’extinction Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "Description Du Temps De Synchronisation Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "Description Du Type De Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "Description De La Durée De Fonctionnement Maximale",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "Description De La Durée De Fonctionnement Minimale",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "Description De L’intervalle De Protection De Fonctionnement",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "Description De L’activation Du Scan Global",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "Description De L’activation De L’inversion Ct Réseau",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "Description Du Réglage Du Rapport De Spires Du Compteur Ct Réseau",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "Description De La Limitation De La Puissance Réseau",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "Description Du Modèle De Compteur",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "Description De L’activation Mid / Passerelle",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "Description De L’activation De L’inversion Ct Photovoltaïque",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "Description Du Réglage Du Rapport De Spires Du Compteur Ct Photovoltaïque",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "Description De L’activation Du Déséquilibre Triphasé",
  "50901.ctrl_Safety": "Normes De Sécurité",
  "50901.DCI": "Isolation Cc",
  "50901.Device": "Appareil",
  "50901.economic": "Mode Économique",
  "50901.EPS": "Alimentation De Secours",
  "50901.Fault": "Défaut",
  "50901.Fault.arcFault.0": "Désactiver",
  "50901.Fault.arcFault.1": "Activer",
  "50901.Fault.arcSelfTestFault.0": "Désactiver",
  "50901.Fault.arcSelfTestFault.1": "Activer",
  "50901.Fault.batteryCapacityAbnormality.0": "Disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "Désactiver",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "Activer",
  "50901.Fault.busbarAbnormality.0": "Désactiver",
  "50901.Fault.busbarAbnormality.1": "Activer",
  "50901.Fault.cmpssBiasCalculationError.0": "Désactiver",
  "50901.Fault.cmpssBiasCalculationError.1": "Activer",
  "50901.Fault.driveAbnormality.0": "Désactiver",
  "50901.Fault.driveAbnormality.1": "Activer",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "Activer",
  "50901.Fault.dspSafCommunicationAbnormality.0": "Disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "Désactiver",
  "50901.Fault.dtsCommunicationAbnormality.1": "Activer",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "Enable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "Disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "Désactiver",
  "50901.Fault.e2rpomFault.1": "Activer",
  "50901.Fault.epsOverload.0": "Désactiver",
  "50901.Fault.epsOverload.1": "Activer",
  "50901.Fault.epsRelayProtection.0": "Désactiver",
  "50901.Fault.epsRelayProtection.1": "Activer",
  "50901.Fault.epsVoltageAbnormality.0": "Désactiver",
  "50901.Fault.epsVoltageAbnormality.1": "Activer",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "Disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "Enable",
  "50901.Fault.evCharger2Fault.0": "Disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "Désactiver",
  "50901.Fault.fanSpeedAbnormality.1": "Enable",
  "50901.Fault.flashCommunicationFault.0": "Désactiver",
  "50901.Fault.flashCommunicationFault.1": "Activer",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "Désactiver",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "Activer",
  "50901.Fault.genAbnormality.0": "Désactiver",
  "50901.Fault.genAbnormality.1": "Activer",
  "50901.Fault.genOverload.0": "Désactiver",
  "50901.Fault.genOverload.1": "Activer",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "Enable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "Désactiver",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "Activer",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "Disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "Activer",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "Enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "Désactiver",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "Activer",
  "50901.Fault.gridOverfrequency.0": "Désactiver",
  "50901.Fault.gridOverfrequency.1": "Activer",
  "50901.Fault.gridOvervoltage.0": "Désactiver",
  "50901.Fault.gridOvervoltage.1": "Activer",
  "50901.fault.gridPortOvercurrent.0": "Désactiver",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.Fault.gridPowerOutage.0": "Désactiver",
  "50901.Fault.gridPowerOutage.1": "Activer",
  "50901.Fault.gridUnderfrequency.0": "Désactiver",
  "50901.Fault.gridUnderfrequency.1": "Activer",
  "50901.Fault.gridUndervoltage.0": "Désactiver",
  "50901.Fault.gridUndervoltage.1": "Activer",
  "50901.Fault.gridVoltageAbnormality.0": "Désactiver",
  "50901.Fault.gridVoltageAbnormality.1": "Activer",
  "50901.Fault.hmidCommunicationAbnormality.0": "Disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "Enable",
  "50901.Fault.insulationFault.0": "Désactiver",
  "50901.Fault.insulationFault.1": "Activer",
  "50901.Fault.interruptOverflow.0": "Désactiver",
  "50901.Fault.interruptOverflow.1": "Activer",
  "50901.fault.inverterCanCommunicationFailed.0": "Disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.Fault.lineToEarthFault.0": "Désactiver",
  "50901.Fault.lineToEarthFault.1": "Activer",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "Activer",
  "50901.fault.loadRelayBFault.0": "Disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "Désactiver",
  "50901.Fault.lowAmbientTemperature.1": "Activer",
  "50901.Fault.lowDtuVersion.0": "Disable",
  "50901.Fault.lowDtuVersion.1": "Activer",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "Disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "Désactiver",
  "50901.Fault.meterWiringAbnormality.1": "Activer",
  "50901.Fault.microelectronicFault.0": "Désactiver",
  "50901.Fault.microelectronicFault.1": "Activer",
  "50901.Fault.neutralWireNotConnected.0": "Désactiver",
  "50901.Fault.neutralWireNotConnected.1": "Activer",
  "50901.Fault.neutralWireToEarthFault.0": "Désactiver",
  "50901.Fault.neutralWireToEarthFault.1": "Activer",
  "50901.Fault.overTemperature.0": "Désactiver",
  "50901.Fault.overTemperature.1": "Activer",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "Enable",
  "50901.Fault.pllLockFailed.0": "Désactiver",
  "50901.Fault.pllLockFailed.1": "Activer",
  "50901.Fault.preSynchronizationFailed.0": "Désactiver",
  "50901.Fault.preSynchronizationFailed.1": "Activer",
  "50901.Fault.pvFault.0": "Désactiver",
  "50901.Fault.pvFault.1": "Activer",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "Désactiver",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "Enable",
  "50901.fault.pvRelayAbFault.0": "Disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "Désactiver",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "Activer",
  "50901.Fault.rcdFault.0": "Désactiver",
  "50901.Fault.rcdFault.1": "Activer",
  "50901.Fault.rcdSelfTestFault.0": "Désactiver",
  "50901.Fault.rcdSelfTestFault.1": "Activer",
  "50901.Fault.reconnectionFailed.0": "Désactiver",
  "50901.Fault.reconnectionFailed.1": "Activer",
  "50901.Fault.shutDown.0": "Désactiver",
  "50901.Fault.shutDown.1": "Activer",
  "50901.Fault.slaveWrongBatteryConnection.0": "Disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "Enable",
  "50901.Fault.sustainedNegativeLoad.0": "Désactiver",
  "50901.Fault.sustainedNegativeLoad.1": "Activer",
  "50901.Fault.temperatureAbnormality.0": "Désactiver",
  "50901.Fault.temperatureAbnormality.1": "Activer",
  "50901.Fault.tenMinuteOvervoltage.0": "Désactiver",
  "50901.Fault.tenMinuteOvervoltage.1": "Activer",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.Fault.wiringAbnormality.0": "Désactiver",
  "50901.Fault.wiringAbnormality.1": "Activer",
  "50901.forceCharge": "Charge Forcée",
  "50901.forceDischarge": "Décharge Forcée",
  "50901.FRT": "Tenue De Fréquence",
  "50901.FW": "Dérive De Fréquence",
  "50901.Gateway": "Passerelle",
  "50901.Generator": "Génératrice",
  "50901.Grid Profile": "Paramètres Réseau",
  "50901.HeatPump": "Commande De La Pompe À Chaleur",
  "50901.peakMeter": "Mesure De La Demande De Pointe",
  "50901.PV": "Chint Monophasé",
  "50901.RCD": "Protection Contre Les Courants De Fuite",
  "50901.real_time": "Signification De La Valeur D’énumération 0",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "Description De La Version Dsp (Version U Principale)",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "Puissance Réactive Photovoltaïque Ca",
  "50901.real_time.数据分析_AC光伏电压.tag": "Tension Photovoltaïque Ca",
  "50901.real_time.数据分析_AC光伏电流.tag": "Courant Photovoltaïque Ca",
  "50901.real_time.数据分析_EPS功率.tag": "Puissance Eps",
  "50901.real_time.数据分析_EPS电流.tag": "Courant Eps",
  "50901.real_time.数据分析_发电机电压.tag": "Tension Du Générateur",
  "50901.real_time.数据分析_发电机电流.tag": "Courant Du Générateur",
  "50901.real_time.数据分析_混逆光伏功率.tag": "Puissance Photovoltaïque Onduleur Hybride",
  "50901.real_time.数据分析_混逆光伏电压.tag": "Tension Photovoltaïque Onduleur Hybride",
  "50901.RPC": "Non",
  "50901.RR": "Taux De Variation",
  "50901.RT": "Signification De La Valeur D’énumération 0",
  "50901.Settings": "Mode De Fonctionnement",
  "50901.Settings-Load_Control": "Contrôle De La Charge",
  "50901.Settings-Manual_Control": "Signification De La Valeur D’énumération 0",
  "50901.Switch": "Commutation De Mode",
  "50901.System": "Signification De La Valeur D’énumération 0",
  "50901.VRT": "Signification De La Valeur D’énumération 0",
  "50901.VW": "Dérive De Tension",
  "50901.warning": "Commande De La Pompe À Chaleur",
  "50901.warning.batteryHighVoltageAlarm.0": "Désactiver",
  "50901.warning.batteryHighVoltageAlarm.1": "Activer",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "Enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "Désactiver",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "Désactiver",
  "50901.warning.dischargeHighTemperatureAlarm.1": "Enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "Enable",
  "50901..cfgMultPcsBmsFlag.0": "Non",
  "50901..cfgMultPcsBmsFlag.1": "Oui",
  "50901..connectionRouterStatus.0": "Non Connecté",
  "50901..connectionRouterStatus.1": "Connecté",
  "50901..connectionRouterStatus.3": "Non Connecté",
  "50901..connectionServerStatus.0": "Non Connecté",
  "50901..connectionServerStatus.1": "Connecté",
  "50901..connectionServerStatus.2": "Connecté",
  "50901..connectionServerStatus.3": "Non Connecté",
  "50901..hpTime2WeekRange1.0": "Désactiver",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "Enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "Activer",
  "50901..hpTime2WeekRange4.0": "Désactiver",
  "50901..hpTime2WeekRange4.1": "Enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "Disable",
  "50901..hpTime2WeekRange6.1": "Activer",
  "50901..hpTime2WeekRange7.0": "Désactiver",
  "50901..hpTime2WeekRange7.1": "Enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "Disable",
  "50901..hpTime3WeekRange2.1": "Activer",
  "50901..hpTime3WeekRange3.0": "Désactiver",
  "50901..hpTime3WeekRange3.1": "Enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "Disable",
  "50901..hpTime3WeekRange5.1": "Activer",
  "50901..hpTime3WeekRange6.0": "Désactiver",
  "50901..hpTime3WeekRange6.1": "Enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "Enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "Activer",
  "50901..hpTime4WeekRange2.0": "Désactiver",
  "50901..hpTime4WeekRange2.1": "Enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "Disable",
  "50901..hpTime4WeekRange4.1": "Activer",
  "50901..hpTime4WeekRange5.0": "Désactiver",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "Disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "Disable",
  "50901..hpTime4WeekRange7.1": "Activer",
  "50901..materType.0": "Pas De Compteur Côté Réseau",
  "50901..materType.1": "Chengtai monophasé",
  "50901..materType.2": "Chint Monophasé",
  "50901..materType.3": "Phase fissurée",
  "50901..materType.5": "Module De Mesure",
  "50901..materType.6": "Route unique d'ancory",
  "50901..materType.7": "La Double route ancory",
  "50901..section1WeekRange1.0": "Lundi",
  "50901..section1WeekRange1.1": "Mardi",
  "50901..section1WeekRange1.2": "mercredi",
  "50901..section1WeekRange1.3": "Jeudi",
  "50901..section1WeekRange1.4": "Vendredi",
  "50901..section1WeekRange1.5": "Samedi",
  "50901..section1WeekRange1.6": "Dimanche",
  "50901..section1WeekRange2.0": "Signification De La Valeur D’énumération 0",
  "50901..section1WeekRange2.1": "Signification De La Valeur D’énumération 1",
  "50901..section2WeekRange1.0": "Signification De La Valeur D’énumération 0",
  "50901..section2WeekRange1.1": "Signification De La Valeur D’énumération 2",
  "50901..section3WeekRange1.0": "Signification De La Valeur D’énumération 0",
  "50901..section3WeekRange1.1": "Signification De La Valeur D’énumération 2",
  "50901..section4WeekRange1.0": "Signification De La Valeur D’énumération 0",
  "50901..section4WeekRange1.1": "Signification de la valeur énumérée 2",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "Non",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "Oui",
  "50901.ctrl_Config.Device.masterSlave.0": "Unité Unique",
  "50901.ctrl_Config.Device.masterSlave.1": "Maître",
  "50901.ctrl_Config.Device.masterSlave.2": "Esclave",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "Éteint",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "Manuel",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "Automatique",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "Aucun",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "Hebdomadaire",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "Toutes Les 2 Semaines",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "Toutes Les 3 Semaines",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "Toutes Les 4 Semaines",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "Non",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "Oui",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "Activer",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "Non",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "Oui",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "permettre",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "Activer",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "Désactiver",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "permettre",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "permettre",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "Activer",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "Désactiver",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "permettre",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "permettre",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "Non",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "Oui",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "Manuel",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "Mode Horaire",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "Charge Intelligente",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "Charge Intelligente Hors Réseau",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "Chargeur Véhicule Électrique",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "Contrôle de pompe à chaleur",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "Non",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "Oui",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "Ne permet pas",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "permettre",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "Activer",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "Aucun",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "Défaut À La Terre",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "Génératrice",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "Activer",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "Activer",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "Activer",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "Activer",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "permettre",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "Activer",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "Activer",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "Activer",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "Activer",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "Activer",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "permettre",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "Activer",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "permettre",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "permettre",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "Activer",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "permettre",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "permettre",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "Activer",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "permettre",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "Signification de la valeur énumérée 0",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "Signification De La Valeur D’énumération 1",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "permettre",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "Activer",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "permettre",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "permettre",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "Activer",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "Désactiver",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "permettre",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "Ne permet pas",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "permettre",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "Signification de la valeur énumérée 0",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "Signification De La Valeur D’énumération 1",
  "50901.fault.emergencyStopSwitchStatus.0": "Disable",
  "50901.fault.emergencyStopSwitchStatus.1": "Activer",
  "50901.fault.fiveVoltPowerSupplyFault.0": "Désactiver",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "Enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "Activer",
  "50901.fault.gridMeter.0": "Désactiver",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "Enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "Activer",
  "50901.fault.pvPortOvercurrent.0": "Désactiver",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "Disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.real_time.batteryConnectionStatus.0": "Non",
  "50901.real_time.batteryConnectionStatus.1": "Oui",
  "50901.real_time.BatteryModel.20": "Weineng Hv",
  "50901.real_time.BatteryModel.21": "Gsl Lv",
  "50901.real_time.BatteryModel.5": "Sunwoda Lv",
  "50901.real_time.BatteryModel.6": "Uz Lv",
  "50901.real_time.BatteryModel.7": "Soluna Hv",
  "50901.real_time.BatteryModel.8": "Soluna Lv",
  "50901.real_time.BatteryModel.9": "Steltec Lv",
  "50901.real_time.batteryType_04.0": "Pas De Batterie",
  "50901.real_time.batteryType_04.1": "Batterie au lithium",
  "50901.real_time.batteryType_04.2": "Batterie Plomb-Acide",
  "50901.real_time.batteryWorkingStatus.00": "Veille",
  "50901.real_time.batteryWorkingStatus.01": "En Charge",
  "50901.real_time.batteryWorkingStatus.02": "En Décharge",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "Limite De Puissance Levée, Mode Par Défaut",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "Puissance Onduleur 0, Hors Réseau",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "Puissance De Charge Pc=0, Pas Hors Réseau",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "Puissance De Charge Pc<50%Pn Puissance Nominale",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "Puissance De Charge Pc<75%Pn Puissance Nominale && Puissance Réactive Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "Puissance De Charge Pc, Aucune Limite",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "Puissance De Décharge P=0, Pas Hors Réseau",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "Puissance De Décharge P<50%Pn Puissance Nominale",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "Puissance De Décharge P<75%Pn Puissance Nominale && Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "Puissance De Décharge P, Aucune Limite",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "Puissance De Charge Pc<50%Pn Puissance Nominale --> Puissance De Charge Réduite À 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "Puissance De Charge Pc<50%Pn Puissance Nominale && Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "Puissance De Décharge P<50%Pn Puissance Nominale --> Puissance De Décharge Réduite À 0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "Puissance De Charge Pc<50%Pn Puissance Nominale && Q=-Qmax",
  "50901.real_time.meterFlag.0": "Hors Ligne",
  "50901.real_time.meterFlag.1": "En Ligne",
  "50901.real_time.meterFlag.3": "Communication Passerelle Normale",
  "50901.real_time.meterFlag.4": "Communication Passerelle Déconnectée",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.1": "1",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.127": "7",
  "50901.real_time.packNum.15": "4",
  "50901.real_time.packNum.16383": "14",
  "50901.real_time.packNum.2047": "11",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.3": "2",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.32767": "15",
  "50901.real_time.packNum.4095": "12",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.63": "6",
  "50901.real_time.packNum.65535": "16",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.8191": "13",
  "50901.real_time.relayStatus.00": "Alimentation Km1",
  "50901.real_time.relayStatus.01": "Alimentation Km1",
  "50901.real_time.relayStatus.02": "Alimentation Générateur A",
  "50901.real_time.relayStatus.03": "Alimentation Générateur A",
  "50901.real_time.relayStatus.04": "Alimentation Générateur B",
  "50901.real_time.relayStatus.05": "Alimentation Générateur B",
  "50901.real_time.relayStatus.06": "Alimentation Générateur Ab",
  "50901.real_time.relayStatus.07": "Alimentation Générateur Ab",
  "50901.real_time.relayStatus.08": "Alimentation Charge Critique A",
  "50901.real_time.relayStatus.09": "Alimentation Charge Critique A",
  "50901.real_time.relayStatus.10": "Alimentation Charge Critique B",
  "50901.real_time.relayStatus.11": "Alimentation Charge Critique B",
  "50901.real_time.relayStatus.12": "Réservé",
  "50901.real_time.relayStatus.13": "Réservé",
  "50901.real_time.relayStatus.14": "Réservé",
  "50901.real_time.relayStatus.15": "Réservé",
  "50901.real_time.workStatus.00": "Initialisation De L’alimentation",
  "50901.real_time.workStatus.01": "Mode Veille",
  "50901.real_time.workStatus.02": "Test De Connexion Au Réseau",
  "50901.real_time.workStatus.03": "Mode Connecté Au Réseau",
  "50901.real_time.workStatus.04": "Mode Défaut",
  "50901.real_time.workStatus.05": "Mode Hors Réseau",
  "50901.real_time.workStatus.06": "Mode Bypass",
  "50901..antiIslandingEnable.0": "Désactiver",
  "50901..antiIslandingEnable.1": "Activer",
  "50901..apcEn.0": "Désactiver",
  "50901..apcEn.1": "Activer",
  "50901..drmEnable.0": "Désactiver",
  "50901..drmEnable.1": "Activer",
  "50901..parallelNetworking.0": "Invalide",
  "50901..parallelNetworking.1": "Mise En Réseau En Cours",
  "50901..parallelNetworking.2": "Dissoudre Le Réseau",
  "50901..permitEnable.0": "Désactiver",
  "50901..permitEnable.1": "Activer",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901..relayU16NlineRlyTestDis.0": "Désactiver",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901.ctrl_Config.ClockSetting.clockSet": "Période de réglage de l'horloge",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "Désactiver",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "Activer",
  "50901.ctrl_Config.Device.arcfaultClear.0": "Non",
  "50901.ctrl_Config.Device.arcfaultClear.1": "Oui",
  "50901.ctrl_Config.Device.batActivate.0": "Non",
  "50901.ctrl_Config.Device.batActivate.1": "Oui",
  "50901.ctrl_Config.Device.batteryBalancing.0": "Non",
  "50901.ctrl_Config.Device.batteryBalancing.1": "Oui",
  "50901.ctrl_Config.Device.checkTime": "Heure De L’appareil",
  "50901.ctrl_Config.Device.clearfault.0": "Non",
  "50901.ctrl_Config.Device.clearfault.1": "Oui",
  "50901.ctrl_Config.Device.networkingType": "Type De Connexion Au Réseau",
  "50901.ctrl_Config.Device.restartSystem.0": "Non",
  "50901.ctrl_Config.Device.restartSystem.1": "Oui",
  "50901.ctrl_Config.Device.restoreDefault.0": "Non",
  "50901.ctrl_Config.Device.restoreDefault.1": "Oui",
  "50901.ctrl_Config.Device.selfTest.0": "Non",
  "50901.ctrl_Config.Device.selfTest.1": "Oui",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "Arrêter Le Système",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "Démarrer Le Système",
  "50901.ctrl_Config.Grid Profile.country.1": "En_En50549(Par Défaut)",
  "50901.ctrl_Config.Grid Profile.country.27": "Ieee1547_208(États-Unis)",
  "50901.ctrl_Config.Grid Profile.country.30": "Ieee1547_220(États-Unis)",
  "50901.ctrl_Config.Grid Profile.country.44": "Us_Miso_208V(États-Unis)",
  "50901.ctrl_Config.Grid Profile.country.45": "Us_Miso_240V(États-Unis)",
  "50901.ctrl_Config.Grid Profile.country.9": "Us_Ieee1547(États-Unis)",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "Charge du générateur de nœud sec",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "Générateur de nœud sec en veille 1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "Mise En Veille Générateur À Contact Sec 2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "Temps de démarrage du mode d'exercice du générateur",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "Pompe à chaleur période 1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "Période De Temps Pompe À Chaleur 2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "Pompe à chaleur période 3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "Pompe à chaleur période 4",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "Minuterie À Contact Sec 1 Période 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "Synchronisation des nœuds secs 1 période 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "Synchronisation des nœuds secs 2 période 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "Minuterie À Contact Sec 2 Période 2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "Période de nœud sec 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "Période de nœud sec 2",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "Non",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "Oui",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "Désactivé",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "Alimentation De Secours",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "Alimentation Sans Interruption",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "Non",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "Oui",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "Interdire",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "Photovoltaïque Externe",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "Générateur Externe",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "Démarrage Forcé",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "Contrôle Local",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "Aucun",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "Côté Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "Côté Réseau",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "Manuel",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "Di/Do",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "Désactiver",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "Activer",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "Aucun Compteur Utilisé",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "Compteur Monophasé",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "Compteur Biphasé",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "Compteur Triphasé",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "Compteur Intelligent (Hmid)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "Transformateur De Courant (Ct)",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "Compteur Monophasé Acrel",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "Compteur Biphasé Acrel",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "Désactiver",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "Activer",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "Désactiver",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "Activer",
  "50901.ctrl_Safety.DCI.dciEnable.0": "Désactiver",
  "50901.ctrl_Safety.DCI.dciEnable.1": "Activer",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "Désactiver",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "Activer",
  "50901.ctrl_Safety.FW.fwEnable.0": "Désactiver",
  "50901.ctrl_Safety.FW.fwEnable.1": "Activer",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "Désactiver",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "Activer",
  "50901.ctrl_Safety.RPC.gcfEn.0": "Désactiver",
  "50901.ctrl_Safety.RPC.gcfEn.1": "Activer",
  "50901.ctrl_Safety.RPC.rpcMode.0": "Désactiver",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "Courbe Pf(P), Mode Pf(P)",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.ctrl_Safety.VRT.vrtEn.0": "Désactiver",
  "50901.ctrl_Safety.VRT.vrtEn.1": "Activer",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "Désactiver",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "Activer",
  "50901.ctrl_Safety.VW.vwEnable.0": "Désactiver",
  "50901.ctrl_Safety.VW.vwEnable.1": "Activer",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "Nœud De Mode Période 1 Creux 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "Noeud de mode période 1 basse 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "Période de nœud de mode 1 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "Nœud De Mode Période 1 Pic 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "Noeud de mode période 2 basse 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "Période de nœud de mode 2 basse 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "Nœud De Mode Période 2 Pic 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "Période de nœud de mode 2 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "Nœud De Mode Période 3 Creux 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "Période de nœud de mode 3 basse 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "Période de nœud de mode 3 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "Nœud De Mode Période 3 Pic 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "Période de nœud de mode 4 basse 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "Nœud De Mode Période 4 Creux 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "Période de nœud de mode 4 Peak 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "Période de nœud de mode 4 Peak 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "Nœud De Mode Période 1",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "Période de nœud de mode 2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "Nœud De Mode Période 3",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "Période de nœud de mode 4",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "Temps partagé période de nœud 1 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "Nœud Horaire Période 1 Décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "Temps partagé période de nœud 2 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "Temps partagé noeud période 2 Décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "Nœud Horaire Période 3 Charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "Temps partagé noeud période 3 décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "Temps partagé période de nœud 4 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "Nœud Horaire Période 4 Décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "Temps partagé période de nœud 5 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "Nœud Horaire Période 5 Décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "Temps partagé période de nœud 6 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "Temps partagé noeud période 6 décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "Nœud Horaire Période 7 Charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "Temps partagé noeud période 7 décharge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "Temps partagé période de nœud 8 charge",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "Nœud Horaire Période 8 Décharge",
  "50901.Fault.arcFault": "Défaut D'arc",
  "50901.Fault.arcSelfTestFault": "Échec Auto-Test D'arc",
  "50901.Fault.batteryCapacityAbnormality": "Capacité De La Batterie Anormale",
  "50901.Fault.batteryForceChargeRequest": "Demande De Charge Forcée De La Batterie",
  "50901.Fault.bmsCanCommunicationAbnormality": "Anomalie De Communication Can Du Bms",
  "50901.Fault.busbarAbnormality": "Bus Cc Anormal",
  "50901.Fault.cmpssBiasCalculationError": "Erreur De Calcul Décalage Cmpss",
  "50901.Fault.driveAbnormality": "Commande Anormale",
  "50901.Fault.dspPwrCommunicationAbnormality": "Anomalie De Communication De L’alimentation Dsp",
  "50901.Fault.dspSafCommunicationAbnormality": "Anomalie De Communication Sécurisée Dsp",
  "50901.Fault.dtsCommunicationAbnormality": "Anomalie De Communication Dts",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu1",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu2",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu3",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu4",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu5",
  "50901.Fault.e2rpomFault": "Défaut Eeprom",
  "50901.Fault.epsOverload": "Surcharge Eps",
  "50901.Fault.epsRelayProtection": "Protection Relais Eps",
  "50901.Fault.epsVoltageAbnormality": "Tension Eps Anormale",
  "50901.Fault.evCharger1CommunicationAbnormality": "Anomalie De Communication Borne De Recharge Véhicule Électrique 1",
  "50901.Fault.evCharger1Fault": "Défaut Borne De Recharge 1",
  "50901.Fault.evCharger2CommunicationAbnormality": "Anomalie De Communication Borne De Recharge Véhicule Électrique 2",
  "50901.Fault.evCharger2Fault": "Défaut Borne De Recharge 2",
  "50901.Fault.fanSpeedAbnormality": "Vitesse Du Ventilateur Anormale",
  "50901.Fault.flashCommunicationFault": "Défaut De Communication De La Mémoire Flash",
  "50901.Fault.frequencyVariationRateOutOfRange": "Dépassement De La Limite Du Taux De Variation De Fréquence",
  "50901.Fault.genAbnormality": "Générateur Anormal",
  "50901.Fault.genOverload": "Surcharge Du Générateur",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "Dépassement De La Limite Du Décalage Cc Du Courant Réseau",
  "50901.Fault.gridMeterCommunicationAbnormality": "Anomalie De Communication Du Compteur Réseau",
  "50901.Fault.gridMeterTypeError": "Erreur De Type Du Compteur Réseau",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "Dépassement De La Limite Du Décalage Cc De La Tension Hors Réseau",
  "50901.Fault.gridOverfrequency": "Surcharge Fréquentielle Du Réseau",
  "50901.Fault.gridOvervoltage": "Surtension Du Réseau",
  "50901.Fault.gridPowerOutage": "Panne De Courant Du Réseau",
  "50901.Fault.gridUnderfrequency": "Sous-Fréquence Du Réseau",
  "50901.Fault.gridUndervoltage": "Sous-Tension Du Réseau",
  "50901.Fault.gridVoltageAbnormality": "Tension Réseau Anormale",
  "50901.Fault.hmidCommunicationAbnormality": "Anomalie De Communication De L’ihm",
  "50901.Fault.hmidMachineFault": "Défaut Du Dispositif Ihm",
  "50901.Fault.insulationFault": "Défaut D'isolement",
  "50901.Fault.interruptOverflow": "Débordement D'interruption",
  "50901.Fault.lineToEarthFault": "Défaut À La Terre (Phase-Terre)",
  "50901.Fault.lowAmbientTemperature": "Température Ambiante Trop Basse",
  "50901.Fault.lowDtuVersion": "Version Dtu Trop Basse",
  "50901.Fault.masterSlaveCommunicationAbnormality": "Anomalie De Communication Maître-Esclave",
  "50901.Fault.meterWiringAbnormality": "Câblage Du Compteur Anormal",
  "50901.Fault.microelectronicFault": "Défaut Microélectronique",
  "50901.Fault.neutralWireNotConnected": "Fil Neutre Non Connecté",
  "50901.Fault.neutralWireToEarthFault": "Défaut Du Fil Neutre À La Terre",
  "50901.Fault.overTemperature": "Surchauffe",
  "50901.Fault.pllLockFailed": "Échec Du Verrouillage Pll",
  "50901.Fault.preSynchronizationFailed": "Échec De La Pré-Synchronisation",
  "50901.Fault.pvFault": "Défaut Photovoltaïque",
  "50901.Fault.pvMeterCommunicationAbnormality": "Anomalie De Communication Du Compteur Photovoltaïque",
  "50901.Fault.pvMeterTypeError": "Erreur De Type Du Compteur Photovoltaïque",
  "50901.Fault.pvVoltageExceedingBusVoltage": "Tension Photovoltaïque Dépassant La Tension Du Bus",
  "50901.Fault.rcdFault": "Défaut Du Disjoncteur Différentiel",
  "50901.Fault.rcdSelfTestFault": "Échec De L'auto-Test Du Disjoncteur Différentiel",
  "50901.Fault.reconnectionFailed": "Échec De La Reconnexion",
  "50901.Fault.shutDown": "Arrêt Du Système",
  "50901.Fault.slaveWrongBatteryConnection": "Erreur De Connexion De La Batterie Esclave",
  "50901.Fault.sustainedNegativeLoad": "Charge Négative Prolongée",
  "50901.Fault.temperatureAbnormality": "Température Anormale",
  "50901.Fault.tenMinuteOvervoltage": "Surtension De 10 Minutes",
  "50901.Fault.wiringAbnormality": "Câblage Anormal",
  "50901.real_time.BatteryModel.10": "Xin Yi Lv",
  "50901.real_time.BatteryModel.11": "Vestwoods Lv",
  "50901.real_time.BatteryModel.12": "Jk Hv",
  "50901.real_time.BatteryModel.13": "Byd Lv",
  "50901.real_time.BatteryModel.14": "Uz Hv",
  "50901.real_time.BatteryModel.15": "Zetara Lv",
  "50901.real_time.BatteryModel.16": "Feb Hv",
  "50901.real_time.BatteryModel.17": "Pytes Lv",
  "50901.real_time.BatteryModel.18": "Dmegc Lv",
  "50901.real_time.BatteryModel.19": "Weineng Lv",
  "50901.real_time.BatteryModel.2": "Pylon Hv",
  "50901.real_time.BatteryModel.22": "Hoy Lv",
  "50901.real_time.BatteryModel.23": "Hoy Hv",
  "50901.real_time.BatteryModel.24": "Feb Lv",
  "50901.real_time.BatteryModel.25": "Uhhome Lv",
  "50901.real_time.BatteryModel.26": "Uhhome Hv",
  "50901.real_time.BatteryModel.27": "Byd Hv",
  "50901.real_time.BatteryModel.28": "Vestwoods Hv",
  "50901.real_time.BatteryModel.29": "Phylion Hv",
  "50901.real_time.BatteryModel.3": "Dyness Lv",
  "50901.real_time.BatteryModel.30": "Hoymiles Lv",
  "50901.real_time.BatteryModel.31": "Pholion Lv",
  "50901.real_time.BatteryModel.32": "Wattsonic Lv",
  "50901.real_time.BatteryModel.33": "Enershare Hv",
  "50901.real_time.BatteryModel.34": "Beghelli Lv",
  "50901.real_time.BatteryModel.35": "Lvtopsun Lv",
  "50901.real_time.BatteryModel.36": "Pytes Hv",
  "50901.real_time.BatteryModel.37": "Lvtopsun Hv",
  "50901.real_time.BatteryModel.38": "Raja Hv",
  "50901.real_time.BatteryModel.39": "Felicity Lv",
  "50901.real_time.BatteryModel.4": "Dyness Hv",
  "50901.real_time.communicationStickHardwareVersion": "Version Matérielle Du Dongle De Communication",
  "50901.real_time.communicationStickSn": "Sn Du Dongle De Communication",
  "50901.real_time.copy_communicationStickSoftwareVersion": "Version du logiciel Newsletter stick",
  "50901.real_time.dTSReset": "Réinitialisation De La Clé De Données",
  "50901.real_time.inverterHardwareVersion": "Version Matérielle De L’onduleur",
  "50901.real_time.inverterModelNumber": "Numéro De Modèle De L’onduleur",
  "50901.real_time.macAddr": "Adresse Mac",
  "50901.real_time.rssi": "Intensité Du Signal",
  "50901.real_time.ssid": "Ssid",
  "50901.warning.batteryLowVoltageAlarm": "Sous-Tension De La Batterie",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "Alarme De Surtension De Charge Du Pack Batterie",
  "50901.warning.chargeHighTemperatureAlarm": "Alarme De Température Élevée De Charge",
  "50901.warning.chargeLowTemperatureAlarm": "Alarme De Basse Température De Charge",
  "50901.warning.dischargeHighTemperatureAlarm": "Alarme De Température Élevée De Décharge",
  "50901.warning.dischargeLowTemperatureAlarm": "Alarme De Basse Température De Décharge",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "Réglage De L’horloge",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "Réglage De L’horloge - Jour",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "Réglage De L’horloge - Heure",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "Réglage De L’horloge - Minute",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "Réglage De L’horloge - Mois",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "Réglage De L’horloge - Seconde",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "Réglage De L’horloge - Jour De La Semaine",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "Réglage De L’horloge - Année",
  "50901.ctrl_Config.Device.masterSlave": "Maître/Esclave",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "Seuil De Température Ambiante",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "Seuil De Température Ambiante Du Circuit Imprimé",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "Adresse De Communication De La Passerelle",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "Mode de détection de la pompe à chaleur battsoc",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "Arrêt de la pompe à chaleur SOC",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "Limite De Temps De Détection De Temporisation Pompe À Chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "Puissance de rétroaction maximale de la pompe à chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "Durée maximale de fonctionnement d'une pompe à chaleur par jour",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "Activation Détection Durée Maximale Pompe À Chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "Limitation du temps de fonctionnement minimum de la pompe à chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "Puissance De Démarrage Pompe À Chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "Démarrage de la pompe à chaleur SOC",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "Puissance de pompe à chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "Fin Pompe À Chaleur Temps 1 - Jour",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "Fin du temps de pompe à chaleur 1 -",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "Début Pompe À Chaleur Temps 1 - Jour",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "Temps de pompe à chaleur 1 début - mois",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "Temps de pompe à chaleur 1 semaine 1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "Pompe À Chaleur Temps 1 Semaine 2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "Temps de pompe à chaleur 1 semaine 3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "Temps de pompe à chaleur 1 semaine 4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "Pompe À Chaleur Temps 1 Semaine 5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "Temps de pompe à chaleur 1 semaine 6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "Temps de pompe à chaleur 1 semaine 7",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "Mode de fonctionnement de la pompe à chaleur",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "Durée De Fonctionnement Pompe À Chaleur",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "Minute De Début Des Heures Creuses De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "Heure De Fin Des Heures Creuses De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "Minute De Fin Des Heures Creuses De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "Heure De Début De Pointe De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "Heure De Début De Pointe De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "Minute De Début De Pointe De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "Minute De Début De Pointe De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "Heure De Fin De Pointe De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "Heure De Fin De Pointe De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "Minute De Fin De Pointe De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "Minute De Fin De Pointe De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4StartDay": "Jour De Début De La Section 4",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "Mois De Début De La Section 4",
  "50901.ctrl_WorkMode.economic.section4StopDay": "Jour De Fin De La Section 4",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "Mois De Fin De La Section 4",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "Heure De Début Des Heures Creuses De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "Heure De Début Des Heures Creuses De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "Minute De Début Des Heures Creuses De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "Minute De Début Des Heures Creuses De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "Heure De Fin Des Heures Creuses De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "Heure De Fin Des Heures Creuses De La Section 4 - Heure",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "Minute De Fin Des Heures Creuses De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "Minute De Fin Des Heures Creuses De La Section 4 - Minute",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "Période 4 Groupe 1 lundi",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "Période 4 Groupe 1 mardi",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "Période 4 Groupe 1 Mercredi",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "Période 4 Groupe 1 jeudi",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "Période 4 Groupe 1 vendredi",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "Période 4 Groupe 1 Samedi",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "Période 4 Groupe 1 samedi",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "Plage Hebdomadaire 2 De La Section 4",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "Puissance Du Compteur De Pointe",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "Soc Du Compteur De Pointe",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "Plage Horaire Du Mode Tou",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "Heure De Fin De Charge Période D’utilisation 1 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 1 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "Minute De Début De Charge Période D’utilisation 1 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 1 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 1 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 1 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "Heure De Fin De Charge Période D’utilisation 2 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 2 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "Minute De Début De Charge Période D’utilisation 2 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 2 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 2 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 2 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "Heure De Fin De Charge Période D’utilisation 3 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 3 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "Minute De Début De Charge Période D’utilisation 3 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 3 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 3 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 3 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "Heure De Fin De Charge Période D’utilisation 4 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 4 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "Minute De Début De Charge Période D’utilisation 4 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 4 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 4 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 4 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "Puissance De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "Heure De Fin De Charge Période D’utilisation 5 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 5 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "Heure De Début De Charge Période D’utilisation 5 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "Minute De Début De Charge Période D’utilisation 5 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 5 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 5 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "Heure De Début De Décharge Période D’utilisation 5 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 5 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "Heure De Fin De Charge Période D’utilisation 6 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 6 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "Heure De Début De Charge Période D’utilisation 6 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "Minute De Début De Charge Période D’utilisation 6 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 6 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 6 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "Heure De Début De Décharge Période D’utilisation 6 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 6 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "Heure De Fin De Charge Période D’utilisation 7 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 7 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "Heure De Début De Charge Période D’utilisation 7 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "Minute De Début De Charge Période D’utilisation 7 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 7 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 7 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "Heure De Début De Décharge Période D’utilisation 7 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 7 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "Heure De Fin De Charge Période D’utilisation 8 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "Minute De Fin De Charge Période D’utilisation 8 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "Puissance De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "Heure De Début De Charge Période D’utilisation 8 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "Minute De Début De Charge Période D’utilisation 8 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "Capacité De Coupure De Charge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "Heure De Fin De Décharge Période D’utilisation 8 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "Minute De Fin De Décharge Période D’utilisation 8 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "Puissance De Décharge",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "Heure De Début De Décharge Période D’utilisation 8 - Heure",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "Minute De Début De Décharge Période D’utilisation 8 - Minute",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "Capacité De Coupure De Décharge",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "Mode Tou - Soc Réservé",
  "50901.fault.emergencyStopSwitchStatus": "Arrêt D’urgence",
  "50901.fault.fiveVoltPowerSupplyFault": "Défaut De L’alimentation 5V",
  "50901.fault.genPortOvercurrent": "Surcharge Du Port Du Générateur",
  "50901.fault.genRelayAFault": "Défaut Du Relais A Du Générateur",
  "50901.fault.genRelayBFault": "Défaut Du Relais B Du Générateur",
  "50901.fault.gridMeter": "Échec De La Communication Du Compteur Réseau",
  "50901.fault.gridPortOvercurrent": "Surcharge Du Port Réseau",
  "50901.fault.inverterCanCommunicationFailed": "Échec De La Communication Can De L’onduleur",
  "50901.fault.inverterCommunicationFailed": "Échec De La Communication De L’onduleur",
  "50901.fault.kmRelayFault": "Défaut Du Relais Km",
  "50901.fault.loadRelayAFault": "Défaut Du Relais De Charge A",
  "50901.fault.loadRelayBFault": "Défaut Du Relais De Charge B",
  "50901.fault.overtemperatureAlarm": "Alarme De Surchauffe",
  "50901.fault.pvPortOvercurrent": "Surcharge Du Port Photovoltaïque",
  "50901.fault.pvRelayAbFault": "Défaut Du Relais Ab Photovoltaïque",
  "50901.fault.smartloadPortOvercurrent": "Surcharge Du Port De Charge Intelligente",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "Défaut De L’alimentation 3.3V",
  "50901.fault.twelveVoltPowerSupplyFault": "Défaut De L’alimentation 12V",
  "50901.real_time.12vAuxiliaryVoltageSampling": "Échantillonnage De La Tension Auxiliaire 12V",
  "50901.real_time.12vOutputVoltageSampling": "Échantillonnage De La Tension De Sortie 12V",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "Échantillonnage De La Tension Auxiliaire 3.3V",
  "50901.real_time.5vAuxiliaryVoltageSampling": "Échantillonnage De La Tension Auxiliaire 5V",
  "50901.real_time.afciVersion": "Version Afci",
  "50901.real_time.ambientTemperatureSampling": "Échantillonnage De La Température Ambiante",
  "50901.real_time.appSoftwareVersion": "Version Logicielle De L’application",
  "50901.real_time.batteryChargePower": "Capacité De Charge Cumulative De La Batterie",
  "50901.real_time.batteryConnectionStatus": "État De La Connexion De La Batterie",
  "50901.real_time.batteryCurrent": "Courant De La Batterie",
  "50901.real_time.batteryDailyChargeEnergy": "Capacité De Charge Quotidienne De La Batterie",
  "50901.real_time.batteryDailyDischargeEnergy": "Capacité De Décharge Quotidienne De La Batterie",
  "50901.real_time.batteryDischargePower": "Capacité De Décharge Cumulative De La Batterie",
  "50901.real_time.batteryPower": "Puissance De La Batterie (Charge/Décharge)",
  "50901.real_time.batterySoc": "Soc De La Batterie",
  "50901.real_time.batteryType_04": "Type De Batterie",
  "50901.real_time.batteryVoltage": "Tension De La Batterie",
  "50901.real_time.batteryWorkingStatus": "État De La Batterie",
  "50901.real_time.bootSoftwareVersion": "Version Logicielle Du Bootloader",
  "50901.real_time.commAddress10Slave9": "Adresse De Communication 10 (Esclave 9)",
  "50901.real_time.commAddress1Master": "Adresse De Communication 1 (Maître)",
  "50901.real_time.commAddress2Slave1": "Adresse De Communication 2 (Esclave 1)",
  "50901.real_time.commAddress3Slave2": "Adresse De Communication 3 (Esclave 2)",
  "50901.real_time.commAddress3Slave3": "Adresse De Communication 4 (Esclave 3)",
  "50901.real_time.commAddress4Slave4": "Adresse De Communication 5 (Esclave 4)",
  "50901.real_time.commAddress6Slave6": "Adresse De Communication 6 (Esclave 5)",
  "50901.real_time.commAddress7Slave6": "Adresse De Communication 7 (Esclave 6)",
  "50901.real_time.commAddress8Slave7": "Adresse De Communication 8 (Esclave 7)",
  "50901.real_time.commAddress9Slave8": "Adresse De Communication 9 (Esclave 8)",
  "50901.real_time.copy_bmsSoftwareVersion": "BMS version - Logiciel",
  "50901.real_time.copy_controllerarmFirmwareVersion": "Version Arm De L'onduleur",
  "50901.real_time.copy_dspVersionMainUVersion": "Version Dsp (Version U Principale)",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "État Drm (Pour Australie/Allemagne/Autriche)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "Version Dsp (Version U Auxiliaire)",
  "50901.real_time.epsCurrentA": "Courant De La Phase A Côté Eps",
  "50901.real_time.epsCurrentB": "Courant De La Phase B Côté Eps",
  "50901.real_time.epsCurrentC": "Courant De La Phase C Côté Eps",
  "50901.real_time.epsPower": "Puissance Côté Eps",
  "50901.real_time.epsPowerA": "Puissance De La Phase A Côté Eps",
  "50901.real_time.epsPowerB": "Puissance De La Phase B Côté Eps",
  "50901.real_time.epsPowerC": "Puissance De La Phase C Côté Eps",
  "50901.real_time.epsVoltageA": "Tension De La Phase A Côté Eps",
  "50901.real_time.epsVoltageB": "Tension De La Phase B Côté Eps",
  "50901.real_time.epsVoltageC": "Tension De La Phase C Côté Eps",
  "50901.real_time.essAccessPoint": "Point D’accès Ess",
  "50901.real_time.externalFanSpeed1": "Vitesse Du Ventilateur Externe 1",
  "50901.real_time.externalFanSpeed2": "Vitesse Du Ventilateur Externe 2",
  "50901.real_time.externalFanSpeed3": "Vitesse Du Ventilateur Externe 3",
  "50901.real_time.externalFanSpeed4": "Vitesse Du Ventilateur Externe 4",
  "50901.real_time.firmwareBuildTimeDateHour": "Heure De Construction Du Firmware (Jour/Heure)",
  "50901.real_time.firmwareBuildTimeYearMonth": "Date De Construction Du Firmware (Année Et Mois)",
  "50901.real_time.firmwareCrc": "Crc Du Firmware",
  "50901.real_time.firmwareEndAddressHigh": "Adresse De Fin Du Firmware (Haut)",
  "50901.real_time.firmwareEndAddressLow": "Adresse De Fin Du Firmware (Bas)",
  "50901.real_time.firmwareInformationCrc": "Crc Des Informations Du Firmware",
  "50901.real_time.firmwareStartAddressHigh": "Adresse De Début Du Firmware (Haut)",
  "50901.real_time.firmwareStartAddressLow": "Adresse De Début Du Firmware (Bas)",
  "50901.real_time.generatorConnectionStatus": "État De La Connexion Du Générateur",
  "50901.real_time.generatorCurrentA": "Courant De La Phase A Du Générateur",
  "50901.real_time.generatorCurrentB": "Courant De La Phase B Du Générateur",
  "50901.real_time.generatorCurrentC": "Courant De La Phase C Du Générateur",
  "50901.real_time.generatorPower": "Puissance Du Générateur",
  "50901.real_time.generatorVoltageA": "Tension De La Phase A Du Générateur",
  "50901.real_time.generatorVoltageB": "Tension De La Phase B Du Générateur",
  "50901.real_time.generatorVoltageC": "Tension De La Phase C Du Générateur",
  "50901.real_time.gridCurrentA": "Courant De La Phase A Côté Réseau",
  "50901.real_time.gridCurrentB": "Courant De La Phase B Côté Réseau",
  "50901.real_time.gridCurrentC": "Courant De La Phase C Côté Réseau",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "Température Du Dissipateur Thermique Côté Réseau",
  "50901.real_time.gridMeterSerialNumber": "Numéro De Série Du Compteur Côté Réseau",
  "50901.real_time.gridPower": "Puissance Côté Réseau",
  "50901.real_time.gridPowerA": "Puissance De La Phase A Côté Réseau",
  "50901.real_time.gridPowerB": "Puissance De La Phase B Côté Réseau",
  "50901.real_time.gridPowerC": "Puissance De La Phase C Côté Réseau",
  "50901.real_time.gridPowerFactor": "Facteur De Puissance Côté Réseau",
  "50901.real_time.gridPowerFactorA": "Facteur De Puissance De La Phase A Côté Réseau",
  "50901.real_time.gridPowerFactorB": "Facteur De Puissance De La Phase B Côté Réseau",
  "50901.real_time.gridPowerFactorC": "Facteur De Puissance De La Phase C Côté Réseau",
  "50901.real_time.gridReactivePower": "Puissance Réactive Côté Réseau",
  "50901.real_time.gridReactivePowerA": "Puissance Réactive De La Phase A Côté Réseau",
  "50901.real_time.gridReactivePowerB": "Puissance Réactive De La Phase B Côté Réseau",
  "50901.real_time.gridReactivePowerC": "Puissance Réactive De La Phase C Côté Réseau",
  "50901.real_time.gridTotalFrequency": "Fréquence Côté Réseau",
  "50901.real_time.gridVoltageA": "Tension De La Phase A Côté Réseau",
  "50901.real_time.gridVoltageB": "Tension De La Phase B Côté Réseau",
  "50901.real_time.gridVoltageC": "Tension De La Phase C Côté Réseau",
  "50901.real_time.hoymilesSerialNumber": "Numéro De Série Hoymiles",
  "50901.real_time.internalFanSpeed1": "Vitesse Du Ventilateur Interne 1",
  "50901.real_time.internalFanSpeed2": "Vitesse Du Ventilateur Interne 2",
  "50901.real_time.internalFanSpeed3": "Vitesse Du Ventilateur Interne 3",
  "50901.real_time.inverterSideRadiatorTemperature": "Température Du Dissipateur Thermique Côté Onduleur",
  "50901.real_time.inverterTemp": "Température De Fonctionnement Interne De L’onduleur",
  "50901.real_time.invRatedPower": "Puissance Nominale",
  "50901.real_time.invRunningtime": "Durée De Fonctionnement De L’onduleur (Hoymiles: Temps De Fonctionnement Normal)",
  "50901.real_time.machineSnMaster": "Sn De L’unité Maître",
  "50901.real_time.machineSnSlave1": "Sn De L’esclave 1",
  "50901.real_time.machineSnSlave2": "Sn De L’esclave 2",
  "50901.real_time.machineSnSlave3": "Sn De L’esclave 3",
  "50901.real_time.machineSnSlave4": "Sn De L’esclave 4",
  "50901.real_time.machineSnSlave5": "Sn De L’esclave 5",
  "50901.real_time.machineSnSlave6": "Sn De L’esclave 6",
  "50901.real_time.machineSnSlave7": "Sn De L’esclave 7",
  "50901.real_time.machineSnSlave8": "Sn De L’esclave 8",
  "50901.real_time.machineSnSlave9": "Sn De L’esclave 9",
  "50901.real_time.maxCellTemperature": "Température Maximale De La Cellule",
  "50901.real_time.maxCellVoltage": "Tension Maximale De La Cellule",
  "50901.real_time.MaxChargeCurrent": "Courant De Charge Maximal",
  "50901.real_time.MaxDisChargeCurrent": "Courant De Décharge Maximal",
  "50901.real_time.meterFlag": "Fanion Du Compteur",
  "50901.real_time.minCellTemperature": "Température Minimale De La Cellule",
  "50901.real_time.minCellVoltage": "Tension Minimale De La Cellule",
  "50901.real_time.mpptTemp": "Température Du Dissipateur Thermique Côté Photovoltaïque",
  "50901.real_time.numberOfUnits": "Quantité D’unités",
  "50901.real_time.oemModelName": "Nom Du Modèle Oem",
  "50901.real_time.oemSerialNumber": "Numéro De Série Oem",
  "50901.real_time.packNum": "Quantité Parallèle (Nombre De Packs Batterie)",
  "50901.real_time.previous_gridPower": "Puissance Côté Réseau",
  "50901.real_time.pv1Current": "Courant Pv1",
  "50901.real_time.pv1Power": "Puissance Pv1",
  "50901.real_time.pv1Voltage": "Tension Pv1",
  "50901.real_time.pv2Current": "Courant Pv2",
  "50901.real_time.pv2Power": "Puissance Pv2",
  "50901.real_time.pv2Voltage": "Tension Pv2",
  "50901.real_time.pv3Current": "Courant Pv3",
  "50901.real_time.pv3Power": "Puissance Pv3",
  "50901.real_time.pv3Voltage": "Tension Pv3",
  "50901.real_time.pv4Current": "Courant Pv4",
  "50901.real_time.pv4Power": "Puissance Pv4",
  "50901.real_time.pv4Voltage": "Tension Pv4",
  "50901.real_time.pvConnectionStatus": "État De La Connexion Photovoltaïque",
  "50901.real_time.pvDailyYield": "Production Quotidienne Photovoltaïque",
  "50901.real_time.pvMeterConnectionStatus": "État De La Connexion Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterCurrentA": "Courant De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterCurrentB": "Courant De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterCurrentC": "Courant De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterFrequency": "Fréquence Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseAActivePower": "Puissance Active De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseAPowerFactor": "Facteur De Puissance De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseAReactivePower": "Puissance Réactive De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseBActivePower": "Puissance Active De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseBPowerFactor": "Facteur De Puissance De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseBReactivePower": "Puissance Réactive De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseCActivePower": "Puissance Active De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseCPowerFactor": "Facteur De Puissance De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPhaseCReactivePower": "Puissance Réactive De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPower": "Puissance Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPowerA": "Puissance De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPowerB": "Puissance De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterPowerC": "Puissance De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterSerialNumber": "Numéro De Série Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterVoltageA": "Tension De La Phase A Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterVoltageB": "Tension De La Phase B Du Compteur Photovoltaïque",
  "50901.real_time.pvMeterVoltageC": "Tension De La Phase C Du Compteur Photovoltaïque",
  "50901.real_time.pvPower": "Puissance Photovoltaïque",
  "50901.real_time.relayStatus": "État Du Relais",
  "50901.real_time.relaySupplyVoltageSampling": "Échantillonnage De La Tension D’alimentation Du Relais",
  "50901.real_time.serviceEntranceBreakerCurrent": "Courant Du Disjoncteur D’entrée De Service",
  "50901.real_time.soh": "Soh",
  "50901.real_time.workStatus": "État De Fonctionnement",
  "50901.warning.batteryHighVoltageAlarm": "Alarme De Surtension De La Batterie",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "Alarme De Sous-Tension De Décharge Du Pack Batterie",
  "50901.warning.inputOvervoltageAlarm": "Alarme De Surtension D’entrée",
  "50901.ctrl_Config.Battery.absorptionVoltage": "Tension D’absorption",
  "50901.ctrl_Config.Battery.endChargeVoltage": "Tension De Fin De Charge",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "Courant De Fin De Charge",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "Délai D’expiration De La Charge D’égalisation",
  "50901.ctrl_Config.Battery.equalizationEnable": "Activation De L’égalisation",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "Nombre De Jours D’intervalle D’égalisation",
  "50901.ctrl_Config.Battery.equalizationTime": "Temps D’égalisation",
  "50901.ctrl_Config.Battery.equalizationVoltage": "Tension D’égalisation",
  "50901.ctrl_Config.Battery.floatVoltage": "Tension Flottante",
  "50901.ctrl_Config.Battery.initialResistance": "Résistance Initiale",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "Limite De Charge Maximale",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "Limite De Décharge Maximale",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "Coefficient De Correction De Température",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "Activation De La Communication Dtu",
  "50901.ctrl_Config.Device.arcfaultClear": "Suppression Des Défauts D’Arc",
  "50901.ctrl_Config.Device.batActivate": "Activation De La Batterie",
  "50901.ctrl_Config.Device.batteryBalancing": "Équilibrage De La Batterie",
  "50901.ctrl_Config.Device.clearfault": "Effacer Le Défaut",
  "50901.ctrl_Config.Device.restartSystem": "Redémarrage Du Système",
  "50901.ctrl_Config.Device.restoreDefault": "Restauration Des Valeurs Par Défaut",
  "50901.ctrl_Config.Device.selfTest": "Auto-Test",
  "50901.ctrl_Config.Device.systemPowerOnOff": "Mise Sous/Hors Tension Du Système",
  "50901.ctrl_Config.Grid Profile.country": "Pays/Norme De Connexion Au Réseau",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "Heure De Fin De Charge De La Commande Du Générateur - Heure",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "Minute De Fin De Charge De La Commande Du Générateur - Minute",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "Heure De Début De Charge De La Commande Du Générateur - Heure",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "Minute De Début De Charge De La Commande Du Générateur - Minute",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "Capacité De La Batterie D’arrêt Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "Mode Générateur",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "Capacité De La Batterie De Démarrage Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "Fréquence Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "Durée D’exécution Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "Heure De Démarrage Du Mode D’exercice Du Générateur - Heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "Minute De Démarrage Du Mode D’exercice Du Générateur - Minute",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "Heure De Démarrage Du Mode D’exercice Du Générateur",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "Heure De Fin Du Temps De Veille 1 - Heure",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "Minute De Fin Du Temps De Veille 1 - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "Heure De Début Du Temps De Veille 1 - Heure",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "Minute De Début Du Temps De Veille 1 - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "Heure De Fin Du Temps De Veille 2 - Heure",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "Minute De Fin Du Temps De Veille 2 - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "Heure De Début Du Temps De Veille 2 - Heure",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "Minute De Début Du Temps De Veille 2 - Minute",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "Activation Du Temps De Veille",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "Mode De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "Courant Nominal De La Borne De Recharge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "Lundi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "Mardi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "Mercredi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "Jeudi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "Vendredi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "Samedi De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "Dimanche De Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "Courant Nominal Du Disjoncteur Principal",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "Interrupteur De Mode Manuel",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "Seuil De Puissance De Charge En Mode Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "Durée Minimale De Marche Du Contrôle De La Charge",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "Soc De Protection Hors Réseau",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "Plage Horaire 1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "Mardi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "Mercredi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "Jeudi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "Vendredi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "Samedi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "Dimanche",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "Dimanche",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "Heure De Fin De La Minuterie 1 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "Heure De Fin De La Minuterie 1_2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "Heure De Fin Du Créneau Horaire 1 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "Minute De Fin De La Minuterie 1 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "Minute De Fin De La Minuterie 1_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "Minute De Fin Du Créneau Horaire 1 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "Minute De Début De La Minuterie 1 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "Minute De Début De La Minuterie 1_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "Minute De Début Du Créneau Horaire 1 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "Heure De Fin De La Minuterie 2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "Heure De Fin De La Minuterie 2_2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "Heure De Fin Du Créneau Horaire 2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "Minute De Fin De La Minuterie 2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "Minute De Fin De La Minuterie 2_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "Minute De Fin Du Créneau Horaire 2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "Minute De Début De La Minuterie 2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "Minute De Début De La Minuterie 2_2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "Minute De Début Du Créneau Horaire 2 - Minute",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "Heure De Début De La Minuterie 1 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "Heure De Début De La Minuterie 1_2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "Heure De Début Du Créneau Horaire 1 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "Heure De Début De La Minuterie 2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "Heure De Début De La Minuterie 2_2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "Heure De Début Du Créneau Horaire 2 - Heure",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "Mode Programmée - Activation Soc Batterie",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "Mode Programmée - Soc Démarrage Batterie",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "Mode Programmée - Soc Arrêt Batterie",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "Lundi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "Mardi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "Mercredi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "Jeudi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "Vendredi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "Samedi",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "Dimanche",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "Mode De Fonctionnement Des Contacts Secs",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "Puissance De Décharge Maximale De La Batterie En Période De Pointe",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "Puissance D’injection Réseau En Période De Pointe",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "Puissance De Charge Maximale De La Batterie",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "Puissance De Décharge Maximale De La Batterie",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "Temps De Maintenance De La Batterie Au Plomb",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "Soc Maximal",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "Soc Minimal",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "Compensation De Puissance",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Puissance De Réserve Rsvd",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "Désactivation Du Contournement",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "Mode Eps",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "Activation Du Mode Photovoltaïque",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "Limite Supérieure De Fréquence Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "Limite Supérieure De Tension Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "Limite Inférieure De Fréquence Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "Limite Inférieure De Tension Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "Puissance De Charge De La Batterie Par Le Générateur En Parallèle Multi-Unités",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "Délai D’extinction Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "Activation Du Scan Global",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "Limitation De La Puissance Réseau",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "Activation Mid / Passerelle",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "Activation Du Déséquilibre Triphasé",
  "50901.ctrl_Safety.DCI.dciEnable": "Activation Dci",
  "50901.ctrl_Safety.DCI.lowerLimit": "Courant De Limite Inférieure Dci",
  "50901.ctrl_Safety.DCI.lowerTime": "Temps De Limite Inférieure Dci",
  "50901.ctrl_Safety.DCI.upperLimit": "Courant De Limite Supérieure Dci",
  "50901.ctrl_Safety.DCI.upperTime": "Temps De Limite Supérieure Dci",
  "50901.ctrl_Safety.FRT.frtFuncCode": "Code De Fonction Frt",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "Limite Supérieure De Fréquence 1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "Durée De La Limite Supérieure De Fréquence 1",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "Limite Supérieure De Fréquence 2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "Durée De La Limite Supérieure De Fréquence 2",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "Limite Supérieure De Fréquence 3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "Durée De La Limite Supérieure De Fréquence 3",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "Limite Inférieure De Fréquence 1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "Durée De La Limite Inférieure De Fréquence 1",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "Limite Inférieure De Fréquence 2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "Durée De La Limite Inférieure De Fréquence 2",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "Limite Inférieure De Fréquence 3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "Durée De La Limite Inférieure De Fréquence 3",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "Activation De La Différence De Mode Batterie Fw",
  "50901.ctrl_Safety.FW.fwEnable": "Activation Fw",
  "50901.ctrl_Safety.FW.fwFuncCode": "Code De Fonction Fw",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "Fréquence De Fin De Surcharge Fréquentielle Fw",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "Fréquence De Début De Surcharge Fréquentielle Fw",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "Fréquence De Transition De Surcharge Fréquentielle Fw",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "Limite Inférieure De Fréquence De Récupération Fw",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "Temps De Stabilisation De La Récupération Fw",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "Limite Supérieure De Fréquence De Récupération Fw",
  "50901.ctrl_Safety.FW.fwTr": "Temps Fw_Tr",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "Fréquence De Fin De Sous-Fréquence Fw",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "Fréquence De Début De Sous-Fréquence Fw",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "Fréquence D’arrêt De Sous-Fréquence Fw",
  "50901.ctrl_Safety.RCD.continueLimitTime": "Temps De Limite Continue Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.continueLimitValue": "Courant De Limite Continue Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.rcdEnable": "Activation Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step1LimitTime": "Temps De Limite De L’échelon 1 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step1LimitValue": "Courant De Limite De L’échelon 1 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step2LimitTime": "Temps De Limite De L’échelon 2 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step2LimitValue": "Courant De Limite De L’échelon 2 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step3LimitTime": "Temps De Limite De L’échelon 3 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RCD.step3LimitValue": "Courant De Limite De L’échelon 3 Du Disjoncteur Différentiel",
  "50901.ctrl_Safety.RPC.gcfEn": "Activation Gcf",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "Rapport De Limite Dure D’exportation Gcf",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "Rapport De Limite Douce D’exportation Gcf",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "Code De Fonction Gcf",
  "50901.ctrl_Safety.RPC.rpcMode": "Mode Rp",
  "50901.ctrl_Safety.RPC.rpcPf": "Facteur De Puissance Pf Rpc",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "Rapport De Puissance Réactive Rpc",
  "50901.ctrl_Safety.RPC.rpcTr": "Temps Rpc_Tr",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Code De Fonction Volt-Var",
  "50901.ctrl_Safety.RPC.vvLockIn": "Valeur De Verrouillage Vv",
  "50901.ctrl_Safety.RPC.vvLockOut": "Valeur De Déverrouillage Vv",
  "50901.ctrl_Safety.RPC.vvQ1": "Point De Consigne Réactif_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "Point De Consigne Réactif_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "Point De Consigne Réactif_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "Point De Consigne Réactif_Q4",
  "50901.ctrl_Safety.RPC.vvV1": "Point De Consigne Tension_V1",
  "50901.ctrl_Safety.RPC.vvV2": "Point De Consigne Tension_V2",
  "50901.ctrl_Safety.RPC.vvV3": "Point De Consigne Tension_V3",
  "50901.ctrl_Safety.RPC.vvV4": "Point De Consigne Tension_V4",
  "50901.ctrl_Safety.RPC.vvVref": "Valeur De Référence Volt-Var (Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "Temps Tr De La Valeur De Référence Volt-Var",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "Code De Fonction Wpf",
  "50901.ctrl_Safety.RPC.wpfLockIn": "Valeur De Verrouillage Wpf",
  "50901.ctrl_Safety.RPC.wpfLockOut": "Valeur De Déverrouillage Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "Pf Minimum De Surpuissance Wpf",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "Pf Minimum De Sous-Puissance Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "Rapport De Fin De Puissance Wpf",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "Rapport De Début De Puissance Wpf",
  "50901.ctrl_Safety.RR.rrFuncCode": "Code De Fonction Rr",
  "50901.ctrl_Safety.RR.rrRurNm": "Rr_Rur_Nm",
  "50901.ctrl_Safety.RR.rrRurSs": "Rr_Rur_Ss",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "Limite Supérieure De Récupération De Fréquence Rt",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "Limite Inférieure De Récupération De Fréquence Rt",
  "50901.ctrl_Safety.RT.rtFuncCode": "Code De Fonction Rt",
  "50901.ctrl_Safety.RT.rtNMTime": "Temps Rt_Nm",
  "50901.ctrl_Safety.RT.rtSRTTime": "Temps Rt_Srt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "Limite Supérieure De Récupération De Tension Rt",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "Limite Inférieure De Récupération De Tension Rt",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "Tension Moyenne Sur 10 Minutes",
  "50901.ctrl_Safety.VRT.vrtEn": "Activation Vrt",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "Code De Fonction Vrt",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "Seuil De Haute Tension Vrt",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "Seuil De Basse Tension Vrt",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "Temps De Stabilisation De La Récupération Vrt",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "Durée De La Surtension Transitoire",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "Seuil De Surtension Transitoire",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "Limite Supérieure De Tension 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "Durée De La Limite Supérieure De Tension 1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "Limite Supérieure De Tension 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "Durée De La Limite Supérieure De Tension 2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "Limite Supérieure De Tension 3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "Durée De La Limite Supérieure De Tension 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "Limite Inférieure De Tension 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "Durée De La Limite Inférieure De Tension 1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "Limite Inférieure De Tension 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "Durée De La Limite Inférieure De Tension 2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "Limite Inférieure De Tension 3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "Durée De La Limite Inférieure De Tension 3",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "Activation De La Différence De Mode Batterie Vw",
  "50901.ctrl_Safety.VW.vwEnable": "Activation Vw",
  "50901.ctrl_Safety.VW.vwFuncCode": "Code De Fonction Vw",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "Tension De Fin De Surtension Vw",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "Tension Kp / Tension De Coefficient De Surtension Vw",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "Tension De Début De Surtension Vw",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "Limite Inférieure De La Tension De Récupération Vw",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "Temps De Stabilisation De La Récupération Vw",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "Limite Supérieure De La Tension De Récupération Vw",
  "50901.ctrl_Safety.VW.vwTr": "Temps Vw_Tr",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "Tension De Fin De Sous-Tension Vw",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "Tension Kp / Tension De Coefficient De Sous-Tension Vw",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "Tension De Début De Sous-Tension Vw",
  "50901.ctrl_WorkMode.Backup.backupSoc": "Soc De Réserve",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "Soc En Mode Économique",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "Index De Date Du Mode Économique",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "Heure De Début De Pointe De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "Heure De Début De Pointe De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "Minute De Début De Pointe De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "Minute De Début De Pointe De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "Heure De Fin De Pointe De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "Heure De Fin De Pointe De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "Minute De Fin De Pointe De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "Minute De Fin De Pointe De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1StartDay": "Jour De Début De La Section 1",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "Mois De Début De La Section 1",
  "50901.ctrl_WorkMode.economic.section1StopDay": "Jour De Fin De La Section 1",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "Mois De Fin De La Section 1",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "Heure De Début Des Heures Creuses De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "Heure De Début Des Heures Creuses De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "Minute De Début Des Heures Creuses De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "Minute De Début Des Heures Creuses De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "Heure De Fin Des Heures Creuses De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "Heure De Fin Des Heures Creuses De La Section 1 - Heure",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "Minute De Fin Des Heures Creuses De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "Minute De Fin Des Heures Creuses De La Section 1 - Minute",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "Période 1 Groupe 1 Lundi",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "Période 1 Groupe 1 Mardi",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "Période 1 Groupe 1 Mercredi",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "Période 1 Groupe 1 Jeudi",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "Période 1 Groupe 1 Vendredi",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "Période 1 Groupe 1 Samedi",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "Période 1 Groupe 1 Dimanche",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "Période 1 Groupe 2 Lundi",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "Période 1 Groupe 2 Mardi",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "Période 1 Groupe 2 Mercredi",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "Période 1 Groupe 2 Jeudi",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "Période 1 Groupe 2 Vendredi",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "Période 1 Groupe 2 Samedi",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "Période 1 Groupe 2 Dimanche",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "Heure De Début De Pointe De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "Heure De Début De Pointe De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "Minute De Début De Pointe De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "Minute De Début De Pointe De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "Heure De Fin De Pointe De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "Heure De Fin De Pointe De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "Minute De Fin De Pointe De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "Minute De Fin De Pointe De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2StartDay": "Jour De Début De La Section 2",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "Mois De Début De La Section 2",
  "50901.ctrl_WorkMode.economic.section2StopDay": "Jour De Fin De La Section 2",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "Mois De Fin De La Section 2",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "Heure De Début Des Heures Creuses De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "Heure De Début Des Heures Creuses De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "Minute De Début Des Heures Creuses De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "Minute De Début Des Heures Creuses De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "Heure De Fin Des Heures Creuses De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "Heure De Fin Des Heures Creuses De La Section 2 - Heure",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "Minute De Fin Des Heures Creuses De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "Minute De Fin Des Heures Creuses De La Section 2 - Minute",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "Période 2 Groupe 1 Lundi",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "Période 2 Groupe 1 Mardi",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "Période 2 Groupe 1 Mercredi",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "Période 2 Groupe 1 Jeudi",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "Période 2 Groupe 1 Vendredi",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "Période 2 Groupe 1 Samedi",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "Période 2 Groupe 1 Dimanche",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "Période 2 Groupe 2 Lundi",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "Période 2 Groupe 2 Mardi",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "Période 2 Groupe 2 Mercredi",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "Période 2 Groupe 2 Jeudi",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "Période 2 Groupe 2 Vendredi",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "Période 2 Groupe 2 Samedi",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "Période 2 Groupe 2 Dimanche",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "Heure De Début De Pointe De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "Heure De Début De Pointe De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "Minute De Début De Pointe De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "Minute De Début De Pointe De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "Heure De Fin De Pointe De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "Heure De Fin De Pointe De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "Minute De Fin De Pointe De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "Minute De Fin De Pointe De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3StartDay": "Jour De Début De La Section 3",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "Mois De Début De La Section 3",
  "50901.ctrl_WorkMode.economic.section3StopDay": "Jour De Fin De La Section 3",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "Mois De Fin De La Section 3",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "Heure De Début Des Heures Creuses De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "Heure De Début Des Heures Creuses De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "Minute De Début Des Heures Creuses De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "Heure De Fin Des Heures Creuses De La Section 3 - Heure",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "Minute De Fin Des Heures Creuses De La Section 3 - Minute",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "Période 3 Groupe 1 Lundi",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "Période 3 Groupe 1 Mardi",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "Période 3 Groupe 1 Mercredi",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "Période 3 Groupe 1 Jeudi",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "Période 3 Groupe 1 Vendredi",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "Période 3 Groupe 1 Samedi",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "Période 3 Groupe 1 Dimanche",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "Plage Hebdomadaire 2 De La Section 3",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "Soc De Charge Forcée",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "Puissance De Charge Maximale",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "Soc De Décharge Forcée",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "Puissance De Décharge Maximale",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "Soc D’autoconsommation",
  "50901.ctrl_WorkMode.Switch.workMode": "Mode De Fonctionnement Du Sme",
  "50901.real_time.batteryCapacity": "Capacité Installée De La Batterie",
  "50901.real_time.BatteryModel": "Modèle De Batterie",
  "50901.real_time.inverterSn": "Sn De L’onduleur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "Mode Du Port Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "Emplacement Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "Temps De Synchronisation Du Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "Type De Générateur",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "Durée De Fonctionnement Maximale",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "Durée De Fonctionnement Minimale",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "Intervalle De Protection De Fonctionnement",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "Modèle De Compteur",
  "50901.real_time.batteryWorkingStatus.desc": "Description De L’état De La Batterie",
  "50901.real_time.batteryWorkingStatus.1": "Veille",
  "org.aiMessage.charge.fail": "",
  "org.aiMessage.charge.success": "",
  "org.aiMessage.discharge.fail": "",
  "org.aiMessage.discharge.success": "",
  "ai.message.charge.title.success": "Commande de charge réussie",
  "ai.message.charge.title.fail": "Échec de la commande de charge",
  "ai.message.charge.content.success": "Commande de charge exécutée avec succès. La stratégie d'IA fonctionne normalement.",
  "ai.message.charge.content.fail": "Échec de la commande de charge (3 tentatives auto). L'IA réessaiera lors des périodes suivantes. Contrôle manuel possible après désactivation du mode IA.",
  "ai.message.discharge.title.success": "Commande de décharge réussie",
  "ai.message.discharge.title.fail": "Échec de la commande de décharge",
  "ai.message.discharge.content.success": "Commande de décharge exécutée avec succès. La stratégie d'IA fonctionne normalement.",
  "ai.message.discharge.content.fail": "Échec de la commande de décharge (3 tentatives auto). L'IA réessaiera lors des périodes suivantes. Contrôle manuel possible après désactivation du mode IA.",
  "50901.fault.evCharger1CommunicationAbnormality": "Anomalie De Communication Borne De Recharge Véhicule Électrique 1",
  "50901.fault.bmsCanCommunicationAbnormality": "Anomalie De Communication Can Du Bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu3",
  "50901.fault.gridMeterTypeError": "Erreur De Type Du Compteur Réseau",
  "50901.fault.lowDtuVersion": "Version Dtu Trop Basse",
  "50901.fault.gridMeterCommunicationAbnormality": "Anomalie De Communication Du Compteur Réseau",
  "50901.fault.pvMeterTypeError": "Erreur De Type Du Compteur Photovoltaïque",
  "50901.fault.dspPwrCommunicationAbnormality": "Anomalie De Communication De L’alimentation Dsp",
  "50901.fault.evCharger2CommunicationAbnormality": "Anomalie De Communication Borne De Recharge Véhicule Électrique 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu5",
  "50901.fault.dtsCommunicationAbnormality": "Anomalie De Communication Dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu4",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu1",
  "50901.fault.pvMeterCommunicationAbnormality": "Anomalie De Communication Du Compteur Photovoltaïque",
  "50901.fault.slaveWrongBatteryConnection": "Erreur De Connexion De La Batterie Esclave",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "Anomalie De Communication Rs485 Dtu2",
  "50901.fault.dspSafCommunicationAbnormality": "Anomalie De Communication Sécurisée Dsp",
  "50901.fault.sustainedNegativeLoad": "Charge Négative Prolongée",
  "50901.fault.hmidMachineFault": "Défaut Du Dispositif Ihm",
  "50901.fault.evCharger1Fault": "Défaut Borne De Recharge 1",
  "50901.fault.evCharger2Fault": "Défaut Borne De Recharge 2",
  "50901.fault.fanSpeedAbnormality": "Vitesse Du Ventilateur Anormale",
  "50901.fault.masterSlaveCommunicationAbnormality": "Anomalie De Communication Maître-Esclave",
  "50901.fault.batteryCapacityAbnormality": "Capacité De La Batterie Anormale",
  "50901.fault.batteryForceChargeRequest": "Demande De Charge Forcée De La Batterie",
  "50901.fault.hmidCommunicationAbnormality": "Anomalie De Communication De L’ihm",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "Le générateur démarre périodiquement à cette heure",
  "50901.fault.loadRelayAfault.0": "Désactiver",
  "50901.fault.fiveVoltPowerSupplyfault.0": "Désactiver",
  "50901.fault.fiveVoltPowerSupplyfault.1": "Activer",
  "50901.fault.genRelayAfault.0": "Désactiver",
  "50901.fault.genRelayAfault.1": "Activer",
  "50901.fault.genRelayBfault.0": "Désactiver",
  "50901.fault.genRelayBfault.1": "Activer",
  "50901.fault.kmRelayfault.0": "Désactiver",
  "50901.fault.kmRelayfault.1": "Activer",
  "50901.fault.twelveVoltPowerSupplyfault.1": "Activer",
  "50901.fault.loadRelayAfault.1": "Activer",
  "50901.fault.loadRelayBfault.0": "Désactiver",
  "50901.fault.loadRelayBfault.1": "Activer",
  "50901.fault.pvRelayAbfault.0": "Désactiver",
  "50901.fault.pvRelayAbfault.1": "Activer",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "Désactiver",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "Activer",
  "50901.fault.twelveVoltPowerSupplyfault.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "Activer",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "Désactiver",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "Activer",
  "50901.fault.loadRelayAfault": "Défaillance du relais de charge A",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "Défaut d'alimentation 3,3V",
  "50901.fault.pvRelayAbfault": "Défaut du relais PV AB",
  "50901.fault.twelveVoltPowerSupplyfault": "Défaut d'alimentation 12V",
  "50901.fault.loadRelayBfault": "Défaillance du relais de charge B",
  "50901.fault.kmRelayfault": "Défaut du relais KM",
  "50901.fault.genRelayBfault": "Défaut du relais générateur B",
  "50901.fault.genRelayAfault": "Défaut du relais générateur A",
  "50901.fault.fiveVoltPowerSupplyfault": "Défaut d'alimentation 5V",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "Heure de démarrage du mode exercice du générateur jeudi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "Heure de démarrage du mode exercice du générateur mercredi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "Heure de démarrage du mode exercice du générateur vendredi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "Heure de démarrage du mode exercice du générateur samedi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "Heure de démarrage du mode exercice du générateur mardi",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "Heure de démarrage du mode exercice du générateur dimanche",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "Heure de démarrage du mode exercice du générateur lundi",
  "50901.fault.evCharger1CommunicationAbnormality.0": "Désactiver",
  "50901.fault.evCharger1CommunicationAbnormality.1": "Activer",
  "50901.fault.bmsCanCommunicationAbnormality.0": "Désactiver",
  "50901.fault.bmsCanCommunicationAbnormality.1": "Activer",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "Activer",
  "50901.fault.gridMeterTypeError.0": "Désactiver",
  "50901.fault.gridMeterTypeError.1": "Activer",
  "50901.fault.lowDtuVersion.0": "Désactiver",
  "50901.fault.lowDtuVersion.1": "Activer",
  "50901.fault.gridMeterCommunicationAbnormality.0": "Désactiver",
  "50901.fault.gridMeterCommunicationAbnormality.1": "Activer",
  "50901.fault.pvMeterTypeError.0": "Désactiver",
  "50901.fault.pvMeterTypeError.1": "Activer",
  "50901.fault.dspPwrCommunicationAbnormality.0": "Désactiver",
  "50901.fault.dspPwrCommunicationAbnormality.1": "Activer",
  "50901.fault.evCharger2CommunicationAbnormality.0": "Désactiver",
  "50901.fault.evCharger2CommunicationAbnormality.1": "Activer",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "Activer",
  "50901.fault.dtsCommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtsCommunicationAbnormality.1": "Activer",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "Activer",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "Activer",
  "50901.fault.pvMeterCommunicationAbnormality.0": "Désactiver",
  "50901.fault.pvMeterCommunicationAbnormality.1": "Activer",
  "50901.fault.slaveWrongBatteryConnection.0": "Désactiver",
  "50901.fault.slaveWrongBatteryConnection.1": "Activer",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "Désactiver",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "Activer",
  "50901.fault.dspSafCommunicationAbnormality.0": "Désactiver",
  "50901.fault.dspSafCommunicationAbnormality.1": "Activer",
  "50901.fault.sustainedNegativeLoad.0": "Désactiver",
  "50901.fault.sustainedNegativeLoad.1": "Activer",
  "50901.fault.hmidMachineFault.0": "Désactiver",
  "50901.fault.hmidMachineFault.1": "Activer",
  "50901.fault.evCharger1Fault.0": "Désactiver",
  "50901.fault.evCharger1Fault.1": "Activer",
  "50901.fault.evCharger2Fault.0": "Désactiver",
  "50901.fault.evCharger2Fault.1": "Activer",
  "50901.fault.fanSpeedAbnormality.0": "Désactiver",
  "50901.fault.fanSpeedAbnormality.1": "Activer",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "Désactiver",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "Activer",
  "50901.fault.batteryCapacityAbnormality.0": "Désactiver",
  "50901.fault.batteryCapacityAbnormality.1": "Activer",
  "50901.fault.batteryForceChargeRequest.0": "Désactiver",
  "50901.fault.batteryForceChargeRequest.1": "Activer",
  "50901.fault.hmidCommunicationAbnormality.0": "Désactiver",
  "50901.fault.hmidCommunicationAbnormality.1": "Activer",
  "50901.fault.batteryFault": "Défaut De La Batterie",
  "50901.fault.fanFault.0": "Désactiver",
  "50901.fault.armCommunicationFault.1": "Activer",
  "50901.fault.batteryFault.0": "Désactiver",
  "50901.fault.batteryFault.1": "Activer",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "Description De L’anomalie De Communication Borne De Recharge Véhicule Électrique 1",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "Description De L’anomalie De Communication Can Du Bms",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "Description De L’anomalie De Communication Rs485 Dtu3",
  "50901.fault.gridMeterTypeError.desc": "Description De L’erreur De Type Du Compteur Réseau",
  "50901.fault.lowDtuVersion.desc": "Description De La Version Dtu Trop Basse",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "Description De L’anomalie De Communication Du Compteur Réseau",
  "50901.fault.pvMeterTypeError.desc": "Description De L’erreur De Type Du Compteur Photovoltaïque",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "Description De L’anomalie De Communication De L’alimentation Dsp",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "Description De L’anomalie De Communication Borne De Recharge Véhicule Électrique 2",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "Description De L’anomalie De Communication Rs485 Dtu5",
  "50901.fault.dtsCommunicationAbnormality.desc": "Description De L’anomalie De Communication Dts",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "Description De L’anomalie De Communication Rs485 Dtu4",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "Description De L’anomalie De Communication Rs485 Dtu1",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "Description De L’anomalie De Communication Du Compteur Photovoltaïque",
  "50901.fault.slaveWrongBatteryConnection.desc": "Description De L’erreur De Connexion De La Batterie Esclave",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "Description De L’anomalie De Communication Rs485 Dtu2",
  "50901.fault.dspSafCommunicationAbnormality.desc": "Description De L’anomalie De Communication Sécurisée Dsp",
  "50901.fault.sustainedNegativeLoad.desc": "Description De La Charge Négative Prolongée",
  "50901.fault.hmidMachineFault.desc": "Description De Défaut Du Dispositif Ihm",
  "50901.fault.evCharger1Fault.desc": "Description De Défaut Borne De Recharge 1",
  "50901.fault.evCharger2Fault.desc": "Description De Défaut Borne De Recharge 2",
  "50901.fault.fanSpeedAbnormality.desc": "Description De La Vitesse Du Ventilateur Anormale",
  "50901.fault.batteryFault.desc": "Description De Défaut De La Batterie",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "Description De L’anomalie De Communication Maître-Esclave",
  "50901.fault.batteryCapacityAbnormality.desc": "Description De La Capacité De La Batterie Anormale",
  "50901.fault.batteryForceChargeRequest.desc": "Description De La Demande De Charge Forcée De La Batterie",
  "50901.fault.hmidCommunicationAbnormality.desc": "Description De L’anomalie De Communication De L’ihm",
  "50901.fault.evCharger1CommunicationAbnormality.00": "Désactiver",
  "50901.fault.evCharger1CommunicationAbnormality.01": "Activer",
  "50901.fault.bmsCanCommunicationAbnormality.00": "Désactiver",
  "50901.fault.bmsCanCommunicationAbnormality.01": "Activer",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "Activer",
  "50901.fault.gridMeterTypeError.00": "Désactiver",
  "50901.fault.gridMeterTypeError.01": "Activer",
  "50901.fault.lowDtuVersion.00": "Désactiver",
  "50901.fault.lowDtuVersion.01": "Activer",
  "50901.fault.gridMeterCommunicationAbnormality.00": "Désactiver",
  "50901.fault.gridMeterCommunicationAbnormality.01": "Activer",
  "50901.fault.pvMeterTypeError.00": "Désactiver",
  "50901.fault.pvMeterTypeError.01": "Activer",
  "50901.fault.dspPwrCommunicationAbnormality.00": "Désactiver",
  "50901.fault.dspPwrCommunicationAbnormality.01": "Activer",
  "50901.fault.evCharger2CommunicationAbnormality.00": "Désactiver",
  "50901.fault.evCharger2CommunicationAbnormality.01": "Activer",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "Activer",
  "50901.fault.dtsCommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtsCommunicationAbnormality.01": "Activer",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "Activer",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "Activer",
  "50901.fault.pvMeterCommunicationAbnormality.00": "Désactiver",
  "50901.fault.pvMeterCommunicationAbnormality.01": "Activer",
  "50901.fault.slaveWrongBatteryConnection.00": "Désactiver",
  "50901.fault.slaveWrongBatteryConnection.01": "Activer",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "Désactiver",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "Activer",
  "50901.fault.dspSafCommunicationAbnormality.00": "Désactiver",
  "50901.fault.dspSafCommunicationAbnormality.01": "Activer",
  "50901.fault.sustainedNegativeLoad.00": "Désactiver",
  "50901.fault.sustainedNegativeLoad.01": "Activer",
  "50901.fault.hmidMachineFault.00": "Désactiver",
  "50901.fault.hmidMachineFault.01": "Activer",
  "50901.fault.evCharger1Fault.00": "Désactiver",
  "50901.fault.evCharger1Fault.01": "Activer",
  "50901.fault.evCharger2Fault.00": "Désactiver",
  "50901.fault.evCharger2Fault.01": "Activer",
  "50901.fault.fanSpeedAbnormality.00": "Désactiver",
  "50901.fault.fanSpeedAbnormality.01": "Activer",
  "50901.fault.batteryFault.00": "Désactiver",
  "50901.fault.batteryFault.01": "Activer",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "Désactiver",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "Activer",
  "50901.fault.batteryCapacityAbnormality.00": "Désactiver",
  "50901.fault.batteryCapacityAbnormality.01": "Activer",
  "50901.fault.batteryForceChargeRequest.00": "Désactiver",
  "50901.fault.batteryForceChargeRequest.01": "Activer",
  "50901.fault.hmidCommunicationAbnormality.00": "Désactiver",
  "50901.fault.hmidCommunicationAbnormality.01": "Activer",
  "alarm.excDesc.2047494139783155712": "Défaut de communication ARM",
  "alarm.name.2047494139783155712": "Défaut de communication ARM",
  "plant.create.type.0": "Installateur",
  "plant.create.type.1": "Utilisateur final",
  "not.configured": "Non configuré",
  "10001.quickset.note1": "1. Mode d'autoconsommation : Le réglage recommandé est le mode d'autoconsommation. Ce mode maximise l'utilisation de la production photovoltaïque pour l'électricité domestique ou la stocke dans les batteries pour un usage domestique. 2. Mode d'injection prioritaire : Ce mode permet d'envoyer prioritairement l'énergie au réseau lorsque la charge est satisfaite, utilisé dans les zones avec subvention pour l'injection réseau. 3. Mode d'écrêtement des pointes : Après avoir réglé le mode d'autoconsommation ou d'injection prioritaire, l'écrêtement des pointes réseau peut également être sélectionné lorsque le fournisseur local facture l'électricité en fonction de la puissance de pointe du système. Les clients peuvent activer cette option pour éviter la puissance de pointe au point de connexion au réseau. 4. Mode hors réseau : Ce mode est uniquement destiné au pur hors réseau et n'est pas recommandé pour les systèmes de stockage standard. Notez que si ce mode est activé en état connecté au réseau, la logique de fonctionnement de l'appareil sera perturbée et \"Hors réseau\" s'affichera. 5. Utilisation horaire : Si vous devez contrôler manuellement la charge et la décharge de la batterie en fonction du temps sous les modes d'autoconsommation, d'injection prioritaire ou d'écrêtement des pointes, utilisez l'interrupteur d'utilisation horaire et les points de consigne suivants. L'option \"Autoriser la charge réseau\" dans ces trois modes est recommandée activée (si désactivée, l'onduleur ne forcera pas la charge de la batterie, et la batterie pourrait passer en veille).",
  "10001.quickset.note2": "1. Mode d'utilisation autonome : Le paramètre recommandé est le mode d'utilisation autonome. Ce mode peut maximiser l'utilisation de la production d'énergie photovoltaïque pour l'électricité domestique ou la stocker dans des batteries et l'utiliser pour l'électricité domestique ;\n2. Alimentation en mode prioritaire : Ce mode peut préférentiellement envoyer de l'électricité au réseau lorsque la charge est satisfaite, utilisé dans les zones bénéficiant d'une subvention pour l'alimentation du réseau ;\n3. Mode de rasage de pointe : après avoir réglé le mode Auto-utilisation ou Alimentation en priorité, le rasage de pointe du réseau peut également être sélectionné lorsque la société de réseau locale facture le prix de l'électricité en fonction de la consommation d'énergie de pointe du système. Les clients peuvent sélectionner ce rasage de pointe pour éviter la consommation d'énergie de pointe au point de connexion au réseau ;\n4. Mode hors réseau : Ce mode n'est utilisé que pour le hors réseau pur et n'est pas recommandé pour les systèmes de stockage standard. Notez que si ce mode est activé dans l'état connecté au réseau, la logique de travail de la machine sera confuse et le \"Hors réseau\" sera affiché ;\n5. Temps d'utilisation : Si vous devez contrôler manuellement la charge et la décharge de la batterie par rapport au temps passé en mode Auto-utilisation ou Alimentation en mode Priorité ou Rasage de pointe, veuillez utiliser le commutateur Temps d'utilisation et les points de consigne suivants. Et le \"Autoriser la charge du réseau\" dans ces 3 modes est ou recommandé d'être activé (s'il est éteint, l'onduleur ne forcera pas la charge de la batterie, et la batterie pourrait potentiellement se mettre en veille).",
  "10001.quickset.note3": "1. Mode d'utilisation autonome : Le paramètre recommandé est le mode d'utilisation autonome. Ce mode peut maximiser l'utilisation de la production d'énergie photovoltaïque pour l'électricité domestique ou la stocker dans des batteries et l'utiliser pour l'électricité domestique ;\n2. Alimentation en mode prioritaire : Ce mode peut préférentiellement envoyer de l'électricité au réseau lorsque la charge est satisfaite, utilisé dans les zones bénéficiant d'une subvention pour l'alimentation du réseau ;\n3. Mode hors réseau : Ce mode n'est utilisé que pour le hors réseau pur et n'est pas recommandé pour les systèmes de stockage standard. Notez que si ce mode est activé dans l'état connecté au réseau, la logique de travail de la machine sera confuse et le \"Hors réseau\" sera affiché ;\n4. Temps d'utilisation : Si vous devez contrôler manuellement la charge et la décharge de la batterie par rapport au temps passé en mode Auto-utilisation ou Alimentation en mode Priorité ou Rasage de pointe, veuillez utiliser le commutateur Temps d'utilisation et les points de consigne suivants. Et le \"Autoriser la charge du réseau\" dans ces 3 modes est ou recommandé d'être activé (s'il est éteint, l'onduleur ne forcera pas la charge de la batterie, et la batterie pourrait potentiellement se mettre en veille).",
  "chinaAreas.Shandong": "Shandong",
  "country.China": "Chine",
  "json.50901.workmode.timeSection": "Période de temps",
  "json.device.dryWorking": "Travail à sec",
  "device.dryWorking": "Travail à sec",
  "51002.ctrl_antireverse": "Contrôle anti-retour",
  "51002.ctrl_inverter": "Contrôle",
  "51002.null.数据分析_实时监控_PV.tag": "Surveillance en temps réel_PV",
  "51002.real_time": "Surveillance en temps réel",
  "51002.real_time.Energy_PV1.desc": "Énergie accumulée PV1",
  "51002.real_time.Energy_PV2.desc": "Énergie accumulée PV2",
  "51002.real_time.Energy_PV3.desc": "Énergie accumulée PV3",
  "51002.real_time.Energy_PV4.desc": "Énergie accumulée PV4",
  "51002.real_time.gridTotalFrequency.desc": "Fréquence totale du réseau",
  "51002.real_time.inverterTemp.desc": "Température de l’onduleur",
  "51002.real_time.pvPower.desc": "Puissance de sortie PV",
  "51002.real_time.stRelayoN.desc": "État de connexion du relais",
  "51002.real_time.workStatus.desc": "État de fonctionnement",
  "51002.real_time.数据分析_实时监控_GRID.tag": "Données du réseau",
  "51002.real_time.数据分析_实时监控_P.tag": "Puissance de sortie PV",
  "51002.real_time.数据分析_实时监控_PV.tag": "PV",
  "51002.real_time.数据分析_实时监控_TP.tag": "Température de l’onduleur",
  "51002.warning": "Alarme",
  "51002.warning.stAbnorm_Ris.desc": "Anomalie d’impédance d’isolement",
  "51002.warning.stErrAccess_EEPROM.desc": "Anomalie d’accès EEPROM",
  "51002.warning.stErrOP_Relay.desc": "Anomalie du relais côté réseau",
  "51002.warning.stHW_Fault.desc": "Protection matérielle de l’onduleur",
  "51002.warning.stOV_Fgrid.desc": "Protection contre sur-fréquence côté réseau",
  "51002.warning.stOV_Temp.desc": "Protection contre surtempérature de l’onduleur",
  "51002.warning.stOV_Vgrid.desc": "Protection contre surtension côté réseau",
  "51002.warning.stPV1_OV.desc": "Surtension entrée PV 1",
  "51002.warning.stPV1_UV.desc": "Sous-tension entrée PV 1",
  "51002.warning.stPV2_OV.desc": "Surtension entrée PV 2",
  "51002.warning.stPV2_UV.desc": "Sous-tension entrée PV 2",
  "51002.warning.stPV3_OV.desc": "Surtension entrée PV 3",
  "51002.warning.stPV3_UV.desc": "Sous-tension entrée PV 3",
  "51002.warning.stPV4_OV.desc": "Surtension entrée PV 4",
  "51002.warning.stPV4_UV.desc": "Sous-tension entrée PV 4",
  "51002.warning.stUV_Fgrid.desc": "Protection contre sous-fréquence côté réseau",
  "51002.warning.stUV_Vgrid.desc": "Protection contre sous-tension côté réseau",
  "51002..gridtype.desc": "Norme réseau",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "Désactiver",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "Activer",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "Désactiver",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "Activer",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "Désactiver",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "Activer",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "Désactiver",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "Activer",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "Désactiver",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "Activer",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "Désactiver",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "Activer",
  "51002.ctrl_inverter.enaRestoretodefault.0": "Désactiver",
  "51002.ctrl_inverter.enaRestoretodefault.1": "Activer",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "Désactiver",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "Activer",
  "51002.real_time.stRelayoN.0": "Déconnecter",
  "51002.real_time.stRelayoN.1": "Fermer",
  "51002.real_time.workStatus.0": "Arrêt",
  "51002.real_time.workStatus.1": "Mise sous tension",
  "51002.warning.stAbnorm_Ris.0": "Fonctionnement normal",
  "51002.warning.stAbnorm_Ris.1": "Déclencher alarme",
  "51002.warning.stErrAccess_EEPROM.0": "Fonctionnement normal",
  "51002.warning.stErrAccess_EEPROM.1": "Déclencher alarme",
  "51002.warning.stErrOP_Relay.0": "Fonctionnement normal",
  "51002.warning.stErrOP_Relay.1": "Déclencher alarme",
  "51002.warning.stHW_Fault.0": "Fonctionnement normal",
  "51002.warning.stHW_Fault.1": "Déclencher alarme",
  "51002.warning.stOV_Fgrid.0": "Fonctionnement normal",
  "51002.warning.stOV_Fgrid.1": "Déclencher alarme",
  "51002.warning.stOV_Temp.0": "Fonctionnement normal",
  "51002.warning.stOV_Temp.1": "Déclencher alarme",
  "51002.warning.stOV_Vgrid.0": "Fonctionnement normal",
  "51002.warning.stOV_Vgrid.1": "Déclencher alarme",
  "51002.warning.stPV1_OV.0": "Fonctionnement normal",
  "51002.warning.stPV1_OV.1": "Déclencher alarme",
  "51002.warning.stPV1_UV.0": "Fonctionnement normal",
  "51002.warning.stPV1_UV.1": "Déclencher alarme",
  "51002.warning.stPV2_OV.0": "Fonctionnement normal",
  "51002.warning.stPV2_OV.1": "Déclencher alarme",
  "51002.warning.stPV2_UV.0": "Fonctionnement normal",
  "51002.warning.stPV2_UV.1": "Déclencher alarme",
  "51002.warning.stPV3_OV.0": "Fonctionnement normal",
  "51002.warning.stPV3_OV.1": "Déclencher alarme",
  "51002.warning.stPV3_UV.0": "Fonctionnement normal",
  "51002.warning.stPV3_UV.1": "Déclencher alarme",
  "51002.warning.stPV4_OV.0": "Fonctionnement normal",
  "51002.warning.stPV4_OV.1": "Déclencher alarme",
  "51002.warning.stPV4_UV.0": "Fonctionnement normal",
  "51002.warning.stPV4_UV.1": "Déclencher alarme",
  "51002.warning.stUV_Fgrid.0": "Fonctionnement normal",
  "51002.warning.stUV_Fgrid.1": "Déclencher alarme",
  "51002.warning.stUV_Vgrid.0": "Fonctionnement normal",
  "51002.warning.stUV_Vgrid.1": "Déclencher alarme",
  "51002.ctrl_inverter.ena10mVs1Prot": "Activation de la protection contre surtension moyenne de niveau 1 côté réseau sur 10 minutes",
  "51002.ctrl_inverter.enaINVTR.0": "Arrêt",
  "51002.ctrl_inverter.enaINVTR.1": "Mise sous tension",
  "51002.ctrl_inverter.enaOVTPWDN.0": "Désactiver",
  "51002.ctrl_inverter.enaOVTPWDN.1": "Activer",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "Interrupteur de fonction d’autotest de l’interface de protection système",
  "51002.real_time.Energy_PV1": "Production d’énergie cumulative PV1",
  "51002.real_time.Energy_PV2": "Production d’énergie cumulative PV2",
  "51002.real_time.Energy_PV3": "Production d’énergie cumulative PV3",
  "51002.real_time.Energy_PV4": "Production d’énergie cumulative PV4",
  "51002.real_time.Firmware_ver": "Numéro de version du firmware",
  "51002.real_time.Fn": "Fréquence nominale du réseau raccordé",
  "51002.real_time.gridTotalFrequency": "Fréquence totale",
  "51002.real_time.Iacrms": "Valeur efficace du courant côté réseau",
  "51002.real_time.inverterTemp": "Température de l’onduleur",
  "51002.real_time.Ipv1": "Courant d’entrée PV1",
  "51002.real_time.Ipv2": "Courant d’entrée PV2",
  "51002.real_time.Ipv3": "Courant d’entrée PV3",
  "51002.real_time.Ipv4": "Courant d’entrée PV4",
  "51002.real_time.Ipvmax": "Courant PV d’entrée maximal",
  "51002.real_time.Irmsmax": "Valeur efficace maximale du courant de raccordement au réseau",
  "51002.real_time.Pn": "Puissance active maximale raccordée au réseau",
  "51002.real_time.powerGeneration": "Production d’énergie totale",
  "51002.real_time.Powpvmax": "Puissance PV d’entrée maximale",
  "51002.real_time.pvPower": "Puissance de sortie PV",
  "51002.real_time.stRelayoN": "État de connexion du relais",
  "51002.real_time.Tempmax": "Température de fonctionnement maximale",
  "51002.real_time.Un": "Valeur efficace de la tension nominale de raccordement au réseau",
  "51002.real_time.Vacrms": "Valeur efficace de la tension côté réseau",
  "51002.real_time.Vmpptmax": "Tension MPPT maximale",
  "51002.real_time.Vmpptmin": "Tension MPPT minimale",
  "51002.real_time.Vpv1": "Tension d’entrée PV1",
  "51002.real_time.Vpv2": "Tension d’entrée PV2",
  "51002.real_time.Vpv3": "Tension d’entrée PV3",
  "51002.real_time.Vpv4": "Tension d’entrée PV4",
  "51002.real_time.workStatus": "État de fonctionnement",
  "51002.warning.stAbnorm_Ris": "Anomalie d’impédance d’isolement",
  "51002.warning.stErrAccess_EEPROM": "Anomalie d’accès EEPROM",
  "51002.warning.stErrOP_Relay": "Protection contre anomalie du relais côté réseau",
  "51002.warning.stHW_Fault": "Protection matérielle de l’onduleur",
  "51002.warning.stOV_Fgrid": "Protection contre sur-fréquence côté réseau",
  "51002.warning.stOV_Temp": "Protection contre surtempérature de l’onduleur",
  "51002.warning.stOV_Vgrid": "Protection contre surtension côté réseau",
  "51002.warning.stPV1_OV": "Surtension entrée PV 1",
  "51002.warning.stPV1_UV": "Sous-tension entrée PV 1",
  "51002.warning.stPV2_OV": "Surtension entrée PV 2",
  "51002.warning.stPV2_UV": "Sous-tension entrée PV 2",
  "51002.warning.stPV3_OV": "Surtension entrée PV 3",
  "51002.warning.stPV3_UV": "Sous-tension entrée PV 3",
  "51002.warning.stPV4_OV": "Surtension entrée PV 4",
  "51002.warning.stPV4_UV": "Sous-tension entrée PV 4",
  "51002.warning.stUV_Fgrid": "Protection contre sous-fréquence côté réseau",
  "51002.warning.stUV_Vgrid": "Protection contre sous-tension côté réseau",
  "51002.ctrl_antireverse.dynamicPowerLimit": "Valeur de pourcentage de limite de puissance anti-retour",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "Activation anti-retour",
  "51002.ctrl_inverter.enaAPP_PWSET": "Activation du réglage de puissance utilisateur",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "Activation de la régulation de puissance par décalage de fréquence",
  "51002.ctrl_inverter.enaINVTR": "Marche/Arrêt à distance de l’onduleur",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "Activation de la protection contre anomalie d’impédance d’isolement",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "Activation du déclassement de surtension de premier niveau",
  "51002.ctrl_inverter.enaOVTPWDN": "Activation du déclassement en cas de surtempérature",
  "51002.ctrl_inverter.enaRestoretodefault": "Restaurer les valeurs de protection par défaut et les commutateurs de fonction",
  "51002.ctrl_inverter.powersetUserApp": "Pourcentage de limite de puissance utilisateur",
  "bw_param_ctrl_option_BackupMode": "Mode alimentation secours",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "Priorité injection réseau",
  "50657.fault.comStatus": "État de communication",
  "50657.fault.comStatus.00": "Déconnecté",
  "50657.fault.comStatus.01": " Connecté",
  "50657.realtime.FADE": "Énergie active vallée profonde avant",
  "50657.realtime.FAFE": "Énergie active pleine charge avant",
  "50657.realtime.FAFE_PSD": "Énergie active pleine charge avant (jour de facturation précédent)",
  "50657.realtime.FAPE": " Énergie active pointe avant",
  "50657.realtime.FAPE_PSD": "Abrechnungstag)Énergie active pointe avant (jour de facturation précédent)",
  "50657.realtime.FAPVE": "Énergie active pointe et vallée avant",
  "50657.realtime.FAPVE_PSD": "Énergie active pointe et vallée avant (jour de facturation précédent)",
  "50657.realtime.FASE": "Énergie active super pointe avant",
  "50657.realtime.FASE_PSD": "Énergie active super pointe avant (jour de facturation précédent)",
  "50657.realtime.FAVE": "Énergie active vallée avant",
  "50657.realtime.FAVE_PSD": "Énergie active vallée avant (jour de facturation précédent)",
  "50657.realtime.FTAE": "Énergie active totale avant",
  "50657.realtime.FTAE_PSD": "Énergie active totale avant (jour de facturation précédent)",
  "50657.realtime.Fr": "Fréquence",
  "50657.realtime.Ia": " Courant phase A",
  "50657.realtime.Ib": "Courant phase B",
  "50657.realtime.Ic": "Courant phase C",
  "50657.realtime.P": "Puissance active totale",
  "50657.realtime.Pa": "Puissance active totale phase A",
  "50657.realtime.Pb": "Puissance active totale phase B",
  "50657.realtime.Pc": "Puissance active totale phase C",
  "50657.realtime.Pf": "Facteur de puissance total",
  "50657.realtime.Pfa": "Facteur de puissance phase A",
  "50657.realtime.Pfb": "Facteur de puissance phase B",
  "50657.realtime.Pfc": "Facteur de puissance phase C",
  "50657.realtime.Q": "Puissance réactive totale",
  "50657.realtime.Qa": "Puissance réactive totale phase A",
  "50657.realtime.Qb": "Puissance réactive totale phase B",
  "50657.realtime.Qc": "Puissance réactive totale phase C",
  "50657.realtime.RADE": "Énergie active vallée profonde inverse",
  "50657.realtime.RAFE": "Énergie active pleine charge inverse",
  "50657.realtime.RAPE": "Énergie active pointe inverse",
  "50657.realtime.RASE": "Énergie active super pointe inverse",
  "50657.realtime.RAVE": "Énergie active vallée invers",
  "50657.realtime.RTAE": "Énergie active totale inverse",
  "50657.realtime.S": " Puissance apparente totale",
  "50657.realtime.Sa": "Puissance apparente phase A",
  "50657.realtime.Sb": "Puissance apparente phase B",
  "50657.realtime.Sc": "Puissance apparente phase C",
  "50657.realtime.T": "Température",
  "50657.realtime.Ua": "Tension phase A",
  "50657.realtime.Uab": "Tension ligne AB",
  "50657.realtime.Ub": "Tension phase B",
  "50657.realtime.Ubc": "Tension ligne BC",
  "50657.realtime.Uc": "Tension phase C",
  "50657.realtime.Uca": "Tension ligne CA",
  "50657.realtime.Z0": "Impédance séquence nulle",
  "50657.realtime.Zf": "Impédance directe",
  "bw_param_ctrl_note_DispatchActivepower": "Définir ces données sur un nombre positif indique la nécessité d'une décharge, tandis que les définir sur un nombre négatif indique la nécessité d'une charge.",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "Charge/Décharge forcée",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "Utilisation de la grille CT、Utilisation PV Meter",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "Utilisation de la grille Meter、PV utilisation CT",
  "bw_param_ctrl_option_DisableTimePeriodControl": "Désactiver le contrôle de période de temps",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "Activer uniquement le contrôle de période de temps de charge",
  "bw_RTparam_name_TotalApparentPower_Grid": "Puissance apparente du compteur (Totale)",
  "bw_param_ctrl_name_FactoryReset ": "Réinitialisation d'usine",
  "bw_param_ctrl_option_FactoryReset ": "Redémarrer",
  "bw_param_ctrl_note_DSPReset": "Lorsque les informations de défaut sont incohérentes avec la situation réelle, elles peuvent être récupérées en redémarrant le DSP. Par exemple, si l'application subit un défaut de perte du fil de terre, mais que le fil de terre connecté à l'onduleur n'est pas déconnecté, il peut être récupéré en redémarrant le DSP.",
  "bw_param_ctrl_note_EMSReset": "Lorsqu'une collecte de données anormale se produit, veuillez réinitialiser l'EMS pour récupérer le système.",
  "bw_param_ctrl_note_FactoryReset": "Si vous souhaitez définir tous les paramètres de l'onduleur sur les valeurs par défaut, cette fonction peut être utilisée.",
  "bw_param_ctrl_option_Grid&PVuseCT": "Réseau & PV utilisent CT",
  "bw_param_outage_soc_setting": "Paramètre SOC de coupure de courant",
  "netherland.areas": "The Netherlands",
  "paramSet.grouping.safetySetting": "Paramètres de sécurité réglementaire",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "Priorité aux revenus de la centrale",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "isShowService.show": "show",
  "subtitle.warn": "Alarme",
  "subtitle.fault": "La faute",
  "transfer.operation.success": "",
  "transfer.operation.fail": "",
  "transfer.operation.unbind": "",
  "transfer.operation.withdraw": "",
  "title.login": "Se connecter",
  "title.vistorLogin": "Login pour les visiteurs",
  "title.createAccount": "Créer un compte",
  "title.retrievePassword": "Récupérer le mot de passe",
  "title.userAgreement": "Accord utilisateur",
  "title.privacyPolicy": "Accord de confidentialité",
  "title.phone": "Téléphone",
  "title.addPlant": "Ajouter une station électrique",
  "title.editPlant": "Modifier la station",
  "title.accountInfo": "Informations sur le compte",
  "title.changePassword": "Modifier le mot de passe",
  "title.message": "Message",
  "title.systemMessage": "Messages système",
  "title.faultMessage": "Message de défaillance",
  "title.deviceMessage": "Message de l'appareil",
  "title.aboutUs": "À propos",
  "title.device": "Équipement",
  "title.datalogger": "Collecteur",
  "title.setting": "Paramètres",
  "title.socketSetting": "Paramètres de prise",
  "title.addSchedule": "Ajouter une minuterie",
  "title.editSchedule": "Modifier la minuterie",
  "title.repetitionTime": "Temps de répétition",
  "title.addDatalogger": "Ajouter un équipement",
  "title.connectWifi": "Routage de connexion",
  "title.distributionNetworkStatus": "État du réseau de distribution",
  "title.language": "Langue",
  "title.selectCountry": "Sélectionner un pays",
  "title.selectCity": "Choisir une ville",
  "bar.home": "Accueil",
  "bar.energy": "Analyse",
  "bar.plant": "Station électrique",
  "bar.user": "Utilisateurs",
  "bar.endpoint": "Le terminal",
  "bar.mine": "Le mien",
  "bar.my": "Le mien",
  "button.logOut": "Quitter",
  "button.rememberMe": "Mémoriser le numéro de compte mot de passe",
  "button.forgetPassword": "Mot de passe oublié",
  "button.register": "Enregistrement",
  "button.send": "Envoyer",
  "button.auto": "Automatique",
  "button.cancle": "Annuler",
  "button.yes": "Oui",
  "button.close": "Fermé",
  "button.refresh": "Rafraîchir",
  "button.next": "Prochaines étapes",
  "button.redistributionNetwork": "Réallocation du réseau",
  "button.upload": "Télécharger",
  "button.edit": "Modifier",
  "button.delete": "Supprimer",
  "button.save": "Sauvegarder",
  "button.allReady": "Tous lus",
  "button.selectAll": "Tout sélectionner",
  "button.deselectAll": "Annuler toute la sélection",
  "button.unsubscribe": "Déconnexion du compte",
  "button.later": "Plus tard",
  "button.upgrade": "Mise à jour",
  "button.unfollow": "Annuler suivre",
  "button.add": "Ajouter",
  "subtitle.NeedMoreHelp": "Plus d'aide",
  "subtitle.VisitSupportCenter": "Consultez le site officiel pour plus d'aide",
  "subtitle.energyFlowDiagram": "Diagramme de flux d'énergie",
  "subtitle.selectTimezone": "Choisir un fuseau horaire",
  "subtitle.selectPlantType": "Choisir le type de station",
  "subtitle.selectInstallationDate": "Choisissez la date d'installation",
  "subtitle.selectCurrency": "Choisir une devise",
  "subtitle.selectDateType": "Choisissez le type de date",
  "subtitle.selectDeviceType": "Choisissez le type d'appareil",
  "subtitle.socketBluetooth": "Prise Bluetooth",
  "subtitle.log": "Logs",
  "subtitle.all": "Tous",
  "subtitle.online": "En ligne",
  "subtitle.offline": "Hors ligne",
  "subtitle.normal": "Normale",
  "subtitle.abnormal": "Anomalies",
  "subtitle.on": "Ouvrir",
  "subtitle.off": "Fermer",
  "subtitle.todayEnergy": "Electricité aujourd'hui",
  "subtitle.totalEnergy": "Quantité totale d'électricité",
  "subtitle.totalRevenue": "Total des revenus",
  "subtitle.plantImage": "Photos de la station",
  "subtitle.plantName": "Nom de la station",
  "subtitle.plantType": "Type de station électrique",
  "subtitle.PVCapacity": "Capacité PV",
  "subtitle.installationDate": "Date d'installation",
  "subtitle.plantAddress": "Adresse de la station",
  "subtitle.revenue": "Revenus",
  "subtitle.timeZone": "Fuseau horaire",
  "subtitle.updatePhone": "Mettre à jour le téléphone",
  "subtitle.solar": "Photovoltaïque",
  "subtitle.grid": "Réseau électrique",
  "subtitle.battery": "Batterie",
  "subtitle.home": "La charge",
  "subtitle.load": "La charge",
  "subtitle.socket": "La prise",
  "subtitle.today": "Jour",
  "subtitle.day": "Jour",
  "subtitle.month": "Mois",
  "subtitle.year": "Année",
  "subtitle.total": "Total",
  "subtitle.time": "Le temps",
  "subtitle.Co2": "CO2",
  "subtitle.coal": "Charbon",
  "subtitle.deforestation": "Arbres",
  "subtitle.parameter": "Paramètres",
  "subtitle.schedule": "Minuterie",
  "subtitle.countdown": "Compte à rebours",
  "subtitle.socketSwitch": "Interrupteur de prise",
  "subtitle.currency": "La monnaie",
  "subtitle.energyPrice": "Prix de l'électricité",
  "subtitle.storagePlant": "Centrale de stockage d'énergie",
  "subtitle.on-GridPlant": "Station électrique connectée au réseau",
  "subtitle.photo": "Image de tête",
  "subtitle.email": "Boîte aux lettres",
  "subtitle.account": "Compte",
  "subtitle.version": "Versions",
  "subtitle.officalWebsite": "Site officiel",
  "subtitle.SN": "Numéro de série",
  "subtitle.wifiSignal": "Signal wifi",
  "subtitle.lastSync": "Dernière synchronisation",
  "subtitle.switch": "Interrupteurs",
  "subtitle.happening": "En cours d'occurrence",
  "subtitle.restored": "Restauré",
  "subtitle.details": "Détails",
  "subtitle.status": "Statut",
  "subtitle.level": "Niveau",
  "subtitle.deviceType": "Type d'équipement",
  "subtitle.alarmStartTime": "Heure de début de l'alerte",
  "subtitle.alarmEndTime": "Heure de fin de l'alerte",
  "subtitle.solution": "La méthode de résolution",
  "subtitle.loginIn": "Dans le login...",
  "subtitle.checkVersion": "Vérifier les mises à jour",
  "subtitle.versionUpgrade": "Mise à jour de la version",
  "subtitle.messageDetail": "Détails du message",
  "subtitle.todayConsumption": "Consommation électrique aujourd'hui",
  "subtitle.totalConsumption": "Consommation électrique totale",
  "subtitle.dataloggerSN": "Numéro de série du collecteur",
  "subtitle.configurationGuidance": "Guide de configuration",
  "subtitle.guideVideo": "Vidéos guidées",
  "subtitle.manualInstuction": "Manuel d'instruction",
  "subtitle.manualInstuction4G": "Manuel d'instructions 4G",
  "subtitle.manualInstuctionMasterControl": "Manuel d'instruction Master Control",
  "subtitle.masterControlConfiguration": "Réseau de distribution maître",
  "subtitle.defaultConfiguration": "Réseau de distribution par défaut",
  "subtitle.findEmail": "Récupération de boîte aux lettres",
  "subtitle.findPhone": "Téléphone récupération",
  "subtitle.family": "Famille",
  "subtitle.agent": "Agents",
  "subtitle.endUsers": "Utilisateurs finaux",
  "subtitle.deviceManagement": "Équipement",
  "subtitle.deviceSN": "Numéro de série de l'appareil",
  "subtitle.firmwareVersion": "Version du firmware",
  "subtitle.alias": "Alias",
  "subtitle.information": "Informations",
  "subtitle.domainName": "Nom de domaine",
  "subtitle.restartdatalogger": "Redémarrer le collecteur",
  "subtitle.value": "Valeur",
  "subtitle.customizable": "Personnalisation",
  "subtitle.ready": "Lire",
  "subtitle.deviceDetails": "Détails de l'équipement",
  "subtitle.startAddress": "Adresse du registre de départ",
  "subtitle.endAddress": "Adresse du registre de terminaison",
  "subtitle.settingParam": "Définir les paramètres",
  "subtitle.tariffType": "Type de tarif électrique",
  "subtitle.fixed": "Fixe",
  "subtitle.timeshare": "Temps partagé",
  "subtitle.addTime": "Ajouter le temps",
  "subtitle.notAllDay": "Pas toute la journée",
  "subtitle.dealer": "Distributeurs",
  "subtitle.dealerNumber": "Numéro de distributeur",
  "subtitle.toggle": "Commuter",
  "subtitle.environmentalBenefit": "Avantages environnementaux",
  "subtitle.basicParam": "Paramètres de base",
  "subtitle.realTimeParam": "Paramètres en temps réel",
  "subtitle.export": "Exporter",
  "subtitle.localDebug": "Débogage proximal",
  "subtitle.mode": "La manière",
  "subtitle.manuallyAdd": "Ajouter manuellement",
  "subtitle.AttachTheDevice": "Équipement d'accrochage inférieur",
  "subtitle.ammeter": "Compteur électrique",
  "subtitle.FeederPowerOnTheSameDay": "Alimentation du réseau le jour même",
  "subtitle.BatterySOC": "Batterie SOC",
  "subtitle.DailyChargingCapacityOfTheBattery": "Charge de la batterie le jour même",
  "subtitle.DailyPowerConsumption": "Consommation électrique de la journée",
  "subtitle.CumulativePowerGeneration": "Production cumulée d'électricité",
  "subtitle.total2": "Total",
  "subtitle.run": "Fonctionnement",
  "subtitle.StopIt": "Arrêter",
  "subtitle.Optimizer": "Optimiseur",
  "subtitle.DataGateways": "Passerelle de données",
  "subtitle.dataType": "Type de données",
  "subtitle.Model": "Modèle",
  "subtitle.TheAmountOfElectricityGeneratedToday": "Production électrique aujourd'hui",
  "subtitle.CurrentPower": "Puissance actuelle",
  "subtitle.AllOptimizerWorkingStatus": "Tous les optimiseurs État de fonctionnement",
  "subtitle.WhenClosedAllOptimizersStopWorking": "Après l'arrêt, tous les optimiseurs lorsqu'ils cessent de fonctionner",
  "subtitle.TheDataGatewayRestarts": "Redémarrage de la passerelle de données",
  "subtitle.Reboot": "Redémarrer",
  "subtitle.Restarting": "Dans le redémarrage",
  "subtitle.HardwareVersionNumber": "Numéro de version du matériel",
  "subtitle.SoftwareVersionNumber": "Numéro de version du logiciel",
  "subtitle.OutputPower": "Puissance de sortie",
  "subtitle.OutputVoltage": "Tension de sortie",
  "subtitle.OutputCurrent": "Courant de sortie",
  "subtitle.InputPower": "Puissance d'entrée",
  "subtitle.InputVoltage": "Tension d'entrée",
  "subtitle.InputCurrent": "Courant d'entrée",
  "subtitle.OperationalStatus": "État de fonctionnement",
  "subtitle.temperature": "Température",
  "subtitle.DeviceAddress": "Adresse de l'équipement",
  "subtitle.FeederMode": "Mode alimentation réseau",
  "subtitle.StandbyMode": "Mode de préparation électrique",
  "subtitle.Off-gridMode": "Mode hors réseau",
  "subtitle.TimedChargingAndDischarging": "Charge et décharge temporisées",
  "subtitle.WorkingModeSettings": "Réglages du mode de travail",
  "subtitle.DeviceInformation": "Informations sur l'équipement",
  "subtitle.HMISoftwareVersion": "Version du logiciel HMI",
  "subtitle.DSPSoftwareVersion": "Version du logiciel DSP",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "Réglage de la période de charge et de décharge",
  "subtitle.ChargingPeriod": "Période de charge",
  "subtitle.DischargeTimePeriod": "Période de décharge",
  "subtitle.BatteryMinimumSOC(%)": "SOC minimum de la batterie (%)",
  "subtitle.BatteryOvervoltageMethod(V)": "Valeur de la méthode de surtension de la batterie (v)",
  "subtitle.BatteryUndervoltageThreshold(A)": "Valeur de la valve de sous - tension de la batterie (A)",
  "subtitle.ChargingCurrentLimit(A)": "Limite de charge (A)",
  "subtitle.DischargeCurrentLimit(A)": "Limite de décharge (A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "Décharge hors réseau SOC minimum (%)",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "Décharge hors réseau 2 SOC minimum (%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "Hors réseau 2 Décharge tension minimale de la batterie (v)",
  "subtitle.Auto-replenishment": "Recharge électrique automatique",
  "subtitle.BatteryBMSActivationCommand": "Commande d'activation de la batterie BMS",
  "subtitle.ForcedFullCharge": "Remplissage obligatoire",
  "subtitle.ForceCharge2": "Charge obligatoire 2",
  "subtitle.ForceCharge1": "Charge obligatoire 1",
  "subtitle.DischargeEnabled": "Autorisation de décharge",
  "subtitle.ChargingEnabled": "Charge permet",
  "subtitle.NumberOfOptimizers": "Nombre d'optimiseurs",
  "subtitle.TheNameOfTheDevice": "Nom de l'appareil",
  "subtitle.GeneralSettings": "Paramètres universels",
  "subtitle.Anti-backflowSwitch": "Interrupteur anti - contre - courant",
  "subtitle.ReflowPowerLimit(W)": "Limite de puissance de retour (w)",
  "subtitle.OptimizerNumber": "Numéro de l'optimiseur",
  "subtitle.reset": "Réinitialisation",
  "subtitle.areYouSure": "Êtes - vous sûr de vouloir Réinitialiser",
  "subtitle.PhysicalView": "Vue physique",
  "subtitle.LogicalView": "Vue logique",
  "subtitle.LayoutDrawing": "Diagramme de disposition",
  "placeholder.select": "Veuillez sélectionner",
  "placeholder.choiceCountry": "Veuillez sélectionner un pays",
  "placeholder.choiceTimezone": "Veuillez sélectionner un fuseau horaire",
  "placeholder.enterEmail": "Veuillez entrer une boîte aux lettres",
  "placeholder.enterPhone": "Veuillez entrer le numéro de téléphone portable",
  "placeholder.verificationCode": "Veuillez entrer le Code de vérification",
  "placeholder.enterPassword": "Veuillez entrer un mot de passe à 6 - 20 chiffres",
  "placeholder.confirmPassword": "Veuillez confirmer votre mot de passe",
  "placeholder.readAndAgree": "J'ai lu et j'accepte",
  "placeholder.search": "Rechercher",
  "placeholder.searchPlantName": "Rechercher le nom de la station",
  "placeholder.searchDeviceName": "Rechercher le nom de l'appareil",
  "placeholder.searchDataloggerName": "Rechercher le nom du collecteur",
  "placeholder.enterPlantName": "Veuillez entrer le nom de la station",
  "placeholder.enterPlantType": "Veuillez entrer le type de station",
  "placeholder.enterPVCapacity": "Veuillez entrer la capacité PV",
  "placeholder.choiceInstallationDate": "Veuillez sélectionner la date d'installation",
  "placeholder.enterPlantAddress": "Veuillez entrer l'adresse de la station",
  "placeholder.enterOldPassword": "Veuillez entrer votre ancien mot de passe",
  "placeholder.enterNewPassword": "Veuillez entrer un nouveau mot de passe",
  "placeholder.enterConfirmPassword": "Veuillez confirmer votre nouveau mot de passe",
  "placeholder.country": "Pays",
  "placeholder.city": "La ville",
  "placeholder.scanCodeAddPlant": "S'il vous plaît balayer le Code pour ajouter la station!",
  "placeholder.currentNoPlant": "Il n'y a actuellement aucune station, cliquez sur Ajouter!",
  "placeholder.selectRepeatTime": "Veuillez sélectionner un temps de répétition",
  "placeholder.enterDatalogger": "Veuillez entrer le numéro de série du collecteur",
  "placeholder.enterDeviceSN": "Veuillez entrer le numéro de série de l'appareil",
  "tip.noData": "Pas de données pour le moment",
  "tip.base.maxDistance": "Le plus loin",
  "tip.base.minDistance": "Récemment",
  "tip.base.maxSize": "Max",
  "tip.base.minSize": "Le minimum",
  "tip.request.loading": "En chargement",
  "tip.request.netWork": "La connexion réseau a échoué, vérifiez le réseau",
  "tip.request.connectServerFail": "Impossible de se connecter au serveur",
  "tip.request.requestTimeout": "Délai de demande dépassé",
  "tip.validate.choiceCountry": "Veuillez d'abord sélectionner un pays",
  "tip.validate.country": "Le pays ne peut pas être vide, veuillez sélectionner un pays",
  "tip.validate.timeZone": "Le fuseau horaire ne peut pas être vide, veuillez sélectionner un fuseau horaire",
  "tip.validate.email": "Format de boîte aux lettres incorrect, veuillez entrer une boîte aux lettres correcte",
  "tip.validate.verification": "Veuillez d'abord envoyer le Code de vérification",
  "tip.validate.verificationError": "Erreur de captcha, veuillez entrer un CAPTCHA valide",
  "tip.validate.passwordFormTip": "Veuillez entrer un mot de passe de 6 à 20 chiffres composé de chiffres et de lettres",
  "tip.validate.passwordError": "Mot de passe mal formaté, veuillez entrer un mot de passe de 6 à 20 chiffres composé de chiffres et de lettres",
  "tip.validate.passwordError2": "Veuillez entrer un mot de passe valide (le mot de passe ne doit pas inclure de caractères, symboles et espaces spéciaux)",
  "tip.validate.validatePassword": "Les deux mots de passe que vous avez entrés ne correspondent pas, veuillez les saisir à nouveau après vérification",
  "tip.validate.confirmAgreement": "Veuillez d'abord lire et accepter l'Accord de confidentialité",
  "tip.validate.plantName": "Le nom de la station ne peut pas être vide, veuillez entrer le nom de la station",
  "tip.validate.plantType": "Le type de station ne peut pas être vide, veuillez sélectionner le type de station",
  "tip.validate.pvCapacity": "La capacité de la batterie solaire ne peut pas être vide, veuillez entrer la capacité de la batterie",
  "tip.validate.installationDate": "La date d'installation ne peut pas être vide, sélectionnez la date d'installation",
  "tip.validate.city": "La ville ne peut pas être vide, veuillez sélectionner une ville",
  "tip.validate.incomeunit": "La devise ne peut pas être vide, veuillez sélectionner une devise",
  "tip.validate.energyPrice": "Le tarif ne peut pas être vide, veuillez entrer le tarif",
  "tip.validate.firstChoiceCountry": "Veuillez d'abord sélectionner un pays",
  "tip.validate.oldPassword": "L'ancien mot de passe ne peut pas être vide, veuillez entrer l'ancien mot de passe",
  "tip.validate.newPassword": "Le nouveau mot de passe ne peut pas être vide, veuillez entrer un nouveau mot de passe",
  "tip.validate.confirmPassword": "Confirmer le mot de passe ne peut pas être vide, veuillez confirmer le mot de passe",
  "tip.validate.passwordNotMatch": "Deux entrées de mot de passe incohérentes, veuillez vérifier la soumission après confirmation",
  "tip.validate.SN1": "Le numéro de série ne peut pas être vide",
  "tip.validate.SN2": "Le numéro de série doit comporter 10 chiffres",
  "tip.validate.noSocketTimer": "Il n'y a actuellement pas de minuterie de prise, appuyez sur Ajouter",
  "tip.validate.cameraPermission": "App nécessite des autorisations de caméra pour l'ajout de collecteurs de balayage de codes",
  "tip.validate.searchingState": "Rechercher dans Bluetooth, ne pas répéter les clics",
  "tip.validate.notInTheScope": "Les paramètres d'entrée ne sont pas dans la plage spécifiée",
  "tip.validate.enterDecimal": "Vous devez entrer {num} bit décimal ou entier",
  "tip.validate.integer": "Doit être un nombre entier",
  "tip.validate.phone": "Numéro de téléphone ne prend en charge que la Chine continentale, d'autres s'il vous plaît utiliser la boîte aux lettres pour récupérer",
  "tip.validate.can`tEmpty": "{Param} ne peut pas être vide",
  "tip.validate.dealerSope": "La gamme de numéros de revendeur est de 6 ~ 8 chiffres",
  "tip.validate.firstChoicePlant": "Veuillez d'abord sélectionner la station",
  "tip.log.permissionOpen": "Assurez - vous que les autorisations de localisation et Bluetooth sont activées",
  "tip.log.openBluetoothSystem": "Activer les paramètres Bluetooth",
  "tip.log.openIosBtSystem": "Veuillez redémarrer le commutateur Bluetooth",
  "tip.log.openLocationSystem": "Ouvrir les paramètres de positionnement",
  "tip.log.bluetoothAuthorization": "L'autorisation app Bluetooth n'est pas activée",
  "tip.log.locationAuthorization": "L'autorisation de localisation app n'est pas activée",
  "tip.log.searchSurroundingDevicesPermission": "Rechercher des appareils à proximité non autorisés",
  "tip.log.bluetoothNotPermission": "Bluetooth n'est pas activé",
  "tip.log.locationNotPermission": "Positionnement non activé",
  "tip.log.bluetoothPermission": "Bluetooth est activé",
  "tip.log.locationPermission": "Le positionnement est ouvert",
  "tip.log.bluetoothException": "Déconnexion anormale du Bluetooth, vérifiez que le Bluetooth de l'appareil est activé, puis reconnectez - le",
  "tip.log.listeningFailure": "Échec de l'écoute du changement de valeur caractéristique, reconnectez le Bluetooth",
  "tip.log.communicationException": "Communication Bluetooth anormale, veuillez reconnecter Bluetooth",
  "tip.log.reconnect": "Reconnexion Bluetooth",
  "tip.log.connectFail": "La connexion Bluetooth a échoué",
  "tip.log.connect": "Connexion Bluetooth",
  "tip.log.bluetoothService": "Veuillez activer le service Bluetooth",
  "tip.log.locationService": "Veuillez activer le Service de localisation",
  "tip.log.notsupport": "La plate - forme actuelle prend en charge l'appel de la fonction Bluetooth",
  "tip.log.locationNotTurnOn": "Localisation non activée, impossible de rechercher Bluetooth",
  "tip.log.init": "Initialisation Bluetooth",
  "tip.log.searching": "Recherche autour de Bluetooth",
  "tip.log.searchFail": "Il n'y a pas de requêtes sur l'appareil autour, assurez - vous que le Bluetooth de l'appareil est activé, puis appuyez sur actualiser",
  "tip.log.stopSearch": "Arrêter la recherche autour de Bluetooth",
  "tip.log.stopSearchFail": "Arrêter la recherche Bluetooth autour échoue",
  "tip.log.connectSuccess": "Connexion Bluetooth réussie",
  "tip.log.setMTUsSuccess": "Définir l'unité de transmission maximale avec succès",
  "tip.log.setMTUsFail": "Échec du réglage de l'unité de transmission maximale",
  "tip.log.closeSuccess": "Connexion Bluetooth déconnectée",
  "tip.log.closeFail": "La déconnexion Bluetooth a échoué",
  "tip.log.wifiLoadFail": "Le chargement de la liste WiFi a échoué, entrez - la manuellement",
  "tip.log.bluetoothAbnormal": "Connexion Bluetooth anormale, tentative de reconnexion",
  "tip.log.getBluetoothServiceSuccess": "Obtenir le Service de périphérique Bluetooth avec succès",
  "tip.log.getBluetoothServiceFail": "L'obtention du Service de périphérique Bluetooth a échoué",
  "tip.log.getFeatureValuesSucess": "A obtenu avec succès toutes les valeurs caractéristiques dans le service spécifié de périphérique Bluetooth",
  "tip.log.getFeatureValuesFail": "Échec de l'obtention de toutes les valeurs caractéristiques dans le service spécifié pour le périphérique Bluetooth",
  "tip.log.subscriptionEigenvalueSuccess": "La fonction notify est activée lorsque la valeur caractéristique d'un périphérique Bluetooth basse consommation change, abonnez - vous à la valeur caractéristique",
  "tip.log.subscriptionEigenvalueFail": "Activer la fonction notify lorsque la valeur caractéristique d'un périphérique Bluetooth à faible consommation change, la valeur caractéristique de l'abonnement échoue",
  "tip.log.monitoringSuccess": "Écouter avec succès les événements de changement de valeur caractéristique des appareils Bluetooth basse consommation",
  "tip.log.monitoringFail": "Échec de l'écoute des événements de changement de valeur caractéristique pour les appareils Bluetooth basse consommation",
  "tip.log.CRC": "Le contrôle CRC a échoué",
  "tip.log.queryWiFi": "La liste WiFi a été consultée avec succès",
  "tip.log.queryWiFiState": "Instruction de requête de liste wifi envoyée avec succès",
  "tip.log.wifiConenct": "Enquête sur l'état de la connexion de routage",
  "tip.log.wifiFail": "Vérifiez le numéro de compte et le mot de passe du routeur et essayez de vous reconnecter",
  "tip.log.connectWiFiSuccess": "Connexion réussie du routeur",
  "tip.log.connectWiFiFail": "La connexion au routeur a échoué",
  "tip.log.routerAccount": "Erreur dans le numéro de compte du routeur",
  "tip.log.routerPassword": "Erreur de mot de passe du routeur",
  "tip.log.gettingIP": "Obtenir l'IP du routeur",
  "tip.log.getIPFail": "L'obtention de l'IP du routeur a échoué",
  "tip.log.queryServerState": "Instruction d'état d'interaction du périphérique de requête avec le serveur envoyée avec succès",
  "tip.log.server03": "Il y a 03 interactions de données",
  "tip.log.server04": "Il y a 04 interactions de données",
  "tip.log.heartbeat": "Interaction de données avec battement de cœur",
  "tip.log.noInteraction": "Aucune interaction de données",
  "tip.log.bluetoothCommunication": "Communication via Bluetooth",
  "tip.log.connectWiFi": "Connexion wifi",
  "tip.log.getWiFiList": "Recherche de la liste WiFi",
  "tip.log.wifiName": "Le nom wifi ne peut pas être vide, sélectionnez ou entrez 2.4wifi",
  "tip.log.wifiPasword": "Wifi ne peut pas être vide, veuillez entrer votre mot de passe",
  "tip.log.wifiPasswordError": "Le mot de passe wifi ne peut pas contenir de caractères spéciaux (ǎǐò • ♢∝⌒℃℉etc.)",
  "tip.log.masterControlId": "Master ID ne peut pas être vide, veuillez entrer un ID",
  "tip.addDatalogger.noSearchDevice": "Impossible d'interroger l'appareil, assurez - vous que le Bluetooth de l'appareil est activé",
  "tip.addDatalogger.searchAroundBluetooth": "Réseau Bluetooth disponible autour",
  "tip.addDatalogger.scan": "Scannez le Code QR ou entrez manuellement le numéro de série du collecteur sous le Code QR.",
  "tip.addDatalogger.connectBluetoothFail": "La connexion Bluetooth a échoué, Scannez le Code QR ou reconnectez - le après avoir saisi manuellement le numéro de série du collecteur sous le Code QR.",
  "tip.connectWifi.tip1": "Configurer le périphérique pour rejoindre le réseau",
  "tip.connectWifi.tip": "Veuillez sélectionner 2.4G WiFi",
  "tip.connectWifi.devicePower": "Puissance de l'équipement",
  "tip.connectWifi.enterSSID": "Veuillez entrer le numéro de compte du routeur",
  "tip.connectWifi.enterPassword": "Veuillez entrer le mot de passe du routeur",
  "tip.connectWifi.masterId": "Veuillez entrer le Master id",
  "tip.connectWifi.commandSetFail": "La configuration de la commande a échoué, reconnectez le collecteur",
  "tip.configurationState.connecting": "Dans la connexion",
  "tip.configurationState.connectFail": "La connexion a échoué",
  "tip.configurationState.connectSuccess": "Connexion réussie",
  "tip.configurationState.wait": "Un instant.",
  "tip.configurationState.addDeviceSuccess": "Ajouter un appareil avec succès",
  "tip.home.today": "Production quotidienne d'électricité",
  "tip.home.month": "Production mensuelle d'électricité",
  "tip.home.year": "Production annuelle d'électricité",
  "tip.home.total": "Production totale d'électricité",
  "tip.home.homePower": "Charge totale du ménage",
  "tip.home.socketPower": "Charge de prise",
  "tip.home.off-gridPower": "Charge hors réseau",
  "tip.home.acPower": "Puissance électrique municipale",
  "tip.home.on-gridPower": "Puissance connectée au réseau",
  "tip.home.others": "Autres",
  "tip.home.latestVersion": "Déjà la dernière version",
  "tip.home.frontEndLoad": "Charge frontale",
  "tip.home.backEndLoad": "Charge hors réseau",
  "tip.energy.choiceDate": "Les données actuelles ne sont disponibles que pour",
  "tip.energy.explain": "Description",
  "tip.energy.tip1.load": "Énergie consommée par la charge",
  "tip.energy.tip1.solar": "Convertir l'énergie solaire en énergie électrique pour la charge de la batterie ou l'énergie alimentée par la charge",
  "tip.energy.tip1.grid": "Énergie accumulée vendue au réseau",
  "tip.energy.tip1.battery": "Énergie électrique accumulée pour charger la batterie",
  "tip.energy.tip2": "Le nom?",
  "tip.energy.tip3.title": "Normes de calcul de la contribution sociale",
  "tip.energy.tip3.title2": "1 kWh est égal à:",
  "tip.energy.tip3.Co2": "Réduction des émissions de CO2:",
  "tip.energy.tip3.coal": "Économies sur l'utilisation du charbon Standard:",
  "tip.energy.tip3.deforestation": "Protection des arbres:",
  "tip.plant.comprehensive": "Tri intégré",
  "tip.plant.totalEnergyMax": "Électricité totale la plus élevée",
  "tip.plant.totalEnergyMin": "Puissance totale la plus faible",
  "tip.plant.realTimePower": "Puissance en temps réel",
  "tip.plant.pvcapacityMax": "Capacité PV la plus élevée",
  "tip.plant.pvcapacityMin": "Capacité PV minimale",
  "tip.plant.installationDateMax": "La date d'installation la plus éloignée",
  "tip.plant.installationDateMin": "Date d'installation récente",
  "tip.plant.paramChoice": "Sélection des paramètres",
  "tip.plant.filter": "Filtrer",
  "tip.plant.addVisitor": "Ajouter un visiteur",
  "tip.plant.tip": "Conseils",
  "tip.plant.visitorTip": "Partager uniquement avec les utilisateurs déjà enregistrés",
  "tip.plant.name": "Nom",
  "tip.plant.permission": "Permissions",
  "tip.plant.read-write": "Lire et écrire",
  "tip.plant.onlyread": "Lecture seule",
  "tip.plant.visitor": "Visiteurs",
  "tip.plant.unfollow": "Vous êtes sûr de vouloir vous concentrer sur cette station?",
  "tip.device.power": "Puissance",
  "tip.device.type": "Type",
  "tip.device.updateTime": "Temps de mise à jour",
  "tip.device.powerOnTime": "Temps de mise sous tension",
  "tip.device.todayEnergy": "Electricité aujourd'hui",
  "tip.device.signal": "Force du signal",
  "tip.delDevice": "Êtes - vous sûr de vouloir supprimer ce {Device}?",
  "tip.currentNoDevice": "Aucun équipement actuellement",
  "tip.currentNoDatalog": "Il n'y a actuellement aucun collecteur",
  "tip.messageInfo.storage": "Stockage d'énergie",
  "tip.messageInfo.inverter": "Onduleurs",
  "tip.messageInfo.microInverter": "Micro - inverse",
  "tip.ops.setDomainName": "Êtes - vous sûr de vouloir configurer ce nom de domaine?",
  "tip.ops.restartDatalogger": "Êtes - vous sûr de vouloir redémarrer le collecteur?",
  "tip.opsLog.addUser": "Ajouter un utilisateur final",
  "tip.opsLog.bindSuccess": "Lier avec succès",
  "tip.opsLog.selectDate": "Choisissez une date",
  "tip.opsLog.start": "Commencer",
  "tip.opsLog.end": "La fin",
  "tip.opsLog.upgrade": "Mise à niveau",
  "tip.opsLog.operation": "Opérations",
  "tip.opsLog.communication": "Communications",
  "tip.opsLog.type": "Type",
  "tip.opsLog.content": "Contenu",
  "tip.opsLog.control": "Contrôleur",
  "tip.opsLog.command": "Type de commande",
  "tip.opsLog.reset": "Réinitialisation",
  "tip.opsLog.serverTime": "Heure du serveur",
  "tip.opsLog.inverter": "Intervalle",
  "tip.opsLog.bindAgent": "Revendeur de fixations",
  "tip.opsLog.deleteDeviceSN": "Veuillez confirmer s'il est supprimé?",
  "tip.opsLog.recordLog": "Appareils nécessitant l'enregistrement de journaux",
  "tip.userLocation": "Localisation de l'utilisateur",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "La puissance active connectée au réseau ne peut pas être supérieure à la puissance maximale du modèle de produit sélectionné",
  "setting.general.needGreat": "Besoin de plus de",
  "setting.general.needSmall": "Nécessite moins de",
  "setting.general.gapScope": "L'intervalle des paramètres d'entrée est",
  "setting.general.valScope": "La portée des paramètres d'entrée est",
  "setting.socket.switchStatus": "Interrupteur de prise",
  "setting.socket.repetition": "Temps de répétition",
  "setting.socket.enableOrNot": "Activé ou non",
  "setting.socket.monday": "Lundi",
  "setting.socket.tuesday": "Mardi",
  "setting.socket.wednesday": "Mercredi",
  "setting.socket.thursday": "Jeudi",
  "setting.socket.friday": "Vendredi",
  "setting.socket.saturday": "Samedi",
  "setting.socket.sunday": "Dimanche",
  "setting.type3.dischargeScheduleMode": "Mode de décharge temporelle",
  "setting.type3.timeDischarge": "Décharge temporelle",
  "setting.type3.workingDay": "Jours de travail",
  "setting.type3.weekend": "Week - end",
  "setting.type3.pureLightControlMode": "Mode de contrôle optique pur",
  "setting.type3.stopDischarge": "SOC bas de gamme arrêt de décharge valeur de consigne",
  "setting.type3.chargeTransferDischarge": "SOC full turn Discharge valeur de consigne",
  "setting.type3.batterySOCSetting": "Configuration SOC de la batterie",
  "setting.type3.lowBatteryAlam": "Batterie SOC bas de gamme Alarm Setup",
  "setting.type3.lowBatteryShutdown": "Valeur de consigne d'arrêt de décharge SOC bas de gamme de la batterie",
  "setting.type3.systemSetting": "Paramètres du système",
  "setting.type3.systemWorkMode": "Mode de fonctionnement du système",
  "setting.type3.restoreFactory": "Restaurer les paramètres d'usine",
  "setting.type3.loadMode": "Mode de charge",
  "setting.type3.timingDischarge": "Mode de décharge temporelle",
  "setting.type3.DCOutputNormallyClosed": "Sortie DC mode normalement fermé",
  "setting.type3.DCOutputNormallyOpen": "Sortie DC mode normalement ouvert",
  "setting.type3.ForcedPowerProtection": "Mode de rétention forcée",
  "setting.type3.mode": "Mode",
  "setting.type3.startTime": "Heure de début",
  "setting.type3.stopTime": "Heure de fin",
  "setting.type3.onlyAddThree": "Ajouter jusqu'à 21 minuteries",
  "setting.type3.startCompareEnd": "L'heure de début de la minuterie ne peut être inférieure qu'à l'heure de fin",
  "setting.type3.confirmClose": "Êtes - vous sûr de vouloir éteindre?",
  "setting.type6.countryCode": "Numéro de pays",
  "setting.type6.poweradjppm": "Taux de régulation de la puissance de l'onduleur",
  "setting.type6.enaINVTR": "Machine de commutation à distance",
  "setting.type6.enaSysProtIF_selfCheck": "Auto - test de l'interface de protection du système",
  "setting.type6.enaRestoretodefault": "Restaurer les valeurs par défaut",
  "setting.type6.UV_resopnseTime": "{num} temps de réponse de sous - tension de niveau",
  "setting.type6.UF_resopnseTime": "{num} temps de réponse en sous - fréquence de niveau",
  "setting.type6.OV_resopnseTime": "{num} temps de réponse de surpression de niveau",
  "setting.type6.OF_resopnseTime": "{num} niveau overfrequency temps de réponse",
  "setting.type6.open": "Ouvrir",
  "setting.type6.recover": "Récupération",
  "setting.type6.noHave": "Aucun",
  "setting.type6.activePowerSwitch": "Interrupteur de puissance actif",
  "setting.type6.activePowerPermillage": "Rapport de puissance active en milliers",
  "setting.type7.paramterSetting": "Paramètres paramètres",
  "setting.type7.batteryVoltage": "Tension de la batterie",
  "setting.type7.batteryCapacity": "Capacité de la batterie",
  "setting.type7.PVChargingCurrent": "Courant de charge photovoltaïque",
  "setting.type7.overVoltage": "Tension de surtension",
  "setting.type7.chargingLimitVoltage": "Tension de limitation de charge",
  "setting.type7.increaseChargeReturnVoltage": "Augmenter la tension de retour de charge",
  "setting.type7.overDischargeVoltage": "Tension de surdécharge",
  "setting.type7.stopchangeCurrent": "Arrêter le courant de charge",
  "setting.type7.inverter485Address": "485 adresse",
  "setting.type7.passwordValue": "Mot de passe utilisateur",
  "setting.type7.inputPassword": "Entrée du mot de passe",
  "setting.type7.recordFaultCodes": "Enregistrer le Code d'erreur",
  "setting.type7.isOpen": "Contrôle de la machine de commutation",
  "setting.type7.equalizingChargeCmd": "Équilibrage de charge immédiat",
  "setting.type7.reset": "Contrôle de réinitialisation",
  "setting.type7.factory": "Restaurer les paramètres d'usine",
  "setting.type7.clearAlarm": "Effacer l'alerte actuelle",
  "setting.type7.clearHistory": "Effacer l'historique",
  "setting.type7.generatorSwitchCmd": "Changement de générateur",
  "setting.type7.nowTimeStr": "Heure actuelle",
  "setting.type7.setVal.reset": "Réinitialisation",
  "setting.type7.setVal.recover": "Récupération",
  "setting.type7.setVal.clearAlarm": "Effacer les avertissements",
  "setting.type7.setVal.clearHistory": "Effacer l'histoire",
  "setting.type7.setVal.toggle": "Commuter",
  "setting.type8.systemSwitch": "Interrupteurs système",
  "setting.type10.modeSelect": "Mode",
  "setting.type10.standbyMode": "Mode de préparation électrique",
  "setting.type10.PureOffGrid": "Mode de démarrage hors réseau pur",
  "setting.type10.energyNet": "Paramètres de sortie réseau",
  "setting.type10.inverter0": "énergie de rattrapage inverse à charge locale",
  "setting.type10.inverter1": "Inverser la génération d'électricité au réseau",
  "setting.type10.inverter2": "Inversé à la bande de charge locale CT",
  "setting.type10.inverter3": "Inversion de charge locale ou prise intelligente et compteur intelligent",
  "setting.type10.chargePriority": "Priorité de charge",
  "setting.type10.PVPriority": "Priorité au photovoltaïque",
  "setting.type10.utilityPriority": "Priorité électrique municipale",
  "setting.type10.hybridModel": "Chargement mixte",
  "setting.type10.PVOnly": "Chargement photovoltaïque uniquement",
  "setting.type10.batteryLowAlarm": "Batterie faible point d'alerte",
  "setting.type10.batteryLowShutdown": "Point d'arrêt de batterie faible",
  "setting.type10.batteryFull": "Point d'arrêt complet de la batterie",
  "setting.type10.ACCharging": "Temps de charge",
  "setting.type10.startTime": "Heure de départ",
  "setting.type10.endTime": "Heure de fin",
  "setting.type10.forcedDischarge": "Temps de décharge",
  "setting.type10.phaseGridSide": "Côté réseau électrique",
  "setting.type10.power": "Puissance active de phase",
  "setting.type10.current": "Courant de phase",
  "setting.type10.gridConnectionStandard": "Normes de connexion au réseau",
  "setting.type10.baudRate": "485 bauds taux",
  "setting.type10.disable": "Ne permet pas",
  "setting.type10.enable": "Permettre",
  "setting.type10.ApprovalStandards": "Normes de certification",
  "setting.type10.antiRefluxPower": "Puissance anti - contre - courant",
  "setting.type10.antiRefluxSet": "Anti - contre - courant enable",
  "setting.type10.batFullSocSet": "Valeur de jugement de saturation d'impulsion de batterie (%)",
  "setting.type10.auxSourceSet": "Commutateur de source auxiliaire",
  "setting.type10.timeSharingGridConnectedDischarge": "Décharge en temps partagé sur le réseau",
  "setting.type10.timeSharingGridConnection": "Paramètres de connexion réseau en temps partagé",
  "setting.type10.outputPower": "Puissance de sortie",
  "setting.type10.onlyAddThree": "Ajouter jusqu'à {num} timers",
  "setting.type10.productModelNumber": "Modèle de produit",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "Veuillez ouvrir l'interrupteur en premier",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "Temps de charge et de décharge en conflit",
  "setting.type10.ChargeDischargeTimeSetting": "Réglage du temps de charge et de décharge",
  "setting.type11.switchPCS": "Contrôle de la machine de commutation",
  "setting.type11.functionSwitch": "Interrupteur fonctionnel",
  "setting.type11.maxChargeVol": "Tension de charge maximale (v)",
  "setting.type11.onGridMinDischargeVol": "Tension de décharge minimale connectée au réseau (v)",
  "setting.type11.offGridOutputVol": "Tension de sortie hors réseau (v)",
  "setting.type11.maxChargeCur": "Puissance de charge maximale",
  "setting.type11.onGridMaxDischargeCur": "Courant de décharge le plus élevé connecté au réseau (A)",
  "setting.type11.offGridMaxDisChargeCur": "Courant de décharge le plus élevé hors réseau (A)",
  "setting.type11.minSocBMS": "SOC minimum du BMS (%)",
  "setting.type11.minSocDischarge": "SOC minimal pour décharge intelligente (%)",
  "setting.type11.maxSocDischarge": "Décharge intelligente SOC max (%)",
  "setting.type11.timeStr": "Temps d'équipement",
  "setting.type11.timerSetting": "Réglage de la minuterie {num}",
  "setting.type11.chargeStartTime1": "Temps de charge de départ 1",
  "setting.type11.chargeLongTime1": "Durée de charge 1",
  "setting.type11.chargeTimeMaxSOC1": "Période de charge 1 SOC maximum (%)",
  "setting.type11.chargeTimeCurrent1": "Période de charge 1 courant de charge (A)",
  "setting.type11.dischargeStartTime1": "Temps de décharge de départ 1",
  "setting.type11.dischargeLongTime1": "Durée de décharge 1",
  "setting.type11.dischargeTimeMaxSOC1": "Période de décharge 1 SOC minimum (%)",
  "setting.type11.dischargeTimeCurrent1": "Période de décharge 1 courant de décharge (A)",
  "setting.type11.chargeStartTime2": "Temps de charge de départ 2",
  "setting.type11.chargeLongTime2": "Durée de charge 2",
  "setting.type11.chargeTimeMaxSOC2": "Période de charge 2 SOC maximum (%)",
  "setting.type11.chargeTimeCurrent2": "Période de charge 2 courant de charge (A)",
  "setting.type11.dischargeStartTime2": "Temps de décharge initiale 2",
  "setting.type11.dischargeLongTime2": "Durée de décharge 2",
  "setting.type11.dischargeTimeMaxSOC2": "Période de décharge 2 SOC minimum (%)",
  "setting.type11.dischargeTimeCurrent2": "Période de décharge 2 courant de décharge (A)",
  "setting.type11.chargeStartTime3": "Temps de charge de départ 3",
  "setting.type11.chargeLongTime3": "Durée de charge 3",
  "setting.type11.chargeTimeMaxSOC3": "Période de charge 3 SOC maximum (%)",
  "setting.type11.chargeTimeCurrent3": "Période de charge 3 courant de charge (A)",
  "setting.type11.dischargeStartTime3": "Temps de décharge initiale 3",
  "setting.type11.dischargeLongTime3": "Durée de décharge 3",
  "setting.type11.dischargeTimeMaxSOC3": "Période de décharge 3 SOC minimum (%)",
  "setting.type11.dischargeTimeCurrent3": "Période de décharge 3 courant de décharge (A)",
  "setting.type11.chargeStartTime4": "Temps de charge de départ 4",
  "setting.type11.chargeLongTime4": "Durée de charge 4",
  "setting.type11.chargeTimeMaxSOC4": "Période de charge 4 SOC maximum (%)",
  "setting.type11.chargeTimeCurrent4": "Période de charge 4 courant de charge (A)",
  "setting.type11.dischargeStartTime4": "Temps de décharge initiale 4",
  "setting.type11.dischargeLongTime4": "Durée de décharge 4",
  "setting.type11.dischargeTimeMaxSOC4": "Période de décharge 4 SOC minimum (%)",
  "setting.type11.dischargeTimeCurrent4": "Période de décharge 4 courant de décharge (A)",
  "setting.type11.functionSwitchObj.val1": "Mode intelligent",
  "setting.type11.functionSwitchObj.val2": "Mode de temporisation",
  "setting.type11.functionSwitchObj.val3": "Mode auto - utilisation spontanée",
  "setting.type12.LEDSwitch": "Interrupteur LED",
  "setting.type12.LEDSpeed": "Vitesse LED",
  "setting.type12.LEDEffect": "Effet LED",
  "setting.type12.LEDBrightness": "Luminosité LED",
  "setting.type12.dataColor": "Représentation couleur des données",
  "setting.type12.LED1Color": "Led1 couleur",
  "setting.type12.LED2Color": "Led2 couleur",
  "setting.type12.LED3Color": "Led3 couleur",
  "setting.type12.buzzerAlarm": "Alarme buzzer",
  "setting.type12.overLoadToBypass": "Bypass de transfert de surcharge",
  "setting.type12.lcdRestartPage": "LCD aucune opération récupération interface principale",
  "setting.type12.overloadReset": "Redémarrage de surcharge",
  "setting.type12.overloadTemperature": "Redémarrage à température excessive",
  "setting.type12.backLightOn": "LCD sans rétroéclairage opérationnel",
  "setting.type12.inputSourceChangeAlarm": "Entrer une alerte de changement de source",
  "setting.type12.faultCodeRecord": "Enregistrement des défaillances du logiciel de communication",
  "setting.type12.solarFeedToGird": "Solar Idle connecté au réseau",
  "setting.type12.switchOptions": "Options de commutation",
  "setting.type12.batteryParam": "Paramètres de la batterie",
  "setting.type12.outputParam": "Paramètres de sortie",
  "setting.type12.ratedOutputVol": "Tension de sortie nominale",
  "setting.type12.ratedOutputFreq": "Fréquence de sortie nominale",
  "setting.type12.inputVolRange": "Gamme de tension d'entrée",
  "setting.type12.outPutSourcePriority": "Priorité à la source de sortie",
  "setting.type12.batType": "Type de batterie",
  "setting.type12.batUnderVol": "Tension de coupure de la batterie",
  "setting.type12.batBulkVol": "Tension de charge constante de la batterie",
  "setting.type12.batFloatVol": "Tension de charge flottante de la batterie",
  "setting.type12.maxChargingCur": "Courant de charge maximal",
  "setting.type12.maxAcChargingCur": "Courant de charge AC Max.",
  "setting.type12.chargeSourcePriority": "Priorité de la source du chargeur",
  "setting.type12.batReChargeVol": "Restaurer la tension de charge",
  "setting.type12.batFullRestoreDischargeVol": "Restaurer la tension de décharge",
  "setting.type12.solarSupplyPriority": "Priorité à l'alimentation solaire",
  "setting.type12.resetPvStorage": "Réinitialiser les statistiques PV",
  "setting.type12.countryRegulations": "Règlements nationaux",
  "setting.type12.acChargeStartTime": "Chargeur AC temps de démarrage de travail",
  "setting.type12.acChargeEndTime": "Chargeur AC temps d'arrêt de travail",
  "setting.type12.acSupplyStartTime": "Temps de démarrage de l'alimentation secteur",
  "setting.type12.acSupplyEndTime": "Temps d'arrêt de l'alimentation secteur",
  "setting.type12.restoreFactorySet": "Restaurer les paramètres d'usine",
  "setting.type12.parallelMode": "Et mode machine",
  "setting.type12.bulkChargeVol": "Tension de charge CV",
  "setting.type12.batEquSet": "Fonction de charge moyenne de la batterie",
  "setting.type12.batEquTime": "Temps de charge moyen de la batterie (min)",
  "setting.type12.batEquDay": "Nombre moyen de jours entre les charges de la batterie (d)",
  "setting.type12.batEquChargeVol": "Tension de charge moyenne de la batterie (v)",
  "setting.type12.batEquTimeout": "Temps de recharge moyen de la batterie (min)",
  "setting.type12.equInfoSet": "Réglage des informations d'égalisation",
  "setting.type12.val.slow": "Lent",
  "setting.type12.val.medium": "Au milieu",
  "setting.type12.val.fast": "Rapide",
  "setting.type12.val.low": "Faible",
  "setting.type12.val.high": "Haute",
  "setting.type12.val.powerCycle": "Cycle de puissance",
  "setting.type12.val.powerRotation": "Rotation de puissance",
  "setting.type12.val.additionalPower": "Puissance supplémentaire",
  "setting.type12.val.powerUnchanged": "Dynamique inchangée",
  "setting.type12.val.solarPowerInput": "Puissance d'entrée solaire",
  "setting.type12.val.batteryCapacity": "Pourcentage de capacité de la batterie",
  "setting.type12.val.percentageLoad": "Pourcentage de charge",
  "setting.type12.val.energySource": "Source d'énergie",
  "setting.type12.val.batteryStatus": "État de charge et de décharge de la batterie",
  "setting.type12.val.blue": "Bleu",
  "setting.type12.val.cyan": "Couleur Cyan",
  "setting.type12.val.green": "Vert",
  "setting.type12.val.pink": "Couleur rose",
  "setting.type12.val.purple": "La couleur violette",
  "setting.type12.val.orange": "Couleur orange",
  "setting.type12.val.yellow": "Jaune",
  "setting.type12.val.white": "Blanc",
  "setting.type12.val.inputOvlRange1": "Mode APL (90 - 280v)",
  "setting.type12.val.inputOvlRange2": "Mode UPS (170 - 280v)",
  "setting.type12.val.outputSource1": "Solaire - > utilitaire - > Batterie",
  "setting.type12.val.outputSource2": "Solaire - > batterie - > utilitaire",
  "setting.type12.val.chargeSourcePriority1": "Priorité au photovoltaïque",
  "setting.type12.val.chargeSourcePriority2": "Photovoltaïque et électricité municipale",
  "setting.type12.val.chargeSourcePriority3": "Photovoltaïque uniquement",
  "setting.type12.val.solarSupplyPriority1": "Batterie - charge - utilitaire",
  "setting.type12.val.solarSupplyPriority2": "Charge - batterie - utilitaire",
  "setting.type12.val.countryRegulations1": "Inde",
  "setting.type12.val.countryRegulations2": "Allemagne",
  "setting.type12.val.countryRegulations3": "Amérique du Sud",
  "setting.type12.val.parallelMode1": "Aucune machine parallèle",
  "setting.type12.val.parallelMode2": "Machine parallèle monophasée",
  "setting.type12.val.outPutSourcePriority1": "Priorité électrique municipale",
  "setting.type12.val.outPutSourcePriority2": "Priorité solaire",
  "setting.type12.val.outPutSourcePriority3": "Énergie solaire - > batteries - > secteur",
  "setting.ops15.invSwitch": "Interrupteur inverseur",
  "setting.ops15.workMode": "Mode de travail",
  "setting.ops15.workMode1": "Priorité au Feed Network",
  "setting.ops15.workMode2": "Mode hors réseau",
  "setting.ops15.workMode3": "Auto - utilisation spontanée",
  "setting.ops15.invTime": "Temps de l'onduleur",
  "setting.ops15.batType": "Type de batterie",
  "setting.ops15.batType1": "Sans batterie",
  "setting.ops15.batType2": "Batterie au lithium universelle",
  "setting.ops15.batType3": "Batteries plomb - acide",
  "setting.ops15.batType4": "Batterie au lithium",
  "setting.ops15.timingTime": "Temps chronométré",
  "setting.ops15.offGirdSoc": "SOC sur - libéré (%)",
  "setting.ops15.optimizeRevenue": "Optimisation des gains",
  "setting.type19.totalActivePower": "Puissance active",
  "setting.type19.offgridSettings": "Et hors réseau Configuration",
  "setting.type19.gridConnectedControlMode": "Contrôle connecté au réseau",
  "setting.type19.offGridControlMode": "Contrôle hors réseau",
  "setting.type19.offgrid.gridNet": "Connexion au réseau",
  "setting.type19.offgrid.offNet": "Hors réseau",
  "setting.type22.parameterScope": "Gamme de paramètres",
  "setting.type22.ACStartVoltage": "Réglage tension / fréquence de démarrage",
  "setting.type22.highVoltage": "Démarrage AC haute pression",
  "setting.type22.lowVoltage": "Démarrage AC basse pression",
  "setting.type22.pvStartLowVol": "Démarrage PV basse pression",
  "setting.type22.acUnderVol1": "AC Undervoltage premier ordre (v)",
  "setting.type22.acOverVol1": "Surpression AC premier ordre (v)",
  "setting.type22.acUnderVolTime1": "Temps de premier ordre de sous - tension AC (s)",
  "setting.type22.acOverVolTime1": "Temps de surpression AC du premier ordre (s)",
  "setting.type22.acUnderVol2": "AC Undervoltage deuxième ordre (v)",
  "setting.type22.acOverVol2": "Surpression AC deuxième ordre (v)",
  "setting.type22.acUnderVolTime2": "Temps de second ordre de sous - tension AC (s)",
  "setting.type22.acOverVolTime2": "Temps de surpression AC du deuxième ordre (s)",
  "setting.type22.startDelayTime": "Délai de démarrage",
  "setting.type22.restartDelayTime": "Temps de retard de redémarrage",
  "setting.type22.ACStartFrequency": "Réglages de surtension / fréquence",
  "setting.type22.highFrequency": "Démarrage AC haute fréquence",
  "setting.type22.lowFrequency": "Démarrage AC basse fréquence",
  "setting.type22.acUnderFrequency1": "Sous - fréquence AC du premier ordre (Hz)",
  "setting.type22.acOverFrequency1": "Overfréquence AC premier ordre (Hz)",
  "setting.type22.acUnderFrequencyTime1": "Temps de premier ordre de sous - fréquence AC (s)",
  "setting.type22.acOverFrequencyTime1": "Temps de premier ordre de surfréquence AC (s)",
  "setting.type22.acUnderFrequency2": "Sous - fréquence AC deuxième ordre (Hz)",
  "setting.type22.acOverFrequency2": "Surfréquence AC deuxième ordre (Hz)",
  "setting.type22.acUnderFrequencyTime2": "Temps de second ordre de sous - fréquence AC (s)",
  "setting.type22.acOverFrequencyTime2": "Temps de surfréquence AC du deuxième ordre (s)",
  "setting.type22.systemSetting": "Paramètres des informations sur l'appareil",
  "setting.type22.SNset": "Paramètres du numéro de série",
  "setting.type22.reactiveControlMode": "Mode de contrôle réactif",
  "setting.type22.inputMode": "Mode d'entrée",
  "setting.type22.startSolpe": "Pente de démarrage",
  "setting.type22.restartSolpe": "Pente de redémarrage",
  "setting.type22.reactivePercentage": "Pourcentage de réactivité",
  "setting.type22.activePercentage": "Pourcentage actif",
  "setting.type22.shutdown": "Interrupteur à distance",
  "setting.type22.functionSelect": "Sélection des fonctions",
  "setting.type22.manufacturer": "Fabricants",
  "setting.type22.setFunctionSelect.val1": "Interdit",
  "setting.type22.setFunctionSelect.val2": "Résistant au contre - courant",
  "setting.type22.setManufacturer.val1": "Inviteng",
  "setting.type22.setManufacturer.val2": "Créer une dimension",
  "setting.type22.reactiveControlModeChoice.val1": "Contrôle du facteur de puissance",
  "setting.type22.reactiveControlModeChoice.val2": "Contrôle du pourcentage de puissance réactive",
  "setting.type22.reactiveControlModeChoice.val3": "Contrôle de la courbe QV",
  "setting.type22.inputModeChoice.val1": "Entrez le mode indépendant",
  "setting.type22.inputModeChoice.val2": "Entrez le mode parallèle",
  "setting.type22.inputModeChoice.val3": "Le mode DC source",
  "productEquipment.productModelNumber": "Modèle de produit",
  "productEquipment.warnMessage": "Informations d'alerte",
  "productEquipment.customInstruction": "Instructions personnalisées",
  "productEquipment.firmwareUpdate": "Mise à niveau du firmware",
  "productEquipment.historicalData": "Données historiques",
  "productEquipment.linkageInformation": "Informations de connexion",
  "validate.email.getVerificationCode": "Obtenir le Code de vérification",
  "validate.email.reacquireCode": "Récupérer",
  "validate.email.verificationCodeHasBeenSent": "Le Code de vérification a été envoyé",
  "validate.tips.passwordRule": "Les mots de passe ont entre 8 et 20 caractères et contiennent au moins trois types de caractères différents (chiffres, majuscules, minuscules, caractères spéciaux)",
  "validate.email.sendVerificationCodeEmailAddress": "Veuillez entrer votre boîte aux lettres et nous vous enverrons le Code de vérification dans votre boîte aux lettres",
  "validate.tips.PleaseEnterPassword": "Veuillez entrer votre mot de passe",
  "login.donTHaveAccount": "Pas encore de compte?",
  "login.forgotPassword": "Mot de passe oublié {scope}",
  "login.agreement.readAndAgree": "Lire et accepter",
  "login.agreement.and": "Et",
  "login.agreement.checkAgreeAgreement": "Veuillez d'abord cocher j'accepte l'accord utilisateur et l'Accord de confidentialité",
  "register.title.WelcomeRegister": "Inscription bienvenue",
  "register.lable.VerificationCode": "Code de vérification",
  "register.lable.password": "Mot de passe",
  "register.lable.register": "Enregistrement",
  "register.lable.Email": "Boîte aux lettres",
  "register.guidance.toLogin": "Vous avez déjà un compte pour vous connecter",
  "button.SendVerificationCode": "Envoyer le Code de vérification",
  "retrieve.tips.sendVerificationCodeEmailAddress": "Le Code de vérification a été envoyé à votre boîte aux lettres {scope}",
  "retrieve.lable.newPassword": "Nouveau mot de passe",
  "validate.retrieve.passwordEnteredTwiceInconsistent": "Deux entrées de mot de passe incohérentes",
  "switchover.SelectIdentity": "Veuillez sélectionner votre identité",
  "switchover.tipsProvisionServices": "Laissez - nous vous offrir un meilleur service",
  "switchover.switchover.Installers": "Je suis installateur",
  "product.PleaseEnter": "Veuillez entrer le nom du produit",
  "product.PleaseEnterTheProductSerialNumber": "Veuillez entrer le numéro de série du produit",
  "product.PleaseEnterSubmodelNumber": "Veuillez entrer un sous - modèle",
  "product.PleaseenterTheSubmodelSerialNumber": "Veuillez entrer le numéro de série du sous - modèle",
  "product.PleaseSelectTheDeviceType": "Veuillez sélectionner un type d'appareil",
  "product.PleaseSelectDevelopmentType": "Veuillez sélectionner un type de R & D",
  "product.name": "Gamme de produits",
  "product.reset": "Réinitialisation",
  "product.search": "Rechercher",
  "product.ApplicationList": "Liste des applications",
  "product.newProduct": "Nouveaux produits",
  "product.editName": "Modifier le produit",
  "product.DetailSetting": "Détails paramètres",
  "product.delete": "Supprimer",
  "product.serialNumber": "Numéro de série du produit",
  "product.DeviceType": "Type d'équipement",
  "product.RandDtype": "Type de R & D",
  "product.subType": "Sous - modèle",
  "product.subTypeNumber": "Numéro de sous - série",
  "product.UpdateTime": "Temps de mise à jour",
  "product.operation": "Opérations",
  "product.deviceList": "Liste des équipements (log d'expédition)",
  "product.parameterManagement": "Gestion des paramètres",
  "product.updataManagement": "Gestion des mises à niveau",
  "product.ParentDevice": "Appareil parent",
  "product.AssociatedPowerStationState": "État des stations associées",
  "product.ImportDeviceList": "Importer la liste des appareils",
  "product.PlantDetails": "Détails de la centrale électrique",
  "product.OwningPowerStation": "Station électrique à laquelle appartient",
  "product.parameterName": "Nom du paramètre",
  "product.ParameterClass": "Catégorie de paramètres",
  "product.ParameterSettingType": "Paramètre type de réglage",
  "product.ParameterOperationType": "Paramètre type d'opération",
  "product.ImportParameter": "Paramètres d'importation",
  "product.OwningUpperLevelParameterCategory": "Classification des paramètres supérieurs",
  "product.WhetherYoSupportBatchRead": "Prise en charge de la lecture en masse",
  "product.value": "Valeur",
  "product.scope": "La portée",
  "product.unit": "Unités",
  "product.explain": "Description",
  "product.remark": "Remarques",
  "product.FileName": "Nom du fichier",
  "product.FileAddress": "Adresse du fichier",
  "product.versionNumber": "Numéro de version",
  "product.ProductOfOwnership": "Produits appartenant",
  "product.ProductDetailsSettings": "Balcon 1.0 - détails du produit set",
  "product.QueryResultList": "Liste des résultats de la requête",
  "product.AddFirmware": "Ajouter un firmware",
  "product.NewParameter": "Ajout de paramètres",
  "product.datalog": "Collecteur",
  "product.Inverter": "Onduleurs",
  "product.storage": "Stockage d'énergie",
  "product.battery": "Batterie",
  "product.socket": "La prise",
  "product.DownloadTemplate": "Télécharger le template",
  "product.nation": "Pays",
  "product.agent": "Agents",
  "product.expirationDate": "Durée de conservation",
  "product.LastWeek": "Dernière semaine",
  "product.LastMonth": "Le dernier mois",
  "product.LastThreeMonths": "Les trois derniers mois",
  "product.parameterType": "Type de paramètre",
  "product.ProtocolAddress": "Adresse dans le Protocole paramètre",
  "product.stepSize": "Longueur de pas",
  "product.PleaseEnterAParameterName": "Veuillez entrer le nom du paramètre",
  "product.parameterCoding": "Codage des paramètres",
  "product.PleaseEnterTheParameterCode": "Veuillez entrer le paramètre codage",
  "product.ParameterDataType": "Type de données paramétriques",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "Veuillez entrer l'adresse dans le Protocole paramètre",
  "product.blockEncoding": "Codage de paquets",
  "product.PleaseEnterABlockCode": "Veuillez entrer le codage de groupe",
  "product.GroupName": "Nom du Groupe",
  "product.PleaseEnterAGroupName": "Veuillez entrer le nom du Groupe",
  "product.PleaseEnterTheUnit": "Veuillez entrer un minimum",
  "product.decimalPoint": "Point décimal",
  "product.PleaseEnterTheDecimalPoint": "Veuillez entrer une décimale",
  "product.leastValue": "Valeur minimale",
  "product.maximumValue": "Valeur maximale",
  "product.PleaseEnterTheMaximumValue": "Veuillez entrer un maximum",
  "product.PleaseEnterTheStepSize": "Veuillez entrer le pas",
  "product.addEquipment": "Équipement ajouté",
  "product.equipment": "Équipement",
  "product.remove": "Supprimer",
  "product.sort": "Trier",
  "product.PleaseEnterTheOrder": "Veuillez entrer un tri",
  "product.PleaseEnterTheParameterSettingType": "Veuillez entrer le paramètre set type",
  "product.PleaseSelectAFolderPath": "Veuillez sélectionner le chemin du dossier",
  "product.ReturnToSuperior": "Retour au supérieur",
  "product.PleaseEnterTheVersionNumber": "Veuillez entrer le numéro de version",
  "product.firmwareSpecification": "Description du firmware",
  "product.time": "Heures de service",
  "sidebar.home": "Aperçu des données",
  "sidebar.plant": "Gestion de scène",
  "sidebar.datalog": "Liste des collecteurs",
  "sidebar.inverter": "Liste des onduleurs",
  "sidebar.sotrage": "Liste de stockage d'énergie",
  "sidebar.socket": "Liste des sockets",
  "sidebar.battery": "Liste des batteries",
  "sidebar.agent": "Gestion des agents",
  "sidebar.systematicSupply": "Journal des livraisons",
  "sidebar.firmware_up": "Téléchargement du firmware",
  "sidebar.firmware_log": "Enregistrement de mise à niveau",
  "sidebar.system_datalog_log": "Log du collecteur",
  "sidebar.system_log": "Journal des opérations",
  "sidebar.system_tongxun": "Journal des communications",
  "sidebar.personal": "Informations utilisateur",
  "sidebar.logout": "Quitter le compte",
  "home.echarts1.title": "Utilisateurs enregistrés",
  "home.echarts1.subhead": "Nombre total de nouveaux utilisateurs / utilisateurs aujourd'hui",
  "home.echarts2.title": "Connexion utilisateur",
  "home.echarts2.subhead": "Nombre total de logins / utilisateurs aujourd'hui",
  "home.echarts3.title": "Ajouter un agent",
  "home.echarts3.subhead": "Nombre total de logins / agents aujourd'hui",
  "home.echarts4.title": "Ajouter une scène",
  "home.echarts4.subhead": "Ajout de scènes / nombre total de scènes",
  "home.echarts4.title_plant": "Ajouter une station électrique",
  "home.echarts4.subhead_plant": "Nombre total de nouvelles stations / stations",
  "home.echarts5.title": "Ajouter un collecteur",
  "home.echarts5.subhead": "Nombre total de collecteurs / collecteurs ajoutés",
  "home.echarts6.title": "Ajouter un équipement",
  "home.echarts6.subhead": "Nombre total d'équipements / équipements ajoutés",
  "End_user.input_email": "Veuillez entrer la boîte aux lettres de l'utilisateur",
  "End_user.btn_search": "Rechercher",
  "End_user.btn_add": "Ajouter",
  "End_user.btn_delete": "Supprimer",
  "End_user.btn_binding": "Liaison",
  "End_user.add_station": "Ajouter une scène",
  "End_user.lable_StationName": "Nom de la scène",
  "End_user.lable_StationType": "Type de scène",
  "End_user.lable_PVCapacity": "Capacité de la batterie solaire",
  "End_user.lable_InstalltionDate": "Date d'installation",
  "End_user.lable_Country": "国家",
  "End_user.lable_City": "城市",
  "End_user.lable_Address": "地址",
  "End_user.lable_TimeZone": "时区",
  "End_user.lable_Energyprice": "能源单价",
  "End_user.lable_IncomeUnit": "收入单位",
  "End_user.input_StationName": "请输入场景名字",
  "End_user.input_StationType": "请选择类型",
  "End_user.input_PVCapacity": "请输入电池容量",
  "End_user.input_InstalltionDate": "请选择安装日期",
  "End_user.input_Country": "请选择国家",
  "End_user.input_City": "请选择城市",
  "End_user.input_Address": "请输入地址",
  "End_user.input_TimeZone": "请选择时区",
  "End_user.input_Energyprice": "请输入单价",
  "End_user.input_IncomeUnit": "选择收入单位",
  "End_user.max_20": "字符最大不能超过20个",
  "End_user.max_5": "字符最大不能超过5个",
  "End_user.max_8": "字符最大不能超过8个",
  "End_user.format": "请输入正确的格式",
  "End_user.close": "关闭",
  "End_user.submit": "提交",
  "End_user.title_delete": "删除？",
  "End_user.no": "否",
  "End_user.yes": "是",
  "End_user.Bingding_Agent": "绑定代理商",
  "End_user.Agent_Code": "代理商:",
  "End_user.please_select": "请选择",
  "plant.input_email": "请输入用户邮箱",
  "plant.search": "搜索",
  "plant.edit": "编辑",
  "plant.delete": "删除",
  "plant.edit_plant": "编辑场景",
  "plant.input_station": "请输入场景名字",
  "plant.lable_StationName": "场景名字",
  "plant.lable_StationType": "场景类型",
  "plant.lable_PVCapacity": "太阳电池容量",
  "plant.lable_InstalltionDate": "安装日期",
  "plant.lable_Country": "国家",
  "plant.lable_City": "城市",
  "plant.lable_Address": "地址",
  "plant.lable_TimeZone": "时区",
  "plant.lable_Energyprice": "能源单价",
  "plant.lable_IncomeUnit": "收入单位",
  "plant.input_StationName": "请输入场景名字",
  "plant.input_StationType": "请选择类型",
  "plant.input_PVCapacity": "请输入电池容量",
  "plant.input_InstalltionDate": "请选择安装日期",
  "plant.input_Country": "请选择国家",
  "plant.input_City": "请选择城市",
  "plant.input_Address": "请输入地址",
  "plant.input_TimeZone": "请选择时区",
  "plant.input_Energyprice": "请输入单价",
  "plant.input_IncomeUnit": "选择收入单位",
  "plant.max_20": "字符最大不能超过20个",
  "plant.max_5": "字符最大不能超过5个",
  "plant.max_8": "字符最大不能超过8个",
  "plant.format": "请输入正确的格式",
  "plant.close": "关闭",
  "plant.submit": "提交",
  "plant.title_delete": "删除？",
  "plant.no": "否",
  "plant.yes": "是",
  "datalog.email": "请输入邮箱",
  "datalog.datalogSn": "请输入采集器序列号",
  "datalog.search": "搜索",
  "datalog.Version": "版本号",
  "datalog.setting": "设置",
  "datalog.upgrade": "升级",
  "datalog.delete": "删除",
  "datalog.title_datalog": "采集器设置",
  "datalog.span_info": "信息",
  "datalog.span_datalog": "采集器序列号:",
  "datalog.span_name": "别名:",
  "datalog.span_time": "更新时间:",
  "datalog.span_firmware": "信号/固件版本:",
  "datalog.span_order": "命令",
  "datalog.span_settingdns": "设置域名",
  "datalog.span_inputsetting": "请输入域名",
  "datalog.span_upgrade": "升级采集器",
  "datalog.span_reset": "重启采集器",
  "datalog.span_setup": "高级设置",
  "datalog.span_param": "参数",
  "datalog.span_value": "值",
  "datalog.btn_setup": "高级设置",
  "datalog.btn_setting": "设置",
  "datalog.btn_settingdns": "设置域名",
  "datalog.btn_upgrade": "升级",
  "datalog.btn_reset": "重启",
  "datalog.btn_read": "读取",
  "datalog.btn_close": "Annuler",
  "datalog.methods_version": "检测版本更新?",
  "datalog.no": "否",
  "datalog.yes": "是",
  "datalog.methods_delete": "删除?",
  "datalog.methods_rereset": "重启?",
  "datalog.methodes_inputDns": "请输入域名",
  "datalog.methodes_DNS": "是否设置此域名",
  "sotrage.select": "请选择",
  "sotrage.email": "请输入邮箱",
  "sotrage.datalogSn": "请输入采集器序列号",
  "sotrage.deviceSn": "请输入设备序列号",
  "sotrage.search": "搜索",
  "sotrage.sotrage": "储能设置",
  "device.select": "请选择",
  "device.email": "请输入邮箱",
  "device.datalogSn": "请输入采集器序列号",
  "device.deviceSn": "请输入设备序列号",
  "device.search": "搜索",
  "device.title": "逆变器设置",
  "device.setting": "设置",
  "device.setting_inverte": "设置逆变器参数",
  "device.input_start_address": "起始寄存器地址",
  "device.input_ent_address": "终止寄存器地址",
  "device.input_setting_value": "请输入设置值",
  "device.read_data": "读取寄存器数据:",
  "device.input_start_read": "起始寄存器地址",
  "device.input_end_read": "终止寄存器地址",
  "device.btn_address": "设置地址",
  "device.btn_value": "Définir les paramètres",
  "device.btn_read": "Lire",
  "device.btn_close": "Retour",
  "device.selet_data": "Choisissez une date",
  "battery.select": "Veuillez sélectionner",
  "battery.email": "Veuillez entrer une boîte aux lettres",
  "battery.datalogSn": "Veuillez entrer le numéro de série du collecteur",
  "battery.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "battery.search": "Rechercher",
  "socket.title": "Paramètres de prise",
  "socket.setting": "Paramètres",
  "socket.span": "Plusieurs adresses de registre sont définies et la valeur doit également être définie en plusieurs. Définir des valeurs intermédiaires à utiliser, espacées, exemples (1, 2, 3)",
  "socket.setting_device": "Réglage des paramètres de l'onduleur:",
  "socket.startaddress": "Adresse du registre de départ",
  "socket.stopaddress": "Adresse du registre de terminaison",
  "socket.value": "Veuillez entrer une valeur de réglage",
  "socket.readdata": "Lecture des données du Registre:",
  "socket.setting_address": "Définir une adresse",
  "socket.setting_value": "Définir les paramètres",
  "socket.read": "Lire",
  "socket.return": "Retour",
  "agent.close": "Annuler",
  "agent.submit": "Soumettre",
  "agent.input_email": "Veuillez entrer une boîte aux lettres",
  "agent.search": "Rechercher",
  "agent.add_agent": "Ajouter un agent",
  "agent.import_device": "Importer des appareils",
  "agent.edit": "Modifier",
  "agent.title": "Ajouter un agent",
  "agent.email": "Boîte aux lettres",
  "agent.password": "Mot de passe",
  "agent.phone": "Numéro de téléphone portable",
  "agent.company": "La société",
  "agent.language": "Langue",
  "agent.address": "Adresse",
  "agent.input_password": "Veuillez entrer votre mot de passe",
  "agent.input_phone": "Veuillez entrer le numéro de téléphone portable",
  "agent.input_company": "Veuillez sélectionner une entreprise",
  "agent.input_language": "Veuillez entrer la langue",
  "agent.input_address": "Veuillez entrer une adresse",
  "agent.relus_email": "Veuillez entrer une adresse e - mail valide",
  "agent.title_edit": "Modifier l'agent",
  "agent.title_device": "Télécharger",
  "agent.span": "Exemple: Tableau excle",
  "agent.btn_upload": "Télécharger",
  "agent.delete": "Supprimer",
  "agent.agent_delete": "Supprimer un agent?",
  "ship.starttime": "Heure de début",
  "ship.endtime": "Heure de fin",
  "ship.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "ship.select": "Veuillez sélectionner une entreprise",
  "ship.search": "Rechercher",
  "Firmware.file_name": "Veuillez entrer le nom du fichier",
  "Firmware.search": "Rechercher",
  "Firmware.add": "Ajouter",
  "Firmware.delete": "Supprimer",
  "Firmware.title": "Téléchargement du firmware",
  "Firmware.select_folder": "Sélectionnez le dossier:",
  "Firmware.select_folder_type": "Veuillez sélectionner un type de dossier",
  "Firmware.craete_folder": "Créer un nouveau dossier",
  "Firmware.folder_path": "Chemin du dossier:",
  "Firmware.folder_name": "Nom du fichier:",
  "Firmware.input_folder_name": "Entrez le nom du fichier",
  "Firmware.create": "Créer un dossier",
  "Firmware.listed_files": "Liste des fichiers:",
  "Firmware.import_folder": "Importer un fichier",
  "Firmware.uplad_folder": "Télécharger des fichiers",
  "Firmware.close": "Retour",
  "Upgrade.starttime": "Heure de début",
  "Upgrade.endtime": "Heure de fin",
  "Upgrade.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "Upgrade.search": "Rechercher",
  "Upgrade.datalog": "Collecteur",
  "Upgrade.Inverter": "Onduleurs",
  "Upgrade.Control": "Contrôleur",
  "datalogs_logs.starttime": "Heure de début",
  "datalogs_logs.endtime": "Heure de fin",
  "datalogs_logs.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "datalogs_logs.Version": "Veuillez entrer la version",
  "datalogs_logs.search": "Rechercher",
  "Logs.starttime": "Heure de début",
  "Logs.endtime": "Heure de fin",
  "Logs.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "Logs.type": "Veuillez sélectionner le type",
  "Logs.search": "Rechercher",
  "Special.starttime": "Heure de début",
  "Special.endtime": "Heure de fin",
  "Special.deviceSn": "Veuillez entrer le numéro de série de l'appareil",
  "Special.datalogSn": "Veuillez entrer le numéro de série du collecteur",
  "Special.type": "Veuillez sélectionner le type",
  "Special.search": "Rechercher",
  "Special.save": "Sauvegarder",
  "Special.Examples": "Exemple: (23052102305210139)",
  "App.System_Config": "Configuration du système",
  "App.APP_Version": "App version publiée",
  "App.Android_Version": "Version Android:",
  "App.IOS_Version": "Version IOS:",
  "App.APP_Type": "Type d'APP:",
  "App.New_Version": "Nouvelle version",
  "App.update_content": "Mettre à jour la description du contenu: (diviser par « / N »)",
  "App.Whether_update": "La mise à jour est - elle obligatoire:",
  "App.no": "Non",
  "App.yes": "Oui",
  "App.submit": "Soumettre",
  "Tips.app_submit": "Identifier les informations modifiées?",
  "Tips.firmware_delete": "Confirmer la suppression?",
  "Tips.firmware_deleteCDN": "Supprimer des fichiers dans votre CDN?",
  "Tips.yes": "Oui",
  "Tips.no": "Non",
  "global.DataDetails": "Détails des données",
  "global.device": "Paramètres de l'onduleur",
  "global.device_data": "Réglage des paramètres de l'onduleur:",
  "global.storage": "Paramètres de stockage d'énergie",
  "global.storage_data": "Paramètre de stockage d'énergie",
  "global.battery": "Paramètres de la batterie",
  "global.battery_data": "Définir les paramètres de la batterie",
  "global.socket": "Paramètres de prise",
  "global.socket_data": "Définir les paramètres de la prise",
  "btn.setting_address": "Définir une adresse",
  "btn.close": "Retour",
  "btn.submit": "Soumettre",
  "btn.Setting_parameters": "Définir les paramètres",
  "btn.Reading": "Lire",
  "btn.search": "Rechercher",
  "btn.add": "Ajouter",
  "btn.import": "Importation",
  "btn.download": "Télécharger un exemple",
  "btn.edit": "Modifier",
  "btn.login": "Se connecter",
  "btn.export": "Exporter",
  "form.addShip": "Ajouter un équipement d'expédition",
  "form.editShip": "Modifier l'équipement d'expédition",
  "form.import": "Importer des informations sur le périphérique",
  "form.shipSN": "Numéro de série d'expédition",
  "form.agent": "Agents",
  "form.networkCall": "Effectuer un Callback réseau",
  "form.warrantyPeriod": "Temps de garantie",
  "form.shiptime": "Temps de livraison",
  "form.shiptype": "Type d'expédition",
  "form.classify": "Classification",
  "form.file": "Faites glisser le fichier ici ou cliquez sur upload",
  "form.edit_plant": "Modifier la scène",
  "form.input_station": "Veuillez entrer le nom de la scène",
  "form.lable_StationName": "Nom de la scène",
  "form.lable_StationType": "Type de scène",
  "form.input_StationName": "Veuillez entrer le nom de la scène",
  "form.edit_plant_plant": "Modifier la station",
  "form.input_station_plant": "Veuillez entrer le nom de la station",
  "form.lable_StationName_plant": "Nom de la station",
  "form.lable_StationType_plant": "Type de station électrique",
  "form.input_StationName_plant": "Veuillez entrer le nom de la station",
  "placeholder.input": "Veuillez entrer",
  "placeholder.startTime": "Heure de début",
  "placeholder.endTime": "Heure de fin",
  "placeholder.startDate": "Date de début",
  "placeholder.endDate": "Date de fin",
  "systemAuthority.systemSettings": "Paramètres du système",
  "systemAuthority.authorityManagement": "Authorisation",
  "systemAuthority.accountManagement": "Rôle",
  "systemAuthority.Disabled": "Désactivé",
  "systemAuthority.enable": "Activer",
  "org.ChangeSupplier": "Changer de fournisseur",
  "upload.imageDetail": "Détails de l'image",
  "upload.seeOrigin": "Cliquez pour voir le fichier source",
  "upload.needOpen": "Le fichier peut devoir être visualisé après le téléchargement",
  "upload.knowandSure": "Connaître et confirmer",
  "upload.fail": "Le téléchargement a échoué",
  "upload.uploadError": "Le téléchargement du fichier a échoué, veuillez contacter l'Administrateur",
  "upload.fielExceed": "Fichiers au - delà du nombre",
  "upload.fileSizeExceed": "La taille de l'image téléchargée ne peut pas dépasser",
  "upload.fileTypeError": "Veuillez choisir le bon format de fichier",
  "upload.image": "Images",
  "validator.bank": "Veuillez saisir le bon numéro de carte bancaire",
  "validator.phone": "S'il vous plaît entrer le bon numéro de téléphone portable ou de parole solide",
  "validator.email": "Veuillez entrer la bonne boîte aux lettres",
  "validator.password": "Le mot de passe est de 8 à 20 chiffres et contient au moins les trois types de caractères suivants (chiffres, majuscules, minuscules, symboles anglais)",
  "validator.greater": "Veuillez entrer un nombre supérieur à zéro",
  "org.user": "Utilisateur",
  "org.role": "Rôle",
  "org.email": "Boîte aux lettres",
  "org.editorginfo": "Modifier les informations de l'Organisation",
  "org.passwordResetTo": "Le mot de passe sera réinitialisé",
  "org.pleaseChooseOrg": "Veuillez d'abord sélectionner une organisation",
  "org.addDept": "Ajout de départements",
  "org.editDept": "Département éditorial",
  "org.passwordResetSuccess": "Réinitialisation du mot de passe réussie",
  "org.passwordResetFail": "La Réinitialisation du mot de passe a échoué",
  "org.deleteTip": "Cette action supprimera le Département, voulez - vous continuer?",
  "org.deleteSuccess": "Supprimer avec succès",
  "org.parent": "Organisation supérieure",
  "org.orgName": "Nom de l'Organisation",
  "org.area": "Pays / région",
  "org.leader": "Responsable",
  "org.leaderPhone": "Personne responsable contact",
  "org.logo": "Organiser le logo",
  "org.namenick": "Nom / surnom",
  "org.createTime": "Temps de création",
  "org.status": "Statut",
  "org.action": "Opérations",
  "login.password.not.blank": "Login le mot de passe ne peut pas être vide",
  "token.invalid": "Token invalide, veuillez vous reconnecter",
  "token.empty": "Token ne peut pas être vide",
  "user.not.exist": "L'utilisateur n'existe pas",
  "user.mail.password.not.correct": "Boîte aux lettres utilisateur ou mot de passe incorrect",
  "user.email.exist": "La boîte mail est enregistrée!",
  "dept.suspend": "Département désactivé, aucun ajout autorisé",
  "dept.not.exist": "L'information sectorielle n'existe pas",
  "email.code.valid": "Code de vérification incorrect",
  "service.not.found": "Service non trouvé",
  "service.internal.error": "Erreur interne au serveur",
  "login.email.length.error": "La boîte aux lettres ne peut pas dépasser 50 caractères.",
  "login.password.length.error": "Le mot de passe doit contenir entre 8 et 20 caractères",
  "menu.edit.exist": "La modification du menu '% s' a échoué, le nom du menu existe déjà",
  "menu.add.exist": "L'ajout du menu '% s' a échoué, le nom du menu existe déjà",
  "menu.edit.parent": "La modification du menu '% s' a échoué, le menu supérieur ne peut pas se sélectionner",
  "menu.add.parent": "L'ajout du menu '% s' a échoué, le menu supérieur ne peut pas se sélectionner",
  "menu.child.exist": "Présence de sous - menus, suppression non autorisée",
  "menu.assign.error": "Menu assigné, ne permet pas la suppression",
  "password.reset.success": "Réinitialisation du mot de passe réussie",
  "user.register.success": "Inscription réussie",
  "dept.add.exist": "L'ajout du Département '% s' a échoué, le nom du Département existe déjà",
  "dept.edit.exist": "La modification du Département '% s' a échoué, le nom du Département existe déjà",
  "menu.show.status": "Afficher",
  "menu.hide.status": "Cacher",
  "menu.category.name": "Catalogue",
  "menu.menu.name": "Le menu",
  "menu.button.name": "Le bouton",
  "menu.is.external": "Oui",
  "menu.not.external": "Non",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "Auto - étude",
  "supplier.type.hr": "Haile",
  "supplier.type.jl": "La vague",
  "supplier.type.nt": "Natone",
  "device.category.inverter": "Onduleurs",
  "device.category.pv": "Photovoltaïque",
  "device.category.battery": "Batterie",
  "device.category.switch": "Interrupteurs",
  "device.category.charging.pile": "Pile de charge",
  "product.not.exist": "Le produit n'existe pas",
  "product.binding.error": "Le produit est lié, la suppression n'est pas autorisée",
  "ship.import.empty": "Les données importées ne peuvent pas être vides",
  "mdn.exist": "MDN numéro d'article existe déjà, ne répétez pas l'ajout",
  "ship.mdn.not.empty": "MDN ne peut pas être vide",
  "ship.category.not.empty": "Les catégories ne peuvent pas être vides",
  "ship.hrSn.not.empty": "Le numéro de série Haier ne peut pas être vide",
  "ship.devType.not.empty": "Le type de R & D ne peut pas être vide",
  "ship.supplierSn.not.empty": "Le numéro de série du fournisseur ne peut pas être vide",
  "ship.mdn.not.exist": "Le produit MDN n'existe pas",
  "ship.add.data.error": "Gestion des expéditions ajouter une exception de données, contacter l'Administrateur",
  "plant.InstallationPlan": "Plan d'installation",
  "plant.owner": "Propriétaire",
  "plant.photovoltaicCapacity": "Capacité photovoltaïque (kWh)",
  "plant.batteryCapacity": "Capacité de la batterie (kWh)",
  "plant.electricityConsumptionToday": "Électricité aujourd'hui",
  "plant.electricityConsumptionMonth": "Électricité du mois en cours",
  "plant.electricityConsumptionTotal": "Électricité cumulée",
  "plant.runningState": "État de fonctionnement",
  "plant.buildState": "État de construction",
  "plant.plantNum": "Nombre de centrales",
  "plant.totalPlantNum": "Total",
  "plant.building": "En construction",
  "plant.delivered": "Livré",
  "plant.electricEnergy": "Production d'électricité",
  "plant.deleteSuccess": "Suppression de la centrale réussie",
  "plant.life": "Durée de vie",
  "plant.operatingData": "Données de fonctionnement",
  "plant.dataReportingTime": "Heure de soumission des données",
  "plant.energyBalance": "Bilan énergétique (kWh)",
  "plant.onGridEnergy": "Électricité injectée au réseau",
  "plant.purchaseElectricity": "Électricité achetée",
  "plant.statisticalAnalysis": "Analyse statistique",
  "plant.energyAnalysis": "Analyse énergétique",
  "plant.powerAnalysis": "Analyse de puissance",
  "plant.updateTime": "Heure de mise à jour des données météorologiques",
  "plant.stationInfo": "Informations sur la centrale",
  "plant.userInfo": "Informations sur l'utilisateur",
  "plant.socialContribution": "Contribution sociale",
  "plant.equivalentIncome": "Bénéfice équivalent",
  "plant.priceSet": "Paramètres du prix de l'électricité",
  "plant.photovoltaicPowerGenerations": "Production d'électricité photovoltaïque",
  "plant.weather": "Météo",
  "plant.sunriseSunset": "Lever/Coucher du soleil",
  "plant.temperature": "Température(℃)",
  "plant.humidity": "Humidité",
  "plant.windSpeed": "Vitesse du vent",
  "plant.windDirection": "Direction du vent",
  "plant.primaryUser": "Utilisateur principal",
  "plant.receiveMode": "Mode de réception",
  "plant.dateOfReceipt": "Date de réception",
  "plant.familyName": "Nom de la famille",
  "plant.familyMembers": "Nombre de membres de la famille",
  "plant.currency": "Devise",
  "plant.purchasePrice": "Prix d'achat",
  "plant.sellingPrice": "Prix de vente de l'électricité",
  "plant.noUserInfo": "Utilisateurs non encore livrés",
  "plant.noIncomeTip": "Pour un meilleur calcul de votre bénéfice équivalent, veuillez saisir les prix d'achat et de vente de l'électricité",
  "subttile.week": "Semaine",
  "shipment.spread": "Déplier",
  "shipment.packUp": "Replier",
  "device.empty": "Appareil inexistant",
  "deviceType.empty": "Type d'appareil non pris en charge",
  "collector.params.error": "Lecture anormale de paramètres non provenant d'un capteur",
  "can.not.empty": "Ne peut être vide",
  "shipment.supplierSN": "Numéro de série du fournisseur (SN)",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "Interrupteur slot 1 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot1": "Intervalle de temps de charge 1",
  "jl_param_ctrl_name_SOC1": "SOC 1",
  "jl_param_ctrl_name_ChargeCurrent1": "Courant de charge 1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "Interrupteur slot 2 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot2": "Slot de temps de charge 2",
  "jl_param_ctrl_name_SOC2": "SOC 2",
  "jl_param_ctrl_name_ChargeCurrent2": "Courant de charge 2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "Interrupteur slot 3 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot3": "Slot de temps de charge 3",
  "jl_param_ctrl_name_SOC3": "SOC 3",
  "jl_param_ctrl_name_ChargeCurrent3": "Courant de charge 3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "Interrupteur slot 4 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot4": "Slot de temps de charge 4",
  "jl_param_ctrl_name_SOC4": "SOC 4",
  "jl_param_ctrl_name_ChargeCurrent4": "Courant de charge 4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "Interrupteur slot 5 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot5": "Fente de temps de charge 5",
  "jl_param_ctrl_name_SOC5": "SOC 5",
  "jl_param_ctrl_name_ChargeCurrent5": "Courant de charge 5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "Interrupteur slot 6 de charge",
  "jl_param_ctrl_name_ChargeTimeSlot6": "Slot de temps de charge 6",
  "jl_param_ctrl_name_SOC6": "SOC 6",
  "jl_param_ctrl_name_ChargeCurrent6": "Courant de charge 6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "Interrupteur de slot de décharge 1",
  "jl_param_ctrl_name_DischargeTimeSlot1": "Intervalle de temps de décharge 1",
  "jl_param_ctrl_name_DischargeCurrent1": "Courant de décharge 1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "Interrupteur de décharge slot 2",
  "jl_param_ctrl_name_DischargeTimeSlot2": "Fente de temps de décharge 2",
  "jl_param_ctrl_name_DischargeCurrent2": "Courant de décharge 2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "Interrupteur de slot de décharge 3",
  "jl_param_ctrl_name_DischargeTimeSlot3": "Fente de temps de décharge 3",
  "jl_param_ctrl_name_DischargeCurrent3": "Courant de décharge 3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "Interrupteur de décharge slot 4",
  "jl_param_ctrl_name_DischargeTimeSlot4": "Fente de temps de décharge 4",
  "jl_param_ctrl_name_DischargeCurrent4": "Courant de décharge 4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "Commutateur de fente de temps de décharge 5",
  "jl_param_ctrl_name_DischargeTimeSlot5": "Fente de temps de décharge 5",
  "jl_param_ctrl_name_DischargeCurrent5": "Courant de décharge 5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "Commutateur de fente de temps de décharge 6",
  "jl_param_ctrl_name_DischargeTimeSlot6": "Fente de temps de décharge 6",
  "jl_param_ctrl_name_DischargeCurrent6": "Courant de décharge 6",
  "jl_param_ctrl_note_ChargeTimeSlot1": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC1": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot2": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC2": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot3": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC3": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot4": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC4": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot5": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC5": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_ChargeTimeSlot6": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_SOC6": "Gamme: SOC sur - décharge ~ 100%",
  "jl_param_ctrl_note_DischargeTimeSlot1": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_DischargeTimeSlot2": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_DischargeTimeSlot3": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_DischargeTimeSlot4": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_DischargeTimeSlot5": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "jl_param_ctrl_note_DischargeTimeSlot6": "Ne doit pas se chevaucher avec d'autres périodes de charge et de décharge intenses",
  "device.category.collecting.box": "Boîte de regroupement",
  "device.category.energy.storage": "Contrôleur de stockage tout-en-un",
  "hipment.devType": "Type de développement",
  "device.voltageV": "Tension de l'équipement V",
  "device.electric.currentA": "Courant de l'équipement A",
  "device.return.port": "Port de retour",
  "device.a.phase": "Phase A",
  "device.b.phase": "Phase B",
  "device.c.phase": "Phase C",
  "device.electic.meter.data": "Données du compteur électrique",
  "device.voltage": "Tension",
  "device.electric.current": "Courant",
  "button.confirm": "Confirmer",
  "button.ok": "Confirmer",
  "ywt.65323.runStatus": "État de fonctionnement",
  "unc.65323.runStatus": "État de fonctionnement",
  "bw_RTparam_name_TotalPower": "Puissance totale",
  "bw_RTparam_name_TotalYield": "Production totale",
  "bw_RTparam_name_TotalRuntime": "Durée totale de fonctionnement (PV)",
  "bw_RTparam_name_PV1Voltage": "Tension en temps réel PV1",
  "bw_RTparam_name_PV1Current": "Courant en temps réel PV1",
  "bw_RTparam_name_PV1Power": "Puissance en temps réel PV1",
  "bw_RTparam_name_PV2Voltage": "Tension en temps réel PV2",
  "bw_RTparam_name_PV2Current": "Courant en temps réel PV2",
  "bw_RTparam_name_PV2Power": "Puissance en temps réel PV2",
  "bw_RTparam_name_PV3Voltage": "Tension en temps réel PV3",
  "bw_RTparam_name_PV3Current": "Courant en temps réel PV3",
  "bw_RTparam_name_PV3Power": "Puissance en temps réel PV3",
  "bw_RTparam_name_GridVoltageL1": "Tension du réseau L1",
  "bw_RTparam_name_GridVoltageL2": "Tension du réseau L2",
  "bw_RTparam_name_GridVoltageL3": "Tension du réseau L3",
  "bw_RTparam_name_GridCurrentL1": "Courant du réseau L1",
  "bw_RTparam_name_GridCurrentL2": "Courant du réseau L2",
  "bw_RTparam_name_GridCurrentL3": "Courant du réseau L3",
  "bw_RTparam_name_GridPowerL1": "Puissance active du réseau L1",
  "bw_RTparam_name_GridPowerL2": "Puissance active du réseau L2",
  "bw_RTparam_name_GridPowerL3": "Puissance active du réseau L3",
  "bw_RTparam_name_GridTotalActivePower": "Puissance active totale du réseau",
  "bw_RTparam_name_GridFrequency": "Fréquence du réseau",
  "bw_RTparam_name_ApparentPOAP_Grid": "Puissance apparente de la phase A (réseau)",
  "bw_RTparam_name_ApparentPOBP_Grid": "Puissance apparente de la phase B (réseau)",
  "bw_RTparam_name_ApparentPOCP_Grid": "Puissance apparente de la phase C (réseau)",
  "bw_RTparam_name_ReactivePOAP_Grid": "Puissance réactive de la phase A (réseau)",
  "bw_RTparam_name_ReactivePOBP_Grid": "Puissance réactive de la phase B (réseau)",
  "bw_RTparam_name_ReactivePOCP_Grid": "Puissance réactive de la phase C (réseau)",
  "bw_RTparam_name_PFOA_Grid": "Facteur de puissance de la phase A (réseau)",
  "bw_RTparam_name_PFOB_Grid": "Facteur de puissance de la phase B (réseau)",
  "bw_RTparam_name_PFOC_Grid": "Facteur de puissance de la phase C (réseau)",
  "bw_RTparam_name_DailyEnergytoGrid": "Énergie injectée quotidienne",
  "bw_RTparam_name_TotalEnergytoGrid": "Énergie injectée cumulée",
  "bw_RTparam_name_DailyEnergyfromGrid": "Énergie prélevée quotidienne",
  "bw_RTparam_name_TotalEnergyfromGrid": "Énergie prélevée cumulée",
  "bw_RTparam_name_BatteryVoltage": "Tension de la batterie",
  "bw_RTparam_name_BatteryCurrent": "Courant de la batterie",
  "bw_RTparam_name_BatteryPower": "Puissance de la batterie",
  "bw_RTparam_name_TotalConsumption": "Consommation totale",
  "bw_RTparam_name_TotalEnergyfromBattery": "Énergie déchargée cumulée",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "Énergie de la batterie chargée depuis le réseau",
  "bw_RTparam_name_BatterySOC": "État de charge de la batterie (SOC)",
  "bw_RTparam_name_BatterySOH": "État de santé de la batterie (SOH)",
  "bw_RTparam_name_Maximumtemperatureofbattery": "Température maximale de la batterie",
  "bw_RTparam_name_Minimumtemperatureofbattery": "Température minimale de la batterie",
  "bw_RTparam_name_Maximumcellvoltage": "Tension maximale des cellules",
  "bw_RTparam_name_Minimumcellvoltage": "Tension minimale des cellules",
  "bw_RTparam_name_TotalConsumptionPower": "Puissance totale de consommation",
  "bw_RTparam_name_TodayConsumption": "Consommation quotidienne",
  "bw_RTparam_name_TotalConsumptionEnergy": "Consommation énergétique totale",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "Énergie totale injectée au réseau (PV)",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "Énergie totale prélevée du réseau (PV)",
  "bw_RTparam_name_VoltageOfAPhase_PV": "Tension de la phase A (PV)",
  "bw_RTparam_name_VoltageOfBPhase_PV": "Tension de la phase B (PV)",
  "bw_RTparam_name_VoltageOfCPhase_PV": "Tension de la phase C (PV)",
  "bw_RTparam_name_CurrentOfAPhase_PV": "Actuel de la phase A (PV)",
  "bw_RTparam_name_CurrentOfBPhase_PV": "Current de la phase B (PV)",
  "bw_RTparam_name_CurrentOfCPhase_PV": "Courant de la phase C (PV)",
  "bw_RTparam_name_Frequent_PV": "Fréquence (PV)",
  "bw_RTparam_name_TotalApparentPower_PV": "Puissance apparente totale (PV)",
  "bw_RTparam_name_TotalActivePower_PV": "Puissance active totale (PV)",
  "bw_RTparam_name_TotalReactivePower_PV": "Puissance réactive totale (PV)",
  "bw_RTparam_name_TotalPowerFactor_PV": "Facteur de puissance total (PV)",
  "bw_RTparam_group_Inverter": "Onduleur",
  "bw_RTparam_group_Grid": "Réseau",
  "bw_RTparam_group_Battery": "Batterie",
  "bw_RTparam_group_Load": "Charge",
  "bw_RTparam_group_PVMeter": "Compteur latéral PV",
  "common.50100.pv1Voltage": "Tension PV1",
  "common.50100.pv1Current": "PV1 Courant",
  "common.50100.pv1Power": "Puissance PV1",
  "common.50100.pv2Voltage": "Tension PV2",
  "common.50100.pv2Current": "Courant PV2",
  "common.50100.pv2Power": "Puissance PV2",
  "common.50100.pv3Voltage": "Tension PV3",
  "common.50100.pv3Current": "PV3 Courant",
  "common.50100.pv3Power": "Puissance PV3",
  "common.50100.pv4Voltage": "Tension PV4",
  "common.50100.pv4Current": "Courant PV4",
  "common.50100.pv4Power": "Puissance PV4",
  "common.50100.temperature": "Température(℃)",
  "common.50100.outputGridVoltage": "Tension du réseau de sortie",
  "common.50100.outputGridCurrent": "Courant de la grille de sortie",
  "common.50100.outputGridPower": "Puissance du réseau de sortie",
  "common.50100.pv1CumulativePowerGeneration": "Production d'énergie cumulative PV1",
  "common.50100.pv2CumulativePowerGeneration": "Production d'énergie cumulative PV2",
  "common.50100.pv3CumulativePowerGeneration": "Production d'énergie cumulative PV3",
  "common.50100.pv4CumulativePowerGeneration": "Production d'énergie cumulative PV4",
  "common.50100.totalPowerGeneration": "Production totale d'électricité",
  "common.50100.wnSn": "Enregistreur de données Sn",
  "common.50100.wnWifiVersion": "Datalogger Wifi Version",
  "common.50100.wnHardwareVersion": "Version matérielle de l'enregistreur de données",
  "common.50100.wnSoftwareVersion": "Version du logiciel Datalogger",
  "ltwn_RTparam_group_Inverter": "Onduleurs",
  "bw_param_ctrl_option_withoutBattery": "sans batterie",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "\nActiver uniquement le contrôle de la période de décharge",
  "plant.already.deliver": "La centrale a été livrée",
  "common.50100.totalPvEnergy": "Production totale d'électricité",
  "ltcg_RTparam_name_name": "Nom de l'appareil",
  "ltcg_RTparam_name_out_pac": "Production d'énergie (kW)",
  "ltcg_RTparam_name_eday": "Production d'électricité aujourd'hui (kWh)",
  "ltcg_RTparam_name_etotal": "Production d'électricité cumulée (kWh)",
  "ltcg_RTparam_name_status": "État",
  "ltcg_RTparam_name_turnon_time": "Temps d'accès",
  "ltcg_RTparam_name_type": "Type d'équipement",
  "ltcg_RTparam_name_capacity": "Capacité kw",
  "ltcg_RTparam_name_tempperature": "température",
  "ltcg_RTparam_name_creationDate": "Dernière heure des données",
  "ltcg_RTparam_name_pac": "Production d'électricité",
  "ltcg_RTparam_name_hTotal": "Heures de production d'électricité cumulées",
  "ltcg_RTparam_name_vpv1": "Tension continue 1",
  "ltcg_RTparam_name_vpv2": "Tension continue 2",
  "ltcg_RTparam_name_vpv3": "Tension continue 3",
  "ltcg_RTparam_name_vpv4": "Tension continue 4",
  "ltcg_RTparam_name_vpv5": "Tension continue 5",
  "ltcg_RTparam_name_vpv6": "Tension continue 6",
  "ltcg_RTparam_name_vpv7": "Tension continue 7",
  "ltcg_RTparam_name_vpv8": "Tension continue 8",
  "ltcg_RTparam_name_vpv9": "Tension continue 9",
  "ltcg_RTparam_name_vpv10": "Tension continue 10",
  "ltcg_RTparam_name_vpv11": "Tension continue 11",
  "ltcg_RTparam_name_vpv12": "Tension continue 12",
  "ltcg_RTparam_name_ipv1": "Courant continu 1",
  "ltcg_RTparam_name_ipv2": "Courant continu 2",
  "ltcg_RTparam_name_ipv3": "Courant continu 3",
  "ltcg_RTparam_name_ipv4": "Courant continu 4",
  "ltcg_RTparam_name_ipv5": "Courant continu 5",
  "ltcg_RTparam_name_ipv6": "Courant continu 6",
  "ltcg_RTparam_name_ipv7": "Courant continu 7",
  "ltcg_RTparam_name_ipv8": "Courant continu 8",
  "ltcg_RTparam_name_ipv9": "Courant continu 9",
  "ltcg_RTparam_name_ipv10": "Courant continu 10",
  "ltcg_RTparam_name_ipv11": "Courant continu 11",
  "ltcg_RTparam_name_ipv12": "Courant continu 12",
  "ltcg_RTparam_name_vac1": "Tension alternative 1",
  "ltcg_RTparam_name_vac2": "Tension alternative 2",
  "ltcg_RTparam_name_vac3": "Tension alternative 3",
  "ltcg_RTparam_name_iac1": "Courant alternatif 1",
  "ltcg_RTparam_name_iac2": "Courant alternatif 2",
  "ltcg_RTparam_name_iac3": "Courant alternatif 3",
  "ltcg_RTparam_name_fac1": "Fréquence AC 1",
  "ltcg_RTparam_name_fac2": "Fréquence AC 2",
  "ltcg_RTparam_name_fac3": "Fréquence AC 3",
  "ltcg_RTparam_name_istr1": "Courant de chaîne 1",
  "ltcg_RTparam_name_istr2": "Courant de chaîne 2",
  "ltcg_RTparam_name_istr3": "Courant de chaîne 3",
  "ltcg_RTparam_name_istr4": "Courant de chaîne 4",
  "ltcg_RTparam_name_istr5": "Courant de chaîne 5",
  "ltcg_RTparam_name_istr6": "Courant de chaîne 6",
  "ltcg_RTparam_name_istr7": "Courant de chaîne 7",
  "ltcg_RTparam_name_istr8": "Courant de chaîne 8",
  "ltcg_RTparam_name_istr9": "Courant de chaîne 9",
  "ltcg_RTparam_name_istr10": "Courant de chaîne 10",
  "ltcg_RTparam_name_istr11": "Courant de chaîne 11",
  "ltcg_RTparam_name_istr12": "Courant de chaîne 12",
  "ltcg_RTparam_name_istr13": "Courant de chaîne 13",
  "ltcg_RTparam_name_istr14": "Courant de chaîne 14",
  "ltcg_RTparam_name_istr15": "Courant de chaîne 15",
  "ltcg_RTparam_name_istr16": "Courant de chaîne 16",
  "ltcg_RTparam_name_istr17": "Courant de chaîne 17",
  "ltcg_RTparam_name_istr18": "Courant de chaîne 18",
  "ltcg_RTparam_name_istr19": "Courant de chaîne 19",
  "ltcg_RTparam_name_istr20": "Courant de chaîne 20",
  "ltcg_RTparam_name_istr21": "Courant de chaîne 21",
  "ltcg_RTparam_name_istr22": "Courant de chaîne 22",
  "ltcg_RTparam_name_istr23": "Courant de chaîne 23",
  "ltcg_RTparam_name_istr24": "Courant de chaîne 24",
  "ltcg_RTparam_group_Inverter": "Onduleurs",
  "city.not.exist": "La ville n'existe pas",
  "bw_RTparam_name_BatterySN1": "Batterie1 SN",
  "bw_RTparam_name_BatterySN2": "Batterie2 SN",
  "bw_RTparam_name_BatterySN3": "Batterie3 SN",
  "bw_RTparam_name_BatterySN4": "Batterie4 SN",
  "bw_RTparam_name_BatterySN5": "Batterie5 SN",
  "bw_RTparam_name_BatterySN6": "Batterie6 SN",
  "supplier.type.tb": "Variété spéciale",
  "common.50300.sn": "Numéro de série de l'appareil",
  "common.50300.name": "Nom de l'appareil",
  "common.50300.out_pac": "Production d'énergie (kW)",
  "common.50300.eday": "Production d'électricité aujourd'hui (kWh)",
  "common.50300.etotal": "Production d'électricité cumulée (kWh)",
  "common.50300.status": "État",
  "common.50300.turnon_time": "Temps d'accès",
  "common.50300.type": "Type d'équipement",
  "common.50300.capacity": "Capacité kw",
  "common.50300.tempperature": "température",
  "common.50300.creationDate": "Dernière heure des données",
  "common.50300.pac": "Production d'électricité",
  "common.50300.hTotal": "Heures de production d'électricité cumulées",
  "common.50300.vpv1": "Tension continue 1",
  "common.50300.vpv2": "Tension continue 2",
  "common.50300.vpv3": "Tension continue 3",
  "common.50300.vpv4": "Tension continue 4",
  "common.50300.vpv5": "Tension continue 5",
  "common.50300.vpv6": "Tension continue 6",
  "common.50300.vpv7": "Tension continue 7",
  "common.50300.vpv8": "Tension continue 8",
  "common.50300.vpv9": "Tension continue 9",
  "common.50300.vpv10": "Tension continue 10",
  "common.50300.vpv11": "Tension continue 11",
  "common.50300.vpv12": "Tension continue 12",
  "common.50300.ipv1": "Courant continu 1",
  "common.50300.ipv2": "Courant continu 2",
  "common.50300.ipv3": "Courant continu 3",
  "common.50300.ipv4": "Courant continu 4",
  "common.50300.ipv5": "Courant continu 5",
  "common.50300.ipv6": "Courant continu 6",
  "common.50300.ipv7": "Courant continu 7",
  "common.50300.ipv8": "Courant continu 8",
  "common.50300.ipv9": "Courant continu 9",
  "common.50300.ipv10": "Courant continu 10",
  "common.50300.ipv11": "Courant continu 11",
  "common.50300.ipv12": "Courant continu 12",
  "common.50300.vac1": "Tension alternative 1",
  "common.50300.vac2": "Tension alternative 2",
  "common.50300.vac3": "Tension alternative 3",
  "common.50300.iac1": "Courant alternatif 1",
  "common.50300.iac2": "Courant alternatif 2",
  "common.50300.iac3": "Courant alternatif 3",
  "common.50300.fac1": "Fréquence AC 1",
  "common.50300.fac2": "Fréquence AC 2",
  "common.50300.fac3": "Fréquence AC 3",
  "common.50300.istr1": "Courant de chaîne 1",
  "common.50300.istr2": "Courant de chaîne 2",
  "common.50300.istr3": "Courant de chaîne 3",
  "common.50300.istr4": "Courant de chaîne 4",
  "common.50300.istr5": "Courant de chaîne 5",
  "common.50300.istr6": "Courant de chaîne 6",
  "common.50300.istr7": "Courant de chaîne 7",
  "common.50300.istr8": "Courant de chaîne 8",
  "common.50300.istr9": "Courant de chaîne 9",
  "common.50300.istr10": "Courant de chaîne 10",
  "common.50300.istr11": "Courant de chaîne 11",
  "common.50300.istr12": "Courant de chaîne 12",
  "common.50300.istr13": "Courant de chaîne 13",
  "common.50300.istr14": "Courant de chaîne 14",
  "common.50300.istr15": "Courant de chaîne 15",
  "common.50300.istr16": "Courant de chaîne 16",
  "common.50300.istr17": "Courant de chaîne 17",
  "common.50300.istr18": "Courant de chaîne 18",
  "common.50300.istr19": "Courant de chaîne 19",
  "common.50300.istr20": "Courant de chaîne 20",
  "common.50300.istr21": "Courant de chaîne 21",
  "common.50300.istr22": "Courant de chaîne 22",
  "common.50300.istr23": "Courant de chaîne 23",
  "common.50300.istr24": "Courant de chaîne 24",
  "common.50402.sn": "Onduleur SN",
  "common.50402.ID": "ID de l'onduleur",
  "common.50402.STATION_ID": "Identifiant de la centrale électrique",
  "common.50402.INV_EG_DAY": "production d'électricité quotidienne",
  "common.50402.INV_EG_TOTAL": "Production d'énergie cumulée de l'onduleur",
  "common.50402.INV_I_AC": "Courant de l'onduleur",
  "common.50402.INV_U_AC": "Tension de l'onduleur",
  "common.50402.PV1_I": "PV1 courant",
  "common.50402.PV2_I": "Courant PV2",
  "common.50402.PV3_I": "Courant PV3",
  "common.50402.PV4_I": "Courant PV4",
  "common.50402.PV5_I": "Courant PV5",
  "common.50402.PV6_I": "Courant PV6",
  "common.50402.PV7_I": "PV7 courant",
  "common.50402.PV8_I": "Courant PV8",
  "common.50402.PV9_I": "PV9 courant",
  "common.50402.PV10_I": "PV10 courant",
  "common.50402.PV11_I": "PV11 courant",
  "common.50402.PV12_I": "PV12 courant",
  "common.50402.PV13_I": "PV13 actuel",
  "common.50402.PV14_I": "PV14 courant",
  "common.50402.PV15_I": "PV15 courant",
  "common.50402.PV16_I": "PV16 courant",
  "common.50402.PV17_I": "PV17 actuel",
  "common.50402.PV18_I": "PV18 courant",
  "common.50402.PV19_I": "PV19 actuel",
  "common.50402.PV20_I": "Courant PV20",
  "common.50402.PV21_I": "PV21 courant",
  "common.50402.PV22_I": "PV22 courant",
  "common.50402.PV23_I": "PV23 actuel",
  "common.50402.PV24_I": "PV24 courant",
  "common.50402.PV25_I": "PV25 courant",
  "common.50402.PV26_I": "PV26 actuel",
  "common.50402.PV27_I": "PV27 actuel",
  "common.50402.PV28_I": "PV28 actuel",
  "common.50402.PV29_I": "PV29 actuel",
  "common.50402.PV30_I": "PV30 courant",
  "common.50402.PV1_V": "Tension PV1",
  "common.50402.PV2_V": "Tension PV2",
  "common.50402.PV3_V": "Tension PV3",
  "common.50402.PV4_V": "Tension PV4",
  "common.50402.PV5_V": "Tension PV5",
  "common.50402.PV6_V": "Tension PV6",
  "common.50402.PV7_V": "Tension PV7",
  "common.50402.PV8_V": "Tension PV8",
  "common.50402.PV9_V": "Tension PV9",
  "common.50402.PV10_V": "Tension PV10",
  "common.50402.PV11_V": "Tension PV11",
  "common.50402.PV12_V": "Tension PV12",
  "common.50402.PV13_V": "Tension PV13",
  "common.50402.PV14_V": "Tension PV14",
  "common.50402.PV15_V": "Tension PV15",
  "common.50402.PV16_V": "Tension PV16",
  "common.50402.PV17_V": "Tension PV17",
  "common.50402.PV18_V": "Tension PV18",
  "common.50402.PV19_V": "Tension PV19",
  "common.50402.PV20_V": "Tension PV20",
  "common.50402.PV21_V": "Tension PV21",
  "common.50402.PV22_V": "Tension PV22",
  "common.50402.PV23_V": "Tension PV23",
  "common.50402.PV24_V": "Tension PV24",
  "common.50402.PV25_V": "Tension PV25",
  "common.50402.PV26_V": "Tension PV26",
  "common.50402.PV27_V": "Tension PV27",
  "common.50402.PV28_V": "Tension PV28",
  "common.50402.PV29_V": "Tension PV29",
  "common.50402.PV30_V": "Tension PV30",
  "common.50402.INV_P_AC": "Puissance active de l'onduleur",
  "common.50402.CAPACITY": "Capacité kw",
  "common.50402.INV_RUN_STATE": "État de fonctionnement de l'onduleur",
  "common.50402.DATA_TIME": "temps de données",
  "common.50402.name": "Le nom de l’appareil",
  "common.50402.out_pac": "Production d’énergie (kW)",
  "common.50402.eday": "Production d’électricité d’aujourd’hui (kWh)",
  "common.50402.etotal": "Production d’énergie cumulée (kWh)",
  "common.50402.status": "état",
  "common.50402.turnon_time": "Temps d’accès",
  "common.50402.type": "Type d’appareil",
  "common.50402.tempperature": "température(℃)",
  "common.50402.creationDate": "L’heure à laquelle les données étaient à jour",
  "common.50402.pac": "Production d’électricité",
  "common.50402.hTotal": "Heures cumulées de production d’énergie",
  "common.50402.vpv1": "Tension continue 1",
  "common.50402.vpv2": "Tension continue 2",
  "common.50402.vpv3": "Tension continue 3",
  "common.50402.vpv4": "Tension continue 4",
  "common.50402.vpv5": "Tension continue 5",
  "common.50402.vpv6": "Tension continue 6",
  "common.50402.vpv7": "Tension continue 7",
  "common.50402.vpv8": "Tension continue 8",
  "common.50402.vpv9": "Tension continue 9",
  "common.50402.vpv10": "Tension continue 10",
  "common.50402.vpv11": "Tension continue 11",
  "common.50402.vpv12": "Tension continue 12",
  "common.50402.ipv1": "Courant continu 1",
  "common.50402.ipv2": "Courant continu 2",
  "common.50402.ipv3": "Courant continu 3",
  "common.50402.ipv4": "Courant continu 4",
  "common.50402.ipv5": "Courant continu 5",
  "common.50402.ipv6": "Courant continu 6",
  "common.50402.ipv7": "Courant continu 7",
  "common.50402.ipv8": "Courant continu 8",
  "common.50402.ipv9": "Courant continu 9",
  "common.50402.ipv10": "Courant continu 10",
  "common.50402.ipv11": "Courant continu 11",
  "common.50402.ipv12": "Courant continu 12",
  "common.50402.vac1": "Tension alternative 1",
  "common.50402.vac2": "Tension alternative 2",
  "common.50402.vac3": "Tension alternative 3",
  "common.50402.iac1": "Courant alternatif 1",
  "common.50402.iac2": "Courant alternatif 2",
  "common.50402.iac3": "Courant alternatif 3",
  "common.50402.fac1": "Fréquence AC 1",
  "common.50402.fac2": "Fréquence AC 2",
  "common.50402.fac3": "Fréquence AC 3",
  "common.50402.istr1": "Courant de chaîne 1",
  "common.50402.istr2": "Courant de chaîne 2",
  "common.50402.istr3": "Courant de chaîne 3",
  "common.50402.istr4": "Courant de chaîne 4",
  "common.50402.istr5": "Courant de chaîne 5",
  "common.50402.istr6": "Courant de chaîne 6",
  "common.50402.istr7": "Courant de chaîne 7",
  "common.50402.istr8": "Courant de chaîne 8",
  "common.50402.istr9": "Courant de chaîne 9",
  "common.50402.istr10": "Courant de chaîne 10",
  "common.50402.istr11": "Courant de chaîne 11",
  "common.50402.istr12": "Courant de chaîne 12",
  "common.50402.istr13": "Courant de chaîne 13",
  "common.50402.istr14": "Courant de chaîne 14",
  "common.50402.istr15": "Courant de chaîne 15",
  "common.50402.istr16": "Courant de chaîne 16",
  "common.50402.istr17": "Courant de chaîne 17",
  "common.50402.istr18": "Courant de chaîne 18",
  "common.50402.istr19": "Courant de chaîne 19",
  "common.50402.istr20": "Courant de chaîne 20",
  "common.50402.istr21": "Courant de chaîne 21",
  "common.50402.istr22": "Courant de chaîne 22",
  "common.50402.istr23": "Courant de chaîne 23",
  "common.50402.istr24": "Courant de chaîne 24",
  "bw_RTparam_group_ Dongle": "Dongle",
  "bw_RTparam_name_DongleRssi": "RSSI",
  "bw_RTparam_group_Dongle": "Dongle",
  "common.50500.xnl_RTparam_name_FV_P": "Valeur du facteur de puissance",
  "common.50500.xnl_RTparam_name_GVL": "Niveau de tension connecté au réseau",
  "common.50500.xnl_RTparam_name_RS_D": "État en cours d'exécution (par défaut)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "Production d'électricité quotidienne (active)",
  "common.50500.xnl_RTparam_name_A_R_P_D": "Énergie réactive AC le jour",
  "common.50500.xnl_RTparam_name_GEN_P_D": "Production quotidienne du générateur",
  "common.50500.xnl_RTparam_name_Et_ge0": "Électricité produite cumulée (active) ",
  "common.50500.xnl_RTparam_name_Emon1": "Production d'électricité mensuelle (active)",
  "common.50500.xnl_RTparam_name_Etdy_use2": "Consommation mensuelle d'électricité",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "Capacité mensuelle connectée au réseau",
  "common.50500.xnl_RTparam_name_Eyr1": "Production d'électricité annuelle (active)",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "Le volume de charge d'aujourd'hui",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "Montant de la décharge d'aujourd'hui",
  "common.50500.xnl_RTparam_name_t_cg_n1": "Capacité de charge cumulée ",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "Décharge cumulative ",
  "common.50500.xnl_RTparam_name_E_B_D": "Volume d'achat quotidien d'électricité",
  "common.50500.xnl_RTparam_name_GRID_C_D": "Capacité connectée au réseau du réseau électrique le jour ",
  "common.50500.xnl_RTparam_name_E_B_TO": "Total de l'électricité achetée",
  "common.50500.xnl_RTparam_name_PG_F1": "Fréquence de la grille",
  "common.50500.xnl_RTparam_name_t_gc1": "Capacité cumulée connectée au réseau ",
  "common.50500.xnl_RTparam_name_GDOH": "Heures de travail quotidiennes du générateur ",
  "common.50500.xnl_RTparam_name_Etdy_use1": "La consommation d'électricité d'aujourd'hui",
  "common.50500.xnl_RTparam_name_Et_use1": "Consommation d'électricité cumulée ",
  "common.50500.xnl_RTparam_name_Etdy_use3": "Consommation annuelle d'électricité ",
  "common.50500.xnl_RTparam_name_T_TFM1": "Température du transformateur",
  "common.50500.xnl_RTparam_name_T_RDT1": "Température du radiateur ",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "Production d'électricité totale du générateur",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "Production d'électricité photovoltaïque historique",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "Capacité annuelle raccordée au réseau ",
  "common.50500.xnl_RTparam_name_LCD": "Bit de drapeau de test LCD",
  "common.50500.xnl_RTparam_name_CBAC": "Capacité après étalonnage de la batterie",
  "common.50500.xnl_RTparam_name_PVDE": "Production d'énergie photovoltaïque quotidienne",
  "common.50500.xnl_RTparam_name_DV1": "Tension CC PV1",
  "common.50500.xnl_RTparam_name_DC1": "Courant continu PV1",
  "common.50500.xnl_RTparam_name_DV2": "Tension CC PV2",
  "common.50500.xnl_RTparam_name_DC2": "Courant continu PV2",
  "common.50500.xnl_RTparam_name_DV3": "Tension CC PV3",
  "common.50500.xnl_RTparam_name_DC3": "Courant DC PV3",
  "common.50500.xnl_RTparam_name_DV4": "Tension CC PV4",
  "common.50500.xnl_RTparam_name_DC4": "Courant DC PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "Informations de débogage INV DSP 1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "Informations de débogage INV DSP 2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "Informations de débogage INV DSP 3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "Informations de débogage INV DSP 4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "Informations de débogage INV DSP 5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "Informations de débogage INV DSP 6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "Informations de débogage INV DSP 7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "Informations de débogage INV DSP 8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "Informations de débogage INV DSP 9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "Informations de débogage INV DSP 10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "Informations de débogage INV DSP 11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "Informations de débogage INV DSP 12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "Informations de débogage INV DSP 13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "Informations de débogage INV DSP 14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "Informations de débogage INV DSP 15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "Informations de débogage INV DSP 16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "Informations de débogage INV DSP 17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "Informations de débogage INV DSP 18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "Informations de débogage INV DSP 19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "Informations de débogage INV DSP 20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "Informations de débogage INV DSP 21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "Informations de débogage INV DSP 22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "Informations de débogage INV DSP 23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "Informations de débogage INV DSP 24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "Informations de débogage INV DSP 25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "Informations de débogage INV DSP 26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "Informations de débogage INV DSP 27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "Informations de débogage INV DSP 28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "Tension côté réseau L1-N ",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "Tension côté réseau L2-N ",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "Tension côté réseau L1-L2 ",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "Relais Tension latérale intermédiaire L1-L2 ",
  "common.50500.xnl_RTparam_name_AV1": "Tension CA R / U / A",
  "common.50500.xnl_RTparam_name_AV2": "Tension AC S / V / B",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "Tension de sortie de l'onduleur L1-L2  ",
  "common.50500.xnl_RTparam_name_C_V_L1": "Tension de charge L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "Tension de charge L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "Fréquence de sortie de l'onduleur L2 ",
  "common.50500.xnl_RTparam_name_G_C_L1": "Courant de grille L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "Courant de grille L2",
  "common.50500.xnl_RTparam_name_G_C_A": "Courant de grille A",
  "common.50500.xnl_RTparam_name_G_C_B": "Courant de grille B",
  "common.50500.xnl_RTparam_name_AC1": "Courant alternatif R / U / A",
  "common.50500.xnl_RTparam_name_AC2": "Courant alternatif S / V / B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "Puissance totale du générateur",
  "common.50500.xnl_RTparam_name_G_P_L1": "Puissance du réseau L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "Puissance du réseau L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "Puissance totale du réseau",
  "common.50500.xnl_RTparam_name_E_CT_P1": "Puissance externe CT1",
  "common.50500.xnl_RTparam_name_E_CT_P2": "Puissance externe CT2",
  "common.50500.xnl_RTparam_name_CT_P_T": "Puissance totale du réseau CT",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "Puissance de sortie de l'onduleur L1  ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "Puissance de sortie de l'onduleur L2  ",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "Puissance de sortie de l'onduleur L / N ",
  "common.50500.xnl_RTparam_name_C_P_L1": "Puissance de charge L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "Puissance de charge L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "Consommation électrique totale",
  "common.50500.xnl_RTparam_name_E_Cuse1": "Courant électrique R / U / A",
  "common.50500.xnl_RTparam_name_E_Cuse2": "Courant électrique S / V / B ",
  "common.50500.xnl_RTparam_name_PVGP_A": "Tension de phase A du port Gen",
  "common.50500.xnl_RTparam_name_B_T1": "Température de la batterie ",
  "common.50500.xnl_RTparam_name_B_V1": "Tension de la batterie ",
  "common.50500.xnl_RTparam_name_B_R_C": "Capacité restante de la batterie",
  "common.50500.xnl_RTparam_name_LF2": "Fréquence de charge L2",
  "common.50500.xnl_RTparam_name_DP1": "Alimentation DC PV1",
  "common.50500.xnl_RTparam_name_DP2": "Alimentation DC PV2",
  "common.50500.xnl_RTparam_name_DP3": "Alimentation DC PV3",
  "common.50500.xnl_RTparam_name_DP4": "Alimentation DC PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "Puissance de décharge de la batterie ",
  "common.50500.xnl_RTparam_name_B_C1": "Courant de la batterie ",
  "common.50500.xnl_RTparam_name_LF1": "Fréquence de charge L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "Fréquence de sortie de l'onduleur L1 ",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "État du relais de réseau",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "État du relais côté générateur ",
  "common.50500.xnl_RTparam_name_EG_F1": "Fréquence du générateur",
  "common.50500.xnl_RTparam_name_BUS_VOL": "Tension du bus",
  "common.50500.xnl_RTparam_name_H_B_V": "Tension demi-barre omnibus",
  "common.50500.xnl_RTparam_name_B_B_C": "Courant de pont équilibré",
  "common.50500.xnl_RTparam_name_I_EARipa1": "Impédance de masse parallèle",
  "common.50500.xnl_RTparam_name_LBVN": "Numéro de version de la batterie au lithium ",
  "common.50500.xnl_RTparam_name_M_P": "Puissance totale du compteur d'électricité",
  "common.50500.xnl_RTparam_name_M_P_A": "Compteur électrique Puissance A",
  "common.50500.xnl_RTparam_name_M_P_B": "Compteur électrique Puissance B",
  "common.50500.xnl_RTparam_name_M_P_C": "Compteur électrique Puissance C",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "La capacité connectée au réseau d'aujourd'hui",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "Le volume d'achat d'électricité d'aujourd'hui",
  "common.50500.xnl_RTparam_name_Et_pu1": "Électricité cumulée achetée ",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "Tension totale de la batterie 1",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "Batterie 1 courant ",
  "common.50500.xnl_RTparam_name_T_BAP1": "Batterie 1 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "Batterie 1 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "Capacité restante de la batterie 1",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "Capacité totale de la batterie 1",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "Batterie Pack 1 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "Demande de charge Courant de la batterie 1 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "Batterie Pack 1 Demande de décharge Courant ",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "Tension maximale de la batterie 1",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "Tension minimale de la batterie dans la batterie 1",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "Nombre de cycles de la batterie 1",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "Batterie 1 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "Batterie 1 défaut ",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "Tension totale de la batterie 2",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "Batterie Pack 2 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP2": "Batterie Pack 2 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "Batterie 2 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "Capacité restante de la batterie 2",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "Capacité totale de la batterie 2",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "Batterie Pack 2 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "Batterie Pack 2 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "Batterie pack 2 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "Tension maximale de la batterie 2 dans le bloc-piles ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "Tension minimale de la batterie 2 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "Pack de batteries 2 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "Batterie Pack 2 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "Panne de la batterie 2 ",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "Tension totale de la batterie 3",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "Batterie Pack 3 courant ",
  "common.50500.xnl_RTparam_name_T_BAP3": "Batterie Pack 3 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "Batterie Pack 3 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "Capacité restante de la batterie 3",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "Capacité totale de la batterie 3",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "Batterie Pack 3 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "Batterie Pack 3 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "Batterie pack 3 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "Tension maximale de la batterie 3 dans la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "Tension minimale de la batterie 3 dans la batterie ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "Nombre de cycles de la batterie 3",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "Batterie Pack 3 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "Pack de batteries 3 dysfonctionnement ",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "Tension totale de la batterie 4",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "Batterie 4 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP4": "Batterie Pack 4 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "Batterie 4 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "Capacité restante de la batterie 4",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "Capacité totale de la batterie 4",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "Batterie Pack 4 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "Batterie Pack 4 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "Batterie Pack 4 Demande de décharge Courant ",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "Tension maximale de la batterie 4 dans la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "Tension minimale de la batterie 4 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "Batterie 4 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "Batterie Pack 4 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "Panne de la batterie 4 ",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "Tension totale de la batterie 5",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "Batterie 5 courant ",
  "common.50500.xnl_RTparam_name_T_BAP5": "Batterie 5 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "Batterie 5 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "Capacité restante de la batterie 5",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "Capacité totale de la batterie 5",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "Batterie Pack 5 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "Batterie Pack 5 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "Batterie pack 5 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "Tension maximale de la batterie 5 dans la batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "Tension minimale de la batterie 5 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "Batterie 5 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "Batterie Pack 5 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "Panne de la batterie 5 ",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "Tension totale de la batterie 6",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "Batterie Pack 6 courant ",
  "common.50500.xnl_RTparam_name_T_BAP6": "Batterie Pack 6 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "Batterie 6 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "Capacité restante de la batterie 6",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "Capacité totale de la batterie 6",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "Batterie Pack 6 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "Batterie pack 6 demande de charge actuelle ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "Batterie pack 6 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "Batterie Pack 6 Tension maximale de la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "Tension minimale de la batterie 6 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "Batterie 6 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "Batterie Pack 6 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "Panne de la batterie 6 ",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "Tension totale de la batterie 7",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "Batterie 7 courant ",
  "common.50500.xnl_RTparam_name_T_BAP7": "Batterie Pack 7 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "Batterie 7 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "Capacité restante de la batterie 7",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "Capacité totale de la batterie 7",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "Batterie Pack 7 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "Batterie Pack 7 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "Batterie pack 7 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "Batterie Pack 7 Tension maximale de la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "Tension minimale de la batterie 7 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "Batterie 7 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "Batterie pack 7 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "Panne de la batterie 7 ",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "Tension totale de la batterie 8",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "Batterie 8 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP8": "Batterie Pack 8 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "Batterie 8 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "Capacité restante de la batterie 8",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "Capacité totale de la batterie 8",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "Batterie Pack 8 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "Batterie Pack 8 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "Batterie pack 8 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "Tension maximale de la batterie 8 dans la batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "Tension minimale de la batterie 8 dans la batterie ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "Batterie 8 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "Batterie Pack 8 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "Panne de la batterie 8 ",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "Tension totale de la batterie 9",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "Batterie 9 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP9": "Batterie Pack 9 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "Batterie 9 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "Capacité restante de la batterie 9",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "Capacité totale de la batterie 9",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "Batterie Pack 9 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "Batterie pack 9 demande de charge actuelle ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "Batterie pack 9 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "Pack de batteries 9 Tension maximale de la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "Tension minimale de la batterie 9 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "Pack de batteries 9 cycles ",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "Batterie pack 9 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "Panne de la batterie 9 ",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "Tension totale de la batterie 10",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "Batterie 10 courant ",
  "common.50500.xnl_RTparam_name_T_BAP10": "Batterie 10 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "Batterie 10 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "Capacité restante de la batterie 10",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "Capacité totale de la batterie 10",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "Batterie Pack 10 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "Demande de charge Courant de la batterie 10 ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "Demande de décharge Courant de la batterie 10 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "Tension maximale de la batterie 10 dans la batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "Tension minimale de la batterie 10 dans la batterie ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "Nombre de cycles de la batterie 10",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "Batterie Pack 10 Alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "Panne de la batterie 10 ",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "Tension totale de la batterie 11",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "Batterie 11 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP11": "Batterie Pack 11 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "Batterie 11 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "Capacité restante de la batterie 11",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "Capacité totale de la batterie 11",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "Batterie Pack 11 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "Batterie Pack 11 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "Demande de décharge Courant de la batterie 11 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "Tension maximale du bloc-piles 11 batteries",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "Tension minimale de la batterie 11 dans la batterie ",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "Nombre de cycles de la batterie 11",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "Batterie pack 11 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "Pack de batteries 11 dysfonctionnement ",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "Tension totale de la batterie 12",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "Batterie 12 courant ",
  "common.50500.xnl_RTparam_name_T_BAP12": "Batterie 12 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "Batterie 12 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "Capacité restante de la batterie 12",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "Capacité totale de la batterie 12",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "Batterie Pack 12 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "Batterie Pack 12 Demande de charge Courant ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "Batterie pack 12 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "Tension maximale de la batterie 12 dans la batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "Tension minimale de la batterie 12 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "Nombre de cycles de la batterie 12",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "Batterie pack 12 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "Panne de la batterie 12 ",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "Tension totale de la batterie 13",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "Batterie 13 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP13": "Batterie 13 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "Batterie 13 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "Capacité restante de la batterie 13",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "Capacité totale de la batterie 13",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "Pack de batteries 13 tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "Batterie pack 13 demande de charge actuelle ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "Demande de décharge Courant de la batterie 13 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "Tension maximale de la batterie 13 dans la batterie",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "Tension minimale de la batterie 13 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "Nombre de cycles de la batterie 13",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "Batterie pack 13 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "Pack de batteries 13 dysfonctionnement ",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "Tension totale de la batterie 14",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "Batterie 14 Courant ",
  "common.50500.xnl_RTparam_name_T_BAP14": "Batterie 14 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "Batterie 14 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "Capacité restante de la batterie 14",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "Capacité totale de la batterie 14",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "Batterie Pack 14 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "Batterie pack 14 demande de charge actuelle ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "Demande de décharge Courant de la batterie 14 ",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "Tension maximale de la batterie 14 dans la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "Tension minimale de la batterie 14 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "Nombre de cycles de la batterie 14",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "Batterie pack 14 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "Pack de batteries 14 dysfonctionnement ",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "Tension totale de la batterie 15",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "Batterie 15 courant ",
  "common.50500.xnl_RTparam_name_T_BAP15": "Batterie 15 Température ",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "Batterie 15 SoC ",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "Capacité restante de la batterie 15",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "Capacité totale de la batterie 15",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "Batterie Pack 15 Tension de demande de charge ",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "Batterie pack 15 demande de charge actuelle ",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "Pack de batteries 15 courant de demande de décharge ",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "Tension maximale de la batterie 15 dans la batterie ",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "Tension minimale de la batterie 15 dans la batterie",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "Nombre de cycles de la batterie 15",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "Batterie pack 15 alarme ",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "Pack de batteries 15 dysfonctionnement ",
  "common.50500.xnl_RTparam_name_yr1": "Année",
  "common.50500.xnl_RTparam_name_mon1": "Mois",
  "common.50500.xnl_RTparam_name_tdy1": "Jour",
  "common.50500.xnl_RTparam_name_hou1": "Quand ",
  "common.50500.xnl_RTparam_name_min1": "points ",
  "common.50500.xnl_RTparam_name_sec1": "secondes ",
  "common.50500.xnl_RTparam_name_BMS_D_V": "Tension de décharge BMS",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "La charge de la batterie BMS limite l'audience de",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "La décharge de la batterie BMS limite l'audience de",
  "common.50500.xnl_RTparam_name_B_R_P": "Puissance restante du BMS ",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "Tension de la batterie BMS",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "Courant de batterie BMS",
  "common.50500.xnl_RTparam_name_BMST": "Température BMS",
  "common.50500.xnl_RTparam_name_BCT": "Type de batterie ",
  "common.50500.xnl_RTparam_name_HF_1": "Faille historique 1",
  "common.50500.xnl_RTparam_name_HF_2": "Faille historique 2",
  "common.50500.xnl_RTparam_name_HF_3": "Faille historique 3",
  "common.50500.xnl_RTparam_name_HF_4": "Faille historique 4",
  "common.50500.xnl_RTparam_name_HF_5": "Faille historique 5",
  "common.50500.xnl_RTparam_name_HF_6": "Faille historique 6",
  "common.50500.xnl_RTparam_name_HF_7": "Faille historique 7",
  "common.50500.xnl_RTparam_name_HF_8": "Faille historique 8",
  "common.50500.xnl_RTparam_name_HF_9": "Faille historique 9",
  "common.50500.xnl_RTparam_name_HF_10": "Défaut historique 10",
  "common.50500.xnl_RTparam_name_HF_11": "Faille historique 11",
  "common.50500.xnl_RTparam_name_HF_12": "Défaut historique 12",
  "common.50500.xnl_RTparam_name_HF_13": "Faille historique 13",
  "common.50500.xnl_RTparam_name_G_V_L3": "Tension du réseau L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "Tension côté réseau L1-L3 ",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "Tension côté réseau L2-L3 ",
  "common.50500.xnl_RTparam_name_AV3": "Tension AC T / W / C",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "Tension de sortie de l'onduleur L1-L3 ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "Tension de sortie de l'onduleur L2-L3 ",
  "common.50500.xnl_RTparam_name_C_V_L3": "Tension de charge L3",
  "common.50500.xnl_RTparam_name_NA": "NA",
  "common.50500.xnl_RTparam_name_I_O_F3": "Fréquence de sortie de l'onduleur L3 ",
  "common.50500.xnl_RTparam_name_G_C_L3": "Courant de grille L3",
  "common.50500.xnl_RTparam_name_G_C_C": "Courant de grille C",
  "common.50500.xnl_RTparam_name_AC3": "Courant alternatif T / W / C",
  "common.50500.xnl_RTparam_name_G_P_L3": "Puissance du réseau L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "Puissance externe CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "Puissance de sortie de l'onduleur L3  ",
  "common.50500.xnl_RTparam_name_C_P_L3": "Puissance de charge L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "Courant de charge L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "Tension de charge BMS",
  "common.50500.xnl_RTparam_name_INV_ADDR": "Adresse de l'inverseur",
  "bw_RTparam_name_online": "en ligne",
  "bw_RTparam_name_offline": "hors-ligne",
  "bw_RTparam_name_buy": "Acheter de l’électricité",
  "bw_RTparam_name_sell": "Vendre de l’électricité",
  "bw_RTparam_name_dontBuy": "N’achetez pas, ne vendez pas",
  "bw_RTparam_name_noCharging": "Pas de charge et pas de décharge",
  "bw_RTparam_name_forbidden": "Il est interdit de charger et de décharger",
  "bw_RTparam_name_charging": "Imputation et interdiction de mainlevée",
  "bw_RTparam_name_allowCharged": "Permettre d’être chargé et libéré",
  "bw_RTparam_name_forcedCharging": "Charge forcée et interdiction",
  "bw_RTparam_name_forcedCharge": "Charge et décharge forcées",
  "bw_RTparam_name_photovoltaics": "La tomodensitométrie est utilisée pour les réseaux électriques et le photovoltaïque",
  "bw_RTparam_name_gridCT": "Le réseau utilise le TC et le photovoltaïque utilise des compteurs",
  "bw_RTparam_name_electricity": "Les compteurs d’électricité sont utilisés pour les réseaux électriques, et le TC est utilisé pour le photovoltaïque",
  "bw_RTparam_name_grid": "Compteurs réseau et photovoltaïques",
  "bw_RTparam_name_forced": "Charge et décharge forcées",
  "bw_RTparam_name_charge": "La fonction de charge/décharge n’est pas activée",
  "switchover.switchover.user": "Je suis un utilisateur",
  "common.50100.Inverter": "Onduleurs",
  "supplier.type.tuobang": "Tuobao",
  "supplier.type.gd": "GOODWE",
  "Ajouterbar.plant": "Ajouter Plante",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "Déclassement",
  "common.50402.dispatch": "dépêche",
  "common.50402.fault": "faute",
  "common.50402.outages": "Rationnement et pannes d’électricité",
  "common.50402.generation": "Production d’électricité connectée au réseau",
  "common.50402.Standby": "Veille",
  "common.50402.Planned": "Pannes planifiées",
  "common.50300.offline": "hors-ligne",
  "common.50300.Standby": "Veille",
  "common.50300.online": "en ligne",
  "common.50300.fault": "faute",
  "device.category.fox": "Fox",
  "bw_RTparam_name_TotalPowerFactor_PV1": "Facteur de puissance total (PV)1",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "La charge",
  "common.50700.xnl_RTparam_group_Inverter": "Inverseur et inverseur",
  "common.50700.xnl_RTparam_group_Grid": "Le réseau",
  "common.50700.170": "illicite",
  "common.50700.169": "Testé en usine",
  "common.50700.168": "En cours de modernisation",
  "common.50700.167": "veille",
  "common.50700.166": "Un dysfonctionnement permanent",
  "common.50700.165": "Les pannes",
  "common.50700.164": "Hors réseau",
  "common.50700.163": "Raccordées au réseau",
  "common.50700.162": "Sous inspection en cours",
  "common.50700.161": "Dans l’attente",
  "common.50700.160": "autocontrôles",
  "common.50700.TFreq": "Fréquence de phase T",
  "common.50700.TCurrent": "Courant de phase T",
  "common.50700.SVolt": "Tension de phase S",
  "common.50700.SPower": "Puissance de phase S",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "Fréquence de phase S",
  "common.50700.SCurrent": "Courant de phase S",
  "common.50700.RVolt": "Tension de phase R",
  "common.50700.runningState": "État de fonctionnement",
  "common.50700.RPower": "Puissance de phase R",
  "common.50700.RFreq": "Fréquence de phase R",
  "common.50700.ResidualEnergy": "Batterie restante puissance",
  "common.50700.ReactivePower": "Puissance active réactive",
  "common.50700.RCurrent": "Courant de phase R",
  "common.50700.pvPower": "La puissance PV",
  "common.50700.pv9Volt": "PV9 tension électrique",
  "common.50700.pv9Power": "PV9 la puissance",
  "common.50700.pv9Current": "PV9 courant électrique",
  "common.50700.pv8Volt": "PV8 tension électrique",
  "common.50700.pv8Power": "La puissance PV8",
  "common.50700.pv8Current": "PV8 courant électrique",
  "common.50700.pv7Volt": "PV7 tension électrique",
  "common.50700.pv7Power": "La puissance PV7",
  "common.50700.pv7Current": "PV7 courant électrique",
  "common.50700.pv6Volt": "PV6 tension électrique",
  "common.50700.pv6Power": "La puissance PV6",
  "common.50700.pv6Current": "PV6 courant électrique",
  "common.50700.pv5Volt": "La tension PV5",
  "common.50700.pv5Power": "La puissance PV5",
  "common.50700.pv5Current": "PV5 courant électrique",
  "common.50700.pv4Volt": "La tension PV4",
  "common.50700.pv4Power": "La puissance PV4",
  "common.50700.pv4Current": "PV4 courant électrique",
  "common.50700.pv3Volt": "La tension PV3",
  "common.50700.pv3Power": "La puissance PV3",
  "common.50700.pv3Current": "PV3 courant électrique",
  "common.50700.pv2Volt": "La tension PV2",
  "common.50700.pv2Power": "La puissance PV2",
  "common.50700.pv2Current": "PV2 courant électrique",
  "common.50700.pv1Volt": "PV1 tension électrique",
  "common.50700.pv1Power": "La puissance PV1",
  "common.50700.pv1Current": "PV1 courant électrique",
  "common.50700.pv18Volt": "PV18 tension électrique",
  "common.50700.pv18Power": "La puissance PV18",
  "common.50700.pv18Current": "PV18 courant électrique",
  "common.50700.pv17Volt": "PV17 tension électrique",
  "common.50700.pv17Power": "La puissance PV17",
  "common.50700.pv17Current": "PV17 courant électrique",
  "common.50700.pv16Volt": "PV16 tension électrique",
  "common.50700.pv16Power": "PV16 la puissance",
  "common.50700.pv16Current": "PV16 courant électrique",
  "common.50700.pv15Volt": "PV15 tension électrique",
  "common.50700.pv15Power": "PV15 la puissance",
  "common.50700.pv15Current": "PV15 courant électrique",
  "common.50700.pv14Volt": "PV14 tension électrique",
  "common.50700.pv14Power": "La puissance PV14",
  "common.50700.pv14Current": "PV14 courant électrique",
  "common.50700.pv13Volt": "PV13 tension électrique",
  "common.50700.pv13Power": "La puissance PV13",
  "common.50700.pv13Current": "PV13 courant électrique",
  "common.50700.pv12Volt": "PV12 tension électrique",
  "common.50700.pv12Power": "La puissance PV12",
  "common.50700.pv12Current": "PV12 courant électrique",
  "common.50700.pv11Volt": "PV11 tension électrique",
  "common.50700.pv11Power": "PV11 la puissance",
  "common.50700.pv11Current": "PV11 courant électrique",
  "common.50700.pv10Volt": "PV10 tension électrique",
  "common.50700.pv10Power": "La puissance PV10",
  "common.50700.pv10Current": "PV10 courant électrique",
  "common.50700.PowerFactor": "Facteur de puissance",
  "common.50700.meterPowerT": "Puissance de compteur T",
  "common.50700.meterPowerS": "Puissance de compteur S",
  "common.50700.meterPowerR": "Puissance du compteur R",
  "common.50700.meterPower2": "Compteur 2 puissance",
  "common.50700.meterPower": "Puissance du compteur",
  "common.50700.loadsPowerT": "Charge T phase puissance",
  "common.50700.loadsPowerS": "Charge S phase puissance",
  "common.50700.loadsPowerR": "Charge R phase puissance",
  "common.50700.loadsPower": "Puissance de charge",
  "common.50700.loads": "Charge consommation électrique",
  "common.50700.invTemperation": "Température de l’inverseur",
  "common.50700.invBatVolt": "Inverseur côté batterie tension",
  "common.50700.invBatPower": "Inverseur côté batterie puissance",
  "common.50700.invBatCurrent": "Inverseur côté batterie courant",
  "common.50700.gridConsumptionPower": "Perte de puissance sur le réseau",
  "common.50700.gridConsumption": "Consommation totale d’électricité du réseau",
  "common.50700.generationPower": "Puissance générée",
  "common.50700.generation": "Production d’électricité cumulée",
  "common.50700.feedinPower": "Puissance connectée au réseau",
  "common.50700.feedin": "Alimentation totale au réseau",
  "common.50700.epsVoltT": "Tension de phase eps-t",
  "common.50700.epsVoltS": "Tension de phase eps-s",
  "common.50700.epsVoltR": "Tension de phase eps-r",
  "common.50700.epsPowerT": "Puissance de phase eps-t",
  "common.50700.epsPowerS": "Puissance de phase eps-s",
  "common.50700.epsPowerR": "Puissance de phase eps-r",
  "common.50700.epsPower": "Puissance avec EPS",
  "common.50700.epsCurrentT": "Courant de phase eps-t",
  "common.50700.epsCurrentS": "Courant de phase eps-s",
  "common.50700.epsCurrentR": "Courant de phase eps-r",
  "common.50700.energyThroughput": "Rendement des batteries",
  "common.50700.dspTemperature": "Température de DSP",
  "common.50700.dischargeEnergyToTal": "Décharge totale de puissance",
  "common.50700.chargeTemperature": "Température de charge",
  "common.50700.chargeEnergyToTal": "Quantité totale de charge",
  "common.50700.boostTemperation": "Température du chargeur",
  "common.50700.batVolt": "Tension de batterie",
  "common.50700.batTemperature": "Température de batterie",
  "common.50700.batStatusV2": "État de batterie",
  "common.50700.batStatus": "État de batterie",
  "common.50700.batDischargePower": "Batterie décharge puissance",
  "common.50700.batCurrent": "Courant de batterie",
  "common.50700.batChargePower": "Puissance de charge de batterie",
  "common.50700.ambientTemperation": "La température ambiante",
  "common.50700.xnl_RTparam_group_Battery": "Batterie",
  "common.50702.xnl_RTparam_group_Battery": "Batterie",
  "common.50698.TVolt": "Tension de phase T",
  "common.50700.TPower": "Puissance de phase T",
  "common.50700.TVolt": "Tension de phase T",
  "supplier.type.ankerui": "ankerui",
  "subtype.collector.4g.meters": "compteur 4G",
  "param_set.xnl_inverter_Factoryresetenable": "Réinitialisation d'usine",
  "param_set.xnl_inverter_GridMode": "Norme raccordée au réseau",
  "param_set.xnl_inverter_GridType": "Paramétrage du type de grille",
  "param_set.xnl_inverter_GridFrequency": "Réglage de la fréquence de la grille",
  "param_set.xnl_inverter_Restoreconnectiontime": "Restaurer le temps de connexion au réseau",
  "param_set.xnl_inverter_PF": "Réglage de la valeur PF de sortie",
  "param_set.xnl_inverter_GridFrequencyOver": "Point de protection haute fréquence",
  "param_set.xnl_inverter_GridFrequencyUnder": "Fréquence du réseau faible point de protection",
  "param_set.xnl_inverter_GridVoltageOver": "Point de protection contre les surtensions du réseau électrique",
  "param_set.xnl_inverter_GridVoltageUnder": "Point de protection basse tension du réseau électrique",
  "param_set.xnl_inverter_Q(V)": "Californie CA _ QV Activer",
  "param_set.xnl_inverter_V1": "CA _ QV _ V1",
  "param_set.xnl_inverter_V2": "CA _ QV _ V2",
  "param_set.xnl_inverter_V3": "CA _ QV _ V3",
  "param_set.xnl_inverter_V4": "CA _ QV _ V4",
  "param_set.xnl_inverter_Q1": "CA _ QV _ Q1",
  "param_set.xnl_inverter_Q2": "CA _ QV _ Q2",
  "param_set.xnl_inverter_Q3": "CA _ QV _ Q3",
  "param_set.xnl_inverter_Q4": "CA _ QV _ Q4",
  "param_set.xnl_inverter_FW": "Californie CA _ FW Activer",
  "param_set.xnl_inverter_Fstart": "CA _ Fstart",
  "param_set.xnl_inverter_Fstop": "CA _ Fstop",
  "param_set.xnl_inverter_VW": "Californie CA _ VW Activer",
  "param_set.xnl_inverter_Vstart": "CA _ Vstart",
  "param_set.xnl_inverter_Vstop": "CA _ Vstop",
  "param_set.xnl_inverter_Normalupwardslope": "Pente ascendante normale",
  "param_set.xnl_inverter_Softstartriserate": "Taux d'augmentation du démarrage en douceur",
  "param_set.xnl_inverter_LHVRT": "La traversée haute pression basse pression de Californie permet",
  "param_set.xnl_inverter_HV2": "CA _ HV2",
  "param_set.xnl_inverter_HV1": "CA _ HV1",
  "param_set.xnl_inverter_LV1": "CA _ LV1",
  "param_set.xnl_inverter_LV2": "CA _ LV2",
  "param_set.xnl_inverter_LV3": "CA _ LV3",
  "param_set.xnl_inverter_CA_HV2_Time": "CA _ HV2 _ Time",
  "param_set.xnl_inverter_CA_HV1_Time": "CA _ HV1 _ Time",
  "param_set.xnl_inverter_CA_LV1_Time": "CA _ LV1 _ Time",
  "param_set.xnl_inverter_CA_LV2_Time": "CA _ LV2 _ Time",
  "param_set.xnl_inverter_CA_LV3_Time": "CA _ LV3 _ Time",
  "param_set.xnl_inverter_CA_LHFRT": "Traversée haute fréquence basse fréquence en Californie CA _ LHFRT Activer",
  "param_set.xnl_inverter_CA_HF2": "CA _ HF2",
  "param_set.xnl_inverter_CA_HF1": "CA _ HF1",
  "param_set.xnl_inverter_CA_LF1": "CA _ LF1",
  "param_set.xnl_inverter_CA_LF2": "CA _ LF2",
  "param_set.xnl_inverter_CA_HF2_Time": "CA _ HF2 _ Time",
  "param_set.xnl_inverter_CA_HF1_Time": "CA _ HF1 _ Time",
  "param_set.xnl_inverter_CA_LF1_Time": "CA _ LF1 _ Time",
  "param_set.xnl_inverter_CA_LF2_Time": "CA _ LF2 _ Time",
  "param_set.xnl_inverter_GeneratorInputRatedPower": "Puissance d'entrée nominale du générateur",
  "param_set.xnl_inverter_GENConnectToGridInput": "Le générateur est connecté au réseau électrique",
  "param_set.xnl_inverter_SmartLoadOutput": "Puissance en charge",
  "param_set.xnl_inverter_OnGridAlwayson00": "Activer les conditions du réseau",
  "param_set.xnl_inverter_OFF1": "SmartLoad OFF Tension de la batterie",
  "param_set.xnl_inverter_ON1": "SmartLoad ON tension de la batterie",
  "param_set.xnl_inverter_OFF2": "SmartLoad OFF Charge de la batterie",
  "param_set.xnl_inverter_ON2": "SmartLoad ON Batterie",
  "param_set.xnl_inverter_Battery_Type": "Type de batterie",
  "param_set.xnl_inverter_Battery_Mode": "Mode batterie",
  "param_set.xnl_inverter_Activate Battery": "Drapeau de réveil de la batterie au lithium",
  "param_set.xnl_inverter_Batt Capacity": "Capacité de la batterie",
  "param_set.xnl_inverter_MaxACharge": "Courant de charge maximal de la batterie",
  "param_set.xnl_inverter_MaxAdischarge": "Courant de décharge maximal de la batterie",
  "param_set.xnl_inverter_GenCharge1": "Chargement du générateur activé",
  "param_set.xnl_inverter_GenSignal1": "Gen signal",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": "Point de capacité de démarrage de charge du générateur",
  "param_set.xnl_inverter_GenMainsPowerBattery2": "Courant de charge du générateur sur la batterie",
  "param_set.xnl_inverter_MaxRunTime": "Durée de fonctionnement maximale du générateur",
  "param_set.xnl_inverter_CoolingTime": "Refroidissement du générateur",
  "param_set.xnl_inverter_GridCharge": "Activation de la charge secteur",
  "param_set.xnl_inverter_GridSignal": "Signal de grille",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": "Point de capacité de démarrage de charge du secteur",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": "Courant de charge secteur pour la batterie",
  "param_set.xnl_inverter_Lithium Protocol": "Options de communication par batterie au lithium",
  "param_set.xnl_inverter_ShutDown": "Batterie éteinte",
  "param_set.xnl_inverter_Restart": "Redémarrage de la batterie",
  "param_set.xnl_inverter_LowBatt": "Batterie basse tension",
  "param_set.xnl_inverter_GenSignal ": "Signal secteur",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": "Point de tension de démarrage de charge du générateur",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": "Point de tension de départ de charge du secteur",
  "param_set.xnl_inverter_FloatVoltage": "tension flottante",
  "param_set.xnl_inverter_AbsorptionVoltage": "Tension d'absorption",
  "param_set.xnl_inverter_EqualizationVoltage": "Tension de charge égale",
  "param_set.xnl_inverter_EqualizationdayS": "La charge équilibrée est exécutée tous les quelques jours",
  "param_set.xnl_inverter_TEMPCO": "Valeur de compensation de la température",
  "param_set.xnl_inverter_Equalizationhours": "Temps d'exécution de la charge d'équilibre",
  "param_set.xnl_inverter_batteryresistancevalue": "Valeur de résistance interne de la batterie",
  "param_set.xnl_inverter_GenStartingCapacityPoint": "Point de capacité de démarrage de charge du générateur",
  "param_set.xnl_inverter_SellingFirst": "Priorité aux ventes d'électricité",
  "param_set.xnl_inverter_Solarsell": "Énergie photovoltaïque",
  "param_set.xnl_inverter_MaxSolarPower": "Puissance photovoltaïque maximale",
  "param_set.xnl_inverter_MaxSellPower": "Puissance maximale connectée au réseau",
  "param_set.xnl_inverter_Zero-Exportpower": "Puissance de fonctionnement minimale",
  "param_set.xnl_inverter_EnergyPattern": "Modèle de gestion de l'énergie",
  "param_set.xnl_inverter_GridPeakShavingPower": "Rasage des pics du réseau électrique",
  "param_set.xnl_inverter_GridGen10": "Activation de charge du réseau 1",
  "param_set.xnl_inverter_GridGen20": "Activation de charge du réseau 2",
  "param_set.xnl_inverter_GridGen30": "Activation de charge du réseau 3",
  "param_set.xnl_inverter_GridGen40": "Activation de charge du réseau 4",
  "param_set.xnl_inverter_GridGen50": "Activation de charge du réseau 5",
  "param_set.xnl_inverter_GridGen60": "Activation de charge du réseau 6",
  "param_set.xnl_inverter_Time1": "Période 1",
  "param_set.xnl_inverter_Time2": "Période 2",
  "param_set.xnl_inverter_Time3": "Période 3",
  "param_set.xnl_inverter_Time4": "Période 4",
  "param_set.xnl_inverter_Time5": "Période 5",
  "param_set.xnl_inverter_Time6": "Période 6",
  "param_set.xnl_inverter_Power1": "puissance",
  "param_set.xnl_inverter_Power2": "Puissance 2",
  "param_set.xnl_inverter_Power3": "Puissance 3",
  "param_set.xnl_inverter_Power4": "Puissance 4",
  "param_set.xnl_inverter_Power5": "Puissance 5",
  "param_set.xnl_inverter_Power6": "Puissance 6",
  "param_set.xnl_inverter_BattV1": "Tension de la batterie 1 ",
  "param_set.xnl_inverter_BattV2": "Tension de la batterie 2 ",
  "param_set.xnl_inverter_BattV3": "Tension de la batterie 3 ",
  "param_set.xnl_inverter_BattV4": "Tension de la batterie 4 ",
  "param_set.xnl_inverter_BattV5": "Tension de la batterie 5 ",
  "param_set.xnl_inverter_BattV6": "Tension de la batterie 6 ",
  "param_set.xnl_inverter_Batt1": "Batterie 1",
  "param_set.xnl_inverter_Batt2": "Batterie 2",
  "param_set.xnl_inverter_Batt3": "Batterie 3",
  "param_set.xnl_inverter_Batt4": "Batterie 4",
  "param_set.xnl_inverter_Batt5": "Batterie 5",
  "param_set.xnl_inverter_Batt6": "Batterie 6",
  "param_set.xnl_inverter_SolarArcFaultON": "Mode défaut arc",
  "param_set.xnl_inverter_CTRatio": "Rapport de transformation CT",
  "param_set.xnl_inverter_BackupDelay": "Ups _ time",
  "param_set.xnl_inverter_Parallel1": "Parallèle",
  "param_set.xnl_inverter_3P1": "Parallèle triphasé - Activer le compteur CT",
  "param_set.xnl_inverter_GenCharge": "Chargement du générateur activé",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": "Courant de charge du générateur sur la batterie",
  "param_set.xnl_inverter_Down Time": "Refroidissement du générateur",
  "param_set.xnl_inverter_Grid Charge": "Activation de la charge secteur",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": "Courant de charge secteur pour la batterie",
  "param_set.xnl_inverter_GenMainsPowerBattery": "Courant de charge du générateur sur la batterie",
  "param_set.xnl_inverter_DownTime": "Refroidissement du générateur",
  "param_set.xnl_inverter_StartingCapacityPoint": "Point de capacité de démarrage de charge du secteur",
  "param_set.xnl_inverter_MainsPowerBattery": "Courant de charge secteur pour la batterie",
  "param_set.xnl_inverter_Equalizationtime": "Temps d'exécution de la charge d'équilibre",
  "param_set.xnl_inverter_Parallel2": "Maître",
  "param_set.xnl_inverter_Parallel3": "Phase",
  "param_set.xnl_inverter_Parallel4": "Modbus SN",
  "param_set.xnl_inverter_3P2": "Activation triphasée parallèle-A",
  "param_set.xnl_inverter_3P3": "Activation triphasée parallèle-B",
  "param_set.xnl_inverter_3P4": "Activation triphasée parallèle-C",
  "param_set.xnl_inverter_GridGen11": "Carburant / Chargement Activer 1",
  "param_set.xnl_inverter_GridGen21": "Chaifa charge activer 2",
  "param_set.xnl_inverter_GridGen31": "Chaifa charge activer 3",
  "param_set.xnl_inverter_GridGen41": "Chaifa charge activer 4",
  "param_set.xnl_inverter_GridGen51": "Chaifa charge activer 5",
  "param_set.xnl_inverter_GridGen61": "Chaifa charge activer 6",
  "param_set.xnl_inverter_OnGridAlwayson04": "Activer les conditions du réseau - pic du générateur",
  "param_set.xnl_inverter_OnGridAlwayson08": "Activer les conditions de la grille - rasage des pics de la grille",
  "param_set.xnl_inverter_OnGridAlwayson12": "À l'état de la grille - Sur la grille toujours allumée",
  "param_set.xnl_inverter_OnGridAlwayson13": "Activer l'état du réseau - relais externe",
  "param_set.xnl_inverter_OnGridAlwayson14": "Activez l'état du réseau - la batterie au lithium est perdue et le défaut est signalé. Activer le bit",
  "param_set.xnl_inverter_OnGridAlwayson15": "Activer l'état de la grille - bit d'activation DRM",
  "param_set.xnl_inverterGroup_BasicSettings": "Paramètres de Base",
  "param_set.xnl_inverterGroup_GridSettings": "Paramètres du Réseau",
  "param_set.xnl_inverterGroup_GeneratorSettings": "Paramètres du Générateur",
  "param_set.xnl_inverterGroup_BatterySettings": "Paramètres de Batterie",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "Mode de Fonctionnement Système",
  "param_set.xnl_inverterGroup_AdvancedSettings": "Paramètres Avancés",
  "param_set.xnl_inverter_GenSignal_fdj": "signal du générateur",
  "param_set.xnl_inverter_GenSignal_charge": "Signal secteur",
  "param_set.xnl_inverter_GenSignal_fdj_1": "signal du générateur1",
  "param_set.xnl_inverter_GenSignal_charge_1": "Signal secteur1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "signal du générateur2",
  "param_set.xnl_inverter_GenSignal_charge_2": "Signal secteur2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "Port de générateur utilisé pour",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Version du logiciel maître de l'inverseur",
  "bw_RTparam_name_TotalReactivePower_Grid": "Total Reactive Power(Grid)",
  "bw_RTparam_name_TotalApparent Power_Grid": "Total Apparent Power(Grid)",
  "bw_RTparam_name_TotalPowerFactor_Grid": "Facteur de puissance total (réseau)",
  "bw_RTparam_name_BatteryRelayStatus": "Statut du relais de batterie",
  "bw_RTparam_name_BatWarnningPack": "Bat Warnning Pack",
  "bw_RTparam_name_PvBoostTemperature": "Temperature de boost Pv",
  "bw_RTparam_name_InvModuleTemperature": "Temperature du module d'inv",
  "bw_RTparam_name_PowerBoardTemperature": "Temperature de la carte d'alimentation",
  "bw_RTparam_name_InvApparentPower": "Inv Puissance apparente",
  "bw_RTparam_name_InvActivePower": "Inv Puissance active",
  "bw_RTparam_name_InvReactivePower": "Inv Puissance réactive",
  "bw_RTparam_name_InvPowerFactor": "Facteur de puissance Inv",
  "bw_RTparam_name_BackupFrequency": "Fréquence de sauvegarde",
  "bw_RTparam_name_InvCurrentR": "Inv Current R",
  "bw_RTparam_name_InvCurrentS": "Inv Courant S",
  "bw_RTparam_name_InvCurrentT": "Inv Current T",
  "bw_RTparam_name_BatteryMaxChargePower": "Puissance de charge maximale de la batterie",
  "bw_RTparam_name_BatteryMaxDischargePower": "Puissance de décharge maximale de la batterie",
  "bw_RTparam_name_TotalEnergyInvInput": "Total Energy Inv Input",
  "bw_RTparam_name_BackupVoltageR": "Backup Voltage R",
  "bw_RTparam_name_BackupVoltageS": "Backup Voltage S",
  "bw_RTparam_name_BackupVoltageT": "Backup Voltage T",
  "bw_RTparam_name_BackupCurrentR": "Backup Current R",
  "bw_RTparam_name_BackupCurrentS": "Backup Current S",
  "bw_RTparam_name_BackupCurrentT": "Sauvegarder la T actuelle",
  "bw_RTparam_name_BackupPower": "Alimentation de secours",
  "common.50300.Ia": "Courant de phase A",
  "common.50300.Pa": "Puissance active de phase A",
  "common.50300.Ib": "Courant de phase B",
  "common.50300.Pb": "Puissance active de phase B",
  "common.50300.Ic": "Courant de phase C",
  "common.50300.Pc": "Puissance active de phase C",
  "common.50300.ctTotalActivePower": "Puissance active totale",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "Les relais de charge et de décharge sont déconnectés",
  "bw_value_OnlyDischargeRelayIsClosed": "Seul le relais de décharge est fermé",
  "bw_value_OnlyChargeRelayIsClosed": "Seul le relais de charge est fermé",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "Les relais de charge et de décharge sont fermés",
  "bw_value_Single-Phase5KwModel": "Modèle monophasé 5Kw",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "Modèle de stockage d'énergie monophasé 5Kw",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "Modèle de stockage d'énergie monophasé de 3 kW",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "Modèle de stockage d'énergie monophasé 6 Kw",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "Modèle de stockage d'énergie monophasé 8 Kw",
  "bw_value_Three-Phase4KwModel": "Modèle triphasé 4Kw",
  "bw_value_Three-Phase5KwModel": "Modèle 5Kw triphasé",
  "bw_value_Three-Phase6KwModel": "Modèle triphasé de 6 Kw",
  "bw_value_Three-Phase8KwModel": "Modèle triphasé de 8 kW",
  "bw_value_ThreePhase10KwModel": "Modèle 10 Kw en trois phases",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "Énergie PV totale du système (y compris l'énergie du compteur PV)",
  "bw_RTparam_name_GridFrequencyINV": "Fréquence de la grille (INV)",
  "device.category.heatpump": "pompe à chaleur",
  "device.category.collector": "Dongle",
  "jl_RTparam_name_powerAmmeter2": "Puissance du compteur 2",
  "jl_RTparam_name_dayEnergyAmmeter2": "Consommation électrique du jour du compteur 2",
  "jl_RTparam_name_monthEnergyAmmeter2": "Consommation électrique du mois du compteur 2",
  "jl_RTparam_name_yearEnergyAmmeter2": "Consommation électrique de l'année du compteur 2",
  "jl_RTparam_name_totalEnergyAmmeter2": "Consommation électrique cumulative du compteur 2",
  "jl_RTparam_group_Ammeter": "Compteur électrique",
  "ai.robot.manage.family": "Bonjour, le robot IA gère votre consommation d'électricité domestique.",
  "ai.robot.predicted.price": "Le prix de l'électricité d'aujourd'hui a été obtenu, la production d'aujourd'hui est prévue à {###}kWh.",
  "ai.robot.regulating.heat.pump": "Le fonctionnement de la pompe à chaleur sera ajusté selon les circonstances.",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "Puissance active de la phase A (PV)",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "Puissance active de la phase B (PV)",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "Puissance active de la phase C (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "Puissance apparente de la phase A (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "Puissance apparente de la phase B (PV)",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "Puissance apparente de la phase C (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "Puissance réactive de la phase A (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "Puissance réactive de la phase B (PV)",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "Puissance réactive de la phase C (PV)",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "Facteur de puissance de la phase A (PV)",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "Facteur de puissance de la phase B (PV)",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "Facteur de puissance de la phase C (PV)",
  "bw_RTparam_name_PVConnectState": "État d'exploitation du travail",
  "bw_RTparam_name_PVMeterNegate": "Direction d'accès au compteur PV",
  "bw_RTparam_Option_NoPV": "Pas de PV",
  "bw_RTparam_Option_HasPV": "A PV",
  "bw_RTparam_Option_PVMeterNormal": "Compteur PV Normal",
  "bw_RTparam_Option_PVMeterReversed": "Compteur PV inversé",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "Génération PV totale (INV à l'intérieur + à l'extérieur)",
  "bw_RTparam_name_TodayYield": "Intérieur INV Génération PV quotidienne",
  "bw_RTparam_name_TotalDevicePower": "Puissance PV totale",
  "bw_RTparam_name_DailyDeviceEnergy": "Total de la génération PV quotidienne",
  "device.category.module": "Composant",
  "bw_RTparam_name_TotalEnergyInvOutput": "Rendement énergétique total INV",
  "common.device.check.tab.collector": "Bâton de communication",
  "common.device.check.tab.grid": "Réseau électrique",
  "common.device.check.tab.meterselect": "Sélection du compteur électrique",
  "common.device.check.tab.meterYes": "État de connexion du compteur électrique",
  "common.device.check.tab.gridmeter": "Compteur électrique côté réseau",
  "common.device.check.tab.pvmeter": "Compteur électrique côté PV",
  "common.device.check.tab.battery": "Batterie",
  "common.check.field.collectorSn": "SN du bâton de communication",
  "common.check.field.dongleRSSI": "Force du signal",
  "common.check.field.inverterHardwareVersion": "Version matérielle du bâton de communication",
  "common.check.field.dongleSoftwareVersion": "Version logicielle du bâton de communication",
  "common.check.field.gridVoltageR": "Tension de phase R du réseau",
  "common.check.field.gridVoltageS": "Tension de phase S du réseau",
  "common.check.field.gridVoltageT": "Tension de phase T du réseau",
  "common.check.field.meterCTSelect": "État de connexion du compteur électrique (Connecté/Déconnecté)",
  "common.check.field.gridVoltageOfAPhase": "Tension de phase A du compteur électrique",
  "common.check.field.gridCurrentOfAPhaseV2": "Courant de phase A du compteur électrique",
  "common.check.field.gridVoltageOfBPhase": "Tension de phase B du compteur électrique",
  "common.check.field.gridCurrentOfBPhaseV2": "Courant de phase B du compteur électrique",
  "common.check.field.gridVoltageOfCPhase": "Tension de phase C du compteur électrique",
  "common.check.field.gridCurrentOfCPhaseV2": "Courant de phase C du compteur électrique",
  "common.check.field.gridFrequent": "Fréquence du compteur électrique",
  "common.check.field.pvVoltageOfAPhase": "Tension de phase A du compteur électrique",
  "common.check.field.pvCurrentOfAPhase": "Courant de phase A du compteur électrique",
  "common.check.field.pvVoltageOfBPhase": "Tension de phase B du compteur électrique",
  "common.check.field.pvCurrentOfBPhase": "Courant de phase B du compteur électrique",
  "common.check.field.pvVoltageOfCPhase": "Tension de phase C du compteur électrique",
  "common.check.field.pvCurrentOfCPhase": "Courant de phase C du compteur électrique",
  "common.check.field.pvFrequent": "Fréquence du compteur électrique",
  "common.check.field.pvTotalApparentPower": "Puissance apparente du compteur électrique (Totale)",
  "common.check.field.pvMeterTotalActivePower": "Puissance active du compteur électrique (Totale)",
  "common.check.field.pvTotalReactivePower": "Puissance réactive du compteur électrique (Totale)",
  "common.check.field.pvTotalPowerFactor": "Facteur de puissance du compteur électrique (Total)",
  "common.check.field.batteryOnlineStatus": "État de connexion effectif de la batterie (Connecté/Déconnecté)",
  "50000_0X561-M-12": "La phase grille est incohérente",
  "50000_0X561-M-13": "Échantillon DCV anormal",
  "50000_0X561-M-14": "Faute de flash de boîte noire",
  "50000_0X561-M-15": "Faute RTC",
  "bw.content.alarm.0X55E-M-60": "La phase grille est incohérente",
  "bw.content.alarm.0X55E-M-61": "Échantillon DCV anormal",
  "bw.content.alarm.0X55E-M-62": "Faute de flash de boîte noire",
  "bw.content.alarm.0X55E-M-63": "Faute RTC",
  "plant.deliver.type.zj": "Haier Smart Home",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "Haier Smart Home",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "IEC61727": "IEC61727",
  "G59_3": "G59_3",
  "RD1699": "Spain--RD1699",
  "G99": "UK--G99",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "G98": "UK--G98",
  "EN50549-CZ": "EN50549-CZ",
  "PEA": "Thailand--PEA",
  "MEA": "Thailand--MEA",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "EN50549": "EU--EN50549",
  "common.50800.defrosting": "dégivrage",
  "common.50800.antiFreezing": "anti-gel",
  "common.50800.sterilization": "stérilisation",
  "common.50800.antiRust": "anti-rouille",
  "common.50800.auto": "automatique",
  "common.50800.cool": "refroidissement",
  "common.50800.heat": "chauffage",
  "common.50800.dhw": "eau chaude sanitaire",
  "common.50800.pool": "piscine",
  "common.50800.heat+pool": "chauffage + piscine",
  "common.50800.auto+dhw": "automatique + eau chaude",
  "common.50800.cool+dhw": "refroidissement + eau chaude",
  "common.50800.heat+dhw": "chauffage + eau chaude",
  "bw_RTparam_name_deviceRunningState": "État d'exploitation du travail",
  "person.confirmPassword": "Confirmer le mot de passe",
  "supplier.type.lg": "LIGOO",
  "plant.not.delivered": "La centrale électrique n'a pas été livrée",
  "plant.not.exist": "La centrale électrique n'existe pas",
  "device.agent.admin.can.operate": "Vous n'avez pas l'autorisation de retirer la livraison.",
  "plant.pure.light": "Maison adaptée zéro carbone - purement solaire",
  "ywt.60419.meterTPower\n": "Puissance de phase T du compteur électrique",
  "ywt.60419.loadPower\n": "Puissance de charge",
  "param_set.lg_inverterGroup_LithiumBattery": "Batterielithium",
  "param_set.lg_inverterGroup_AdvancedSettings": "Paramètresavancés",
  "param_set.lg_inverterGroup_SystemOperationMode": "Modedefonctionnementdusystème",
  "param_set.lg_inverterGroup_GeneratorSettings": "Paramètresdugénérateur",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "Paramètresdefonctionnementenparallèle",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "Paramètresdelissagedecourbedecharge",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "Activationdel'entréegénérateur",
  "param_set.lg_inverterGroup_SmartLoadEnable": "Activationdelachargeintelligente",
  "param_set.lg_inverterGroup_MicroinverterEnable": "Activationdesmicro-onduleurs",
  "param_set.lg_inverterGroup_Battery(Shared)": "Batterie(partagée)",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "Batterieplomb-acide",
  "param_set.lg_inverter_SystemOn": "Marche/arrêtdusystème",
  "param_set.lg_inverter_ClearFault": "Effacerlesdéfauts",
  "param_set.lg_inverter_ManualActivation": "Activationmanuelle",
  "param_set.lg_inverter_InverterRated（%）": "Réglagedupourcentagedepuissanceonduleur",
  "param_set.lg_inverter_PVActivePowerSetting": "RéglagedelapuissanceactivePV(%)",
  "param_set.lg_inverter_PVConnectorMode": "ParamètresdeconnexionPV",
  "param_set.lg_inverter_PVStarupEnable": "ActivationdedémarragePVsimple",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "Activationdeladétectiondedéfauttensionneutre-terre",
  "param_set.lg_inverter_GFCIEnable": "Activationdeladétectiondefuitedecourant",
  "param_set.lg_inverter_AllowGridCharging": "Autoriserlachargeparleréseau",
  "param_set.lg_inverter_PVISOEnable": "Activationdeladétectiond'isolementPV",
  "param_set.lg_inverter_CT/MeterOptional": "Bitd'activationducompteurCT",
  "param_set.lg_inverter_PhaseType": "Typedeséquencedephases",
  "param_set.lg_inverter_CTRatio": "RapportCT",
  "param_set.lg_inverter_PVOperationMode": "ModedefonctionnementPV",
  "param_set.lg_inverter_CVT1CurrentLimit": "LimitedecourantCVT1",
  "param_set.lg_inverter_CVT2CurrentLimit": "LimitedecourantCVT2",
  "param_set.lg_inverter_ChargingCurrent": "Courantdecharge",
  "param_set.lg_inverter_DischargingCurrent": "Courantdedécharge",
  "param_set.lg_inverter_FloatChargingVoltage": "Tensiondefloating",
  "param_set.lg_inverter_EqualChargingVoltage": "Tensiondecharged'égalisation",
  "param_set.lg_inverter_CT/MeterAccessDirection": "SensdeconnexionCT/compteur",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "Activationdudéséquilibredechargedomestique",
  "param_set.lg_inverter_BMSClearFault": "EffacementdesdéfautsBMS",
  "param_set.lg_inverter_AFCIReset": "RéinitialisationAFCI",
  "param_set.lg_inverter_HMIBrightness": "Luminositédel'IHM",
  "param_set.lg_inverter_HMIRestTime": "Délaid'extinctiondel'écranIHM",
  "param_set.lg_inverter_StatisticClear": "Effacerlesstatistiques",
  "param_set.lg_inverter_EnergyPattern": "Modedegestiondel'énergie",
  "param_set.lg_inverter_SyncTimeEnable": "Activationdelasynchronisationtemporelle",
  "param_set.lg_inverter_RSDEnable": "ActivationRSD",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "Heurededémarragedéfinieparl'installateur",
  "param_set.lg_inverter_DynamicPassword": "Motdepassedynamique",
  "param_set.lg_inverter_ACType": "Typedecourantalternatif",
  "param_set.lg_inverter_ChargingPriorityMode": "Modeprioritéàlacharge",
  "param_set.lg_inverter_SellPowerLimit": "Limiterlapuissancedesortiemaximaleversleréseau",
  "param_set.lg_inverter_BuzzerEnable": "Buzzer",
  "param_set.lg_inverter_MeterType": "Typedecompteur",
  "param_set.lg_inverter_Specialfeatures": "Fonctionsspéciales",
  "param_set.lg_inverter_NLineNotGrounded": "Neutrenonmisàlaterre",
  "param_set.lg_inverter_AFCIEnable": "Activationdeladétectiond'arc",
  "param_set.lg_inverter_FactoryReset": "Restaurerlesparamètresd'usine",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "Alimentationdephaseasymétrique",
  "param_set.lg_inverter_ParamsChangeLock": "Verrouillagedemodificationdesparamètres",
  "param_set.lg_inverter_SystemWorkMode": "Modedefonctionnementdusystème",
  "param_set.lg_inverter_SolarSell": "Vented'électricitéPV",
  "param_set.lg_inverter_SignalIslandMode": "Entréedusignalhorsréseau",
  "param_set.lg_inverter_GridTOUEnable": "Activationdesplageshorairesd'écrêtementréseau",
  "param_set.lg_inverter_AutoRunEnable": "Activationdufonctionnementautomatique",
  "param_set.lg_inverter_DRMEnable": "ActivationDRM",
  "param_set.lg_inverter_Password": "Motdepassepardéfaut",
  "param_set.lg_inverter_PasswordValidityTime": "Duréedevaliditédumotdepasse",
  "param_set.lg_inverter_GeneratorStartMode": "Modededémarragedugénérateur",
  "param_set.lg_inverter_GeneratorManualStartMode": "Démarragemanueldugénérateur",
  "param_set.lg_inverter_Generatorpriority": "Prioritéaugénérateur",
  "param_set.lg_inverter_GeneratorInputPort": "Portd'entréedugénérateur",
  "param_set.lg_inverter_GeneratorPower": "Puissancedugénérateur",
  "param_set.lg_inverter_GeneratorStartupVoltage": "Tensiondedémarragedugénérateur",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "Tensiond'arrêtdugénérateur",
  "param_set.lg_inverter_GeneratorStartupSOC": "SOCdedémarragedugénérateur",
  "param_set.lg_inverter_GeneratorShutdownSOC": "SOCdefingénérateur(modedémarrageauto)",
  "param_set.lg_inverter_GeneratorStartSignal": "Signaldedémarragedugénérateur",
  "param_set.lg_inverter_GeneratorChargeCurrent": "Courantdechargedugénérateur",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "Duréedefonctionnementmaximaledugénérateur",
  "param_set.lg_inverter_GeneratorCutOffTime": "Heuredecoupuredugénérateur",
  "param_set.lg_inverter_GeneratorTOUEnable": "Activationdel'écrêtementpargénérateur",
  "param_set.lg_inverter_ParallelEnable": "Activationdufonctionnementenparallèle",
  "param_set.lg_inverter_ParallelAddress": "Adressedesunitésparallèles",
  "param_set.lg_inverter_ParallelNumber": "Nombred'unitésparallèles",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "Activationdupartagedebatterieenparallèle",
  "param_set.lg_inverter_ParallelPhase": "Séquencedephasesdesunitésparallèles",
  "param_set.lg_inverter_ParallelMode": "Modedefonctionnementenparallèle",
  "param_set.lg_inverter_Year/Month": "Année/Mois",
  "param_set.lg_inverter_Day/Reserve": "Jour/Réservé",
  "param_set.lg_inverter_Hour/Minute": "Heure/Minute",
  "param_set.lg_inverter_Second/Week": "Seconde/Semaine",
  "param_set.lg_inverter_TOUStartTime1": "Heurededébutcharge/décharge1(lissage)",
  "param_set.lg_inverter_TOUEndTime1": "Heuredefincharge/décharge1(lissage)",
  "param_set.lg_inverter_Time1TOUPower": "Puissancecharge/déchargeréseauPériode1",
  "param_set.lg_inverter_TOUStartTime2": "Heurededébutcharge/décharge2(lissage)",
  "param_set.lg_inverter_TOUEndTime2": "Heuredefincharge/décharge2(lissage)",
  "param_set.lg_inverter_Time2TOUPower": "Puissancecharge/déchargeréseauPériode2",
  "param_set.lg_inverter_TOUStartTime3": "Heurededébutcharge/décharge3(lissage)",
  "param_set.lg_inverter_TOUEndTime3": "Heuredefincharge/décharge3(lissage)",
  "param_set.lg_inverter_Time3TOUPower": "Puissancecharge/déchargeréseauPériode3",
  "param_set.lg_inverter_TOUStartTime4": "Heurededébutcharge/décharge4(lissage)",
  "param_set.lg_inverter_TOUEndTime4": "Heuredefincharge/décharge4(lissage)",
  "param_set.lg_inverter_Time4TOUPower": "Puissancecharge/déchargeréseauPériode4",
  "param_set.lg_inverter_TOUStartTime5": "Heurededébutcharge/décharge5(lissage)",
  "param_set.lg_inverter_TOUEndTime5": "Heuredefincharge/décharge5(lissage)",
  "param_set.lg_inverter_Time5TOUPower": "Puissancecharge/déchargeréseauPériode5",
  "param_set.lg_inverter_TOUStartTime6": "Heurededébutcharge/décharge6(lissage)",
  "param_set.lg_inverter_TOUEndTime6": "Heuredefincharge/décharge6(lissage)",
  "param_set.lg_inverter_Time6TOUPower": "Puissancecharge/déchargeréseauPériode5",
  "param_set.lg_inverter_Time1TOUSOC": "SOCbatterieécrétapePériode1",
  "param_set.lg_inverter_Time2TOUSOC": "SOCbatterieécrétapePériode2",
  "param_set.lg_inverter_Time3TOUSOC": "SOCbatterieécrétapePériode3",
  "param_set.lg_inverter_Time4TOUSOC": "SOCbatterieécrétapePériode4",
  "param_set.lg_inverter_Time5TOUSOC": "SOCbatterieécrétapePériode5",
  "param_set.lg_inverter_Time6TOUSOC": "SOCbatterieécrétapePériode6",
  "param_set.lg_inverter_Time1TOUVoltage": "TensionécrétapePériode1",
  "param_set.lg_inverter_Time2TOUVoltage": "TensionécrétapePériode2",
  "param_set.lg_inverter_Time3TOUVoltage": "TensionécrétapePériode3",
  "param_set.lg_inverter_Time4TOUVoltage": "TensionécrétapePériode4",
  "param_set.lg_inverter_Time5TOUVoltage": "TensionécrétapePériode5",
  "param_set.lg_inverter_Time6TOUVoltage": "TensionécrétapePériode6",
  "param_set.lg_inverter_TOUWeek": "Paramètreshebdomadairesd'écrêtement",
  "param_set.lg_inverter_GENTOUEnable": "Activationdesplageshorairesd'écrêtementgénérateur",
  "param_set.lg_inverter_SmartLoadSetting": "ParamètresSmartLoad",
  "param_set.lg_inverter_SmartLoadStopVoltage": "Tensiond'arrêtdelachargeintelligente",
  "param_set.lg_inverter_GeneratorLinktoInput": "Générateurconnectéàl'entréeréseau",
  "param_set.lg_inverter_MicroINVLinkLoad": "Micro-onduleurconnectécôtécharge",
  "param_set.lg_inverter_MicroINVLinkGrid": "Micro-onduleurconnectécôtéréseau",
  "param_set.lg_inverter_SolarPower": "Puissancesolaire",
  "param_set.lg_inverter_GridAlwaysOn": "Réseautoujoursactivé",
  "param_set.lg_inverter_OffGridDisconnection": "Déconnexionimmédiatehorsréseau",
  "param_set.lg_inverter_SmartLoadONSOC": "SOCdedémarragedelachargeintelligente",
  "param_set.lg_inverter_SmartLoadOFFSOC": "SOCd'arrêtdelachargeintelligente",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "RéglagedelalimitesupérieuredefréquenceACCouple",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "Coupuredelasortiemicro-onduleurversleréseau",
  "param_set.lg_inverter_MicroINVOFFSOC": "SOCd'arrêtdesmicro-onduleurs",
  "param_set.lg_inverter_MicroINVONSOC": "SOCdedémarragedesmicro-onduleurs",
  "param_set.lg_inverter_SmartLoadStartVoltage": "Tensiondemarchedelachargeintelligente",
  "param_set.lg_inverter_SmartLoadDuration": "Duréed'activationdelachargeintelligente",
  "param_set.lg_inverter_SmartLoadStartTime": "Heurededébutdelachargeintelligente",
  "param_set.lg_inverter_SmartLoadEndTime": "Heuredefindelachargeintelligente",
  "param_set.lg_inverter_BatteryType": "Typedebatterie",
  "param_set.lg_inverter_BatteryInputMode": "Modedeconnexiondelabatterie",
  "param_set.lg_inverter_BatteryFailureShutdown": "Arrêtsurdéfautdecommunicationbatterie",
  "param_set.lg_inverter_GridChargeEnable": "Activationdelachargeparleréseau",
  "param_set.lg_inverter_GridSignal": "Signalréseau",
  "param_set.lg_inverter_GridChargeCurrent": "Courantdechargeréseau",
  "param_set.lg_inverter_GridStartupSOC": "SOCdedémarrageréseau",
  "param_set.lg_inverter_BatteryLowCostMode": "Modebasseconsommationbatterie",
  "param_set.lg_inverter_LowNoiseMode": "Modesilencieuxbatterie",
  "param_set.lg_inverter_StrongchargeSOC": "PointSOCdechargeforcée",
  "param_set.lg_inverter_StrongchargeStopSOC": "PointSOCdefindechargeforcée",
  "param_set.lg_inverter_StrongchargeSOCEN": "ActivationduSOCdechargeforcée",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "Fabricantdelabatterielithium",
  "param_set.lg_inverter_ChargingVoltage": "Tensiondecharge",
  "param_set.lg_inverter_ChargingCurrentLimit": "Courantdechargemaximal",
  "param_set.lg_inverter_DischargingCurrentLimit": "Courantdedéchargemaximal",
  "param_set.lg_inverter_DischargingShutdownVoltage": "Pointdecoupuretensiondedéchargebatterie",
  "param_set.lg_inverter_BatteryLowVoltage": "Pointdebassetensiondedéchargebatterie",
  "param_set.lg_inverter_DischargingShutdownSOC": "SOCdecoupurededéchargebatterie",
  "param_set.lg_inverter_ChargingEndSOC": "SOCdecoupuredechargebatterie",
  "param_set.lg_inverter_BatteryLowSOC": "SOCdebatteriefaible",
  "param_set.lg_inverter_BatteryRestartSOC": "SOCderedémarragebatterie",
  "param_set.lg_inverter_AutoForced-chargeEnable": "Activationdelachargeforcéeautomatique",
  "param_set.lg_inverter_AutoActivationEnable": "Activationdel'activationautomatiquedelabatterie",
  "param_set.lg_inverter_BatteryTriggerVoltage": "Tensiond'activationdelabatterie",
  "param_set.lg_inverter_BatteryTriggerTime": "Duréed'activationdelabatterie",
  "param_set.lg_inverter_DisableFloatCharge": "Désactiverlachargefloating",
  "param_set.lg_inverter_CV-CCChargingTime": "TempsdetransitionCVversCC",
  "param_set.lg_inverter_CC-CVChargingTime": "TempsdetransitionCCversCV",
  "param_set.lg_inverter_CC-FCChargingTime": "Tempsdetransitionégalisationversfloating",
  "param_set.lg_inverter_LeadAcidOvervolt": "Pointdesurtensionplomb-acide",
  "param_set.lg_inverter_LeadAcidBatteryType": "Typedebatterieplomb-acide",
  "param_set.lg_inverter_BatteryRatedCapacity": "Capaciténominaledelabatterie",
  "param_set.lg_inverter_BatteryOverTempVoltage": "Pointdeprotectioncontrelasurtempératurebatterie",
  "param_set.lg_inverter_TempCompensationFactor": "Coefficientdecompensationthermiquebatterie",
  "param_set.lg_inverter_BatteryRestartVoltage": "Pointdetensionderécupérationbatterie",
  "param_set.lg_inverter_EC-FCChargeCurrent": "Courantdechargetransitionégalisationversfloating",
  "param_set.lg_inverter_FC-ECChargeCurrent": "Courantdechargetransitionfloatingverségalisation",
  "param_set.lg_inverter_CCChargingTimeLimit": "Duréemaximaledecharged'égalisationàcourantconstant",
  "param_set.lg_inverter_CVChargingTimeLimit": "Duréemaximaledecharged'égalisationàtensionconstante",
  "status.enable": "activer",
  "status.disable": "désactiver",
  "end.app": "app",
  "end.backend": "backend",
  "module.product_management": "Gestion de Produit",
  "module.plant_management": "Gestion d'Usine",
  "module.shipment_management": "Gestion des Expéditions",
  "module.device_management": "Gestion des Périphériques",
  "module.device_detail": "Détail du Périphérique",
  "module.org_management": "Gestion des Organisations",
  "module.login_register": "Connexion Inscription",
  "module.user_management": "Gestion des Utilisateurs",
  "module.family_management": "Gestion Familiale",
  "module.physical_model": "Modèle Physique",
  "module.dictionary_value": "Valeur du Dictionnaire",
  "param.name.dongle.reset.returnTip": "Dongle réinitialisé avec succès. Veuillez le reconnecter.",
  "bw_RTparam_name_AFCI_Version": "Numéro de version de l'AFCI",
  "bw_RTparam_name_BB_Version": "Numéro de version de la Backup Box",
  "test.code": "",
  "test.code1": "",
  "test.code3": "",
  "test.code.222": "",
  "dict.sttaus.not.normal": "fa",
  "dict.status.normal": "fa",
  "dict..status.not.normal": "fa",
  "org.keyFilter": "Saisissez un mot-clé pour filtrer",
  "dict.status.not.normal": "fa-normal",
  "test": "",
  "role.status.abnormal": "Anormal",
  "filter.all.blank.null": "toutes les versions de traduction sont vides",
  "shipment.confirmDownload": "Télécharger la liste",
  "shipment.updateCustomer": "Mettre à jour le client d’expédition",
  "shipment.invalidEquipmentList": "Souhaitez-vous télécharger la liste des équipements ayant échoué à la validation ? (Valable 10 minutes) Nombre d’équipements non validés :",
  "plant.smart.investment": "Investissement intelligent zéro carbone",
  "module.oversea": "Gestion des tickets",
  "income.unit.cny.pkr": "PKR",
  "alarmInfo.time": "Temps d'alerte",
  "alarmInfo.duration": "Durée de l'alerte",
  "alarmInfo.level": "Niveau d'alerte",
  "alarmInfo.triggerCondition": "Conditions de déclenchement",
  "alarmInfo.reason": "Raisons de l'alerte",
  "alarmInfo.handleTime": "Temps de traitement",
  "alarmInfo.handleType": "Type de traitement",
  "common.maintain": "Veuillez d'abord maintenir",
  "device.robotChannel": "robot",
  "device.communicationChannel": "bâton de communication",
  "device.channelType": "canal de communication",
  "device.switchChannelFailed": "Échec du changement de canal de communication",
  "test.chuneng": "chuneng",
  "Manual": "Manuel",
  "System": "Système",
  "Processed": "Traité",
  "Critical": "Critique",
  "Urgent": "Urgent",
  "Severe": "Sévère",
  "General": "Général",
  "Reminder": "Rappel",
  "common.cropper": "Recadrage d'image",
  "common.confirmCropper": "Confirmer le recadrage",
  "welcome": "",
  "device.operatingDataInfoTip": "Remarque : si ce champ est vide, veuillez contacter l’administrateur de la plateforme IoT pour le configurer.",
  "dynamic.price.not.exist": "Impossible d'obtenir le prix de l'électricité dynamique",
  "product.pleaseUploadAtLeastOneImage": "Veuillez télécharger au moins une image.",
  "device.importTemplateDownload": "Importvorlage herunterladen",
  "device.snNumber": "SN-Nummer",
  "device.enterSnCode": "Bitte geben Sie den SN-Code ein",
  "device.enterSupplierSN": "Bitte geben Sie die Lieferanten-SN ein",
  "device.deviceModelLabel": "Gerätemodell",
  "device.importTip": "Bitte importieren Sie den entsprechenden Kraftwerkscode, Gerätenamen, SN-Nummer und MDM-Code",
  "device.importTip2": "Bitte importieren Sie den entsprechenden Gerätenamen, SN-Nummer und MDM-Code",
  "device.keepAtLeastOneRow": "Mindestens eine Zeile behalten",
  "device.importSuccessWithCount": "{count} Gerätedatensätze erfolgreich importiert",
  "device.fillAllRequiredFields": "Bitte füllen Sie alle Pflichtfelder vollständig aus",
  "device.enterPlantCode": "Bitte geben Sie den Kraftwerkscode ein",
  "device.plantCodeLabel": "Kraftwerkscode",
  "device.supplierSNLabel": "Lieferanten-SN",
  "device.importTemplateEmpty": "Importvorlage ist leer",
  "plant.plantCategory": "Type de station électrique",
  "plant.plantCode": "Codage de la station",
  "plant.energyStorageCapacity": "Capacité de stockage d'énergie",
  "plant.energyStoragePower": "Puissance de stockage d'énergie",
  "plant.gridConnectionMode": "Moyens de surfer sur Internet",
  "plant.img": "Photos de la station",
  "device.realTimeMonitoring": "Surveillance en temps réel",
  "device.propertyName": "Nom de la propriété",
  "device.issueCommand": "Posté en bas",
  "device.history": "histoire",
  "device.properName": "nom",
  "device.daterange": "personnalisé",
  "device.near24h": "Près de 24 heures",
  "device.date": "Aujourd'hui",
  "device.near3d": "Près de 3 jours",
  "device.chartModule": "Module de diagramme",
  "device.lineChart": "graphique",
  "device.barChart": "Diagramme des colonnes",
  "device.dateRangeDayError": "La plage de dates doit être dans {scope} jours",
  "device.SOCHistoryData": "données historiques",
  "device.paramSave": "Posté sous paramètres",
  "common.deleteTip": "Confirmer supprimer {scope}?",
  "product.deleteConfirm": "Êtes-vous sûr de vouloir supprimer le produit {productName}?",
  "upgrade.upgradeSN": "Mise à niveau SN",
  "upgrade.datalogSN": "Journal de données SN",
  "upgrade.upgradeType": "Type de mise à niveau",
  "upgrade.fileAddress": "Adresse du fichier",
  "upgrade.plantTime": "Temps de la station",
  "upgrade.timeUTC8": "Heure (UTC + 8)",
  "upgrade.timeServer": "Temps (serveur)",
  "upgrade.content": "contenu",
  "upgrade.account": "compte",
  "upgrade.devicesSN": "Équipement SN",
  "firmware.secretType": "Type secret",
  "product.ratedPowerOnTheACSide": "Puissance nominale côté CA (kW)",
  "product.ratedPowerOnTheDCSide": "Puissance nominale côté CC (kW)",
  "product.energyStoragePower": "Puissance de stockage d'énergie (kW)",
  "product.energyStorageCapacity": "Capacité de stockage d'énergie (kWh)",
  "iot.device.register.failed": "Échec de l'enregistrement de l'appareil IoT",
  "common.title": "Paramètres d'affichage des colonnes",
  "common.fixedLeft": "Fixé à gauche",
  "common.fixedRight": "Fixé à droite",
  "common.notFixed": "Non fixé",
  "common.unfix": "Détacher",
  "common.resetSuccess": "Réinitialisation des colonnes réussie",
  "alarmInfo.exceptionDesc": "Description de l'exception",
  "alarmInfo.suggestion": "Suggestion de traitement",
  "language.syncIot": "Synchroniser l'alarme IoT",
  "language.syncSuccess": "Synchronisation de la configuration d'alarme IoT Qingluo réussie",
  "plant.saveTimezoneTip": "Changer de fuseau horaire peut entraîner :\nDes lacunes ou chevauchements dans les graphiques de données de l'appareil (durant plusieurs heures)\nDes tâches locales de l'appareil peuvent être perturbées et l'appareil peut être brièvement hors ligne",
  "plant.deviceCount": "Nombre d'appareils installés",
  "common.rangeErrorTip": "Erreur de plage {scope}, veuillez confirmer",
  "expired": "expiré",
  "due.today": "dû aujourd'hui",
  "sidebar.bulletinBoard": "Installation",
  "sidebar.dataQuery": "Requête de données",
  "plant.electrovalence": "Tarifkonfiguration",
  "plant.energy_management": "Energiemanagement",
  "plant.energy_todayStrategy": "Heutige Strategie",
  "plant.energy_PeakShavingAndValleyFilling": "Lastmanagement (Spitzenglättung & Talaufweitung)",
  "plant.energy_ValidTime": "Gültigkeitszeitraum",
  "plant.energy_Charging": "Laden",
  "plant.energy_Discharging": "Entladen",
  "plant.energy_SelectStartTime": "Startzeit wählen",
  "plant.energy_StrategyName": "Strategiename",
  "plant.energy_StrategyType": "Strategietyp",
  "plant.energy_Status": "Status",
  "plant.energy_No": "Nr.",
  "plant.energy_StartDate": "Startdatum",
  "plant.energy_EndDate": "Enddatum",
  "plant.energy_AddStrategy": "Strategie hinzufügen",
  "plant.energy_EffectiveTime": "Wirkungszeit",
  "plant.energy_SelectStrategy": "Strategie wählen",
  "plant.energy_SelectCorrespondingStrategy": "Entsprechende Strategie wählen",
  "plant.energy_ConfirmAndDeploy": "Bestätigen und bereitstellen",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "Bitte Strategie bestätigen, speichern und bereitstellen.",
  "plant.energy_Cancel": "Abbrechen",
  "plant.energy_PleaseConfirmStrategyDeletion": "Bitte Löschung der Strategie bestätigen.",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "Falls keine andere Strategie existiert, führe die manuelle Strategie aus.",
  "plant.energy_PriorityChargingTime": "Bevorzugte Ladezeit",
  "plant.energy_PriorityDischargingTime": "Bevorzugte Entladezeit",
  "plant.energy_PVConsumptionPeriod": "PV-Eigenverbrauchszeit",
  "plant.energy_StartTime": "Startzeit",
  "plant.energy_EndTime": "Endzeit",
  "plant.energy_ChargingPower": "Ladeleistung",
  "plant.energy_DischargingPower": "Entladeleistung",
  "plant.energy_SOCUpperLimit": "SOC-Obergrenze",
  "plant.energy_SOCLowerLimit": "SOC-Untergrenze",
  "plant.energy_Action": "Aktion",
  "plant.energy_AddTimePeriod": "Zeitraum hinzufügen",
  "plant.energy_ChargingStatus": "Ladezustand",
  "plant.energy_DischargingPower_kW": "Entladeleistung (kW)",
  "plant.energy_copyStrategy": "Strategie kopieren",
  "plant.energy_examine": "Anzeigen",
  "plant.energy_delete": "Löschen",
  "plant.energy_edit": "Bearbeiten",
  "plant.energy_basicInfo": "Grundinformationen",
  "plant.energy_PriorityChargingDischargingTime": "Bevorzugte Lade- und Entladezeit",
  "plant.energy_PeakShavingAtLeastOne": "Behalten Sie mindestens einen Eintrag bei.",
  "plant.energy_overlapTime": "Zeiträume dürfen sich nicht überschneiden.",
  "plant.energy_cover24hour": "Die Zeiträume müssen 24 Stunden abdecken.",
  "plant.energy_PleaseConfirmStrategyModification": "Bitte bestätigen Sie die Strategieänderung.",
  "plant.energy_Strategy": "Strategie",
  "plant.energy_cutOff_SOC": "Stopp-SOC",
  "plant.energy_EditStrategy": "Strategie bearbeiten",
  "plant.energy_ExamineStrategy": "Strategie anzeigen",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1) Bevorzugte Ladezeit: Lädt den Speicher mit überschüssiger PV-Leistung und (Niederlast-)Netzstrom, um den eingestellten SOC-Wert zu erreichen; der Speicher entlädt nicht.",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2) Bevorzugte Entladezeit: Überschüssige PV-Leistung lädt den Speicher. Bei unzureichender PV-Leistung entlädt der Speicher zuerst bis zum eingestellten SOC-Limit; die Netzeinspeisung ist sekundär.",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3) PV-Eigenverbrauchszeit: PV-Strom wird vorrangig für den Verbrauch genutzt, dann zum Laden des Speichers (bis zur SOC-Obergrenze), und schließlich wird Überschuss gedrosselt oder eingespeist. Bei unzureichender PV-Leistung entlädt der Speicher zuerst (bis zur SOC-Untergrenze), gefolgt von der Netzeinspeisung.",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4) Andere Zeiten: PV-Strom wird vorrangig für den Verbrauch genutzt, dann zum Laden des Speichers (bis zur SOC-Obergrenze), und schließlich wird Überschuss gedrosselt oder eingespeist. Der Speicher entlädt nicht.",
  "plant.energy_peak_shaving_valley_filling_explain": "Eine Strategie, die das Laden/Entladen des Speichers so plant, dass Lastspitzen gekappt und Nachfragelücken gefüllt werden, um eine ausgeglichene Ressourcennutzung zu erreichen.",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "PV-Strom wird vorrangig für den Verbrauch genutzt, dann vom Speicher verbraucht, und schließlich wird die PV-Erzeugung gedrosselt, um Rückeinspeisung zu verhindern. Bei unzureichender PV-Leistung entlädt der Speicher zuerst, gefolgt von der Netzeinspeisung.",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "PV-Strom wird vorrangig für den Verbrauch genutzt, dann vom Speicher verbraucht, und schließlich wird Überschuss eingespeist. Bei unzureichender PV-Leistung entlädt der Speicher zuerst, gefolgt von der Netzeinspeisung.",
  "plant.energy_smart_strategy_station_profit_priority_explain": "Integriert mehrdimensionale Ziele wie Zeitnutzungsentgelte, PV-Eigenverbrauch, Spitzenlastmanagement, PV- und Lastprognose sowie Bedarfssteuerung. Unter der Voraussetzung eines stabilen Mikronetzbetriebs berechnet und ermittelt eine KI-Robotersteuerung intelligent den optimalen Fahrplan für Energiespeicher und regelbare Lasten, um so den Gesamtertrag des Standorts zu maximieren.",
  "plant.energy_manual_mode_explain": "Derzeit gibt es keine Fahrstrategie für PV und Speicher. Bitte gehen Sie zur Geräteseite für manuelle Bedienung.",
  "plant.energy_SOCUpperLowerLimits": "Limites supérieure et inférieure du SOC",
  "plant.energy_ChargeDischargePower": "Puissance de charge et de décharge",
  "plant.energy_ChargeDischargeStatus": "État de charge et de décharge",
  "system.physicalModels": "Gestion des modèles physiques",
  "subtitle.physicalModelsDetail": "Détails du modèle physique",
  "physicalModels.functionSet": "Ensemble de fonctions",
  "physicalModels.minItemsTip": "Au moins {scope} élément(s) doivent être conservés",
  "physicalModels.conflictTip": "Période de conflit : {scope}",
  "physicalModels.name": "Nom de la configuration",
  "physicalModels.jsonCorrect": "Le format JSON est correct",
  "physicalModels.jsonCorrectTip": "Le format JSON est correct (service de validation non connecté)",
  "physicalModels.jsonInCorrect": "Le format JSON est incorrect",
  "physicalModels.deleteFailed": "Échec de la suppression",
  "physicalModels.loadPreviewFailed": "Échec du chargement de la configuration d'aperçu",
  "physicalModels.configEditor": "Éditeur de configuration",
  "physicalModels.selectTemplate": "Sélectionner un modèle prédéfini",
  "physicalModels.jsonConfig": "Configuration JSON",
  "physicalModels.realTimePreview": "Aperçu en temps réel",
  "physicalModels.checkJsonFormat": "Veuillez vérifier si le format JSON est correct",
  "physicalModels.readDataStructure": "Lire la structure des données",
  "physicalModels.userBehaviorData": "Données brutes du comportement utilisateur",
  "physicalModels.actualDataData": "Données réellement envoyées",
  "physicalModels.ready": "Prêt",
  "physicalModels.previewConfigLoaded": "Configuration d'aperçu chargée",
  "physicalModels.pasteFromClipboard": "Collé depuis le presse-papiers",
  "physicalModels.pasteFromClipboardTip": "Veuillez ajouter le numéro de série de l'appareil après le chemin du navigateur, par exemple :",
  "physicalModels.error": "Erreur",
  "plant.createType": "Créé par",
  "physicalModels.jsonComplete": "Complétion JSON",
  "physicalModels.jsonCompleteTip": "Si le JSON a été enregistré, une recomplétion peut entraîner des problèmes de production. Veuillez procéder avec prudence.",
  "physicalModels.maxItemsTip": "Un maximum de {scope} élément(s) est autorisé",
  "physicalModels.Empty": "{scope} ne peut pas être vide",
  "Setting.timeSet": "",
  "plantScreen.singleSiteScree.PVPower": "Puissance PV",
  "plantScreen.singleSiteScree.GridImportPower": "Puissance d‘import réseau",
  "plantScreen.singleSiteScree.GridExportPower": "Puissance d’export réseau",
  "plantScreen.singleSiteScree.ChargingPower": "Puissance de charge",
  "plantScreen.singleSiteScree.DischargingPower": "Puissance de décharge",
  "plantScreen.singleSiteScree.LoadPower": "Puissance charge (consommation)",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "Taux d‘autoconsommation",
  "plantScreen.ChartSet.GenerationPower": "Puissance de génération",
  "plantScreen.ChartSet.DayAheadForecast": "Prévision journalière",
  "plantScreen.ChartSet.RealTimeForecast": "Prévision en temps réel",
  "plantScreen.ChartSet.RealTimeScheduling": "Planification en temps réel",
  "plantScreen.ChartSet.DayAheadScheduling": "Planification journalière",
  "plantScreen.PlantInfo": "Informations de la centrale",
  "plantScreen.PhotovoltaicCapacity": "Capacité installée PV",
  "plantScreen.StorageCapacity": "Capacité de la batterie",
  "plantScreen.EnergyDispatch": "Planification énergétique",
  "plantScreen.SelfGenerationRate": "Taux d‘autogénération",
  "plantScreen.DailyStorageCharging": "Énergie chargée quotidienne",
  "plantScreen.DailyStorageDischarging": "Énergie déchargée quotidienne",
  "plantScreen.DailyElectricitySold2": "Électricité vendue quotidienne",
  "plantScreen.ChartSet.Storage": "Stockage d‘énergie",
  "plantScreen.ChartSet.Solar": "PV",
  "plantScreen.ChartSet.Load": "Charge",
  "plantScreen.ChartSet.ChargeDischargePower": "Puissance charge/décharge",
  "plantScreen.coal": "Charbon",
  "physicalModels.missingIoTIdTip": "IoTId ou virtualId manquant, veuillez vérifier",
  "org.authCompanyName": "Nom de l'entreprise certifiée",
  "org.serviceAddress": "Adresse du service",
  "org.servicePhone": "Téléphone du service",
  "org.serviceEmail": "Email du service",
  "org.companyLogo": "Logo de l'entreprise",
  "org.websiteUrl": "URL du site web",
  "org.partnerId": "ID du partenaire",
  "org.serviceAgreement": "Contrat de service",
  "org.serviceCertificate": "Certificat",
  "physicalModels.slotId": "Identifiant publicitaire",
  "report.dataQuery.maxDevicesWarning": "Vous pouvez sélectionner au maximum 10 appareils",
  "report.dataQuery.maxParamsWarning": "Vous pouvez sélectionner au maximum 10 paramètres",
  "report.dataQuery.selectDeviceAndParamsFirst": "Veuillez d'abord sélectionner des appareils et des paramètres",
  "report.dataQuery.chartTitle": "Comparaison des tendances d'exploitation multi-séries",
  "report.dataQuery.selectDevice": "Sélectionner l'appareil",
  "report.dataQuery.placeholderSelectDevice": "Veuillez sélectionner un appareil",
  "report.dataQuery.tabByModel": "Par modèle",
  "report.dataQuery.tabByStation": "Par centrale",
  "report.dataQuery.modelGroupName": "Nom du modèle",
  "report.dataQuery.noMore": "Plus de résultats",
  "report.dataQuery.selectedDevicesFooter": "Sélectionné {current} / 10 appareils",
  "report.dataQuery.selectedDevicesShort": "Appareils sélectionnés",
  "report.dataQuery.clear": "Effacer",
  "report.dataQuery.noDeviceSelectedYet": "Aucun appareil sélectionné",
  "report.dataQuery.selectParamsTitle": "Sélectionner les paramètres (10 max.)",
  "report.dataQuery.maxParamsHint": "Jusqu'à 10 paramètres en même temps",
  "report.dataQuery.searchParamsPlaceholder": "Rechercher des paramètres",
  "report.dataQuery.noMatchingParams": "Aucun paramètre correspondant",
  "report.dataQuery.selectDeviceFirst": "Veuillez d'abord sélectionner un appareil",
  "report.dataQuery.placeholderDeviceSn": "Saisir le numéro de série de l'appareil",
  "report.dataQuery.placeholderModelName": "Saisir le nom du modèle",
  "report.dataQuery.placeholderStationName": "Saisir le nom de la centrale",
  "report.dataQuery.selectedDevicesSummary": "{count} appareils sélectionnés",
  "report.dataQuery.startAnalysis": "Démarrer l'analyse",
  "report.dataQuery.emptyGuide": "Cliquez sur « Sélectionner l'appareil » en haut à gauche, choisissez jusqu'à 10 appareils à analyser, puis les paramètres et la plage de dates pour commencer",
  "report.dataQuery.noDataHint": "Aucune donnée à afficher pour la requête actuelle. Modifiez les appareils, les paramètres ou la plage de dates et réessayez",
  "report.dataQuery.tableTitle": "Comparaison des données d'exploitation multi-appareils",
  "report.dataQuery.peakLabel": "Pic :",
  "report.dataQuery.peakColor": "Rouge",
  "report.dataQuery.valleyLabel": "Creux :",
  "report.dataQuery.valleyColor": "Bleu",
  "report.dataQuery.timeByDay": "Par jour",
  "report.dataQuery.timeByWeek": "Par semaine",
  "report.dataQuery.timeByMonth": "Par mois",
  "report.dataQuery.timeByCustom": "Personnalisé",
  "report.dataQuery.highlightNone": "Aucune mise en évidence",
  "report.dataQuery.highlightCol": "Mise en évidence des écarts par colonne",
  "report.dataQuery.highlightRow": "Mise en évidence des écarts par ligne",
  "report.dataQuery.weekdayMon": "lun.",
  "report.dataQuery.weekdayTue": "mar.",
  "report.dataQuery.weekdayWed": "mer.",
  "report.dataQuery.weekdayThu": "jeu.",
  "report.dataQuery.weekdayFri": "ven.",
  "report.dataQuery.weekdaySat": "sam.",
  "report.dataQuery.weekdaySun": "dim.",
  "report.dataQuery.axisMonthDay": "J.{n}",
  "plant.statisticalCycle": "Cycle statistique",
  "plant.stationTopology": "Topologie de la station",
  "plant.topologyConfig": "Configuration de la topologie",
  "plant.projectName": "Nom du projet",
  "plant.topologyUrl": "URL de la topologie",
  "plant.topologyMap": "Carte de topologie",
  "plant.topologyPlaceholder": "Veuillez saisir l'URL de la topologie",
  "plant.addScopeSuccess": "{scope} ajouté avec succès",
  "plant.updateScopeSuccess": "{scope} modifié avec succès",
  "plant.topologyUrlFormatError": "Erreur de format de l'URL de la topologie",
  "report.dataQuery.maxCurvesWarning": "La sélection dépasse 10 courbes",
  "report.dataQuery.maxCurvesLimitHint": "Jusqu'à 10 courbes peuvent être sélectionnées",
  "report.dataQuery.selectParamsHeading": "Sélectionner les paramètres",
  "ota.don.upgrade": "Mise à niveau du dongle",
  "device.ota.tip.newversion": "La version actuelle est la plus récente et ne nécessite aucune mise à jour.",
  "device.button.cancel": "OK",
  "org.accountNumber": "Numéro de compte utilisateur",
  "org.accountName": "Nom du compte utilisateur",
  "org.description": "Description de l'utilisateur d'électricité",
  "org.creditCode": "Code de crédit social",
  "plant.deptName": "Nom de l'organisation",
  "plant.businessScope": "Industriel et commercial",
  "plant.withdrawBusinessDeliveryTip": "Après le retrait de la livraison, les utilisateurs {scope} ne pourront plus gérer cette centrale. Veuillez procéder avec prudence.",
  "mapScreen.RevenueInfo": "Informations sur les revenus",
  "mapScreen.MonthlyRevenue": "Revenus mensuels",
  "mapScreen.YearlyRevenue": "Revenus annuels",
  "mapScreen.CumulativeRevenue": "Revenus cumulés",
  "mapScreen.CarbonIndicator": "Indicateurs carbone",
  "mapScreen.StorageInfo": "Informations de stockage",
  "mapScreen.MonthlyChargeDischarge": "Charge/Décharge mensuelle",
  "mapScreen.YearlyChargeDischarge": "Charge/Décharge annuelle",
  "mapScreen.TotalPlants": "Nombre de centrales",
  "mapScreen.PvInstalledCapacity": "Capacité PV installée",
  "mapScreen.StorageInstalledCapacity": "Capacité de stockage installée",
  "mapScreen.ChargingPileCapacity": "Capacité des bornes de recharge",
  "mapScreen.Residential": "Résidentiel",
  "mapScreen.Commercial": "Commercial",
  "mapScreen.PlantCount": "Total {count} centrales",
  "mapScreen.NewEnergyPower": "Puissance des énergies renouvelables",
  "mapScreen.GenerationInfo": "Informations de production",
  "mapScreen.MonthlyGeneration": "Production mensuelle",
  "mapScreen.YearlyGeneration": "Production annuelle",
  "mapScreen.ChargingPileInfo": "Informations bornes de recharge",
  "mapScreen.MonthlyConsumption": "Consommation mensuelle",
  "mapScreen.YearlyConsumption": "Consommation annuelle",
  "mapScreen.GridConnectionInfo": "Informations de raccordement au réseau",
  "mapScreen.MonthlyPurchaseFeedin": "Achat/Injection mensuelle",
  "mapScreen.YearlyPurchaseFeedin": "Achat/Injection annuelle",
  "mapScreen.CO2Reduction": "Réduction de CO2",
  "mapScreen.SaveCoal": "Charbon économisé",
  "mapScreen.TreePlanting": "Arbres plantés",
  "mapScreen.SelectCountry": "Sélectionner un pays",
  "mapScreen.BackToPrev": "Retour au niveau précédent",
  "mapScreen.Revenue": "Revenus",
  "mapScreen.ChargeAmount": "Quantité de charge",
  "mapScreen.DischargeAmount": "Quantité de décharge",
  "mapScreen.GenerationAmount": "Quantité de production",
  "mapScreen.ConsumptionAmount": "Quantité de consommation",
  "mapScreen.PowerGeneration": "Puissance de production",
  "mapScreen.PurchaseAmount": "Quantité achetée",
  "mapScreen.GridSellAmount": "Quantité injectée au réseau",
  "mapScreen.title": "Plateforme de Gestion de l'Énergie",
  "mapScreen.PlantMonthlyRevenue": "Revenus mensuels",
  "mapScreen.PlantYearlyRevenue": "Revenus annuels",
  "mapScreen.PlantCumulativeRevenue": "Revenus cumulés",
  "physicalModels.tagGroup": "Groupe d'étiquettes",
  "device.expandAll": "Tout développer",
  "device.collapseAll": "Tout réduire",
  "common.deleteSuccess": "Suppression réussie",
  "device.systemTime": "Heure système",
  "device.traceId": "ID de traçage",
  "device.collectorSn": "SN du collecteur",
  "device.functionCode": "Code de fonction",
  "device.encryptedStr": "Message chiffré",
  "device.decryptedStr": "Message déchiffré",
  "device.dateRangeErrorScope": "La plage de dates doit être comprise dans {scope} jours",
  "common.noMore": "Pas plus",
  "common.unloginOrExpired": "Non connecté ou session expirée",
  "common.serverError": "Exception du serveur, veuillez réessayer plus tard",
  "common.requestFailed": "La requête a échoué",
  "common.backendError": "Erreur de connexion à l'interface backend",
  "common.timeout": "Délai d'attente de la requête de l'interface système",
  "common.systemInterface": "Interface système",
  "common.contains": "Contient",
  "common.columnSetting": "Paramètres de colonne",
  "product.skipShipmentCheck": "Ignorer la vérification d'expédition",
  "system.mapScreen": "Ecran panoramique",
  "settingDrawer.title": "Paramètres de mise en page",
  "settingDrawer.themeMode": "Mode thème",
  "settingDrawer.darkTheme": "Thème sombre",
  "settingDrawer.lightTheme": "Thème clair",
  "settingDrawer.themeColor": "Couleur du thème",
  "settingDrawer.navMode": "Mode de navigation",
  "settingDrawer.sideMenu": "Disposition du menu latéral",
  "settingDrawer.topMenu": "Disposition du menu supérieur",
  "settingDrawer.mixMenu": "Disposition mixte",
  "settingDrawer.columnMenu": "Disposition en colonnes",
  "settingDrawer.drawerMenu": "Disposition en tiroir",
  "settingDrawer.layoutSetting": "Paramètres de mise en page",
  "settingDrawer.contentWidth": "Largeur du contenu",
  "settingDrawer.contentWidthFixed": "Fixe",
  "settingDrawer.contentWidthFluid": "Fluide",
  "settingDrawer.fixedHeader": "En-tête fixe",
  "settingDrawer.fixedSidebar": "Barre latérale fixe",
  "settingDrawer.hideFooter": "Masquer le pied de page",
  "settingDrawer.multiTab": "Mode multi-onglets",
  "settingDrawer.sidebarColorfulIcon": "Icônes colorées de la barre latérale",
  "settingDrawer.searchMode": "Mode du composant de recherche",
  "settingDrawer.searchModeHeader": "Nouvelle version",
  "settingDrawer.searchModeForm": "Ancienne version",
  "settingDrawer.systemConfig": "Configuration système",
  "settingDrawer.systemTitle": "Titre du système",
  "settingDrawer.systemCopyright": "Informations de droit d'auteur",
  "settingDrawer.systemVersion": "Version du système",
  "settingDrawer.systemVersionPlaceholder": "Numéro de version",
  "settingDrawer.tableStyle": "Style de tableau",
  "settingDrawer.tableSize": "Taille du tableau",
  "settingDrawer.tableSizeDefault": "Défaut",
  "settingDrawer.tableSizeMiddle": "Moyen",
  "settingDrawer.tableSizeSmall": "Compact",
  "settingDrawer.tableBordered": "Afficher les bordures",
  "settingDrawer.tableFixHeader": "Fixer l'en-tête",
  "settingDrawer.tableHeaderBold": "En-tête en gras",
  "settingDrawer.tableResizable": "Colonnes redimensionnables",
  "settingDrawer.tableRowSelection": "Sélection de lignes",
  "settingDrawer.tableHeaderBgColor": "Couleur d'arrière-plan de l'en-tête",
  "settingDrawer.tableHeight": "Hauteur du tableau",
  "settingDrawer.pageSize": "Taille de la page",
  "settingDrawer.pageSizeUnit": "Éléments/page",
  "settingDrawer.showTotal": "Afficher le total",
  "settingDrawer.showSizeChanger": "Afficher le sélecteur de taille",
  "settingDrawer.showQuickJumper": "Afficher le saut rapide",
  "settingDrawer.tableStripe": "Rayures zébrées",
  "settingDrawer.tableShowHeader": "Afficher l'en-tête",
  "settingDrawer.saveTableConfig": "Enregistrer la configuration du tableau",
  "settingDrawer.reset": "Réinitialiser",
  "settingDrawer.configManagement": "Gestion de la configuration",
  "settingDrawer.saveAll": "Enregistrer toutes les configurations",
  "settingDrawer.exportConfig": "Exporter la configuration",
  "settingDrawer.importConfig": "Importer la configuration",
  "settingDrawer.resetAll": "Réinitialiser toutes les configurations",
  "settingDrawer.msg.initFail": "Échec de l'initialisation du système, veuillez actualiser et réessayer",
  "settingDrawer.msg.configInitFail": "Échec de l'initialisation de la configuration",
  "settingDrawer.msg.themeChangeFail": "Échec du changement de thème",
  "settingDrawer.msg.colorChangeFail": "Échec du changement de couleur du thème",
  "settingDrawer.msg.searchModeSwitched": "Basculé vers la recherche {mode}",
  "settingDrawer.msg.searchModeSwitchFail": "Échec du changement de composant de recherche",
  "settingDrawer.msg.navModeSwitched": "Basculé en mode {mode}",
  "settingDrawer.msg.navSide": "Barre latérale",
  "settingDrawer.msg.navTop": "Menu supérieur",
  "settingDrawer.msg.navMix": "Mixte",
  "settingDrawer.msg.navModeSwitchFail": "Échec du changement de mode de navigation",
  "settingDrawer.msg.layoutSwitchFail": "Échec du changement de mise en page",
  "settingDrawer.msg.settingUpdateFail": "Échec de la mise à jour des paramètres",
  "settingDrawer.msg.tableStoreNotInit": "Le magasin de configuration du tableau n'est pas initialisé",
  "settingDrawer.msg.tableConfigSaved": "Configuration du tableau enregistrée",
  "settingDrawer.msg.tableConfigSaveFail": "Échec de l'enregistrement de la configuration du tableau",
  "settingDrawer.msg.tableConfigReset": "Configuration du tableau réinitialisée",
  "settingDrawer.msg.tableConfigResetFail": "Échec de la réinitialisation de la configuration du tableau",
  "settingDrawer.msg.systemConfigUpdated": "Configuration système mise à jour",
  "settingDrawer.msg.systemConfigUpdateFailStore": "Échec de la mise à jour de la configuration système : Store non initialisé",
  "settingDrawer.msg.systemConfigUpdateFail": "Échec de la mise à jour de la configuration système",
  "settingDrawer.msg.allConfigSaved": "Toutes les configurations enregistrées",
  "settingDrawer.msg.configSaveFail": "Échec de l'enregistrement de la configuration",
  "settingDrawer.msg.configExported": "Configuration exportée",
  "settingDrawer.msg.configExportFail": "Échec de l'exportation de la configuration",
  "settingDrawer.msg.configImportConfirmTitle": "Confirmer l'importation de la configuration",
  "settingDrawer.msg.configImportConfirmContent": "L'importation de la configuration écrasera tous les paramètres actuels. Continuer ?",
  "settingDrawer.msg.confirm": "Confirmer",
  "settingDrawer.msg.cancel": "Annuler",
  "settingDrawer.msg.configImported": "Configuration importée avec succès",
  "settingDrawer.msg.configFileInvalid": "Format de fichier de configuration invalide",
  "settingDrawer.msg.resetConfirmTitle": "Confirmer la réinitialisation",
  "settingDrawer.msg.resetConfirmContent": "La réinitialisation effacera toutes les configurations personnalisées et rétablira l'état par défaut. Continuer ?",
  "settingDrawer.msg.allConfigReset": "Toutes les configurations réinitialisées"
}
